import { gql } from '@nerdwallet/apollo';
import * as React from 'react';
import * as ApolloReactCommon from '@nerdwallet/apollo';
import * as ApolloReactComponents from '@nerdwallet/apollo';
import * as ApolloReactHoc from '@nerdwallet/apollo';
import * as ApolloReactHooks from '@nerdwallet/apollo';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** For bigger integers */
  BigInt: any;
  /** A date string, such as 2007-12-03 */
  Date: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z */
  DateTime: any;
  /** An ISO date string with time offset, such as 2021-04-09T00:00:00-07:00 */
  DateTimeWithTimeOffset: any;
  /** A string that conforms to the standard internet email address format as specified in RFC822: https://www.w3.org/Protocols/rfc822/#z8. */
  EmailAddress: any;
  /** 3-letter currency code. */
  FinancialCurrency: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** A structured content document JSON blob. This custom scalar currently uses the same validation rules as the JSON scalar. */
  StructuredContentDocument: any;
  /** A string that conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: any;
};

/** The expected payload for the "updateDismissAccountAggCta" mutation. */
export type AccountAggCtaDismissedInput = {
  accountsSmallBanner?: InputMaybe<Scalars['Boolean']>;
  ageAndMixOfAccountsSmallBanner?: InputMaybe<Scalars['Boolean']>;
  balancesSmallBanner?: InputMaybe<Scalars['Boolean']>;
  creditScoreBigBanner?: InputMaybe<Scalars['Boolean']>;
  creditScoreSmallBanner?: InputMaybe<Scalars['Boolean']>;
  debtSmallBanner?: InputMaybe<Scalars['Boolean']>;
  spendingSmallBanner?: InputMaybe<Scalars['Boolean']>;
  tradelineSmallBanner?: InputMaybe<Scalars['Boolean']>;
  tradelineTopLink?: InputMaybe<Scalars['Boolean']>;
  utilizationBigBanner?: InputMaybe<Scalars['Boolean']>;
  utilizationFaq?: InputMaybe<Scalars['Boolean']>;
  utilizationSmallBanner?: InputMaybe<Scalars['Boolean']>;
};

/** List of Account Aggregation CTAs and whether they have been dismissed */
export type AccountAggCtaDismissedResponse = {
  __typename?: 'AccountAggCtaDismissedResponse';
  accountsSmallBanner?: Maybe<Scalars['Boolean']>;
  ageAndMixOfAccountsSmallBanner?: Maybe<Scalars['Boolean']>;
  balancesSmallBanner?: Maybe<Scalars['Boolean']>;
  creditScoreBigBanner?: Maybe<Scalars['Boolean']>;
  creditScoreSmallBanner?: Maybe<Scalars['Boolean']>;
  debtSmallBanner?: Maybe<Scalars['Boolean']>;
  spendingSmallBanner?: Maybe<Scalars['Boolean']>;
  tradelineSmallBanner?: Maybe<Scalars['Boolean']>;
  tradelineTopLink?: Maybe<Scalars['Boolean']>;
  utilizationBigBanner?: Maybe<Scalars['Boolean']>;
  utilizationFaq?: Maybe<Scalars['Boolean']>;
  utilizationSmallBanner?: Maybe<Scalars['Boolean']>;
};

/** TODO: the `canonicalInstitutionId` field should map to a canonical institution */
export type AccountAggregationInstitution = {
  __typename?: 'AccountAggregationInstitution';
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
  /** Manual override by NW employee for the popularity of this institution */
  adminPopularity?: Maybe<Scalars['Int']>;
  /**
   * Indicator of which account aggregator we are surfacing this institution from
   *
   * Example: `yodlee`
   */
  aggregatorType?: Maybe<MarketplaceAggregatorType>;
  /** The countries with which the institution is affiliated. */
  countryCodes?: Maybe<Array<InstitutionCountryCode>>;
  /**
   * The timestamp at which the institution was last deleted from marketplace, if applicable
   *
   * Example: `1563480626`
   */
  deletedAt?: Maybe<Scalars['DateTime']>;
  /**
   * The status of the institution, typically used to determine whether to surface the institution or not
   *
   * Example: `ACTIVE`
   */
  displayStatus: AccountAggregationInstitutionDisplayStatus;
  /** Whether the institution is manually deactivated by an NW employee or not ??? */
  iavAdminDeactivated?: Maybe<Scalars['Boolean']>;
  /** Whether the institution supports IAV or not */
  iavEnabled: Scalars['Boolean'];
  /**
   * The timestamp at which the institution was last updated in marketplace
   *
   * Example: `1563480626`
   */
  lastSyncedAt: Scalars['DateTime'];
  /**
   * The logo for the institution as provided by the relevant third-party account aggregator. This may either be
   * a full url, or a data-image representation of an image.
   *
   * Example: `https://yodlee-1.hs.llnwd.net/v1/LOGO/LOGO_643_1_2.SVG`
   */
  logoUrl?: Maybe<Scalars['String']>;
  /**
   * An alternate logo for the institution provided by NerdWallet that more clearly indicates which institution it is
   * (i.e. via text in the logo)
   */
  topInstitutionLogo?: Maybe<Scalars['String']>;
  /**
   * The URL at which the user will be logged in, as provided by the relevant third-party account aggregator
   *
   * Example: `https://secure01c.chase.com/web/auth/dashboard`
   */
  loginUrl?: Maybe<Scalars['String']>;
  /**
   * How popular this institution is for linking to in relation to others, equal to the number of successful
   * links with this institution in the past
   */
  popularity: Scalars['Int'];
};

export type AccountAggregationInstitutionByIdResponse = {
  __typename?: 'AccountAggregationInstitutionByIdResponse';
  institution?: Maybe<AccountAggregationInstitution>;
};

export enum AccountAggregationInstitutionDisplayStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  /**  This institution is not supported, but is a major institution that we want to show to the user anyway (with messaging)  */
  Unavailable = 'UNAVAILABLE'
}

export type AccountAggregationInstitutionsResponse = {
  __typename?: 'AccountAggregationInstitutionsResponse';
  /** The total number of institutions that match your query */
  total: Scalars['Int'];
  /** The list of institutions that match your query */
  institutions: Array<AccountAggregationInstitution>;
  /** How many top results are excluded from this result set (for pagination) */
  offset: Scalars['Int'];
};

export enum AccountAggregationProductType {
  Banking = 'BANKING',
  CreditCards = 'CREDIT_CARDS',
  InvestmentAccounts = 'INVESTMENT_ACCOUNTS',
  Mortgages = 'MORTGAGES',
  PersonalLoans = 'PERSONAL_LOANS',
  StudentLoans = 'STUDENT_LOANS'
}

export type AccountLinkingOpportunitiesResponse = {
  __typename?: 'AccountLinkingOpportunitiesResponse';
  eligibility: AccountLinkingOpportunityEligibilityEnum;
  creditCardLinkingOpportunities?: Maybe<Array<AccountLinkingOpportunity>>;
  loanLinkingOpportunities?: Maybe<Array<AccountLinkingOpportunity>>;
};

export type AccountLinkingOpportunity = {
  __typename?: 'AccountLinkingOpportunity';
  institutionCanonicalId?: Maybe<Scalars['ID']>;
  institutionCanonicalName?: Maybe<Scalars['String']>;
  institutionLogoUrl?: Maybe<Scalars['URL']>;
  numberOfAccounts: Scalars['Int'];
};

export enum AccountLinkingOpportunityEligibilityEnum {
  /** Denotes if a user is eligible to link all types of accounts. */
  All = 'ALL',
  /** Denotes if a user is eligible to link only credit cards or loans. */
  CcsAndLoans = 'CCS_AND_LOANS',
  /** Denotes if a user already has all types of accounts linked or no TU data. */
  None = 'NONE'
}

/**
 * The `AccountOfferInterface` is the shared fields between savings and investments
 * for the marketplace tab recommendations.
 */
export type AccountOfferInterface = {
  imageUrl?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Float']>;
  reviewUrl?: Maybe<Scalars['String']>;
  providerName?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type AcknowledgeTermsOfServiceInput = {
  type: Scalars['String'];
  source: Scalars['String'];
  version: Scalars['String'];
};

export type AcknowledgeTermsOfServiceResponse = {
  __typename?: 'AcknowledgeTermsOfServiceResponse';
  success: Scalars['Boolean'];
};

/**
 * Wraps the add Net Worth Home - Integrated API response, which allows for adding fields at a
 * later date
 */
export type AddNetWorthHomeIntegratedResponse = {
  __typename?: 'AddNetWorthHomeIntegratedResponse';
  asset: NetWorthHomeIntegrated;
};

/**
 * Wraps the add Net Worth Real asset Self-Reported API response, which allows for adding fields at a
 * later date
 */
export type AddNetWorthRealAssetSelfReportedResponse = {
  __typename?: 'AddNetWorthRealAssetSelfReportedResponse';
  asset: NetWorthRealAssetSelfReported;
};

export type AddUserWalletCardInput = {
  /** The ID of the marketplace offer to associate with the user's wallet card */
  marketplaceOfferId?: InputMaybe<Scalars['ID']>;
  /** The ID of the financial account to associate with the user's wallet card */
  financialAccountId?: InputMaybe<Scalars['ID']>;
};

export type AddUserWalletCardResponse = {
  __typename?: 'AddUserWalletCardResponse';
  card: UserWalletCard;
};

export type AdvancedOffsetPaginationInfo = {
  __typename?: 'AdvancedOffsetPaginationInfo';
  /** The adjusted maximum number of results to return based on the request limit and result set token. */
  limit?: Maybe<Scalars['Int']>;
  /**
   * The adjusted start index of the results to return based on the request limit and result set token.
   * If underlying data has changed, this will be reset to 0 and results will start from the "beginning" of the list.
   */
  offset?: Maybe<Scalars['Int']>;
  /** The token associated with the result set, which may be different if the underlying data changed */
  resultSetToken?: Maybe<Scalars['String']>;
};

export type AdvancedOffsetPaginationInput = {
  /** The maximum number of results to return. Default is 500. */
  limit?: InputMaybe<Scalars['Int']>;
  /** The start index of the results to return. */
  offset?: InputMaybe<Scalars['Int']>;
  /** The token associated with the result set, used to validate whether underlying data may have changed */
  resultSetToken?: InputMaybe<Scalars['String']>;
};

export type AgeRangeMap = {
  __typename?: 'AgeRangeMap';
  /** average insurance cost for a driver at age 20 */
  age20: Scalars['Float'];
  /** average insurance cost for a driver at age 25 */
  age25: Scalars['Float'];
  /** average insurance cost for a driver at age 30 */
  age30: Scalars['Float'];
  /** average insurance cost for a driver at age 35 */
  age35: Scalars['Float'];
  /** average insurance cost for a driver at age 40 */
  age40: Scalars['Float'];
  /** average insurance cost for a driver at age 45 */
  age45: Scalars['Float'];
  /** average insurance cost for a driver at age 50 */
  age50: Scalars['Float'];
  /** average insurance cost for a driver at age 55 */
  age55: Scalars['Float'];
  /** average insurance cost for a driver at age 60 */
  age60: Scalars['Float'];
  /** average insurance cost for a driver at age 65 */
  age65: Scalars['Float'];
  /** average insurance cost for a driver at age 70 */
  age70: Scalars['Float'];
  /** average insurance cost for a driver at age 75 */
  age75: Scalars['Float'];
  /** average insurance cost for a driver at age 80 */
  age80: Scalars['Float'];
};

export type AnnualPremiumByZipCode = {
  __typename?: 'AnnualPremiumByZipCode';
  /** US zipCode */
  zipcode: Scalars['String'];
  /** Carrier's annual premium */
  annualPremium: Scalars['Float'];
};

/**
 * The type used by Native and Web that describes how to handle a defined action.
 * On Mobile, it allows for a link that could deeplink or fall back to a webview if that deeplink
 * is not supported in the client version of the mobile app.
 * On Web, the action is determined using both targetType and the target.
 */
export type AppAction = {
  __typename?: 'AppAction';
  /** A string that describes the type of action (used for analytics). */
  name?: Maybe<Scalars['String']>;
  /** The user-facing copy on the action button/link */
  text: Scalars['String'];
  /** A NerdWallet mobile app deep link */
  mobileTarget?: Maybe<Scalars['String']>;
  /** Typically a web URL. If mobileTarget is not specified or invalid, this will open in a webview. */
  target?: Maybe<Scalars['String']>;
  /** A string that tells the client how to handle this action. Only used on Web. */
  targetType?: Maybe<AppActionTargetType>;
  /** Indicates whether the provided target is a place where the user can fulfill the described action */
  leadsToUserActionFulfillment?: Maybe<Scalars['Boolean']>;
};

export enum AppActionTargetType {
  WebLink = 'WEB_LINK',
  Navigation = 'NAVIGATION',
  Billshark = 'BILLSHARK',
  MyBillsSuggested = 'MY_BILLS_SUGGESTED',
  LinkAccount = 'LINK_ACCOUNT',
  LinkHome = 'LINK_HOME',
  SelfReportedIncome = 'SELF_REPORTED_INCOME',
  TuActivation = 'TU_ACTIVATION'
}

export type AppleLoginInfoInput = {
  /** The app used to log in with Apple */
  appType: AppTypeEnum;
  /** The authorization code associated with the Apple log in/registration */
  authorizationCode: Scalars['String'];
  /** The client ID associated with the Apple log in/registration */
  clientId: Scalars['String'];
  /** The current user's email associated with the Apple log in/registration */
  email?: InputMaybe<Scalars['EmailAddress']>;
  /** The current user's first name associated with the Apple log in/registration */
  firstName?: InputMaybe<Scalars['String']>;
  /** The current user's last name associated with the Apple log in/registration */
  lastName?: InputMaybe<Scalars['String']>;
  /** The "number only used once" associated with the Apple log in/registration */
  nonce?: InputMaybe<Scalars['String']>;
  /** The password used to log in with third party credentials (required for the first log in to existing passworded identities) */
  password?: InputMaybe<Scalars['String']>;
  /** The redirect URI ssociated with the Apple log in/registration */
  redirectUri?: InputMaybe<Scalars['String']>;
  /** Determines if the current user should stay logged in */
  rememberMe: Scalars['Boolean'];
};

/** Enum used to determine the app type of a third party log in */
export enum AppTypeEnum {
  NerdwalletMobile = 'NERDWALLET_MOBILE',
  NerdwalletWeb = 'NERDWALLET_WEB',
  Nwadmin = 'NWADMIN'
}

/** Type modeling the data for posts within the nw_article post type from WordPress. */
export type Article = ContentPageHeaderInterface & PostInterface & PostWithAuthorsInterface & PostWithContentClassificationInterface & PostWithContentInterface & PostWithExcerptInterface & PostWithFaQsInterface & PostWithFeaturedImageInterface & PostWithInternationalVersionsInterface & PostWithPageTaxonomyInterface & PostWithReviewerInterface & PostWithSeoInterface & PostWithTitleInterface & {
  __typename?: 'Article';
  /** Whether or not to show the advertiser disclosure. An empty value here indicates it should be shown. */
  advertiserDisclosure?: Maybe<Scalars['String']>;
  /** The type of Article this is. */
  articleType?: Maybe<ArticleTypeEnum>;
  /** The assigning editor set on the content. */
  assigningEditor?: Maybe<Author>;
  /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
  attributionTopic?: Maybe<Scalars['String']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the Article object. */
  categories?: Maybe<Array<Category>>;
  /** The Disqus thread ID for this content. */
  commentThreadId?: Maybe<Scalars['Int']>;
  /** The structured content for the resource. */
  content?: Maybe<Scalars['StructuredContentDocument']>;
  /** Additional content clusters for this piece of content. */
  contentClusters?: Maybe<Array<Scalars['String']>>;
  /** Content tags associated with the content. */
  contentTags?: Maybe<Array<Scalars['String']>>;
  /** The BlockGroups to use as custom content below the main content of the Article. */
  customBelowContent?: Maybe<BlockGroup>;
  /** The custom HouseAd to use on this Article. */
  customHouseAd?: Maybe<HouseAd>;
  /** The custom last modified date for the content. */
  customLastModifiedDate?: Maybe<Scalars['DateTime']>;
  /** The BlockGroups to use as the custom next steps for this Article. */
  customNextSteps?: Maybe<BlockGroup>;
  /** The BlockGroups to use as custom Related Links for this Article. */
  customRelatedLinks?: Maybe<BlockGroup>;
  /** The block group to use as the custom sidebar on this Article. */
  customSidebar?: Maybe<BlockGroup>;
  /** The custom title to use for this piece of content on a feed by feed basis. */
  customTitlesForRssFeeds?: Maybe<Array<ArticleCustomTitlesForRssFeed>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** The format to use when displaying the date. */
  dateDisplayFormat?: Maybe<DateDisplayFormatEnum>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']>;
  /** Editorial disclaimer setting to show, hide, or display a specific disclaimer. An empty value here indicates it should be shown. */
  editorialDisclaimer?: Maybe<Scalars['String']>;
  /** Whether or not to disable comments on this piece of content. */
  enableComments?: Maybe<Scalars['Boolean']>;
  /** The editorial excerpt of the resource. */
  excerpt?: Maybe<Scalars['String']>;
  /** The faqs to display on this piece of content. */
  faqs?: Maybe<Array<ContentFaq>>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']>;
  /** Whether or not to hide the Author information from the header of this piece of content. */
  hideAuthor?: Maybe<Scalars['Boolean']>;
  /** Whether or not to hide the banner for this piece of content. */
  hideBanner?: Maybe<Scalars['Boolean']>;
  /** Whether or not to hide the custom content to display below the main content for this Article. */
  hideBelowContent?: Maybe<Scalars['Boolean']>;
  /** Whether or not to hide the date for this piece of content. */
  hideDate?: Maybe<Scalars['Boolean']>;
  /** Whether or not to hide the featured image for this piece of content. */
  hideFeaturedImage?: Maybe<Scalars['Boolean']>;
  /** Whether or not to hide the featured image on mobile/small screens. */
  hideFeaturedImageOnMobile?: Maybe<Scalars['Boolean']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** Information about alternate versions of the content that exist for other locales. */
  internationalVersions?: Maybe<Array<InternationalVersion>>;
  /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
  isArchivesEligible?: Maybe<Scalars['Boolean']>;
  /** Whether or not to prevent this piece of content from being recommended to users. */
  isRecommendationEligible?: Maybe<Scalars['Boolean']>;
  /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
  isSearchEligible?: Maybe<Scalars['Boolean']>;
  /** Whether or not to prevent the content from getting syndicated to NerdWalletWire.com and other services that use our full-text feeds. */
  isSyndicationEligible?: Maybe<Scalars['Boolean']>;
  /** The layout to use for the content. */
  layout?: Maybe<ArticleLayoutEnum>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The block to use as the methodology for this piece of content. */
  methodology?: Maybe<Block>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** Whether to override the last modified date for the content using one of the available options. */
  overrideLastModifiedDateWithCurrentDate?: Maybe<OverrideLastModifiedDateEnum>;
  /** Page taxonomy data. This array is designed to be passed directly to GMS. See https://github.com/NerdWallet/global-markup/tree/b3af4e1f2c68485514145ff31b9137d619e910e1#v2-options */
  pageTaxonomy?: Maybe<Scalars['JSON']>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']>;
  /** The primary category object for the content. */
  primaryCategory?: Maybe<Category>;
  /** The primary content cluster for this piece of content. */
  primaryContentCluster?: Maybe<Scalars['String']>;
  /** A date after which this content should no longer be recommended. */
  recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']>;
  /** The reviewers that this Article has been reviewed by. */
  reviewedBy?: Maybe<Array<ContentReviewer>>;
  /** The product, offer, or institution name that the Article represents a review about. */
  reviewProductName?: Maybe<Scalars['String']>;
  /** The rating value to use with the Review schema type. */
  reviewRating?: Maybe<Scalars['Float']>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** Whether or not to show the author box in the footer of this piece of content. */
  showAuthorBox?: Maybe<Scalars['Boolean']>;
  /** Whether or not to display the FAQ's. */
  showFaqs?: Maybe<Scalars['Boolean']>;
  /** Whether or not to show the last modified date. */
  showLastModifiedDate?: Maybe<Scalars['Boolean']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The content to display below the title of a piece of content. */
  synopsis?: Maybe<Scalars['String']>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
  /** Whether or not to use the custom content below the main content for this Article. */
  useCustomBelowContent?: Maybe<Scalars['Boolean']>;
  /** Whether or not to use a custom House Ad on this Article. */
  useCustomHouseAd?: Maybe<Scalars['Boolean']>;
  /** Whether or not to use a custom last modified date for this piece of content. */
  useCustomLastModifiedDate?: Maybe<Scalars['Boolean']>;
  /** Whether or not to use the custom next steps for this Article. */
  useCustomNextSteps?: Maybe<Scalars['Boolean']>;
  /** Whether or not to use the custom related links for this Article. */
  useCustomRelatedLinks?: Maybe<Scalars['Boolean']>;
  /** Whether or not to use a custom sidebar for this Article. */
  useCustomSidebar?: Maybe<Scalars['Boolean']>;
  /** Whether the Article should use the Review schema type. */
  useReviewSchemaType?: Maybe<Scalars['Boolean']>;
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']>>;
  /** Type of advertiser disclosure to display (default credit_cards) */
  advertiserDisclosureType: Scalars['String'];
  /** The banner to display on the article */
  banner?: Maybe<Banner>;
  /** Block group to be rendered below the content. */
  belowContent?: Maybe<BlockGroup>;
  /** The structured content to display below the main article content */
  bottomDocument?: Maybe<Scalars['StructuredContentDocument']>;
  /** A structured content component that is sticky to the bottom of the article when scrolling */
  bottomStickyDocument?: Maybe<Scalars['StructuredContentDocument']>;
  /** the breadcrumb to display on an article */
  breadcrumb?: Maybe<Breadcrumb>;
  /** Display date based on flags and custom dates set on entity */
  displayDate?: Maybe<Scalars['DateTime']>;
  /** Type of article, which will determine what (if any) additional editorial standards message to display. */
  editorialDisclaimerType?: Maybe<Scalars['String']>;
  /** The structured content to use as Hero Banner for this Article */
  heroBannerDocument?: Maybe<Scalars['StructuredContentDocument']>;
  /** HouseAd to be rendered for house ad. */
  houseAd?: Maybe<HouseAd>;
  /** Whether the article's status is PUBLISHED or not. */
  isPublished: Scalars['Boolean'];
  /** The structured content to use as the Marketplace Entity Logo Row Section for this Article */
  marketplaceEntityLogoRowDocument?: Maybe<Scalars['StructuredContentDocument']>;
  /** Block group to be rendered as 'next steps'. */
  nextSteps?: Maybe<BlockGroup>;
  /** User-facing label of the post type. */
  postTypeLabel: Scalars['String'];
  /** Block group to be rendered as related links. */
  relatedLinks?: Maybe<BlockGroup>;
  /** Whether or not to show the advertiser disclosure. */
  showAdvertiserDisclosure: Scalars['Boolean'];
  /** Boolean flag to show/hide author byline in the page header */
  showAuthorByline: Scalars['Boolean'];
  /** Whether or not to show the editorial disclaimer. */
  showEditorialDisclaimer: Scalars['Boolean'];
  /** Block group to be rendered as the sidebar. */
  sidebar?: Maybe<BlockGroup>;
  /** The structured content to display in right or left of the main article content; currently where relatedLinks is */
  sidebarDocument?: Maybe<Scalars['StructuredContentDocument']>;
  /** The structured content for the NerdyTakeaways component. */
  takeaways?: Maybe<Scalars['StructuredContentDocument']>;
  /** The credit cards to display for the CCHeadToHead component. */
  creditCardsHeadToHead?: Maybe<Array<Maybe<MarketplaceEntityInterface>>>;
};


/** Type modeling the data for posts within the nw_article post type from WordPress. */
export type ArticleDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_article post type from WordPress. */
export type ArticleExcerptArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};


/** Type modeling the data for posts within the nw_article post type from WordPress. */
export type ArticleModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_article post type from WordPress. */
export type ArticleTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type ArticleConnectionResponse = {
  __typename?: 'ArticleConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The Article returned for the connection. */
  items?: Maybe<Array<Article>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Type modeling the data within the customTitlesForRssFeeds group of fields on the Article type. */
export type ArticleCustomTitlesForRssFeed = {
  __typename?: 'ArticleCustomTitlesForRssFeed';
  /** The title to show in this feed. */
  customTitle?: Maybe<Scalars['String']>;
  /** The feed this title should show on. */
  feedSlug?: Maybe<Scalars['String']>;
};

/** Query to fetch a collection of Article objects. */
export type ArticleFilterInput = {
  /** Limit collection to Articles published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to Articles within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']>>;
  /** Limit results to those with the specified cluster. */
  cluster?: InputMaybe<Scalars['String']>;
  /** Limit results to items with the specified content tags. */
  contentTags?: InputMaybe<Array<Scalars['String']>>;
  /** Limit results to those with the specified Assigning Editor, filtered by ID. */
  editorIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Limit collection to Articles with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']>;
  /** Limit results to those with the specified Reviewer, filtered by ID. */
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Limit collection to Articles with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

/** Enum values for layout field on Article type. */
export enum ArticleLayoutEnum {
  Default = 'DEFAULT',
  Full = 'FULL',
  Sidebar = 'SIDEBAR'
}

export type ArticlePage = StructuredContentPageInterface & {
  __typename?: 'ArticlePage';
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID'];
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
};

/** Enum values for articleType field on Article type. */
export enum ArticleTypeEnum {
  GeneralAnswer = 'GENERAL_ANSWER',
  HeroBanner = 'HERO_BANNER',
  Listicle = 'LISTICLE',
  StepByStep = 'STEP_BY_STEP',
  TableOfContents = 'TABLE_OF_CONTENTS'
}

export type AuthenticateCreditProfileResponseUnion = TuCreditReportIdentityProfile | CreditProfileAuthStatusProfile;

/** Interface that must be implemented by log in/register user responses */
export type AuthenticationResponseInterface = {
  /** Determines whether user registration was successful */
  success: Scalars['Boolean'];
  /** The A/B experiments associated with the current user */
  abExperiments?: Maybe<Array<Experiment>>;
  /** The feature flags associated with the current user for the calling application */
  featureFlags?: Maybe<Array<FeatureFlag>>;
};

/** The WordPress author type. */
export type Author = {
  __typename?: 'Author';
  /** An organization the author is affiliated with. */
  affiliation?: Maybe<Scalars['String']>;
  /** The author's alma mater. */
  alumniOf?: Maybe<Scalars['String']>;
  /** The full media object to use for the user's avatar image. */
  avatar?: Maybe<MediaItem>;
  /** URLs to various avatar sizes. */
  avatarUrls?: Maybe<Array<AuthorAvatarUrl>>;
  /** An award the author has won. */
  award?: Maybe<Scalars['String']>;
  /** The email address to use to contact the author. */
  contactEmail?: Maybe<Scalars['String']>;
  /** This field is a direct representation of the ID for the Author as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** Description for the author. */
  description?: Maybe<Scalars['String']>;
  /** The author's education history. */
  education?: Maybe<Scalars['String']>;
  /** Email address for the author. */
  email?: Maybe<Scalars['String']>;
  /** The author's previous experience. */
  experience?: Maybe<Scalars['String']>;
  /** Facebook URL for the author. */
  facebook?: Maybe<Scalars['URL']>;
  /** A collection of publications, organizations, etc. where the author has been featured in. */
  featuredIn?: Maybe<Array<AuthorFeaturedIn>>;
  /** The author's honorific suffix. eg: CFP, CPA */
  honorificSuffix?: Maybe<Scalars['String']>;
  /** The ID for the Author. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** The author's job title. */
  jobTitle?: Maybe<Scalars['String']>;
  /** Full url for the author's archive page. */
  link?: Maybe<Scalars['URL']>;
  /** LinkedIn URL for the author. */
  linkedin?: Maybe<Scalars['URL']>;
  /** Marketplace bio for the author. */
  marketplaceBio?: Maybe<Scalars['String']>;
  /** Name of the author. */
  name?: Maybe<Scalars['String']>;
  /** URI slug for the author. */
  slug?: Maybe<Scalars['String']>;
  /** A comma-separated list of this author's areas of specialty. */
  specialties?: Maybe<Scalars['String']>;
  /** Tagline message for the author. */
  tagline?: Maybe<Scalars['String']>;
  /** Twitter handle for the author. */
  twitter?: Maybe<Scalars['String']>;
  /** External URL for the author. */
  url?: Maybe<Scalars['URL']>;
  /** The bio that we display for an author on a roundup page. */
  roundupBio?: Maybe<Scalars['String']>;
  /** The social media links relevant to an author */
  socialMediaLinks?: Maybe<Array<AuthorSocialMediaLink>>;
};


/** The WordPress author type. */
export type AuthorAvatarUrlsArgs = {
  sizes?: InputMaybe<Array<AvatarSizeEnum>>;
};

/** Avatar URL Type for authors. */
export type AuthorAvatarUrl = {
  __typename?: 'AuthorAvatarUrl';
  /** The size of the image. */
  size?: Maybe<Scalars['Int']>;
  /** The url for the image. */
  url?: Maybe<Scalars['URL']>;
};

/** Type modeling the data within the featuredIn group of fields on the Author type. */
export type AuthorFeaturedIn = {
  __typename?: 'AuthorFeaturedIn';
  /** The name of the publication, organization, etc. where the author has been featured. */
  name?: Maybe<Scalars['String']>;
  /** The URL of the publication, organization, etc. where the author was featured. */
  url?: Maybe<Scalars['URL']>;
};

/** The input for retrieving a single author. */
export type AuthorItemInput = {
  /** The WordPress ID for the Author. */
  identifier: Scalars['ID'];
};

export type AuthorPage = StructuredContentPageInterface & {
  __typename?: 'AuthorPage';
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID'];
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
};

/**
 * A social media link related to an author
 * Includes a type, a displayable name, and a URL to the social media
 */
export type AuthorSocialMediaLink = {
  __typename?: 'AuthorSocialMediaLink';
  /** The type of social media link. */
  type: AuthorSocialMediaLinkTypeEnum;
  /** Displayable name for social media link. */
  name: Scalars['String'];
  /** URL for social media link. */
  url: Scalars['String'];
};

export enum AuthorSocialMediaLinkTypeEnum {
  Twitter = 'twitter',
  Email = 'email',
  Facebook = 'facebook',
  Linkedin = 'linkedin'
}

export type AutoInsuranceCarrier = {
  __typename?: 'AutoInsuranceCarrier';
  /** An Insurance offer */
  marketplaceOffer?: Maybe<InsuranceOfferV2>;
  /** Name of a carrier */
  carrierName?: Maybe<Scalars['String']>;
  /** Carrier's annual premium */
  annualPremium?: Maybe<Scalars['Float']>;
};

export type AutoInsuranceCitySummary = {
  __typename?: 'AutoInsuranceCitySummary';
  /** US city name */
  cityName: Scalars['String'];
  /** US state name */
  stateName: Scalars['String'];
  /** US two-letter state abbreviation */
  stateCode: StateCodeEnum;
  /** Average insurance annual premium across a city */
  avgForCity?: Maybe<Scalars['Float']>;
  /** Average insurance annual premium across a state */
  avgForState: Scalars['Float'];
  /** Average insurance annual with minimum coverage across a state */
  minimumCoverageAvgForState: Scalars['Float'];
  /** Array of average annual premium by zipCode within a city */
  avgByZipCode?: Maybe<Array<AnnualPremiumByZipCode>>;
  /** Array of cheapest companies and annual premiums within a city */
  avgByCarrier?: Maybe<Array<AutoInsuranceCarrier>>;
  /** Array of cheapest companies and annual premiums for drivers with poor credit score within a city */
  cheapestForPoorCredit?: Maybe<Array<AutoInsuranceCarrier>>;
  /** Array of cheapest companies and annual premiums for drivers with good credit score within a city */
  cheapestForGoodCredit?: Maybe<Array<AutoInsuranceCarrier>>;
  /** Array of cheapest companies and annual premiums for drivers with excellent credit score within a city */
  cheapestForExcellentCredit?: Maybe<Array<AutoInsuranceCarrier>>;
  /** Array of cheapest companies and annual premiums for a driver at age 20 within a city */
  cheapestFor20YearOlds?: Maybe<Array<AutoInsuranceCarrier>>;
  /** Array of cheapest companies and annual premiums for a driver at age 35 within a city */
  cheapestFor35YearOlds?: Maybe<Array<AutoInsuranceCarrier>>;
  /** Array of cheapest companies and annual premiums for a driver at age 60 within a city */
  cheapestFor60YearOlds?: Maybe<Array<AutoInsuranceCarrier>>;
  /** Array of cheapest companies and annual premiums for a clean driving record within a city */
  cheapestWithCleanRecord?: Maybe<Array<AutoInsuranceCarrier>>;
  /** Array of cheapest companies and annual premiums for a Dui record within a city */
  cheapestWithDui?: Maybe<Array<AutoInsuranceCarrier>>;
  /** Array of cheapest companies and annual premiums for an At Fault record within a city */
  cheapestWithAtFaultAccident?: Maybe<Array<AutoInsuranceCarrier>>;
};

/** Particular prequal job with it's offers populated */
export type AutoInsuranceJobWithOffers = {
  __typename?: 'AutoInsuranceJobWithOffers';
  status?: Maybe<PrequalOfferStatus>;
  offers?: Maybe<Array<InsuranceOfferV2>>;
  job?: Maybe<PrequalJob>;
};

export type AutoInsurancePage = StructuredContentPageInterface & {
  __typename?: 'AutoInsurancePage';
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID'];
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
};

/** Auto Insurance Prequal Offer */
export type AutoInsurancePrequalOffer = PrequalOffer & {
  __typename?: 'AutoInsurancePrequalOffer';
  applyLink: Scalars['String'];
  institutionName: Scalars['String'];
  institutionLogo: Scalars['String'];
  nwRating?: Maybe<Scalars['Float']>;
  providerId?: Maybe<Scalars['ID']>;
  /** The marketplace institution id for the offer */
  institutionId: Scalars['ID'];
  /** offerId indicates the corresponding marketplace id for the offer */
  offerId: Scalars['ID'];
  /** The marketplace product id for the offer */
  productId: Scalars['ID'];
  /** rank tells the client what order the offers should be shown */
  rank: Scalars['Int'];
  /** prosBullets is a list of advantages this offer provides, */
  prosBullets?: Maybe<Array<Scalars['String']>>;
  /** consBullets is a list of disadvantages this offer provides, */
  consBullets?: Maybe<Array<Scalars['String']>>;
  /** reviewLink is the URL to the NerdWallet review of this offer */
  reviewLink?: Maybe<Scalars['URL']>;
};

/** Query variables for AutoInsurancePrequalOffers */
export type AutoInsurancePrequalOfferInput = {
  zipCode: Scalars['String'];
  age?: InputMaybe<Scalars['Int']>;
  creditScoreRange?: InputMaybe<QuinStreetCreditScoreRangeEnum>;
  /** currentInsurer is a string defined by QuinStreet that will be validated on the unified prequal service */
  currentInsurer?: InputMaybe<Scalars['String']>;
  isHomeOwner?: InputMaybe<Scalars['Boolean']>;
  isMarried?: InputMaybe<Scalars['Boolean']>;
  isVeteran?: InputMaybe<Scalars['Boolean']>;
  isGoodDriver?: InputMaybe<Scalars['Boolean']>;
  /** pricingCode is QuinStreet's way of identifying the purpose of the request */
  pricingCode?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<PrequalUserNameInput>;
  contactAddress?: InputMaybe<PrequalUserAddressInput>;
  email?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  gender?: InputMaybe<GenderEnum>;
  requiresSr22?: InputMaybe<Scalars['Boolean']>;
  licenseStatus?: InputMaybe<LicenseStatusEnum>;
  vehicles?: InputMaybe<Array<AutoInsuranceVehicleInput>>;
  vehiclesCount?: InputMaybe<Scalars['Int']>;
  driversCount?: InputMaybe<Scalars['Int']>;
  continuousCoverageMonths?: InputMaybe<Scalars['Int']>;
  hasHadDui?: InputMaybe<Scalars['Boolean']>;
  numRecentIncidents?: InputMaybe<Scalars['Int']>;
  inventoryType?: InputMaybe<Scalars['String']>;
  qsClickKey?: InputMaybe<Scalars['String']>;
};

/** Format of response to autoInsurancePrequalOffers (v2) query */
export type AutoInsurancePrequalOffersJobResponse = {
  __typename?: 'AutoInsurancePrequalOffersJobResponse';
  status?: Maybe<PrequalOfferStatus>;
  jobs?: Maybe<Array<PrequalJob>>;
};

/** Format of response to autoInsurancePrequalOffers query */
export type AutoInsurancePrequalOffersResponse = {
  __typename?: 'autoInsurancePrequalOffersResponse';
  status?: Maybe<PrequalOfferStatus>;
  offers?: Maybe<Array<Maybe<AutoInsurancePrequalOffer>>>;
};

/** Format of response to autoInsurancePrequalOffers (v2) offers */
export type AutoInsurancePrequalOffersResponseV2 = {
  __typename?: 'AutoInsurancePrequalOffersResponseV2';
  jobs?: Maybe<Array<AutoInsuranceJobWithOffers>>;
};

/** Enum of providerIds that are accepted by the auto insurance offers route */
export enum AutoInsuranceProviderId {
  Mock = 'MOCK',
  Quinstreet = 'QUINSTREET'
}

/** Input for Vehicle Information: Year, Make, Model */
export type AutoInsuranceVehicleInput = {
  year?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
};

export type AutoInsuranceVehicleSummary = {
  __typename?: 'AutoInsuranceVehicleSummary';
  /** The make of a vehicle */
  make?: Maybe<Scalars['String']>;
  /** The model of a vehicle */
  model?: Maybe<Scalars['String']>;
  /** Array of years with average for each year */
  avgForModelYear?: Maybe<Array<VehiclePremiumByYear>>;
  /** Array of years for the vehicle, each with cheapest premiums */
  cheapestRatesByModelYear?: Maybe<Array<VehicleYearCheapestPremiums>>;
  /** Other models for this make */
  otherModels?: Maybe<Array<VehicleModel>>;
};

/** A Auto Loans institution */
export type AutoLoansInstitutionV2 = MarketplaceEntityInterface & MarketplaceInstitutionInterface & {
  __typename?: 'AutoLoansInstitutionV2';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** A URL that points to the logo for the institution */
  imageSource?: Maybe<Scalars['URL']>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

/** A Auto Loans offer */
export type AutoLoansOfferV2 = MarketplaceEntityInterface & MarketplaceEntityWithBestOfAwardsInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithQualificationsInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceOfferInterface & {
  __typename?: 'AutoLoansOfferV2';
  /** Redirect link for this Offer */
  applyLink?: Maybe<Scalars['URL']>;
  /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  consBullets?: Maybe<Array<Scalars['String']>>;
  /** The display name for the entity (auto-generated) */
  displayName?: Maybe<Scalars['String']>;
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /** Whether this Offer is monetizing. Client apps use this field to decide display behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA */
  isMonetizing?: Maybe<Scalars['Boolean']>;
  /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
  monetizable: Scalars['String'];
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  product: AutoLoansProductV2;
  /** Product type */
  productType: Scalars['String'];
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  prosBullets?: Maybe<Array<Scalars['String']>>;
  /** List of qualifications for the offer */
  qualificationsBullets?: Maybe<Array<Scalars['String']>>;
  /** The URL to the NerdWallet review of this offer. */
  reviewLink?: Maybe<Scalars['URL']>;
  /** The overall editorial rating for this offer */
  starRating?: Maybe<Scalars['Float']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  tagline?: Maybe<Scalars['String']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The Best Of Awards that this offer has won */
  bestOfAwards?: Maybe<Array<BestOfAward>>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The driver estimated apr associated with the entity */
  driverEstimatedApr?: Maybe<EntityPlacementDriver>;
  /** The driver loan amount associated with the entity */
  driverLoanAmount?: Maybe<EntityPlacementDriver>;
  /** The driver min credit score associated with the entity */
  driverMinCreditScore?: Maybe<EntityPlacementDriver>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /**
   * The drivers associated with the entity
   * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
   */
  placementDrivers: Array<EntityPlacementDriver>;
  /** A boolean indicating if the display name should be shown in the comparison table component */
  showNameInComparisonTable: Scalars['Boolean'];
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']>;
  /** Flag for whether to use the large product card image styles */
  useLargeImageFootprint: Scalars['Boolean'];
};

/** A Auto Loans product */
export type AutoLoansProductV2 = MarketplaceEntityInterface & MarketplaceProductInterface & {
  __typename?: 'AutoLoansProductV2';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  institution: AutoLoansInstitutionV2;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

/** The list of avatar sizes available to choose from. */
export enum AvatarSizeEnum {
  Size_24 = 'SIZE_24',
  Size_48 = 'SIZE_48',
  Size_96 = 'SIZE_96'
}

/** A Banking institution */
export type BankingInstitutionV2 = MarketplaceEntityInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceInstitutionInterface & {
  __typename?: 'BankingInstitutionV2';
  /** The display name for the entity. */
  displayName?: Maybe<Scalars['String']>;
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** A URL that points to the logo for the institution */
  imageSource?: Maybe<Scalars['URL']>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** The editorial rating on the banking experience for the institution. */
  ratingBankExperience?: Maybe<Scalars['Float']>;
  /** The editorial rating on overdraft fees for the institution. */
  ratingOverdraftFee?: Maybe<Scalars['Float']>;
  /** The URL to the NerdWallet review of this institution. */
  reviewLink?: Maybe<Scalars['URL']>;
  /** The overall, editorial rating for the institution. */
  starRating?: Maybe<Scalars['Float']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /** Monetizable status that conforms to one of the values defined by NerdWallet analytics */
  monetizable: Scalars['String'];
  /** The Banking Offer to use for related apply links (filtered based on monetizable status and geotargeting) */
  offerForCta?: Maybe<BankingOfferV2>;
  /**
   * The drivers associated with the entity
   * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
   */
  placementDrivers: Array<EntityPlacementDriver>;
  /** A boolean indicating if the display name should be shown in the comparison table component */
  showNameInComparisonTable: Scalars['Boolean'];
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']>;
  /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
  /** Flag for whether to use the large product card image styles */
  useLargeImageFootprint: Scalars['Boolean'];
};


/** A Banking institution */
export type BankingInstitutionV2OfferForCtaArgs = {
  userState?: InputMaybe<StateAbbreviationsEnum>;
};

/** A Banking offer */
export type BankingOfferV2 = MarketplaceEntityInterface & MarketplaceEntityWithBestOfAwards2021Interface & MarketplaceEntityWithBestOfAwardsInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceOfferInterface & {
  __typename?: 'BankingOfferV2';
  /** The additional details of an offer that are rendered in the 'See details' dropdown of an offer card.  The account details are typically a mix of promotions, disclaimers, and high level summaries of the offer */
  accountDetails?: Maybe<Array<Scalars['String']>>;
  /** Redirect link for this Offer */
  applyLink?: Maybe<Scalars['URL']>;
  apy?: Maybe<Scalars['Float']>;
  apyAnnotation?: Maybe<Scalars['String']>;
  /** Information about limitations or constraints of ATM access whether free or not. */
  atmAccessDetails?: Maybe<Scalars['String']>;
  balanceToAvoidFees?: Maybe<Scalars['Float']>;
  /** List of the benefits associated with a given banking offer */
  benefits?: Maybe<Array<Scalars['String']>>;
  /** The list of NW Best-Of Awards this offer has won for 2021 */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']>>;
  bonusDetails?: Maybe<Scalars['String']>;
  /** The CD deposit term for a CD banking offer in days. */
  cdDepositTerm?: Maybe<Scalars['Int']>;
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  consBullets?: Maybe<Array<Scalars['String']>>;
  /** APY formatted for display in clients, with 2 decimal places and % symbol */
  displayApy?: Maybe<Scalars['String']>;
  /** The display name for the entity */
  displayName?: Maybe<Scalars['String']>;
  /** The array of display pages */
  displayPages?: Maybe<Array<Scalars['String']>>;
  /** Entity type */
  entityType: Scalars['String'];
  feeAtm?: Maybe<Scalars['Float']>;
  feeEarlyClosure?: Maybe<Scalars['Float']>;
  feeMonthly?: Maybe<Scalars['Float']>;
  /** Holds the monthly fee sub copy such as 'Waived with one transaction per month' */
  feeMonthlySubCopy?: Maybe<Scalars['String']>;
  feeOverdraft?: Maybe<Scalars['Float']>;
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** The URL for the logo */
  imageSource?: Maybe<Scalars['URL']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /** Calculates if this offer is monetizing for a specific user (after taking throttling into account) */
  isMonetizing?: Maybe<Scalars['Boolean']>;
  /** Minimum deposit needed to open an account. */
  minOpeningDeposit?: Maybe<Scalars['Float']>;
  /** Monetizable status that conforms to one of the values defined by NerdWallet analytics */
  monetizable: Scalars['String'];
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  product: BankingProductV2;
  /** Product type */
  productType: Scalars['String'];
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  prosBullets?: Maybe<Array<Scalars['String']>>;
  /** The URL to the NerdWallet review of this offer's institution */
  reviewLink?: Maybe<Scalars['URL']>;
  /** The slug associated with the product */
  slug?: Maybe<Scalars['String']>;
  /** The overall editorial rating for this Offer. */
  starRating?: Maybe<Scalars['Float']>;
  /** State(s) where offer is available. If no states are specified, we will consider the offer to be nationally available */
  states?: Maybe<Array<StateAbbreviationsEnum>>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** String representing a product's subtype */
  subProductType?: Maybe<Scalars['String']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The Best Of Awards that this offer has won */
  bestOfAwards?: Maybe<Array<BestOfAward>>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The driver apy associated with the entity */
  driverApy?: Maybe<EntityPlacementDriver>;
  /** The driver bonus associated with the entity */
  driverBonus?: Maybe<EntityPlacementDriver>;
  /** The driver minimum balance associated with the entity */
  driverMinimumBalance?: Maybe<EntityPlacementDriver>;
  /** The driver monthly fee associated with the entity */
  driverMonthlyFee?: Maybe<EntityPlacementDriver>;
  /** The driver overdraft star rating associated with the entity */
  driverOverdraftStarRating?: Maybe<EntityPlacementDriver>;
  /** The annotation for the agency that federally insures the institution */
  federallyInsuredAnnotation?: Maybe<Scalars['String']>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /**
   * The drivers associated with the entity
   * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
   */
  placementDrivers: Array<EntityPlacementDriver>;
  /** The drivers for the entity in non structured content format */
  rawDrivers: Array<RawDriver>;
  /** A boolean indicating if the display name should be shown in the comparison table component */
  showNameInComparisonTable: Scalars['Boolean'];
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
  /** Human readable string describing a product's subtype */
  subProductTypeLabel?: Maybe<Scalars['String']>;
  /** Flag for whether to use the large product card image styles */
  useLargeImageFootprint: Scalars['Boolean'];
};


/** A Banking offer */
export type BankingOfferV2RawDriversArgs = {
  minAccountBalance?: InputMaybe<Scalars['Int']>;
};

/** A Banking product */
export type BankingProductV2 = MarketplaceEntityInterface & MarketplaceProductInterface & {
  __typename?: 'BankingProductV2';
  /** Indicates whether wire transfers are offered by the bank account. */
  allowsWireTransfers?: Maybe<Scalars['Boolean']>;
  /** Entity type */
  entityType: Scalars['String'];
  /** Indicates whether bank charges a fee for depositing cash. */
  freeCashDeposits?: Maybe<Scalars['Boolean']>;
  /** Information about limitations or constraints of Cash Deposits whether free or not. */
  freeCashDepositsDetails?: Maybe<Scalars['String']>;
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  institution: BankingInstitutionV2;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** Indicates whether account holders can execute an unlimited amount of transactions per month. */
  unlimitedTransactions?: Maybe<Scalars['Boolean']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
  /** Additional information about wire transfers (e.g. the incurred fees). */
  wireTransferDetails?: Maybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_banner post type from WordPress. */
export type Banner = PostInterface & PostWithAuthorsInterface & PostWithTitleInterface & {
  __typename?: 'Banner';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The body text for the banner. */
  body?: Maybe<Scalars['StructuredContentDocument']>;
  /** The button text for the banner. */
  buttonText?: Maybe<Scalars['String']>;
  /** The url for the button in the banner. */
  buttonUrl?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']>;
  /** The headline to use for the Banner. */
  headline?: Maybe<Scalars['String']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
};


/** Type modeling the data for posts within the nw_banner post type from WordPress. */
export type BannerDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_banner post type from WordPress. */
export type BannerModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_banner post type from WordPress. */
export type BannerTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type BannerConnectionResponse = {
  __typename?: 'BannerConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The Banner returned for the connection. */
  items?: Maybe<Array<Banner>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of Banner objects. */
export type BannerFilterInput = {
  /** Limit collection to Banners published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to Banners with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
};

/** Type modeling the data for posts within the nw_bcc_page post type from WordPress. */
export type BccPage = PostInterface & PostWithAuthorsInterface & PostWithContentClassificationInterface & PostWithFaQsInterface & PostWithReviewerInterface & PostWithSeoInterface & PostWithTitleInterface & {
  __typename?: 'BccPage';
  /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
  attributionTopic?: Maybe<Scalars['String']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The Disqus thread ID for this content. */
  commentThreadId?: Maybe<Scalars['Int']>;
  /** Additional content clusters for this piece of content. */
  contentClusters?: Maybe<Array<Scalars['String']>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']>;
  /** Editorial content for the page. */
  editorialLearnContent?: Maybe<Scalars['StructuredContentDocument']>;
  /** The faqs to display on this piece of content. */
  faqs?: Maybe<Array<ContentFaq>>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']>;
  /** The primary content cluster for this piece of content. */
  primaryContentCluster?: Maybe<Scalars['String']>;
  /** The Reviewers that this BccPage has been reviewed by. */
  reviewedBy?: Maybe<Array<ContentReviewer>>;
  sections?: Maybe<Array<BccPageSection>>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** Whether or not to display the FAQ's. */
  showFaqs?: Maybe<Scalars['Boolean']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']>>;
  /** The aggregate list of all section categories. */
  imageForBccArticleSchema?: Maybe<Scalars['String']>;
  sectionCategories: Array<BccPageSectionCategory>;
  summarySectionOffers: Array<BccPagePreferredSection>;
};


/** Type modeling the data for posts within the nw_bcc_page post type from WordPress. */
export type BccPageDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_bcc_page post type from WordPress. */
export type BccPageModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_bcc_page post type from WordPress. */
export type BccPageTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_bcc_page_card post type from WordPress. */
export type BccPageCard = PostInterface & PostWithAuthorsInterface & PostWithTitleInterface & {
  __typename?: 'BccPageCard';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The bottom line text to display for the card. */
  bottomLine?: Maybe<Scalars['StructuredContentDocument']>;
  /** The Marketplace entity UUID. */
  cardEntity?: Maybe<MarketplaceEntityInterface>;
  /** The Marketplace entity UUID. */
  cardId?: Maybe<Scalars['String']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The description text for the card. */
  description?: Maybe<Scalars['String']>;
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The summary table text to display for the card. */
  summaryTableText?: Maybe<Scalars['StructuredContentDocument']>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
  /** The credit card offer data for the BccPageCard */
  creditCardOffer?: Maybe<CreditCardsOfferV2>;
  /**
   * Classic drivers associated with the entity, such as APR, that can be used in any context
   * @deprecated Consumers should specify their desired drivers via CreditCardsOfferV2. See the RFC on Placement Drivers for more info.
   */
  classicDrivers: Array<EntityPlacementDriver>;
  /**
   * Drivers associated with the entity that can be used within a rewards related context
   * @deprecated Consumers should specify their desired drivers via CreditCardsOfferV2. See the RFC on Placement Drivers for more info.
   */
  rewardsDrivers: Array<EntityPlacementDriver>;
  /** Summary text for credit card for display in MORE ABOUT THE CARDS FEATURED ON THIS PAGE of BCC */
  summaryTableContent?: Maybe<Scalars['StructuredContentDocument']>;
};


/** Type modeling the data for posts within the nw_bcc_page_card post type from WordPress. */
export type BccPageCardDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_bcc_page_card post type from WordPress. */
export type BccPageCardModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_bcc_page_card post type from WordPress. */
export type BccPageCardTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type BccPageCardConnectionResponse = {
  __typename?: 'BccPageCardConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The BccPageCard returned for the connection. */
  items?: Maybe<Array<BccPageCard>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of BccPageCard objects. */
export type BccPageCardFilterInput = {
  /** Limit collection to BccPageCards published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to BccPageCards with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to BccPageCards with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type BccPageConnectionResponse = {
  __typename?: 'BccPageConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The BccPage returned for the connection. */
  items?: Maybe<Array<BccPage>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of BccPage objects. */
export type BccPageFilterInput = {
  /** Limit collection to BccPages published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit results to those with the specified cluster. */
  cluster?: InputMaybe<Scalars['String']>;
  /** Limit collection to BccPages with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit results to those with the specified Reviewer, filtered by ID. */
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Limit collection to BccPages with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

export type BccPagePreferredSection = {
  __typename?: 'BccPagePreferredSection';
  /** The BccPage section */
  section: BccPageSection;
  /** The preferred offer for the attached section */
  sectionOffer: Scalars['String'];
};

/** Type modeling the data within the sections group of fields on the BccPage type. */
export type BccPageSection = {
  __typename?: 'BccPageSection';
  /** Cards to display within this section of the BCC page. */
  cards?: Maybe<Array<BccPageCard>>;
  /** Unique identifier for distinguishing between sections on the front-end. */
  identifier?: Maybe<Scalars['String']>;
  /** Short title text for the current section. */
  shortTitle?: Maybe<Scalars['String']>;
  /** Title of the current section. */
  title?: Maybe<Scalars['String']>;
  /**
   * The Best Credit Cards page drivers for the section based on the identifier,
   * will optionally accept the category to return that category's drivers. We don't want this on the card
   * because it would be difficult to distinguish query wise for each card.
   */
  cardsDrivers?: Maybe<Array<BccPageSectionDriver>>;
  /**
   * The credit card offer data for the BccPageCard
   * @deprecated Consumers should specify their desired drivers. See the RFC on Placement Drivers for more info.
   */
  driversCategory: BccPageSectionDriversEnum;
};


/** Type modeling the data within the sections group of fields on the BccPage type. */
export type BccPageSectionCardsDriversArgs = {
  category?: InputMaybe<Scalars['String']>;
};

export type BccPageSectionCategory = {
  __typename?: 'BccPageSectionCategory';
  /** The camel-case identifier that uniquely identifies a section category. */
  identifier: Scalars['String'];
  /** The readable title for a given section category. */
  shortTitle: Scalars['String'];
};

export type BccPageSectionDriver = {
  __typename?: 'BccPageSectionDriver';
  /** @deprecated Consumers should specify their desired drivers. See the RFC on Placement Drivers for more info. */
  drivers?: Maybe<Array<EntityPlacementDriver>>;
  id: Scalars['ID'];
  identifier?: Maybe<Scalars['String']>;
};

/** BccPageSectionDriversEnum represents the mobile type of drivers to display for the cards categorized under this section */
export enum BccPageSectionDriversEnum {
  /** Indicates to display classic drivers such as APR */
  Classic = 'CLASSIC',
  /** Indicates to display reward related drivers such as Reward Rate */
  Rewards = 'REWARDS'
}

/**
 * DEPRECATED: Should not be used outside of SavedPersonalLoansPrequalOffers.
 * Response that provides which prequal offers are "best bets" offers.
 */
export type BestBetsOffersResponse = {
  __typename?: 'BestBetsOffersResponse';
  /** Lowest APR best bets offer */
  lowestApr?: Maybe<PrequalPersonalLoansApiOffer>;
  /** Lowest monthly payment best bets offer */
  lowestMonthlyPayment?: Maybe<PrequalPersonalLoansApiOffer>;
};

export type BestOfAward = {
  __typename?: 'BestOfAward';
  /** The year in which the offer won */
  year: Scalars['Int'];
  /** The category in which the offer won */
  category: Scalars['String'];
};

/** Type modeling the data for posts within the nw_block post type from WordPress. */
export type Block = PostInterface & PostWithAuthorsInterface & PostWithContentInterface & PostWithTitleInterface & {
  __typename?: 'Block';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the Block object. */
  categories?: Maybe<Array<Category>>;
  /** The structured content for the resource. */
  content?: Maybe<Scalars['StructuredContentDocument']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** Whether or not the Block's content is inline compatible. */
  inlineCompatible?: Maybe<Scalars['Boolean']>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
};


/** Type modeling the data for posts within the nw_block post type from WordPress. */
export type BlockDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_block post type from WordPress. */
export type BlockModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_block post type from WordPress. */
export type BlockTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type BlockConnectionResponse = {
  __typename?: 'BlockConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The Block returned for the connection. */
  items?: Maybe<Array<Block>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of Block objects. */
export type BlockFilterInput = {
  /** Limit collection to Blocks published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to Blocks within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']>>;
  /** Limit collection to Blocks with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to Blocks with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

/** Type modeling the data for posts within the nw_block_group post type from WordPress. */
export type BlockGroup = PostInterface & PostWithAuthorsInterface & PostWithTitleInterface & {
  __typename?: 'BlockGroup';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the BlockGroup object. */
  categories?: Maybe<Array<Category>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
  blocks?: Maybe<Array<Maybe<CombinedBlockGroupBlock>>>;
};


/** Type modeling the data for posts within the nw_block_group post type from WordPress. */
export type BlockGroupDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_block_group post type from WordPress. */
export type BlockGroupModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_block_group post type from WordPress. */
export type BlockGroupTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type BlockGroupConnectionResponse = {
  __typename?: 'BlockGroupConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The BlockGroup returned for the connection. */
  items?: Maybe<Array<BlockGroup>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of BlockGroup objects. */
export type BlockGroupFilterInput = {
  /** Limit collection to BlockGroups published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to BlockGroups within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']>>;
  /** Limit collection to BlockGroups with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to BlockGroups with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

/** Breadcrumb to be used by global-nav */
export type Breadcrumb = {
  __typename?: 'Breadcrumb';
  slug?: Maybe<Scalars['String']>;
  page?: Maybe<BreadcrumbPage>;
};

/** Breadcrumb Page object with a title */
export type BreadcrumbPage = {
  __typename?: 'BreadcrumbPage';
  title: Scalars['String'];
};

export type BuildSpec = {
  __typename?: 'BuildSpec';
  /** The name of the build spec, e.g. "NodeSpec" */
  name: Scalars['String'];
  /** The TARGET file of the spec, e.g. "package.json" */
  target: Scalars['String'];
};

export type BulkActionInput = {
  /** The IDs visible to the user. */
  track: Array<Scalars['ID']>;
  /** The ID before which to perform the action (inclusive). */
  beforeInclusive?: InputMaybe<Scalars['ID']>;
};

export type BulkActionResponse = {
  __typename?: 'BulkActionResponse';
  /** The updated number of unread notifications for the user. */
  unreadCount: Scalars['Int'];
  /** The updated state of notifications visible to the user. */
  items: Array<Notification>;
};

export type BulkDismissResponse = {
  __typename?: 'BulkDismissResponse';
  /** The updated number of unread notifications for the user. */
  unreadCount: Scalars['Int'];
  /** The operation id associated with the request. */
  operationId: Scalars['String'];
  /** The updated state of notifications visible to the user. */
  items: Array<Notification>;
};

/** Controls whether the response is cacheable by clients and shared (proxy) caches. PRIVATE by default. */
export enum CacheControlScope {
  Public = 'PUBLIC',
  Private = 'PRIVATE'
}

export type CanonicalInstitution = {
  __typename?: 'CanonicalInstitution';
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
  /**
   * The NerdWallet-maintained url for the square logo of the institution, if we have it
   *
   * Example: `https://www.nerdwallet.com/cdn/financial-institutions/american-express/amex_logo_square%404x.png`
   */
  squareLogoUrl?: Maybe<Scalars['String']>;
  /**
   * The NerdWallet-maintained list of lowercase synonyms for how this institution may show up on a TU credit report
   *
   * Example: [`amex`, `american express`]
   */
  tuCreditorSynonyms?: Maybe<Array<Scalars['String']>>;
  /**
   * The NerdWallet-maintained mapping to a yodlee provider id
   *
   * Example: `175e9916-0ca9-4e32-ac2b-56f0c7e70196`
   */
  yodleeProviderId?: Maybe<Scalars['String']>;
};

export type CanonicalInstitutionsResponse = {
  __typename?: 'CanonicalInstitutionsResponse';
  /** The total number of institutions that match your query. */
  total: Scalars['Int'];
  /** The list of institutions that match your query */
  institutions: Array<CanonicalInstitution>;
  /** How many top results are excluded from this result set (for pagination) */
  offset: Scalars['Int'];
};

export type CardImageDetails = {
  __typename?: 'CardImageDetails';
  /** Determines if the card image is a portrait or not */
  isPortrait: Scalars['Boolean'];
  /** Card image sources from small to large */
  source: Scalars['String'];
  sourceMedium: Scalars['String'];
  sourceLarge?: Maybe<Scalars['String']>;
};

export type Carrier = {
  __typename?: 'Carrier';
  /** Unique ID of a Carrier */
  id: Scalars['ID'];
  /** Name of a Carrier */
  carrierName: Scalars['String'];
  /** average insurance price */
  avgCost: Scalars['Float'];
  /** average insurance cost for a driver with a DUI history */
  withDUI: Scalars['Float'];
  /** average insurance cost for a driver with a ACCIDENT history */
  withAccident: Scalars['Float'];
  /** average insurance cost for a good driver (no ACCIDENT or DUI history) */
  withGoodDriver: Scalars['Float'];
  /** average insurance cost for a good and poor credit score */
  byCreditRange: CreditRangeMap;
  /** average insurance cost based on driver's age */
  byAgeRange: AgeRangeMap;
  /** Carrier selected by Nerdwallet to feature as best car insurance companies for 2021 */
  best2021: Scalars['Boolean'];
};

export type CashFlowActivationStatusResponse = MembershipFeatureActivationStatusInterface & {
  __typename?: 'CashFlowActivationStatusResponse';
  id: MembershipFeatureEnum;
  status: MembershipFeatureActivationStatusEnum;
};

export type CashFlowBreakdown = {
  __typename?: 'CashFlowBreakdown';
  /** The amount spent in dollars and cents. */
  spending: Scalars['Float'];
  /**
   * The user's estimated income for the month in dollars. Income is estimated
   * based on user self-reported values or if that is not provided, then based
   * on transactions in the income category.
   */
  estimatedIncome: Scalars['Float'];
  /** The total sum amount of payments needed to cover bills due over the rest of the month, in dollars and cents. */
  upcomingBillsTotalDue: Scalars['Float'];
  /**
   * Computed as (estimated income - spending - upcomingBillsTotalDue).
   * Note: this value can be negative
   */
  remaining: Scalars['Float'];
};

export type CashFlowHistoryBreakdown = {
  __typename?: 'CashFlowHistoryBreakdown';
  /** Month by month breakdown of historical cash flow, current month included */
  cashFlowHistoryBreakdown: Array<CashFlowHistoryMonthlyBreakdownDatum>;
  /**
   * The average of the 'remaining' fields in the breakdown, current month NOT included
   * A positive number means, on average, the user has saved more than they have spent.
   */
  averageSavingsRemaining?: Maybe<Scalars['Float']>;
};

export type CashFlowHistoryMonthlyBreakdownDatum = {
  __typename?: 'CashFlowHistoryMonthlyBreakdownDatum';
  /** A date in the month that this datum represents */
  date: Scalars['Date'];
  /** The amount spent in dollars and cents. */
  spending: Scalars['Float'];
  /**
   * The user's actual earning for the month, in dollars. Earning is credits minus
   * debits in the income category. Estimated income is based on user self-reported values
   * or if that is not provided, then based on transactions in the income category.
   */
  earning: Scalars['Float'];
  /**
   * The user's estimated income for the month, in dollars. It is only present for
   * the current month. Estimated income is based on user self-reported values or
   * if that is not provided, then based on transactions in the income category.
   */
  estimatedIncome?: Maybe<Scalars['Float']>;
  /**
   * The total sum amount of payments needed to cover bills due over the rest of the month, in dollars and cents.
   * Note: this value is only present for the currentMonth (otherwise there are no upcoming bills)
   */
  upcomingBills?: Maybe<Scalars['Float']>;
  /**
   * Computed as ((earnings or estimatedIncome) - spending - upcomingBills (if any)).
   * Note: this value can be negative
   */
  remaining: Scalars['Float'];
};

export type CashFlowTakeaway = {
  __typename?: 'CashFlowTakeaway';
  /** A label describing the takeaway (user facing). */
  label?: Maybe<Scalars['String']>;
  /** The body of the takeaway - describes the takeaway for the user in more detail (user facing). */
  body: Scalars['String'];
  /** A string that describes the type of takeaway (e.g. ONBOARDING) (used for analytics). */
  theme?: Maybe<Scalars['String']>;
  /** A string that can further describe the type within the larger theme of the takeaway (used for analytics). */
  subtheme?: Maybe<Scalars['String']>;
  /** A string representing the takeaway name (used for analytics) */
  takeaway?: Maybe<Scalars['String']>;
  /**
   * Describes the sentiment of the takeaway and further helps distinguish when theme/subtheme are the same
   * (e.g. POSITIVE) (used for analytics).
   */
  condition?: Maybe<Scalars['String']>;
  /**
   * A list of actions that the user can take related to this takeaway. These usually represent
   * links to another page or screen so the user can dig into the details of the takeaway. There's usually
   * 1 action per takeaway (but this is not a requirement).
   */
  actions: Array<AppAction>;
};

/** Type modeling the data for terms within the category taxonomy from WordPress. */
export type Category = TermInterface & {
  __typename?: 'Category';
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The banner to display at the top of content within this category. */
  defaultBanner?: Maybe<Banner>;
  /** The default Block Group to use in the "Below Content" section for content in this category. */
  defaultBelowContent?: Maybe<BlockGroup>;
  /** The default House Ad to use for content in this category. */
  defaultHouseAd?: Maybe<HouseAd>;
  /** The default Block Group to use in the "Next Steps" section for content in this category. */
  defaultNextSteps?: Maybe<BlockGroup>;
  /** The default Block Group to use in the "Related Links" section for content in this category. */
  defaultRelatedLinks?: Maybe<BlockGroup>;
  /** The default Block Group to use as the sidebar for content in this category. */
  defaultSidebar?: Maybe<BlockGroup>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** The WordPress front end URL for this resource. */
  link: Scalars['URL'];
  /** The name of the term. */
  name?: Maybe<Scalars['String']>;
  /** The Category object for the parent of this entity. */
  parent?: Maybe<Category>;
  /** The slug for the term. */
  slug?: Maybe<Scalars['String']>;
  /** The taxonomy the term is in. */
  taxonomy: Scalars['String'];
};

export type ClientEligibilityConfig = {
  __typename?: 'ClientEligibilityConfig';
  /** The minimum native app version required to be eligible for this user insight */
  minNativeAppVersion?: Maybe<Scalars['String']>;
  /** The list of native app versions to block for this user insight */
  blocklistedNativeAppVersions?: Maybe<Array<Scalars['String']>>;
};

export type CombinedBlockGroupBlock = {
  __typename?: 'CombinedBlockGroupBlock';
  type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['JSON']>;
};

export type CompareAutoInsuranceCarriers = {
  __typename?: 'CompareAutoInsuranceCarriers';
  /** Name of State */
  usState: Scalars['String'];
  /** Array of carriers */
  carriers: Array<Carrier>;
};

/** Describes the details of a comparison table column */
export type ComparisonTableColumnDetails = {
  __typename?: 'ComparisonTableColumnDetails';
  /** The tracking params that should be appended to this column's marketplace entity's CTA */
  ctaTrackingParams?: Maybe<Array<TrackingParam>>;
  /** The drivers to display for this column */
  drivers?: Maybe<Array<EntityPlacementDriver>>;
  /** Whether or not the column contains the primary entity */
  isPrimaryEntity: Scalars['Boolean'];
  /** The marketplace entity associated with this column */
  marketplaceEntity: MarketplaceEntityInterface;
};


/** Describes the details of a comparison table column */
export type ComparisonTableColumnDetailsCtaTrackingParamsArgs = {
  utmCampaign?: InputMaybe<Scalars['String']>;
  sourceUrl?: InputMaybe<Scalars['String']>;
};

/** Describes the details of the comparison table */
export type ComparisonTableDetails = {
  __typename?: 'ComparisonTableDetails';
  /** Data used for rendering the columns of the comparison table */
  columns?: Maybe<Array<ComparisonTableColumnDetails>>;
  /** Whether or not the comparison table should include compare rates */
  hasCompareRates: Scalars['Boolean'];
  /** The header text for the comparison table */
  heading?: Maybe<Scalars['String']>;
};

export enum ComparisonTableLocationEnum {
  AboveFullReview = 'ABOVE_FULL_REVIEW',
  PageBottom = 'PAGE_BOTTOM',
  ReviewContentSections = 'REVIEW_CONTENT_SECTIONS'
}

export enum ContentCategory {
  Advisors = 'ADVISORS',
  AirlineCreditCards = 'AIRLINE_CREDIT_CARDS',
  AutoInsurance = 'AUTO_INSURANCE',
  AutoLoans = 'AUTO_LOANS',
  BalanceTransferCreditCards = 'BALANCE_TRANSFER_CREDIT_CARDS',
  Banking = 'BANKING',
  BankingBasics = 'BANKING_BASICS',
  BankingNews = 'BANKING_NEWS',
  BanksAndCreditUnions = 'BANKS_AND_CREDIT_UNIONS',
  BestCreditCards = 'BEST_CREDIT_CARDS',
  Bills = 'BILLS',
  BlackFriday = 'BLACK_FRIDAY',
  BlackFridayAdLeaks = 'BLACK_FRIDAY_AD_LEAKS',
  Brokers = 'BROKERS',
  BusinessCreditCards = 'BUSINESS_CREDIT_CARDS',
  Careers = 'CAREERS',
  CarInsurancEstimates = 'CAR_INSURANC_ESTIMATES',
  CashBackCreditCards = 'CASH_BACK_CREDIT_CARDS',
  Cds = 'CDS',
  CellPhones = 'CELL_PHONES',
  CheckingAccounts = 'CHECKING_ACCOUNTS',
  CollegeSavings = 'COLLEGE_SAVINGS',
  CompareCardOffers = 'COMPARE_CARD_OFFERS',
  CorporateNews = 'CORPORATE_NEWS',
  CorporateTaxRates = 'CORPORATE_TAX_RATES',
  CreditCards = 'CREDIT_CARDS',
  CreditCardBasics = 'CREDIT_CARD_BASICS',
  CreditCardData = 'CREDIT_CARD_DATA',
  CreditCardReviews = 'CREDIT_CARD_REVIEWS',
  CreditCardsAverageFairCredit = 'CREDIT_CARDS_AVERAGE_FAIR_CREDIT',
  CreditCardsBadCredit = 'CREDIT_CARDS_BAD_CREDIT',
  CreditScore = 'CREDIT_SCORE',
  DailyDeals = 'DAILY_DEALS',
  EmployeeEqutiy = 'EMPLOYEE_EQUTIY',
  EnergyGasWater = 'ENERGY_GAS_WATER',
  EnergyTaxIncentives = 'ENERGY_TAX_INCENTIVES',
  EstatePlanning = 'ESTATE_PLANNING',
  Finance = 'FINANCE',
  FinancialPlanning = 'FINANCIAL_PLANNING',
  Finanzas = 'FINANZAS',
  FindingHealthInsurance = 'FINDING_HEALTH_INSURANCE',
  FindingRightMortgage = 'FINDING_RIGHT_MORTGAGE',
  GovernmentPolicy = 'GOVERNMENT_POLICY',
  Health = 'HEALTH',
  HolidayTipsNews = 'HOLIDAY_TIPS_NEWS',
  HomeAffordability = 'HOME_AFFORDABILITY',
  Homeownership = 'HOMEOWNERSHIP',
  HomeownershipCosts = 'HOMEOWNERSHIP_COSTS',
  HomeownersInsurance = 'HOMEOWNERS_INSURANCE',
  HomeSearch = 'HOME_SEARCH',
  HowToStartABusiness = 'HOW_TO_START_A_BUSINESS',
  IncomeTaxes = 'INCOME_TAXES',
  Insurance = 'INSURANCE',
  InternetTv = 'INTERNET_TV',
  Investing = 'INVESTING',
  InvestingData = 'INVESTING_DATA',
  InvestingStrategy = 'INVESTING_STRATEGY',
  Investments = 'INVESTMENTS',
  InvestmentTaxes = 'INVESTMENT_TAXES',
  Ira = 'IRA',
  LifeInsurance = 'LIFE_INSURANCE',
  Loans = 'LOANS',
  LowInterestNoFeeCreditCards = 'LOW_INTEREST_NO_FEE_CREDIT_CARDS',
  LoyaltyPrograms = 'LOYALTY_PROGRAMS',
  MakingMoney = 'MAKING_MONEY',
  ManagingHealthInsurance = 'MANAGING_HEALTH_INSURANCE',
  ManagingMedicalBills = 'MANAGING_MEDICAL_BILLS',
  ManagingMoney = 'MANAGING_MONEY',
  ManagingYourMortgage = 'MANAGING_YOUR_MORTGAGE',
  MedicalCosts = 'MEDICAL_COSTS',
  Money = 'MONEY',
  MoneyMarketAccounts = 'MONEY_MARKET_ACCOUNTS',
  MoneyTransfer = 'MONEY_TRANSFER',
  MortgageProcess = 'MORTGAGE_PROCESS',
  MortgageRates = 'MORTGAGE_RATES',
  Mortgages = 'MORTGAGES',
  MyNerdwallet = 'MY_NERDWALLET',
  OtherRetirementAccounts = 'OTHER_RETIREMENT_ACCOUNTS',
  OtherVehicleInsurance = 'OTHER_VEHICLE_INSURANCE',
  PaydayLoans = 'PAYDAY_LOANS',
  PayingOffDebt = 'PAYING_OFF_DEBT',
  Pensions = 'PENSIONS',
  PersonalFinance = 'PERSONAL_FINANCE',
  PersonalLoans = 'PERSONAL_LOANS',
  PersonalLoansReviews = 'PERSONAL_LOANS_REVIEWS',
  PersonalTaxes = 'PERSONAL_TAXES',
  PetInsurance = 'PET_INSURANCE',
  PrepaidDebitCards = 'PREPAID_DEBIT_CARDS',
  ProductComparisons = 'PRODUCT_COMPARISONS',
  Promos = 'PROMOS',
  PropertyTaxes = 'PROPERTY_TAXES',
  RefinanceAutoLoans = 'REFINANCE_AUTO_LOANS',
  RentersInsurance = 'RENTERS_INSURANCE',
  Retirement_401K = 'RETIREMENT_401K',
  RetirementIncome = 'RETIREMENT_INCOME',
  RetirementPlanning = 'RETIREMENT_PLANNING',
  RewardOptimization = 'REWARD_OPTIMIZATION',
  RewardsCreditCards = 'REWARDS_CREDIT_CARDS',
  RothIra = 'ROTH_IRA',
  RunningYourBusiness = 'RUNNING_YOUR_BUSINESS',
  SavingsAccounts = 'SAVINGS_ACCOUNTS',
  SellingYourHome = 'SELLING_YOUR_HOME',
  Shopping = 'SHOPPING',
  ShoppingNews = 'SHOPPING_NEWS',
  ShoppingTips = 'SHOPPING_TIPS',
  SmallBusiness = 'SMALL_BUSINESS',
  SmallBusinessLegal = 'SMALL_BUSINESS_LEGAL',
  SmallBusinessLoans = 'SMALL_BUSINESS_LOANS',
  SmallBusinessTaxes = 'SMALL_BUSINESS_TAXES',
  SocialSecurity = 'SOCIAL_SECURITY',
  StartingABusiness = 'STARTING_A_BUSINESS',
  StoreSavingsGuide = 'STORE_SAVINGS_GUIDE',
  StudentCreditCards = 'STUDENT_CREDIT_CARDS',
  StudentLoans = 'STUDENT_LOANS',
  Studies = 'STUDIES',
  Taxes = 'TAXES',
  Travel = 'TRAVEL',
  TravelCreditCards = 'TRAVEL_CREDIT_CARDS',
  TravelDeals = 'TRAVEL_DEALS',
  TravelInsurance = 'TRAVEL_INSURANCE',
  Utilities = 'UTILITIES',
  VacationAndTripPlanning = 'VACATION_AND_TRIP_PLANNING'
}

/** Type modeling the data within the faqs group of fields on the Article type. */
export type ContentFaq = {
  __typename?: 'ContentFaq';
  /** The FAQ Answer. */
  answer?: Maybe<Scalars['StructuredContentDocument']>;
  /** The FAQ Question. */
  question?: Maybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_content_pack post type from WordPress. */
export type ContentPack = PostInterface & PostWithAuthorsInterface & PostWithTitleInterface & {
  __typename?: 'ContentPack';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the ContentPack object. */
  categories?: Maybe<Array<Category>>;
  /** The curation type for this Content Pack. */
  curationType?: Maybe<ContentPackCurationTypeEnum>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']>;
  /** The heading for this Content Pack. */
  heading?: Maybe<Scalars['String']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** The content to display for this Content Pack. */
  items?: Maybe<Array<ContentPackItemsUnion>>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The display type to use for this Content Pack. */
  listDisplayType?: Maybe<ContentPackListDisplayTypeEnum>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The subtitle to display for this Content Pack. */
  subtitle?: Maybe<Scalars['String']>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
};


/** Type modeling the data for posts within the nw_content_pack post type from WordPress. */
export type ContentPackDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_content_pack post type from WordPress. */
export type ContentPackModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_content_pack post type from WordPress. */
export type ContentPackTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type ContentPackConnectionResponse = {
  __typename?: 'ContentPackConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The ContentPack returned for the connection. */
  items?: Maybe<Array<ContentPack>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Enum values for curationType field on ContentPack type. */
export enum ContentPackCurationTypeEnum {
  Default = 'DEFAULT',
  Manual = 'MANUAL',
  MobileContentRecs = 'MOBILE_CONTENT_RECS'
}

/** Query to fetch a collection of ContentPack objects. */
export type ContentPackFilterInput = {
  /** Limit collection to ContentPacks published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to ContentPacks within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']>>;
  /** Limit collection to ContentPacks with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
};

/** The union containing the Type members that can be returned by the items field on the ContentPack type. */
export type ContentPackItemsUnion = Article | Hub | LandingPage | Page | Post | Review | Roundup;

/** Enum values for listDisplayType field on ContentPack type. */
export enum ContentPackListDisplayTypeEnum {
  Card = 'CARD',
  Carousel = 'CAROUSEL',
  Default = 'DEFAULT'
}

/** Contains a content pack and its meta data */
export type ContentPackPlacement = {
  __typename?: 'ContentPackPlacement';
  /** A single content pack and its associated data */
  contentPack: ContentPack;
  /** The list of model execution IDs used in personalized/fallback content packs */
  modelExecutionIds?: Maybe<Array<Scalars['String']>>;
};

export type ContentPackResponse = {
  __typename?: 'ContentPackResponse';
  /** The list of content packs returned by the query */
  contentPackPlacements?: Maybe<Array<ContentPackPlacement>>;
};

export type ContentPacksOptionsInput = {
  /** If specified, returns either personalized content pack or interest-based content pack */
  includePersonalizedContentPack?: InputMaybe<Scalars['Boolean']>;
};

/** Common interface containing fields to display within the ContentPageHeader component. */
export type ContentPageHeaderInterface = {
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  authors?: Maybe<Array<Author>>;
  primaryCategory?: Maybe<Category>;
  /** Type of advertiser disclosure to display (default credit_cards) */
  advertiserDisclosureType?: Maybe<Scalars['String']>;
  /** Type of article, which will determine what (if any) additional editorial standards message to display. */
  editorialDisclaimerType?: Maybe<Scalars['String']>;
  /** Boolean flag to show/hide the advertiser disclosure in the page header */
  showAdvertiserDisclosure: Scalars['Boolean'];
  /** Boolean flag to show/hide the author byline in the page header */
  showAuthorByline: Scalars['Boolean'];
  /** Boolean flag to show/hide the editorial disclaimer in the page header */
  showEditorialDisclaimer: Scalars['Boolean'];
};

/** Type modeling the data for posts within the nw_reviewer post type from WordPress. */
export type ContentReviewer = PostInterface & PostWithAuthorsInterface & PostWithContactInfoInterface & PostWithFeaturedImageInterface & PostWithSeoInterface & PostWithTitleInterface & PostWithUserInfoInterface & {
  __typename?: 'ContentReviewer';
  /** Organizations this Reviewer is an alumni of. */
  alumniOf?: Maybe<Array<Scalars['String']>>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** Description for this Reviewer. */
  description?: Maybe<Scalars['String']>;
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']>;
  /** The email address for the Reviewer. */
  emailAddress?: Maybe<Scalars['EmailAddress']>;
  /** KnowsAbout schema data value for this Reviewer. */
  experience?: Maybe<Scalars['String']>;
  /** The facebook link for the Reviewer. */
  facebookLink?: Maybe<Scalars['URL']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** Honorific suffix for this Reviewer. */
  honorificSuffix?: Maybe<Scalars['String']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** Job title for this Reviewer. */
  jobTitle?: Maybe<Scalars['String']>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The facebook link for the Reviewer. */
  linkedinLink?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** Name for this Reviewer. */
  name?: Maybe<Scalars['String']>;
  /** SameAs schema data value for this Reviewer. */
  sameAs?: Maybe<Scalars['URL']>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** The twitter link for the Reviewer. */
  twitterLink?: Maybe<Scalars['URL']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
  /** The social media links for the content reviewer */
  socialMediaLinks?: Maybe<Array<AuthorSocialMediaLink>>;
  /**
   * DEPRECATED: Field containing the information that the content reviewer knows about.
   * @deprecated Use the 'experience' field instead.
   */
  knowsAbout?: Maybe<Scalars['String']>;
  /** The full name of the content reviewer. This isn't currently implemented, but is needed for PostWithUserInfoInterface. */
  fullName?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_reviewer post type from WordPress. */
export type ContentReviewerDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_reviewer post type from WordPress. */
export type ContentReviewerModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_reviewer post type from WordPress. */
export type ContentReviewerTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type ContentReviewerConnectionResponse = {
  __typename?: 'ContentReviewerConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The ContentReviewer returned for the connection. */
  items?: Maybe<Array<ContentReviewer>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of ContentReviewer objects. */
export type ContentReviewerFilterInput = {
  /** Limit collection to ContentReviewers published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to ContentReviewers with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to ContentReviewers with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

/** Input args to filter collections of content search results. */
export type ContentSearchFilterInput = {
  /** Limit collection to Articles published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to search results within a specific Category. This field accepts an array of integer IDs or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']>>;
  /** Limit collection to search results within specific content types. */
  contentTypes?: InputMaybe<Array<PostTypeEnum>>;
  /** Limit collection to search results with or without specific IDs. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']>;
  /** Limit results to those with the specified Reviewer, filtered by ID. */
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Limit result set to content containing a particular string of text. It should be noted that using this input field will cause a cache miss in the WP API and SHOULD NOT BE USED FOR CONSUMER FACING EXPERIENCES! */
  searchText?: InputMaybe<Scalars['String']>;
};

export type ContentSearchInput = {
  /** A set of content categories to match against */
  categories?: InputMaybe<Array<ContentCategory>>;
  /** A flag to include highlights - a snippet of copy */
  includeHighlights?: InputMaybe<Scalars['Boolean']>;
  /** A search string to find related content */
  query?: InputMaybe<Scalars['String']>;
  /** A map of content attributes to relative importance in weighing search result relevancy */
  queryFieldWeights?: InputMaybe<ContentSearchQueryFieldsWeightsInput>;
  /** The "format" of the content requested */
  contentTypes?: InputMaybe<Array<ContentType>>;
  /**
   * The WP Post type is not used to build query params but is used to filter content for requested post types, post-search
   *
   * This filters on nw_page.content_type, which maps to nw_content_type from the WP API
   * possible values include 'article', 'roundup', 'review' (supported here)
   * and 'calculator', 'marketplace', 'product_detail', & 'tool' (not yet supported)
   */
  postTypes?: InputMaybe<Array<PostType>>;
};

/**
 * Each available field carries a weight of 1 relative to it's counterparts. You can weigh certain attributes more than others
 * by supplying a weight. For example, a weight of 'Y' is Y times as important as another specified attribute
 */
export type ContentSearchQueryFieldsWeightsInput = {
  /** Weigh search results against author names */
  authorNames?: InputMaybe<Scalars['Int']>;
  /** Weight search results against category names */
  categoryNames?: InputMaybe<Scalars['Int']>;
  /** Weigh search results aginst the sanitized content */
  contentSanitized?: InputMaybe<Scalars['Int']>;
  /** Weigh search results against the content type */
  contentType?: InputMaybe<Scalars['Int']>;
  /** Weigh search results against the link URL */
  link?: InputMaybe<Scalars['Int']>;
  /** Weigh search results against the tag names */
  tagNames?: InputMaybe<Scalars['Int']>;
  /** Weigh search results against the sanitized title */
  titleSanitized?: InputMaybe<Scalars['Int']>;
};

/** The Type modeling the results returned from the WP search endpoint. */
export type ContentSearchResult = PostInterface & PostWithAuthorsInterface & PostWithFeaturedImageInterface & PostWithTitleInterface & {
  __typename?: 'ContentSearchResult';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** The legacy synopsis field for a search result. Once we support structured content for the synopsis field we will return a structured content document. */
  legacySynopsis?: Maybe<Scalars['String']>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The primary category object for the resource. */
  primaryCategory?: Maybe<Category>;
  /** The reviewers that this Article has been reviewed by. */
  reviewedBy?: Maybe<Array<ContentReviewer>>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
};


/** The Type modeling the results returned from the WP search endpoint. */
export type ContentSearchResultDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** The Type modeling the results returned from the WP search endpoint. */
export type ContentSearchResultModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** The Type modeling the results returned from the WP search endpoint. */
export type ContentSearchResultTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type ContentSearchResultConnectionResponse = {
  __typename?: 'ContentSearchResultConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The ContentSearchResult returned for the connection. */
  items?: Maybe<Array<ContentSearchResult>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

export enum ContentSortDirection {
  /** Sort posts in reverse chronological order across all N search queries */
  MostRecent = 'MOST_RECENT',
  /** Sort posts in chronological order across all N search queries */
  Earliest = 'EARLIEST'
}

export enum ContentType {
  Article = 'ARTICLE',
  Review = 'REVIEW',
  Roundup = 'ROUNDUP'
}

/** Type modeling the data for posts within the nw_user_page post type from WordPress. */
export type ContentUserPage = PostInterface & PostWithAuthorsInterface & PostWithContactInfoInterface & PostWithFeaturedImageInterface & PostWithSeoInterface & PostWithTitleInterface & PostWithUserInfoInterface & {
  __typename?: 'ContentUserPage';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** Awards for the user featured on this User Page. */
  awards?: Maybe<Array<Scalars['String']>>;
  /** Bio for this User Page. */
  bio?: Maybe<Scalars['StructuredContentDocument']>;
  /** Content picks to display on this User Page. */
  contentPicks?: Maybe<Array<ContentUserPageContentPicksUnion>>;
  /** Credentials for the user featured on this User Page. */
  credentials?: Maybe<Array<Scalars['String']>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']>;
  /** Education for the user featured on this User Page. */
  education?: Maybe<Array<Scalars['String']>>;
  /** Expertise for the user featured on this User Page. */
  expertise?: Maybe<Array<Scalars['String']>>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** First name for the user featured on this User Page. */
  firstName?: Maybe<Scalars['String']>;
  /** Full name for the user featured on this User Page. */
  fullName?: Maybe<Scalars['String']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** Job title for this User Page. */
  jobTitle?: Maybe<Scalars['String']>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** Organizations for the user featured on this User Page. */
  organizations?: Maybe<Array<Scalars['String']>>;
  /** Other publications for the user featured on this User Page. */
  otherPublications?: Maybe<Array<Scalars['String']>>;
  /** Page type for this User Page. */
  pageType?: Maybe<ContentUserPagePageTypeEnum>;
  /** Previous experience for the user featured on this User Page. */
  previousExperience?: Maybe<Array<Scalars['String']>>;
  /** A collection of articles, podcasts, and/or TV clips to display on this User Page. */
  quotesAndInterviews?: Maybe<Array<ContentUserPageQuotesAndInterview>>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
  /** User represented by this User Page. */
  user?: Maybe<Author>;
  /** Field connecting to the UserPageVideo Type and all of its nested fields. */
  video?: Maybe<UserPageVideo>;
  /** The social media links to display on the author/editor page. */
  socialMediaLinks?: Maybe<Array<AuthorSocialMediaLink>>;
  /** The users's previous experience. */
  experience?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_user_page post type from WordPress. */
export type ContentUserPageDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_user_page post type from WordPress. */
export type ContentUserPageModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_user_page post type from WordPress. */
export type ContentUserPageTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type ContentUserPageConnectionResponse = {
  __typename?: 'ContentUserPageConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The ContentUserPage returned for the connection. */
  items?: Maybe<Array<ContentUserPage>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** The union containing the Type members that can be returned by the contentPicks field on the ContentUserPage type. */
export type ContentUserPageContentPicksUnion = Article | Hub | LandingPage | Page | Post | Review | Roundup;

/** Query to fetch a collection of ContentUserPage objects. */
export type ContentUserPageFilterInput = {
  /** Limit collection to ContentUserPages published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to ContentUserPages with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to ContentUserPages with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

/** Enum values for pageType field on ContentUserPage type. */
export enum ContentUserPagePageTypeEnum {
  Author = 'AUTHOR',
  Editor = 'EDITOR'
}

/** Type modeling the data within the quotesAndInterviews group of fields on the ContentUserPage type. */
export type ContentUserPageQuotesAndInterview = {
  __typename?: 'ContentUserPageQuotesAndInterview';
  /** Publication name for this quote/interview. */
  name?: Maybe<Scalars['String']>;
  /** Publication title for this quote/interview. */
  title?: Maybe<Scalars['String']>;
  /** URL for this quote/interview. */
  url?: Maybe<Scalars['URL']>;
};

/**
 * The `Cookie` type represents a cookie, with all the standard cookie properties.
 * See https://tools.ietf.org/html/rfc6265
 */
export type Cookie = {
  __typename?: 'Cookie';
  name: Scalars['String'];
  value: Scalars['String'];
  expires?: Maybe<Scalars['String']>;
  maxAge?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  secure?: Maybe<Scalars['Boolean']>;
  httpOnly?: Maybe<Scalars['Boolean']>;
  /**
   * A Set-Cookie header literal representing the Cookie
   *
   * Example: 'AWSALB=n2EKrJVwfmU1FJ0KMGnRY01LfTmkFJmLAF0dNjkuMoW/V7QPwdDatoDKrmzTjDP7j1fO7VTyl/MXjp8Tljq3yM8nmTs9HsSUcZi0f2ik77H9chfNR86RX2ud7zMl; Expires=Fri, 29 Mar 2019 18:47:06 GMT; Path=/'
   */
  headerString: Scalars['String'];
};

export type CreateManualTransactionAccountResponse = {
  __typename?: 'CreateManualTransactionAccountResponse';
  financialAccount: FinancialAccount;
};

export type CreateMoneyTransferAccountResponse = {
  __typename?: 'CreateMoneyTransferAccountResponse';
  account: MoneyTransferAccount;
};

export type CreateMoneyTransferResponse = {
  __typename?: 'CreateMoneyTransferResponse';
  transfer: MoneyTransferTransfer;
};

export type CreateUserFinancialAccountResponse = {
  __typename?: 'CreateUserFinancialAccountResponse';
  financialAccount: FinancialAccount;
};

export type CreditBoosterDataVisualization = UserInsightDataVisualizationInterface & {
  __typename?: 'CreditBoosterDataVisualization';
  /** This will always be CREDIT_BOOSTER */
  dataVisualizationType: UserInsightDataVisualizationTypeEnum;
  /** User's credit score info dating back to a week */
  creditScoreChangeInfo: CreditScoreChangeInfo;
};

export type CreditCardApprovalOddsPrediction = {
  __typename?: 'CreditCardApprovalOddsPrediction';
  /** A user's likelihood of being approved for a credit card as a decimal value. */
  approvalOdds?: Maybe<Scalars['Float']>;
  /**
   * The ID of the credit card that the approval odds have been calculated for. This ID
   * corresponds to a CreditCardOfferV2's legacyId field.
   */
  id: Scalars['String'];
};

export type CreditCardApprovalOddsPredictionResponse = {
  __typename?: 'CreditCardApprovalOddsPredictionResponse';
  predictions: Array<CreditCardApprovalOddsPrediction>;
};

/** Credit Card Institutions */
export type CreditCardInstitution = InstitutionInterface & {
  __typename?: 'CreditCardInstitution';
  canonicalInstitutionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
};

/** The persisted set of answers that the user submitted in the Credit Card Match quiz flow. */
export type CreditCardMatchQuizAnswersResponse = {
  __typename?: 'CreditCardMatchQuizAnswersResponse';
  answers?: Maybe<Scalars['JSON']>;
  quizVersion: Scalars['Int'];
};

export type CreditCardMatchQuizOffersResponse = {
  __typename?: 'CreditCardMatchQuizOffersResponse';
  offers: Array<Maybe<CreditCardsOfferV2>>;
  fallbackOffers: Array<Maybe<CreditCardsOfferV2>>;
  userCardOffers: Array<Maybe<CreditCardsOfferV2>>;
};

/** Credit card offer */
export type CreditCardOffer = OfferInterface & {
  __typename?: 'CreditCardOffer';
  derivedDetails?: Maybe<CreditCardOfferDerivedDetails>;
  details: CreditCardOfferDetails;
  endsAt?: Maybe<Scalars['DateTime']>;
  institution: CreditCardInstitution;
  startsAt?: Maybe<Scalars['DateTime']>;
  product?: Maybe<CreditCardProduct>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
  /**
   * All active related card offers, must query for relatedCardIds in the parent details, and status in relatedCardOffers
   * For example
   *   creditCardOffer {
   *     details {
   *       relatedCardIds
   *     }
   *     relatedCardOffers {
   *       status
   *     }
   *   }
   */
  relatedCreditCardOffers?: Maybe<Array<CreditCardOffer>>;
};

export type CreditCardOfferBundlesResponse = {
  __typename?: 'CreditCardOfferBundlesResponse';
  bundles: Array<CreditCardRecommendationBundle>;
};

/** The derived detail section of a credit card offer */
export type CreditCardOfferDerivedDetails = {
  __typename?: 'CreditCardOfferDerivedDetails';
  /** Link to apply for a credit card offer */
  applyLink?: Maybe<Scalars['URL']>;
  /** The likelihood of approval for the card based on the user's credit score bucket */
  approvalLikelihood?: Maybe<Scalars['Float']>;
  /** Interstitial redirect terms and fees link */
  termsFeesRedirectLink?: Maybe<Scalars['URL']>;
  /** The monetary valuation (in cents) per reward point */
  rewardCentsPerUnit?: Maybe<Scalars['Float']>;
  /** The monetary valuation (in cents) per reward point in string format */
  rewardCentsPerUnitString?: Maybe<Scalars['String']>;
};

/** The details section of a credit card offer */
export type CreditCardOfferDetails = {
  __typename?: 'CreditCardOfferDetails';
  /** The annual fee for the card */
  annualFee?: Maybe<Scalars['Float']>;
  /** The display string for annual fee */
  annualFeeDetails?: Maybe<Scalars['String']>;
  /**
   * The likelihood of approval for the card based on the user's credit score bucket
   * @deprecated Use `derivedDetails.approvalLikelihood`
   */
  approvalOdds?: Maybe<Scalars['Float']>;
  /** The minimum APR */
  aprMin?: Maybe<Scalars['Float']>;
  /** The maximum APR */
  aprMax?: Maybe<Scalars['Float']>;
  /** The balance transfer fee as a percentage of the transfer amount */
  balanceTransferFee?: Maybe<Scalars['Float']>;
  /** A more detailed description of balance transfer */
  balanceTransferFeeDescription?: Maybe<Scalars['String']>;
  /** The balance transfer APR */
  balanceTransferIntroApr?: Maybe<Scalars['Float']>;
  /** The term of 'balanceTransferIntroApr', in months */
  balanceTransferInfoTime?: Maybe<Scalars['Int']>;
  /** The display string for the unit the billing cycle is calculated in (e.g. "months") */
  billingCycleUnits?: Maybe<Scalars['String']>;
  /** Custom details like 'credit cards great for:...' */
  customDetailsList?: Maybe<Array<Scalars['String']>>;
  /** A list of negative attributes about the card */
  consBullets?: Maybe<Array<Scalars['String']>>;
  /** The foreign transaction fee as a percentage of the transaction  amount */
  foreignTransactionFee?: Maybe<Scalars['Float']>;
  /** URL of card image */
  imageSource?: Maybe<Scalars['String']>;
  /** URL of card image (larger format) */
  imageSourceLarge?: Maybe<Scalars['String']>;
  /** URL of card image (medium format) */
  imageSourceMedium?: Maybe<Scalars['String']>;
  /** Boolean flag indicating whether or not an offer is monetizing (revenue generating partnership) */
  isMonetizing?: Maybe<Scalars['Boolean']>;
  /** The card issuer's information page on their domain */
  issuerInfoUrl?: Maybe<Scalars['URL']>;
  legacyId: Scalars['Int'];
  /** A list of marketing strings about the card */
  marketingBullets?: Maybe<Array<Scalars['String']>>;
  /** Marketing strings with terms and fees link removed from list */
  marketingBulletsWithoutTermsFeesLink?: Maybe<Array<Scalars['String']>>;
  /** The maximum FICO recommended for approval */
  maxFico?: Maybe<Scalars['Int']>;
  /** The minimum recommended FICO for approval */
  minFico?: Maybe<Scalars['Int']>;
  /** The regular APR rate after the intro APR offer expires */
  ongoingApr?: Maybe<Scalars['String']>;
  /** List of perks this credit card has */
  perks?: Maybe<Array<Scalars['String']>>;
  /** The program name */
  programName?: Maybe<Scalars['String']>;
  /** A list of positive attributes of the card */
  prosBullets?: Maybe<Array<Scalars['String']>>;
  /** User-friendly string representing the range of 'aprMin' - 'aprMax' */
  purchaseApr?: Maybe<Scalars['String']>;
  /** The introductory purchase APR for new card owners */
  purchaseIntroApr?: Maybe<Scalars['Float']>;
  /** The introductory length of the intro purchase APR in months (maps from purchase_intro_time) */
  purchaseIntroTerm?: Maybe<Scalars['Int']>;
  /** NerdWallet review star rating */
  rating?: Maybe<Scalars['Float']>;
  /** Cards related to this offer */
  relatedCardIds?: Maybe<Array<Scalars['Int']>>;
  /** URL to articles with related content to this card */
  relatedContent?: Maybe<Array<Scalars['String']>>;
  rewardCategoriesBestRates?: Maybe<Array<CreditCardOfferRewardCategories>>;
  /** More in depth detailed notes about the credit card offer */
  rewardRateNotes?: Maybe<Scalars['String']>;
  /** Type of reward units earned by this offer */
  rewardType?: Maybe<CreditCardOfferRewardType>;
  slug?: Maybe<Scalars['String']>;
  /** A link to the card's terms and fees, if applicable */
  termsFeesLink?: Maybe<Scalars['URL']>;
  /** Offer version id */
  versionId?: Maybe<Scalars['Int']>;
  /** Phone number for some issuers that allow calling to apply */
  applyPayPerCall?: Maybe<Scalars['String']>;
  /** Names of the award badge names this offer won in 2020. */
  bestOfBadgeWinner2020?: Maybe<Array<Scalars['String']>>;
  /** Names of the award badge names this offer won in 2021. */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']>>;
};

export type CreditCardOfferIdsWithApprovalOddsPredictionResponse = {
  __typename?: 'CreditCardOfferIdsWithApprovalOddsPredictionResponse';
  offerIds: Array<Scalars['Int']>;
};

/** Breakdown of bonus categories for this credit card offer */
export type CreditCardOfferRewardCategories = {
  __typename?: 'CreditCardOfferRewardCategories';
  category: CreditCardOfferRewardCategoryType;
  rate: Scalars['Float'];
};

export type CreditCardOfferRewardCategoryRates = {
  __typename?: 'CreditCardOfferRewardCategoryRates';
  dining: Scalars['Float'];
  entertainment: Scalars['Float'];
  gas: Scalars['Float'];
  groceries: Scalars['Float'];
  shopping: Scalars['Float'];
  travel: Scalars['Float'];
};

/**
 * Bonus categories of credit card offers
 * https://finproservices.nerdwallet.biz/flask_admin/rewardcategory/
 */
export enum CreditCardOfferRewardCategoryType {
  All = 'ALL',
  Airfare = 'AIRFARE',
  Bookstores = 'BOOKSTORES',
  Business = 'BUSINESS',
  CarRental = 'CAR_RENTAL',
  CarWashes = 'CAR_WASHES',
  Charity = 'CHARITY',
  Dining = 'DINING',
  Discount = 'DISCOUNT',
  Drugstores = 'DRUGSTORES',
  Entertainment = 'ENTERTAINMENT',
  Gas = 'GAS',
  Groceries = 'GROCERIES',
  HomeImprove = 'HOME_IMPROVE',
  Hotel = 'HOTEL',
  Lodging = 'LODGING',
  Movies = 'MOVIES',
  Office = 'OFFICE',
  Other = 'OTHER',
  Parking = 'PARKING',
  Playstation = 'PLAYSTATION',
  RentalCars = 'RENTAL_CARS',
  Telecom = 'TELECOM',
  Travel = 'TRAVEL',
  Utilities = 'UTILITIES',
  Wireless = 'WIRELESS',
  Overall = 'OVERALL'
}

/** Type of rewards this credit card offer gives */
export enum CreditCardOfferRewardType {
  Cash = 'CASH',
  Points = 'POINTS',
  NoRewards = 'NO_REWARDS',
  Miles = 'MILES'
}

/** Query variables for the credit card offers query */
export type CreditCardOffersParameters = {
  debtPayment?: InputMaybe<Scalars['Int']>;
  ficoScore?: InputMaybe<Scalars['Int']>;
  numberOfMonths?: InputMaybe<Scalars['Int']>;
  totalDebt?: InputMaybe<Scalars['Int']>;
  categorySpend?: InputMaybe<CreditCardOffersParametersCategorySpend>;
  existingCardApr?: InputMaybe<Scalars['Float']>;
};

/** Input parameters for credit card offers marketplace queries */
export type CreditCardOffersParametersCategorySpend = {
  dining?: InputMaybe<Scalars['Int']>;
  gas?: InputMaybe<Scalars['Int']>;
  groceries?: InputMaybe<Scalars['Int']>;
  office?: InputMaybe<Scalars['Int']>;
  travel?: InputMaybe<Scalars['Int']>;
  other?: InputMaybe<Scalars['Int']>;
};

/** The response from a credit card offer query. */
export type CreditCardOffersResponse = {
  __typename?: 'CreditCardOffersResponse';
  /** The total number of offers that match your query. */
  total: Scalars['Int'];
  offers: Array<CreditCardOffer>;
  offset: Scalars['Int'];
};

/** The response from a credit card offer query. */
export type CreditCardOffersV2Response = {
  __typename?: 'CreditCardOffersV2Response';
  offers: Array<CreditCardsOfferV2>;
};

/**
 * Since there are overlapping fields across the cc-prequal and personal-loans-prequal
 * services, the inputs are split into 3 different parts for better code reusability.
 */
export type CreditCardPrequalInput = {
  firstName?: InputMaybe<Scalars['String']>;
  middleInitial?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  streetAddressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
  /** Last four digits of user's SSN */
  lastFour: Scalars['String'];
  /** User's date of birth in MM/DD/YYYY format */
  dateOfBirth: Scalars['String'];
  /** Agrees to terms of service */
  agreeToTos: Scalars['Boolean'];
  /** Credit card issuers they would like to see offers from */
  issuers: Array<CreditCardPrequalIssuersEnum>;
};

/** Enums for issuers. */
export enum CreditCardPrequalIssuersEnum {
  Chase = 'CHASE',
  CapitalOne = 'CAPITAL_ONE',
  AmericanExpress = 'AMERICAN_EXPRESS'
}

/** This creates the schema for a singular credit card/offer and refers to the response JSON. */
export type CreditCardPrequalOffer = {
  __typename?: 'CreditCardPrequalOffer';
  /** Issuer card identifier */
  sourceCode: Scalars['String'];
  /** The card's image details */
  cardImageDetails: CardImageDetails;
  /** Indicates if prescreen or prequal offer */
  isPrescreen: Scalars['Boolean'];
  /** Apply now URL */
  applyNowUrl: Scalars['URL'];
  /** Marketing bullets are used for bonus offer and additional info */
  marketingBullets?: Maybe<Array<Scalars['String']>>;
  /** Purchase APR */
  purchaseRegularApr?: Maybe<Scalars['String']>;
  /** Balance transfer APR */
  balanceTransferRegApr?: Maybe<Scalars['String']>;
  /** Purchase introduction APR */
  purchaseIntroductionApr?: Maybe<Scalars['String']>;
  /** Balance transfer intro APR */
  balanceTransferIntroApr?: Maybe<Scalars['String']>;
  /**
   * cc-prequal-service receives a lot of the necessary fields from marketplace, which is passed
   * into the CreditCardOffer type. The remaining fields above are from the actual cc-prequal-service
   */
  creditCardOffer: CreditCardOffer;
};

export type CreditCardPrequalOffersResponse = {
  __typename?: 'CreditCardPrequalOffersResponse';
  /** In order to have working apply now links, we need to set the X-PREQUAL-COOKIE-ID cookie */
  prequalCookieId: Scalars['String'];
  offers?: Maybe<Array<CreditCardPrequalOffer>>;
};

/** Credit Card Product */
export type CreditCardProduct = ProductInterface & {
  __typename?: 'CreditCardProduct';
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
};

/** The `CreditCardRecommendationBundle` represents one recommendation bundle from recommendationServiceApi. */
export type CreditCardRecommendationBundle = {
  __typename?: 'CreditCardRecommendationBundle';
  header?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  teaser?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['String']>;
  trackingId?: Maybe<Scalars['String']>;
  creditCardOffers?: Maybe<Array<CreditCardOffer>>;
  primaryAction?: Maybe<AppAction>;
};

export type CreditCardsCreditScoreComparisonContent = {
  __typename?: 'CreditCardsCreditScoreComparisonContent';
  /** The difference in points from the credit score to the offer preferred score and then padded with the 'points' or 'point' suffix. E.g. 1 point, 10 points */
  pointDifference: Scalars['String'];
  /** The label used to indicate to the user how relative their score is to the offer's preferred score. */
  relativeScoreLabel: Scalars['String'];
  /** The score used to compare. */
  scoreToCompare: Scalars['Int'];
};

/** A Credit Cards institution */
export type CreditCardsInstitutionV2 = MarketplaceEntityInterface & MarketplaceInstitutionInterface & {
  __typename?: 'CreditCardsInstitutionV2';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

/** A Credit Cards offer */
export type CreditCardsOfferV2 = MarketplaceEntityInterface & MarketplaceEntityWithBestOfAwards2021Interface & MarketplaceEntityWithBestOfAwardsInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceOfferInterface & {
  __typename?: 'CreditCardsOfferV2';
  /** Numeric value of a product's annual fee. */
  annualFee?: Maybe<Scalars['Float']>;
  /** Stylized version of annual fee + annual_fee_first_year. ex. '$0*' or '$0 intro first year, then $95' */
  annualFeeDetails?: Maybe<Scalars['String']>;
  /** Numeric value of the product's first year annual fee. This should match annual_fee if the card doesn't have a special fee in the first year. */
  annualFeeFirstYear?: Maybe<Scalars['Float']>;
  /** The offer_url or issuer_info_page_url for this cc offer */
  applyLink?: Maybe<Scalars['URL']>;
  /** The approval calculation for logged in members. */
  approvalLikelihood?: Maybe<Scalars['Float']>;
  /** Powers the shortcodes Content uses to discuss Intro Apr:  ex. '0% intro APR on Purchases for 15 months, and then the ongoing APR of 14.99% - 23.74% Variable APR' */
  aprIntroMessage?: Maybe<Scalars['String']>;
  /** Displays short version of intro text. Usually under 'Intro APR' field on Card Details and Product Cards */
  aprIntroMessageList?: Maybe<Array<Scalars['String']>>;
  /** Numeric value for high end of APR range. ex. '23.74' */
  aprMax?: Maybe<Scalars['Float']>;
  /** Numeric value for low end of APR range. ex. '14.99' */
  aprMin?: Maybe<Scalars['Float']>;
  /** Used to display greater details of a balance transfer fee. ex. 'Either $5 or 5% of the amount of each transfer, whichever is greater.' */
  balanceTransferFeeDescription?: Maybe<Scalars['String']>;
  /** The list of NW Best-Of Awards this offer has won for 2021 */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']>>;
  /** Categorizes cards and makes them eligible to show up in different site features, like site search, and compare marketplace. */
  compareCategories?: Maybe<Array<Scalars['String']>>;
  /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  consBullets?: Maybe<Array<Scalars['String']>>;
  /** Populates the 'great for' text on Marketplace Landing Pages. ex. 'Great for: Airline Miles and a Large Bonus' */
  customDetailsList?: Maybe<Array<Scalars['String']>>;
  /** The display name for the entity (auto-generated) */
  displayName?: Maybe<Scalars['String']>;
  /** Entity type */
  entityType: Scalars['String'];
  /** Stylized version of foreign transaction fee ex. '0%' or '3% of each transaction in U.S. dollars' */
  foreignTransactionFeeDescription?: Maybe<Scalars['String']>;
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /** Whether this Offer is monetizing. Client apps use this field to decide display behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA */
  isMonetizing?: Maybe<Scalars['Boolean']>;
  /** Used to store product details page on issuer site. Particularly when that page is hard to locate. */
  issuerInfoPageUrl?: Maybe<Scalars['String']>;
  /** The late payment fee in dollars. */
  latePaymentFee?: Maybe<Scalars['Int']>;
  /** The late payment fee as as a string as provided by the partner. */
  latePaymentFeeDescription?: Maybe<Scalars['String']>;
  /** Legacy ID used by some Credit Card specific components. */
  legacyId?: Maybe<Scalars['Int']>;
  /** More information about the product. Appears under 'Card Details' or 'Product Details' depending on the experience. It does not include the 'See Rates and Fees' link when applicable. */
  marketingBullets?: Maybe<Array<Scalars['String']>>;
  /** Maximum reccommended FICO score */
  maxFico?: Maybe<Scalars['Int']>;
  /** Minimum reccommended FICO score */
  minFico?: Maybe<Scalars['Int']>;
  /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
  monetizable: Scalars['String'];
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  /** Displays the range of the ongoing APR */
  ongoingApr?: Maybe<Scalars['String']>;
  /** A product's apply by phone telephone number, if applicable. Displays below the CTA on product cards, typically. */
  phoneNumber?: Maybe<Scalars['String']>;
  /** Path for Prequal CTAs when applicable */
  prequalLink?: Maybe<Scalars['URL']>;
  /** Display text for Prequal CTA or Link */
  prequalLinkText?: Maybe<Scalars['String']>;
  product: CreditCardsProductV2;
  /** Product type */
  productType: Scalars['String'];
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  prosBullets?: Maybe<Array<Scalars['String']>>;
  /** Numeric value for the number of months the intro APR applies to purchases */
  purchaseIntroTime?: Maybe<Scalars['Int']>;
  /** The URL to the NerdWallet review of this offer. */
  reviewLink?: Maybe<Scalars['URL']>;
  /** Numeric value of the base reward rate of the product */
  rewardRate?: Maybe<Scalars['Float']>;
  /** String value of the rewards rate range for the product. ex. '1.5%-5%' */
  rewardRateDetails?: Maybe<Scalars['String']>;
  /** Full, detailed text of the rewards rates for the product. ex. 'Earn 5% cash back on grocery store purchases (not including Target® or Walmart® purchases) on up to $12,000 spent in the first year. Earn unlimited 1.5% cash back on all other purchases.' */
  rewardRateNotes?: Maybe<Scalars['String']>;
  /** Numeric value of the product's intro offer */
  signUpBonus?: Maybe<Scalars['Int']>;
  /** Please make sure the text in this field ends with a period. Description of terms to earn intro offer. ex. 'Earn a $200 Bonus after you spend $500 on purchases in your first 3 months from account opening.' */
  signUpBonusDetails?: Maybe<Scalars['String']>;
  /** Please make sure the text in this field ends with a period. Should match sign_up_bonus_details. Unless the product is from Discover and has a Match feature as an Intro Offer. */
  signUpBonusDetailsAnnotation?: Maybe<Scalars['String']>;
  /** The type of bonus received for signing up to this card. Can be different to the Reward bonus. */
  signUpBonusType?: Maybe<Scalars['String']>;
  /** Path to the product's card details page. Keep it simple, and avoid including payment network where possible. ex. 'chase-freedom-unlimited' or 'us-bank-altitude-go-card' */
  slug?: Maybe<Scalars['String']>;
  /** Numeric value of the rating Content has assigned the product */
  starRating?: Maybe<Scalars['Float']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** Prefer this over terms_and_fees_link since this goes to interstitial-client. Link to a product's rates & fees. Should display Rates & fees on most product cards on the site. Marketing bullets require you to add the link directly there. */
  termsAndFeesLink?: Maybe<Scalars['URL']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The Best Of Awards that this offer has won */
  bestOfAwards?: Maybe<Array<BestOfAward>>;
  /** The credit score comparison content used to display to the user information regarding how close the user is to the preferred offer score. */
  creditScoreComparisonContent?: Maybe<CreditCardsCreditScoreComparisonContent>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The driver annual fee associated with the entity */
  driverAnnualFee?: Maybe<EntityPlacementDriver>;
  /** The driver balance transfer fee description associated with the entity */
  driverBalanceTransferFeeDescription?: Maybe<EntityPlacementDriver>;
  /** The driver bonus associated with the entity */
  driverBonus?: Maybe<EntityPlacementDriver>;
  /** The driver foreign transaction fee associated with the entity */
  driverForeignTransactionFee?: Maybe<EntityPlacementDriver>;
  /** The driver intro APR associated with the entity */
  driverIntroApr?: Maybe<EntityPlacementDriver>;
  /** The driver intro offer associated with the entity */
  driverIntroOffer?: Maybe<EntityPlacementDriver>;
  /** The driver regular APR associated with the entity */
  driverRegularApr?: Maybe<EntityPlacementDriver>;
  /** The driver reward rate associated with the entity */
  driverRewardRate?: Maybe<EntityPlacementDriver>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /**
   * The drivers associated with the entity
   * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
   */
  placementDrivers: Array<EntityPlacementDriver>;
  /** A secondary placement config CTA reserved for monetizing marketplace entities */
  ratesAndFeesCta?: Maybe<EntityPlacementCta>;
  /** The recommended credit score range text */
  recommendedCreditScoreRangeDetails?: Maybe<CreditCardsRecommendedCreditScoreRangeDetails>;
  /** Connection field to the review */
  review?: Maybe<MarketplaceEntityRelatedReviewUnion>;
  /** A boolean indicating if the display name should be shown in the comparison table component */
  showNameInComparisonTable: Scalars['Boolean'];
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
  /** Flag for whether to use the large product card image styles */
  useLargeImageFootprint: Scalars['Boolean'];
};

/** A Credit Cards product */
export type CreditCardsProductV2 = MarketplaceEntityInterface & MarketplaceProductInterface & {
  __typename?: 'CreditCardsProductV2';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  institution: CreditCardsInstitutionV2;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

export type CreditCardsRecommendedCreditScoreRangeDetails = {
  __typename?: 'CreditCardsRecommendedCreditScoreRangeDetails';
  /** The recommended credit score range for the offer. */
  creditScoreRange?: Maybe<Scalars['String']>;
  /** The recommended credit score range description for the offer. */
  description?: Maybe<Scalars['String']>;
};

export type CreditCardsReviewPage = StructuredContentPageInterface & {
  __typename?: 'CreditCardsReviewPage';
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID'];
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
};

export type CreditCardsRoundupsPage = StructuredContentPageInterface & {
  __typename?: 'CreditCardsRoundupsPage';
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID'];
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
};

export type CreditFactor = {
  __typename?: 'CreditFactor';
  /** All common questions about this credit factor */
  commonQuestions?: Maybe<Array<CreditFactorCommonQuestion>>;
  /** Data about the core metric for this factor */
  coreMetric?: Maybe<CreditFactorCoreMetric>;
  /** The impact level of this factor on the user's credit score */
  impactLevel?: Maybe<CreditFactorImpactLevel>;
  /** All inquiry sections (only used in recentInquiries factor) */
  inquirySections?: Maybe<Array<CreditFactorInquirySection>>;
  /** The priority inquiry section (only used in recentInquiries factor) */
  priorityInquirySection?: Maybe<CreditFactorInquirySection>;
  /** A list of links to get more information about this factor */
  moreInfoLinks?: Maybe<Array<AppAction>>;
  /** The datetime the user's credit report was last pulled */
  reportPulledAt?: Maybe<Scalars['DateTime']>;
  /** The priority tradeline section (used in all factors other than recentInquiries) */
  priorityTradelineSection?: Maybe<CreditFactorTradelineSection>;
  /** All tradeline sections (used in all factors other than recentInquiries) */
  tradelineSections?: Maybe<Array<CreditFactorTradelineSection>>;
};

export type CreditFactorCommonQuestion = {
  __typename?: 'CreditFactorCommonQuestion';
  /** The answer to the question, separated as paragraphs */
  answerParagraphs?: Maybe<Array<Scalars['String']>>;
  /** A unique identifier for this question */
  key?: Maybe<Scalars['String']>;
  /** The question */
  question?: Maybe<Scalars['String']>;
  /** An optional link to find out more (typically links to an article) */
  learnMoreLink?: Maybe<AppAction>;
};

export type CreditFactorCoreMetric = {
  __typename?: 'CreditFactorCoreMetric';
  /** The NerdWallet suggestion for the credit factor */
  commentary?: Maybe<Scalars['String']>;
  /** The tooltip description for the status of the credit factor */
  description?: Maybe<Scalars['String']>;
  /** The main headline figure for the core metric of the factor */
  displayName?: Maybe<Scalars['String']>;
  /** The label for the displayName */
  label?: Maybe<Scalars['String']>;
  /** The primary value of the core metric (for analytics purposes) */
  value?: Maybe<Scalars['String']>;
  /** An optional secondary value for some factors (for analytics purposes) */
  secondaryValue?: Maybe<Scalars['String']>;
};

export enum CreditFactorImpactLevel {
  Highest = 'HIGHEST',
  High = 'HIGH',
  Medium = 'MEDIUM',
  Low = 'LOW'
}

export type CreditFactorInquiry = {
  __typename?: 'CreditFactorInquiry';
  /** The bureau responsible for the inquiry */
  bureau?: Maybe<Scalars['String']>;
  /** A non-guaranteed unique identifier for this inquiry */
  compositeKey?: Maybe<Scalars['String']>;
  /** The industry the inquirer is in */
  industry?: Maybe<Scalars['String']>;
  /** The date of the inquiry */
  inquiredAt?: Maybe<Scalars['DateTime']>;
  /** The type of inquiry */
  inquiryType?: Maybe<Scalars['String']>;
  /** True if the inquiry has "fallen off" of the user's credit report: exists on their second-most-recent credit report, but not on their most recent credit report. */
  isNoLongerValid?: Maybe<Scalars['Boolean']>;
  /** The name of the creditor that made the inquiry */
  subscriberName?: Maybe<Scalars['String']>;
};

export type CreditFactorInquirySection = {
  __typename?: 'CreditFactorInquirySection';
  /** The short form title used in the priority section */
  abbreviatedTitle?: Maybe<Scalars['String']>;
  /** The list of all inquiries on the user's credit report */
  inquiries?: Maybe<Array<CreditFactorInquiry>>;
  /** True for groups of inquiries that should be highlighted for users to indicate changes or importance */
  isPriority?: Maybe<Scalars['Boolean']>;
  /** The user-facing label describing the sentiment of the inquiry section */
  label?: Maybe<Scalars['String']>;
  /** The sentiment of the inquiry section */
  sentiment?: Maybe<CreditFactorSentiment>;
  /** The full length title for the section (only use in priority sections) */
  title?: Maybe<Scalars['String']>;
  /** Tracking metadata for the section */
  trackingMetadata?: Maybe<CreditFactorTrackingMetadata>;
};

export type CreditFactors = {
  __typename?: 'CreditFactors';
  ageAndMixOfAccounts?: Maybe<CreditFactor>;
  balances?: Maybe<CreditFactor>;
  creditUtilization?: Maybe<CreditFactor>;
  paymentHistory?: Maybe<CreditFactor>;
  recentInquiries?: Maybe<CreditFactor>;
  numTradelines?: Maybe<Scalars['Int']>;
};

export enum CreditFactorSentiment {
  Negative = 'NEGATIVE',
  Positive = 'POSITIVE'
}

/** Metadata passed to analytics events */
export type CreditFactorTrackingMetadata = {
  __typename?: 'CreditFactorTrackingMetadata';
  /** The sentiment of the credit factor or "-" */
  highlightStatus?: Maybe<Scalars['String']>;
  /** The change in account status (used in the ageAndMixOfAccounts factor) */
  accountStatusChange?: Maybe<Scalars['String']>;
  /** The change in inquiry status (used in the recentInquiries factor) */
  inquiryStatusChange?: Maybe<Scalars['String']>;
  /** The derogatory payment type (optional) (used in the paymentHistory factor) */
  paymentDerogatoryType?: Maybe<Scalars['String']>;
  /** The change in payment status (used in the paymentHistory factor) */
  paymentStatusChange?: Maybe<Scalars['String']>;
  /** The current bucket of credit utilization, as defined by NW (used in the creditUtilization factor) */
  utilizationCurrentBucket?: Maybe<Scalars['String']>;
  /** The direction of change of credit utilization (used in the creditUtilization factor) */
  utilizationDirectionChange?: Maybe<Scalars['String']>;
};

export type CreditFactorTradeline = {
  __typename?: 'CreditFactorTradeline';
  /** The condition of the account */
  accountCondition?: Maybe<Scalars['String']>;
  /** The party responsible for the account (e.g. Individual) */
  accountDesignator?: Maybe<Scalars['String']>;
  /** The last 4 digits on the account */
  accountNumberLast4?: Maybe<Scalars['String']>;
  /** The raw representation of the tradeline type */
  accountType?: Maybe<Scalars['String']>;
  /** The 1-character symbol for the account type */
  accountTypeSymbol?: Maybe<Scalars['String']>;
  /** The amount due on the due date */
  amountPastDue?: Maybe<Scalars['Float']>;
  accountDisplayType?: Maybe<Scalars['String']>;
  /** A non-guaranteed unique identifier for this tradeline for this user */
  compositeKey?: Maybe<Scalars['String']>;
  creditLimit?: Maybe<Scalars['Float']>;
  /** The user friendly name for the creditor */
  creditorDisplayName?: Maybe<Scalars['String']>;
  /** A URL for the logo of the creditor */
  creditorLogo?: Maybe<Scalars['String']>;
  /** The raw name of the creditor */
  creditorName?: Maybe<Scalars['String']>;
  /** The balance on the account */
  currentBalance?: Maybe<Scalars['Float']>;
  /** The date the account was opened */
  dateOpenedAt?: Maybe<Scalars['DateTime']>;
  /** The most recent date the account was reported */
  dateReportedAt?: Maybe<Scalars['DateTime']>;
  /** The high balance on the account */
  highBalance?: Maybe<Scalars['Float']>;
  isOpen?: Maybe<Scalars['Boolean']>;
  lastPaymentDate?: Maybe<Scalars['DateTime']>;
  /** The monthly payment for the account */
  monthlyPayment?: Maybe<Scalars['Float']>;
  /** The normalized credit limit */
  nwCreditLimitNormalized?: Maybe<Scalars['Float']>;
  /** The number of months the account has been open */
  nwMonthsOpened?: Maybe<Scalars['Int']>;
  /** The utilization on the account (decimal between 0 and 1) */
  nwUtilizationPct?: Maybe<Scalars['Float']>;
  /** The open/closed symbol of the account */
  openClosedSymbol?: Maybe<CreditFactorTradelineOpenClosedSymbol>;
  /** The pay history of the account */
  payHistoryBreakDown?: Maybe<Array<CreditFactorTradelinePayHistoryDatum>>;
  /** The pay history of the account grouped by months */
  payHistoryBreakDownByMonth?: Maybe<Array<CreditFactorTradelinePayHistoryByMonthDatum>>;
  payHistoryStatus?: Maybe<Scalars['String']>;
  /** The current pay status of the account (raw) */
  payStatus?: Maybe<Scalars['String']>;
  /** The current pay status of the account (user-friendly) */
  payStatusDisplayName?: Maybe<Scalars['String']>;
  /** An optional remark on the account */
  remark?: Maybe<Scalars['String']>;
  /** The length of the loan in months */
  termMonths?: Maybe<Scalars['Int']>;
  /** The user-friendly name for the tradeline */
  tradelineDisplayName?: Maybe<Scalars['String']>;
  wasDisputed?: Maybe<Scalars['Boolean']>;
};

export enum CreditFactorTradelineOpenClosedSymbol {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export type CreditFactorTradelinePayHistoryByMonthDatum = {
  __typename?: 'CreditFactorTradelinePayHistoryByMonthDatum';
  /** The year that the corresponding statuses were submitted */
  year?: Maybe<Scalars['String']>;
  /**
   * The pay status codes for each month of the tradeline.
   *
   * `payStatusCodesByMonth` is a fixed array of 12 pay status codes, one per each month of the year. In the scenario where a pay status code does not exist for the month, null is used to represent that month in the array.
   */
  payStatusCodesByMonth?: Maybe<Array<Maybe<CreditHistoryPayStatusCode>>>;
};

export type CreditFactorTradelinePayHistoryDatum = {
  __typename?: 'CreditFactorTradelinePayHistoryDatum';
  /** The date that the corresponding status was submitted */
  date?: Maybe<Scalars['DateTime']>;
  /** The pay status for the tradeline */
  status?: Maybe<CreditHistoryPayStatusCode>;
};

export type CreditFactorTradelineSection = {
  __typename?: 'CreditFactorTradelineSection';
  /** The short form title used in the priority section */
  abbreviatedTitle?: Maybe<Scalars['String']>;
  /** True for groups of tradelines that should be highlighted for users to indicate changes or importance */
  isPriority?: Maybe<Scalars['Boolean']>;
  /** A unique identifier for the section */
  key?: Maybe<Scalars['String']>;
  /** The user-facing label describing the sentiment of the tradeline section */
  label?: Maybe<Scalars['String']>;
  /** The sentiment of the tradeline section */
  sentiment?: Maybe<CreditFactorSentiment>;
  /** The subtitle describing the tradeline section */
  subtitle?: Maybe<Scalars['String']>;
  /** The title of the tradeline section */
  title?: Maybe<Scalars['String']>;
  /** Tracking metadata for the section */
  trackingMetadata?: Maybe<CreditFactorTrackingMetadata>;
  /** All tradelines associated with this section */
  tradelines?: Maybe<Array<CreditFactorTradeline>>;
};

export enum CreditHistoryPayStatusCode {
  Current = 'CURRENT',
  Unknown = 'UNKNOWN',
  Late_30Days = 'LATE_30_DAYS',
  Late_60Days = 'LATE_60_DAYS',
  Late_90Days = 'LATE_90_DAYS',
  Late_120Days = 'LATE_120_DAYS',
  Late_150Days = 'LATE_150_DAYS',
  PaymentPlan = 'PAYMENT_PLAN',
  Repossession = 'REPOSSESSION',
  CollectionChargeoff = 'COLLECTION_CHARGEOFF'
}

export type CreditProfileAuthAnswer = {
  __typename?: 'CreditProfileAuthAnswer';
  /** The ID of the answer */
  id: Scalars['String'];
  /** The value of the answer */
  text: Scalars['String'];
  /** The order to show the answer */
  sequence: Scalars['Int'];
};

export type CreditProfileAuthAnswerInput = {
  /** The ID of the question */
  questionId: Scalars['String'];
  /** The ID of the answer */
  answerId: Scalars['String'];
};

export type CreditProfileAuthCustomerInput = {
  /** User's full SSN (e.g. "123456789") */
  fullSsn?: InputMaybe<Scalars['String']>;
  /** User's last four of SSN (e.g. "1234") */
  partialSsn?: InputMaybe<Scalars['String']>;
  /** User's first name */
  firstName: Scalars['String'];
  /** User's last name */
  lastName: Scalars['String'];
  /** User's date of birth in the format YYYY-MM-DD */
  dateOfBirth: Scalars['Date'];
  /** User's mailing address */
  mailingAddress: IdentityAddressInput;
  /** User's middle name */
  middleName?: InputMaybe<Scalars['String']>;
  /** User's prefix */
  prefix?: InputMaybe<Scalars['String']>;
  /** User's suffix */
  suffix?: InputMaybe<Scalars['String']>;
  /** User's previous address */
  previousAddress?: InputMaybe<IdentityAddressInput>;
};

export type CreditProfileAuthQuestion = {
  __typename?: 'CreditProfileAuthQuestion';
  /** The ID of the question */
  id: Scalars['String'];
  /** The type of the question */
  type: Scalars['String'];
  /** The question itself as text */
  text: Scalars['String'];
  /** The order to show the question */
  sequence: Scalars['Int'];
  /** The list of answer choices */
  answers: Array<CreditProfileAuthAnswer>;
};

export enum CreditProfileAuthStatus {
  Active = 'ACTIVE',
  Authenticated = 'AUTHENTICATED',
  Blocked = 'BLOCKED',
  Deactivated = 'DEACTIVATED',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

/**
 * The `CreditProfileAuthStatusProfile` represents a TransUnion Authentication Status.
 * Github link (TUAuthenticationStatusProfile): https://github.com/NerdWallet/identity.nerdwallet/blob/master/src/identity/canonical_objects/profiles.py
 */
export type CreditProfileAuthStatusProfile = {
  __typename?: 'CreditProfileAuthStatusProfile';
  /** What is the status of the TU link (PENDING, ACTIVE, AUTHENTICATED, etc.) */
  status: CreditProfileAuthStatus;
  /** When was the profile authenticated at */
  authenticatedAt?: Maybe<Scalars['DateTime']>;
  /** When was the profile activated at */
  activatedAt?: Maybe<Scalars['DateTime']>;
  /** When was the profile deactivated at */
  deactivatedAt?: Maybe<Scalars['DateTime']>;
  /** When was the profile reactivated at */
  reactivatedAt?: Maybe<Scalars['DateTime']>;
  /** When was the profile blocked at */
  blockedAt?: Maybe<Scalars['DateTime']>;
  /** List of questions to authenticate */
  questions?: Maybe<Array<CreditProfileAuthQuestion>>;
  /** Indicates if the user has a thin file */
  hasThinFile?: Maybe<Scalars['Boolean']>;
  /** Reason for the thin file */
  thinFileReason?: Maybe<CreditProfileAuthThinFileReason>;
  /** Is the user deceased */
  isDeceased?: Maybe<Scalars['Boolean']>;
  /** Indicates if there is not enough data */
  notEnoughData?: Maybe<Scalars['Boolean']>;
  /** Number of pulls in the past 24 hours */
  numPullsInPast24Hours?: Maybe<Scalars['Int']>;
  /** TU ID */
  tuId?: Maybe<Scalars['String']>;
  /** The previous status */
  previousStatus?: Maybe<CreditProfileAuthStatus>;
  /** Short message about the status of the operation (TU Initialized, User Already Active, etc.) */
  message?: Maybe<Scalars['String']>;
  /** More details on top of the message (e.g. User already has activated TU on same NW account) */
  description?: Maybe<Scalars['String']>;
};

export enum CreditProfileAuthThinFileReason {
  /** TU is enforcing rate limiting */
  Duplicate = 'DUPLICATE',
  /** True ThinFile - user lacks enough data to generate exam */
  NoData = 'NO_DATA',
  /** User has been 'fuzzy matched' but something doesn't look right */
  FailVerification = 'FAIL_VERIFICATION',
  /** Catch all */
  Other = 'OTHER'
}

export type CreditRangeMap = {
  __typename?: 'CreditRangeMap';
  /** average insurance cost for a good credit score */
  withGoodCredit: Scalars['Float'];
  /** average insurance cost for a poor credit score */
  withPoorCredit: Scalars['Float'];
};

export type CreditScoreActivationStatusResponse = MembershipFeatureActivationStatusInterface & {
  __typename?: 'CreditScoreActivationStatusResponse';
  id: MembershipFeatureEnum;
  status: MembershipFeatureActivationStatusEnum;
  /** If the user is blocked from using the Credit Score feature, this field indicates the reason why. */
  blockedReason?: Maybe<CreditScoreBlockedReasonEnum>;
  /** If the user has a thin file, this field indicates the reason why. */
  thinFileReason?: Maybe<CreditProfileAuthThinFileReason>;
};

export type CreditScoreActivationVisualization = UserInsightDataVisualizationInterface & {
  __typename?: 'CreditScoreActivationVisualization';
  /** This will always be CREDIT_SCORE_ACTIVATION */
  dataVisualizationType: UserInsightDataVisualizationTypeEnum;
};

/**
 * This enum represents each of the possible reasons why the user might be blocked from using the Credit Score feature.
 *
 * Note that it intentionally deviates from the semantics of the underlying data model in order to better align
 * with the product experience.
 */
export enum CreditScoreBlockedReasonEnum {
  Deceased = 'DECEASED',
  DuplicateEmail = 'DUPLICATE_EMAIL',
  NotEnoughData = 'NOT_ENOUGH_DATA',
  RateLimited = 'RATE_LIMITED',
  ThinFile = 'THIN_FILE'
}

export type CreditScoreChangeInfo = {
  __typename?: 'CreditScoreChangeInfo';
  /** User's current credit score */
  currentScore?: Maybe<Scalars['Int']>;
  /** User's previous credit score */
  previousScore?: Maybe<Scalars['Int']>;
  /** User's projected future credit score */
  projectedScore?: Maybe<Scalars['Int']>;
  /** User's current credit bucket */
  currentBucket?: Maybe<TuVantageScore3Buckets>;
  /** User's previous credit bucket */
  previousBucket?: Maybe<TuVantageScore3Buckets>;
  /** User's projected future credit bucket */
  projectedBucket?: Maybe<TuVantageScore3Buckets>;
};

/** A credit score history data point */
export type CreditScoreHistoryDatum = {
  __typename?: 'CreditScoreHistoryDatum';
  /** The credit score associated with the pull date */
  vantageScore3?: Maybe<Scalars['Int']>;
  /** The date the credit score was pulled at */
  date?: Maybe<Scalars['DateTime']>;
};

export type CreditScoreHistoryInput = {
  /** The interval to obtain the credit score history */
  interval: CreditScoreHistoryIntervalEnum;
  /** The end date to obtain the credit score history */
  endDate: Scalars['DateTime'];
  /** The start date to obtain the credit score history */
  startDate: Scalars['DateTime'];
};

/** Represents all possible credit score history intervals */
export enum CreditScoreHistoryIntervalEnum {
  All = 'ALL',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type CreditScoreHistoryResponse = {
  __typename?: 'CreditScoreHistoryResponse';
  /** An array of credit score data points used to represent a user's credit score history */
  data?: Maybe<Array<CreditScoreHistoryDatum>>;
};

/**
 * Deprecated: The service that serves this insight type has been retired as an inventory source
 *
 * A user insight sourced from credit-service
 */
export type CreditScoreInsight = UserInsightInterface & {
  __typename?: 'CreditScoreInsight';
  /**
   * A human-readable identifier for a particular insight inventory item.  Primarily used for analytics.
   *
   * Note that the slug field is the same across all instances of a particular insight (whereas the id field is unique).
   *
   * Example: credit-score-utilization-increase-by-ten-or-more-points
   */
  slug?: Maybe<Scalars['String']>;
  /**
   * The primary identifier for a UserInsight.  Primarily used for tracking user engagement.
   *
   * Because insight inventory items are typically stateless and do not have proper database IDs, this field will generally
   * be inferred by source-specific heuristics.
   *
   * Note that the id field is unique across all instances of a particular insight (whereas the slug field is not).
   */
  id: Scalars['ID'];
  /** Language that summarizes or introduces the insight. */
  title?: Maybe<Scalars['String']>;
  /** The insights regeneration group. */
  regenerationGroup?: Maybe<UserInsightRegenerationGroupEnum>;
  /** Language that describes the insight in detail. */
  description?: Maybe<Scalars['String']>;
  /** General suggestions related to this insight that are not immediately actionable are surfaced as a "tip" */
  tip?: Maybe<UserInsightTip>;
  /**
   * A measure of how impactful this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * impact)
   *
   * For example, a large transaction alert would be high-urgency while a credit card recommendation would be low-urgency.
   */
  impact?: Maybe<Scalars['Float']>;
  /**
   * A measure of how urgent this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * urgency)
   *
   * For example, a large transaction alert would be high-urgency while a credit card recommendation would be
   * low-urgency.
   */
  urgency?: Maybe<Scalars['Float']>;
  /**
   * Information about the ML model used to produce a personalized ranking score for the current user about a particular
   * insight.
   */
  personalizedRankingScore?: Maybe<UserInsightPersonalizedRankingScore>;
  /**
   * A qualitative indication of how the user should feel about a particular insight.  Used primarily to inform UI
   * treatment (e.g. red vs. yellow vs. blue accent color).
   *
   * Note that a NEUTRAL sentiment value means that the insight is explicitly assessed to be of neutral sentiment, whereas
   * the absence of a sentiment value means that the sentiment is unknown.
   */
  sentiment?: Maybe<UserInsightSentimentEnum>;
  /** The actions that we recommend for the user to perform based on this insight. */
  actions: Array<UserAction>;
  /** Insights may be related to one or more features, which are represented via this field. */
  relatedFeatures?: Maybe<Array<MembershipFeatureEnum>>;
  /**
   * The source of truth for this particular insight (typically a service or a CMS).
   *
   * Used primarily to infer the type of a particular UserInsightInterface instance.
   */
  inventorySource: UserInsightInventorySourceEnum;
  /** An object containing the data necessary to render the data visualization for this insight. */
  dataVisualization?: Maybe<UserInsightDataVisualizationInterface>;
  /** An image to be displayed with the insight near the description. */
  bodyImage?: Maybe<UserInsightImage>;
  /**
   * This field encapsulates the concept of an increase or gain to a user’s personal finances.
   *
   * This could range from credit score increases to an increase in savings or debt.
   */
  gain?: Maybe<UserInsightGain>;
  /** The UX modules that this insight may appear in. */
  eligibleModules?: Maybe<Array<UserInsightEligibleModulesEnum>>;
  /** The eligibility configuration for the current client */
  clientEligibilityConfig?: Maybe<ClientEligibilityConfig>;
};

export type CreditSimulationInput = {
  /** Simulates a credit score depending if child support is added */
  addChildSupport?: InputMaybe<Scalars['Boolean']>;
  /** Simulates a credit score depending if a foreclosure is added */
  addForeclosure?: InputMaybe<Scalars['Boolean']>;
  /** Simulates a credit score depending if tax lien is added */
  addTaxLien?: InputMaybe<Scalars['Boolean']>;
  /** Simulates a credit score depending if wage garnishment is added */
  addWageGarnishment?: InputMaybe<Scalars['Boolean']>;
  /** Simulates a credit score given all accounts are past due for a number of days (valid number of days: 30, 60 or 90 days) */
  allAccountsPastDueNumDays?: InputMaybe<Scalars['Int']>;
  /** Simulates a credit score depending if a number of credit card is applied for */
  applyForNumberOfCreditCard?: InputMaybe<Scalars['Boolean']>;
  /** Simulates a credit score depending if the user's oldest credit card is closed */
  closeOldestCreditCard?: InputMaybe<Scalars['Boolean']>;
  /** Simulates a credit score given the user's credit balance is decreased by a certain amount */
  decreaseCreditBalanceAmount?: InputMaybe<Scalars['Int']>;
  /** Simulates a credit score given the user's credit balance is increased by a certain amount */
  increaseCreditBalanceAmount?: InputMaybe<Scalars['Int']>;
  /** Simulates a credit score given the user's credit card limit is increased by a certain amount */
  increaseCreditCardLimit?: InputMaybe<Scalars['Int']>;
  /** Simulates a credit score depending if an account is moved into collection */
  moveOneAccountIntoCollection?: InputMaybe<Scalars['Boolean']>;
  /** Simulates a credit score given the user obtains an auto loan limit for a certain amount */
  obtainAutoLoanLimit?: InputMaybe<Scalars['Int']>;
  /** Simulates a credit score given the user obtains a credit card limit for a certain amount */
  obtainCreditCardLimit?: InputMaybe<Scalars['Int']>;
  /** Simulates a credit score given the user obtains a mortgage limit for a certain amount */
  obtainMortgageLimit?: InputMaybe<Scalars['Int']>;
  /** Simulates a credit score given the user obtains a personal loan limit for a certain amount */
  obtainPersonalLoanLimit?: InputMaybe<Scalars['Int']>;
  /** Simulates a credit score given the user makes on time payments for a certain number of months (minimum months: 1, maximum months: 24) */
  onTimePaymentsNumMonths?: InputMaybe<Scalars['Int']>;
  /** Simulates a credit score given the user has one account past due for a certain number of days (valid number of days: 30, 60 or 90 days) */
  oneAccountPastDueNumDays?: InputMaybe<Scalars['Int']>;
  /** Simulates a credit score depending if all credit cards are paid off */
  payOffAllCreditCards?: InputMaybe<Scalars['Boolean']>;
  /** Simulates a credit score given the user transfers their credit balance for a certain amount */
  transferCreditBalanceAmount?: InputMaybe<Scalars['Int']>;
};

/** The object representing the size of the image. */
export type CroppedImageSize = {
  __typename?: 'CroppedImageSize';
  /** The file name for this crop size. */
  file?: Maybe<Scalars['String']>;
  /** The height of this crop size in pixels. */
  height?: Maybe<Scalars['Int']>;
  /** The mime type for this crop size. */
  mimeType?: Maybe<Scalars['String']>;
  /** The name of the crop size. */
  size: MediaItemImageSizeEnum;
  /** The full url path to the crop of this image. */
  sourceUrl?: Maybe<Scalars['URL']>;
  /** The width of this crop size in pixels. */
  width?: Maybe<Scalars['Int']>;
};

export type CursorPaginationInput = {
  /** The ID of the item from which pagination should start reading backwards. */
  before?: InputMaybe<Scalars['ID']>;
  /** The ID of the item from which pagination should start reading forwards. */
  after?: InputMaybe<Scalars['ID']>;
  /** The number of items to return in the pagination */
  limit?: InputMaybe<Scalars['Int']>;
};

/** Enum values for dateDisplayFormat field on Article type. */
export enum DateDisplayFormatEnum {
  Default = 'DEFAULT',
  MonthAndYear = 'MONTH_AND_YEAR'
}

export enum DebtActivationState {
  Unknown = 'Unknown',
  Unactivated = 'Unactivated',
  Activated = 'Activated',
  BlockedTu = 'BlockedTU',
  BlockedDti = 'BlockedDTI',
  BlockedNoDebtTradelines = 'BlockedNoDebtTradelines'
}

export type DebtRecentChange = {
  __typename?: 'DebtRecentChange';
  actions?: Maybe<Array<AppAction>>;
  body?: Maybe<Scalars['String']>;
  condition: Scalars['String'];
  debtType?: Maybe<DebtTypes>;
  label?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  takeaway?: Maybe<Scalars['String']>;
};

export type DebtSummary = {
  __typename?: 'DebtSummary';
  activatedAt?: Maybe<Scalars['DateTime']>;
  activationState?: Maybe<DebtActivationState>;
  annualGrossIncome?: Maybe<Scalars['Float']>;
  debtFreeDateFormat?: Maybe<Scalars['DateTime']>;
  /**
   * A user-friendly approximation of how much time until they will be debt-free
   *
   * Example: `9¾ years`
   */
  debtFreeDateDisplayString?: Maybe<Scalars['String']>;
  isRecentlyActivatedUser?: Maybe<Scalars['Boolean']>;
  lastUpdated?: Maybe<Scalars['DateTime']>;
  previousTotalDebtAmount?: Maybe<Scalars['Float']>;
  primaryDebtMotivation?: Maybe<Scalars['String']>;
  recentChanges?: Maybe<Array<DebtRecentChange>>;
  totalDebtAmount?: Maybe<Scalars['Float']>;
  /** The percent change from the user’s previous total debt amount to their current total debt amount */
  totalDebtChangePercent?: Maybe<Scalars['Float']>;
};

export enum DebtTypes {
  CreditCard = 'credit_card',
  AutoLoan = 'auto_loan',
  PersonalLoan = 'personal_loan',
  StudentLoan = 'student_loan',
  Deferred = 'deferred'
}

/** declinePersonalLoanOffersSearch response */
export type DeclinePersonalLoanOffers = {
  __typename?: 'DeclinePersonalLoanOffers';
  /** The total number of offers map to the loan purpose. */
  total: Scalars['Int'];
  /** List of marketplace entities that match the query. */
  entities?: Maybe<Array<MarketplaceEntityInterface>>;
};

/** Input for decline results offers query */
export type DeclineResultsQueryInputs = {
  loanPurpose: PersonalLoansPrequalLoanPurposeEnum;
};

export type DeleteFinancialPortalResponse = {
  __typename?: 'DeleteFinancialPortalResponse';
  success: Scalars['Boolean'];
};

export type DeleteFinancialTransactionResponse = {
  __typename?: 'DeleteFinancialTransactionResponse';
  success: Scalars['Boolean'];
};

/** Wraps the delete net worth real API response, which allows for adding fields at a later date */
export type DeleteNetWorthRealAssetResponse = {
  __typename?: 'DeleteNetWorthRealAssetResponse';
  success: Scalars['Boolean'];
};

export type DeleteUserFinancialAccountResponse = {
  __typename?: 'DeleteUserFinancialAccountResponse';
  success: Scalars['Boolean'];
};

/** Types of drivers variations for a Roundup section */
export enum DriversVariationTypeEnum {
  DefaultDrivers = 'DEFAULT_DRIVERS',
  NativeDrivers = 'NATIVE_DRIVERS'
}

/**
 * Wraps the edit Net Worth Real Asset Self-Reported API response, which allows for adding fields at a
 * later date
 */
export type EditNetWorthRealAssetSelfReportedResponse = {
  __typename?: 'EditNetWorthRealAssetSelfReportedResponse';
  asset: NetWorthRealAssetSelfReported;
};

/** A Education Loans institution */
export type EducationLoansInstitutionV2 = MarketplaceEntityInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceInstitutionInterface & {
  __typename?: 'EducationLoansInstitutionV2';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** A URL that points to the logo for the institution */
  imageSource?: Maybe<Scalars['URL']>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** The overall editorial rating for the institution. */
  starRating?: Maybe<Scalars['Float']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']>;
};

/** A Education Loans offer */
export type EducationLoansOfferV2 = MarketplaceEntityInterface & MarketplaceEntityWithBestOfAwards2021Interface & MarketplaceEntityWithBestOfAwardsInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithQualificationsInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceOfferInterface & {
  __typename?: 'EducationLoansOfferV2';
  /** Redirect link for this Offer */
  applyLink?: Maybe<Scalars['URL']>;
  /** Available term lengths for the offer */
  availableTermLengths?: Maybe<Scalars['String']>;
  /** The list of NW Best-Of Awards this offer has won for 2021 */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']>>;
  /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  consBullets?: Maybe<Array<Scalars['String']>>;
  /** Disclaimer for the offer */
  disclaimer?: Maybe<Scalars['String']>;
  /** The display name for the entity (auto-generated) */
  displayName?: Maybe<Scalars['String']>;
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /** Whether this Offer is monetizing. Client apps use this field to decide display behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA */
  isMonetizing?: Maybe<Scalars['Boolean']>;
  /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
  monetizable: Scalars['String'];
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  product: EducationLoansProductV2;
  /** Product type */
  productType: Scalars['String'];
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  prosBullets?: Maybe<Array<Scalars['String']>>;
  /** List of qualifications for the offer */
  qualificationsBullets?: Maybe<Array<Scalars['String']>>;
  /** The URL to the NerdWallet review of this offer. */
  reviewLink?: Maybe<Scalars['URL']>;
  /** The overall editorial rating for this Offer. */
  starRating?: Maybe<Scalars['Float']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  tagline?: Maybe<Scalars['String']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The Best Of Awards that this offer has won */
  bestOfAwards?: Maybe<Array<BestOfAward>>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The driver min credit score associated with the entity */
  driverMinCreditScore?: Maybe<EntityPlacementDriver>;
  /** The driver fixed apr with annotation associated with the entity */
  driverFixedAprWithAnnotation?: Maybe<EntityPlacementDriver>;
  /** The driver variable apr with annotation associated with the entity */
  driverVariableAprWithAnnotation?: Maybe<EntityPlacementDriver>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /**
   * The drivers associated with the entity
   * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
   */
  placementDrivers: Array<EntityPlacementDriver>;
  /** A boolean indicating if the display name should be shown in the comparison table component */
  showNameInComparisonTable: Scalars['Boolean'];
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']>;
  /** Flag for whether to use the large product card image styles */
  useLargeImageFootprint: Scalars['Boolean'];
};

/** A Education Loans product */
export type EducationLoansProductV2 = MarketplaceEntityInterface & MarketplaceProductInterface & {
  __typename?: 'EducationLoansProductV2';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  institution: EducationLoansInstitutionV2;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

export type EmailOnlyRegisteredUserActivationStatusResponse = MembershipFeatureActivationStatusInterface & {
  __typename?: 'EmailOnlyRegisteredUserActivationStatusResponse';
  id: MembershipFeatureEnum;
  status: MembershipFeatureActivationStatusEnum;
};

/** A type that represents an empty object. */
export type EmptyObject = {
  __typename?: 'EmptyObject';
  _empty?: Maybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_eng_post post type from WordPress. */
export type EngineeringPost = PostInterface & PostWithAuthorsInterface & PostWithContentClassificationInterface & PostWithContentInterface & PostWithExcerptInterface & PostWithFeaturedImageInterface & PostWithSeoInterface & PostWithTitleInterface & {
  __typename?: 'EngineeringPost';
  /** The assigning editor set on the content. */
  assigningEditor?: Maybe<Author>;
  /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
  attributionTopic?: Maybe<Scalars['String']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The structured content for the resource. */
  content?: Maybe<Scalars['StructuredContentDocument']>;
  /** Additional content clusters for this piece of content. */
  contentClusters?: Maybe<Array<Scalars['String']>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']>;
  /** The editorial excerpt of the resource. */
  excerpt?: Maybe<Scalars['String']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']>;
  /** The primary content cluster for this piece of content. */
  primaryContentCluster?: Maybe<Scalars['String']>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']>>;
};


/** Type modeling the data for posts within the nw_eng_post post type from WordPress. */
export type EngineeringPostDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_eng_post post type from WordPress. */
export type EngineeringPostExcerptArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};


/** Type modeling the data for posts within the nw_eng_post post type from WordPress. */
export type EngineeringPostModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_eng_post post type from WordPress. */
export type EngineeringPostTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type EngineeringPostConnectionResponse = {
  __typename?: 'EngineeringPostConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The EngineeringPost returned for the connection. */
  items?: Maybe<Array<EngineeringPost>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of EngineeringPost objects. */
export type EngineeringPostFilterInput = {
  /** Limit collection to EngineeringPosts published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit results to those with the specified cluster. */
  cluster?: InputMaybe<Scalars['String']>;
  /** Limit results to those with the specified Assigning Editor, filtered by ID. */
  editorIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Limit collection to EngineeringPosts with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to EngineeringPosts with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

export type EntityPlacementAnalyticsProps = {
  __typename?: 'EntityPlacementAnalyticsProps';
  /** The marketplace UUID for the associated institution. */
  institutionId: Scalars['ID'];
  /** The marketplace UUID for the associated offer. Null for institutions and products. */
  offerId?: Maybe<Scalars['ID']>;
  /** The marketplace UUID for the associated product. Null for institutions. */
  productId?: Maybe<Scalars['ID']>;
  /**
   * Boolean indicating if the entity can log a legacy impression. This is only used for legacy
   * analytics and can be removed after the Bedrock cutover.
   */
  hasLegacyImpression: Scalars['Boolean'];
  /**
   * Additional data to be sent to legacy impression events. This is only used for legacy
   * analytics and can be removed after the Bedrock cutover.
   */
  legacyAdditionalEventData?: Maybe<Scalars['JSON']>;
  /**
   * The entity's issuer name. This is only used for legacy analytics and can be removed after
   * the Bedrock cutover.
   */
  legacyIssuer: Scalars['String'];
  /**
   * The entity slug. This is only used for legacy analytics and can be removed after
   * the Bedrock cutover.
   */
  legacySlug?: Maybe<Scalars['String']>;
  /**
   * The vertical name to use to map to the legacy impression. This is only used for legacy
   * analytics and can be removed after the Bedrock cutover.
   */
  legacyVertical?: Maybe<Scalars['String']>;
};

export type EntityPlacementCta = {
  __typename?: 'EntityPlacementCTA';
  /** The destination url of the CTA */
  link: Scalars['URL'];
  /** Whether or not to show the icon in the CTA */
  showIcon: Scalars['Boolean'];
  /** The text to show underneath the CTA button */
  subtext?: Maybe<Scalars['String']>;
  /** The button/link text to show for the CTA */
  text: Scalars['String'];
  /** The ultimate destination type of the CTA */
  type: EntityPlacementCtaTypeEnum;
};

export enum EntityPlacementCtaTypeEnum {
  ApplyNow = 'APPLY_NOW',
  Prequal = 'PREQUAL',
  ReadReview = 'READ_REVIEW'
}

export type EntityPlacementDriver = {
  __typename?: 'EntityPlacementDriver';
  /** The driver description */
  description?: Maybe<Scalars['String']>;
  /** The driver id */
  id: Scalars['String'];
  /** The driver label */
  label: Scalars['String'];
  /** The tooltip associated with the driver label */
  labelTooltip?: Maybe<Scalars['String']>;
  /** The driver value */
  value?: Maybe<Scalars['String']>;
  /** The driver tooltip */
  tooltip?: Maybe<Scalars['StructuredContentDocument']>;
  /** The driver tooltip (no SC) */
  valueTooltip?: Maybe<Scalars['String']>;
  /** Whether or not the value tooltip has HTML in it */
  valueTooltipHasHtml: Scalars['Boolean'];
};

export type EntityPlacementImage = {
  __typename?: 'EntityPlacementImage';
  /** The alt text that will accompany the logo */
  alt?: Maybe<Scalars['String']>;
  /** The height of the image, in px */
  height?: Maybe<Scalars['Int']>;
  /**
   * The relative image path for CloudFlare's image optimization service.
   * Can be used to build an image URL with custom height/width/quality.
   */
  resizableImagePath?: Maybe<Scalars['String']>;
  /** The URL for the logo */
  source?: Maybe<Scalars['URL']>;
  /** The URL for the large-size logo */
  sourceLarge?: Maybe<Scalars['URL']>;
  /** The URL for the medium-size logo */
  sourceMedium?: Maybe<Scalars['URL']>;
  /** The width of the image, in px */
  width?: Maybe<Scalars['Int']>;
};

export type ExpandedMarketplaceStaticOffer = {
  __typename?: 'ExpandedMarketplaceStaticOffer';
  /** Fields provided by marketplace */
  marketplaceOffer: PersonalLoansOfferV2;
  /** Loan amount retrieved from the user's profile */
  loanAmount: Scalars['Float'];
  /** Loan term months is hardcoded to 24 because we don't have an input asking for loan term, but we need loan term to calculate monthly payment */
  loanTermMonths: Scalars['Int'];
};

export type Experiment = {
  __typename?: 'Experiment';
  /** The name of the experiment */
  experimentName: Scalars['String'];
  /** The ID of the experiment */
  experimentId: Scalars['String'];
  /**
   * The ID of the variant the requesting user is bucketed into.
   * This accounts for variants forced using a request header or query param on the originating URL of the form \`test_[testname]=[variantname]\`
   */
  assignedVariant: Scalars['String'];
  /**
   * The name of the variant the requesting user is bucketed into.
   * This accounts for variants forced using a request header or query param on the originating URL of the form \`test_[testname]=[variantname]\`
   */
  assignedVariantName: Scalars['String'];
  /** Is the variant forced via query param. Variants can be forced using a request header or query param on the originating URL of the form \`test_[testname]=[variantname]\` */
  isForcedVariant: Scalars['Boolean'];
  rampNum: Scalars['Int'];
  usesEEE: Scalars['Boolean'];
  variants: Array<Maybe<Variant>>;
};

export type ExperimentDecision = {
  __typename?: 'ExperimentDecision';
  /** The name of the experiment. */
  experimentName: Scalars['String'];
  /**
   * The name of the variant the requesting user is bucketed into. If the given experimentName is not found,
   * this value is empty. This is different from a valid default variant, which is usually called 'control'.
   */
  assignedVariantName: Scalars['String'];
  /**
   * The UUIDs of the MODEL_EXECUTED events associated with this decision.
   * These should be used in downstream event headers; for more details
   * see: https://github.com/NerdWallet/app-schemata/blob/master/analytic_pipeline/model_executed.yaml
   */
  modelExecutionIds: Array<Scalars['ID']>;
};

/** FacetCategory represents the category name, the number of matched WP entites, and whether it was selected */
export type FacetCategory = {
  __typename?: 'FacetCategory';
  value: Scalars['String'];
  count: Scalars['Int'];
  selected: Scalars['Boolean'];
};

/** FacetContentType represents more about the WP entities returned by the search */
export type FacetContentType = {
  __typename?: 'FacetContentType';
  value: Scalars['String'];
  count: Scalars['Int'];
  selected: Scalars['Boolean'];
};

/** Facets are metadata about the search results, particularly a list of results grouped by category and content type */
export type Facets = {
  __typename?: 'Facets';
  /** The name of the category */
  category?: Maybe<Array<FacetCategory>>;
  /** The content-type */
  contentType?: Maybe<Array<FacetContentType>>;
};

export type FeatureDiscoveryResponse = {
  __typename?: 'FeatureDiscoveryResponse';
  isEnabled: Scalars['Boolean'];
  details?: Maybe<WebFeatureDiscoveryDetails>;
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  /** The name of the feature flag */
  name: Scalars['String'];
  /**
   * The value of the feature flag.
   * This accounts for values forced using a request header or query param on the originating URL of the form `feat_[featurename]=[true|false]`
   */
  value: Scalars['Boolean'];
  /**
   * Extra feature data
   * This accounts for values forced using a request header or query param on the originating URL of the form `feat_[featurename]_data=<stringified_json>`
   */
  extraData?: Maybe<Scalars['JSON']>;
  /**
   * Is the value or extraData forced.
   * values can be forced using a request header or query param on the originating URL of the form `feat_[featurename]=[true|false]`
   * extraData can be forced using a request header or query param on the originating URL of the form `feat_[featurename]_data=<stringified_json>`
   */
  isForced: Scalars['Boolean'];
};

/** The `FeedCard` represents the card JSON shape. */
export type FeedCard = {
  __typename?: 'FeedCard';
  id: Scalars['Int'];
  slug?: Maybe<Scalars['String']>;
  cardTemplate?: Maybe<FeedCardTemplate>;
  recommendation?: Maybe<FeedCardRecommendation>;
  fields?: Maybe<FeedCardFields>;
  displayPlatforms?: Maybe<Scalars['String']>;
  indexInStatement?: Maybe<Scalars['Int']>;
};

/** The `FeedCardAction` type represents shape each item in the primary_actions JSON array takes. */
export type FeedCardAction = {
  __typename?: 'FeedCardAction';
  href?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  type?: Maybe<Scalars['String']>;
};

/**
 * The `FeedCardFields` represents the fields JSON shape. Data contains all fields not shared
 * by all card templates. cardActions will be renamed primaryActions to match the JSON response once the apollo plural codegen error is resolved.
 */
export type FeedCardFields = {
  __typename?: 'FeedCardFields';
  data?: Maybe<Scalars['JSON']>;
  primaryAction?: Maybe<FeedCardPrimaryAction>;
  cardActions?: Maybe<Array<Maybe<FeedCardAction>>>;
  primaryCta?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/**
 * Deprecated: The service that serves this insight type has been retired as an inventory source
 *
 * A user insight sourced from the Feed CMS (includes feed cards and Nerds-Eye View items)
 */
export type FeedCardInsight = UserInsightInterface & {
  __typename?: 'FeedCardInsight';
  /**
   * A human-readable identifier for a particular insight inventory item.  Primarily used for analytics.
   *
   * Note that the slug field is the same across all instances of a particular insight (whereas the id field is unique).
   *
   * Example: credit-score-utilization-increase-by-ten-or-more-points
   */
  slug?: Maybe<Scalars['String']>;
  /**
   * The primary identifier for a UserInsight.  Primarily used for tracking user engagement.
   *
   * Because insight inventory items are typically stateless and do not have proper database IDs, this field will generally
   * be inferred by source-specific heuristics.
   *
   * Note that the id field is unique across all instances of a particular insight (whereas the slug field is not).
   */
  id: Scalars['ID'];
  /** Language that summarizes or introduces the insight. */
  title?: Maybe<Scalars['String']>;
  /** The insights regeneration group. */
  regenerationGroup?: Maybe<UserInsightRegenerationGroupEnum>;
  /** Language that describes the insight in detail. */
  description?: Maybe<Scalars['String']>;
  /** General suggestions related to this insight that are not immediately actionable are surfaced as a "tip" */
  tip?: Maybe<UserInsightTip>;
  /**
   * A measure of how impactful this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * impact)
   *
   * For example, a large transaction alert would be high-urgency while a credit card recommendation would be low-urgency.
   */
  impact?: Maybe<Scalars['Float']>;
  /**
   * A measure of how urgent this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * urgency)
   *
   * For example, a large transaction alert would be high-urgency while a credit card recommendation would be
   * low-urgency.
   */
  urgency?: Maybe<Scalars['Float']>;
  /**
   * Information about the ML model used to produce a personalized ranking score for the current user about a particular
   * insight.
   */
  personalizedRankingScore?: Maybe<UserInsightPersonalizedRankingScore>;
  /**
   * A qualitative indication of how the user should feel about a particular insight.  Used primarily to inform UI
   * treatment (e.g. red vs. yellow vs. blue accent color).
   *
   * Note that a NEUTRAL sentiment value means that the insight is explicitly assessed to be of neutral sentiment, whereas
   * the absence of a sentiment value means that the sentiment is unknown.
   */
  sentiment?: Maybe<UserInsightSentimentEnum>;
  /** The actions that we recommend for the user to perform based on this insight. */
  actions: Array<UserAction>;
  /** Insights may be related to one or more features, which are represented via this field. */
  relatedFeatures?: Maybe<Array<MembershipFeatureEnum>>;
  /**
   * The source of truth for this particular insight (typically a service or a CMS).
   *
   * Used primarily to infer the type of a particular UserInsightInterface instance.
   */
  inventorySource: UserInsightInventorySourceEnum;
  /** An object containing the data necessary to render the data visualization for this insight. */
  dataVisualization?: Maybe<UserInsightDataVisualizationInterface>;
  /** An image to be displayed with the insight near the description. */
  bodyImage?: Maybe<UserInsightImage>;
  /**
   * This field encapsulates the concept of an increase or gain to a user’s personal finances.
   *
   * This could range from credit score increases to an increase in savings or debt.
   */
  gain?: Maybe<UserInsightGain>;
  /** The UX modules that this insight may appear in. */
  eligibleModules?: Maybe<Array<UserInsightEligibleModulesEnum>>;
  /** The eligibility configuration for the current client */
  clientEligibilityConfig?: Maybe<ClientEligibilityConfig>;
  /**
   * The number of days after which a FeedCardInsight can be considered "new" to the user.
   * Clients should disregard all local user engagement data that is older than this value.
   * @deprecated All returned UIAs should be considered non-expired.
   */
  expiresInDays?: Maybe<Scalars['Int']>;
};

/** The `FeedCardPrimaryAction` represents the primary_action JSON shape. */
export type FeedCardPrimaryAction = {
  __typename?: 'FeedCardPrimaryAction';
  mobileTarget?: Maybe<Scalars['String']>;
  target?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** The `FeedCardRecommendation` represents the recommendation JSON shape. */
export type FeedCardRecommendation = {
  __typename?: 'FeedCardRecommendation';
  id: Scalars['Int'];
  actionTarget?: Maybe<Scalars['String']>;
  actionText?: Maybe<Scalars['String']>;
  actionType?: Maybe<Scalars['String']>;
  actionMobileTarget?: Maybe<Scalars['String']>;
};

/** The `FeedCardTemplate` represents the card_template JSON shape. */
export type FeedCardTemplate = {
  __typename?: 'FeedCardTemplate';
  id?: Maybe<Scalars['String']>;
  renderId?: Maybe<Scalars['String']>;
};

/** The `FeedStatement` represents the statement JSON shape. */
export type FeedStatement = {
  __typename?: 'FeedStatement';
  id: Scalars['Int'];
  slug?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
};

/**
 * Field documentation:
 * https://docs.nerdwallet.io/financial-data-platform/branches/master/swagger-crud/#tag/accounts
 */
export type FinancialAccount = {
  __typename?: 'FinancialAccount';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  identityId: Scalars['ID'];
  primarySource?: Maybe<FinancialDataSource>;
  sequenceNumber: Scalars['Int'];
  source?: Maybe<FinancialDataSource>;
  sourceEntityId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  autoRefreshRequired?: Maybe<Scalars['Boolean']>;
  /**  The "cent-normalized" account balance as an integer. e.g. 100 equals $1.00  */
  balance?: Maybe<Scalars['BigInt']>;
  /**  The currency code that transactions on the account are in  */
  currency?: Maybe<Scalars['FinancialCurrency']>;
  /**  JSON Formatted fields related to specific account types: APR, CreditLimit, etc  */
  extra?: Maybe<Scalars['JSON']>;
  /**  The financial portal under which the account resides  */
  financialPortal?: Maybe<FinancialPortal>;
  /**  IAV verification status flag  */
  iavVerified?: Maybe<Scalars['Boolean']>;
  /**  The date at which the account was last synced  */
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  /**  Account mask  */
  mask?: Maybe<Scalars['String']>;
  /**  Account name  */
  name?: Maybe<Scalars['String']>;
  /**  Account status  */
  status?: Maybe<FinancialAccountStatus>;
  /**  Account sub-type  */
  subtype?: Maybe<FinancialAccountSubtype>;
  /**  Account sub-type details, e.g. "CHECKING_ACCOUNT", "PREPAID_CARD", "FSA"  */
  subtypeDetails?: Maybe<Scalars['String']>;
  /**  Timestamp of the last transactions sync for the account  */
  transactionsSyncedAt?: Maybe<Scalars['DateTime']>;
  /**  The type of account, e.g. "bank" or "investment"  */
  type?: Maybe<FinancialAccountType>;
  /**  Verification state of the account  */
  verificationState?: Maybe<Scalars['String']>;
  /**  Whether the account is included in calculations and visible to the user  */
  isHidden?: Maybe<Scalars['Boolean']>;
};

export enum FinancialAccountAccountNames {
  NwManualTransactionAccount = 'NW_MANUAL_TRANSACTION_ACCOUNT'
}

export type FinancialAccountsActivationVisualization = UserInsightDataVisualizationInterface & {
  __typename?: 'FinancialAccountsActivationVisualization';
  /** This will always be FINANCIAL_ACCOUNTS_ACTIVATION */
  dataVisualizationType: UserInsightDataVisualizationTypeEnum;
};

export type FinancialAccountsIavDetailsResponse = {
  __typename?: 'FinancialAccountsIAVDetailsResponse';
  details: Array<IavDetailsResponse>;
};

export type FinancialAccountSnapshot = {
  __typename?: 'FinancialAccountSnapshot';
  account_id: Scalars['ID'];
  amount: Scalars['Int'];
  created_at: Scalars['DateTime'];
  date: Scalars['DateTime'];
  identity_id: Scalars['ID'];
  updated_at: Scalars['DateTime'];
};

export enum FinancialAccountStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum FinancialAccountSubtype {
  Bill = 'BILL',
  Checking = 'CHECKING',
  CreditCard = 'CREDIT_CARD',
  Invalid = 'INVALID',
  Investment = 'INVESTMENT',
  Loan = 'LOAN',
  Other = 'OTHER',
  RealEstate = 'REAL_ESTATE',
  Retirement = 'RETIREMENT',
  Reward = 'REWARD',
  Savings = 'SAVINGS',
  Stuff = 'STUFF',
  Vehicle = 'VEHICLE'
}

export enum FinancialAccountType {
  Bank = 'BANK',
  Bill = 'BILL',
  CreditCard = 'CREDIT_CARD',
  Insurance = 'INSURANCE',
  Investment = 'INVESTMENT',
  Loan = 'LOAN',
  Other = 'OTHER',
  RealEstate = 'REAL_ESTATE',
  Reward = 'REWARD',
  Stuff = 'STUFF',
  Vehicle = 'VEHICLE'
}

export type FinancialAccountTypeSumsResponse = {
  __typename?: 'FinancialAccountTypeSumsResponse';
  /**  Sum of ALL assets, i.e. bank balances + investments in cents  */
  assets: Scalars['BigInt'];
  /**  Sum of bank balances in cents  */
  banks: Scalars['BigInt'];
  /**  Sum of bill balances in cents  */
  bills: Scalars['BigInt'];
  /**  Sum of credit card balances (unsigned) in cents  */
  creditCards: Scalars['BigInt'];
  /**  Sum of ALL debts (unsigned), i.e. credit card balances + loan balances in cents  */
  debts: Scalars['BigInt'];
  /**  Sum of investments in cents  */
  investments: Scalars['BigInt'];
  /**  Sum of loans (unsigned) in cents  */
  loans: Scalars['BigInt'];
  /**  Sum of other account balances in cents  */
  other: Scalars['BigInt'];
};

export enum FinancialDataSource {
  Nerdwallet = 'NERDWALLET',
  Plaid = 'PLAID',
  Qa = 'QA',
  Redfin = 'REDFIN',
  User = 'USER',
  Yodlee = 'YODLEE'
}

/** The `FinancialIdentityDebtTypes` type represents debt types of a user */
export type FinancialIdentityDebtTypes = {
  __typename?: 'FinancialIdentityDebtTypes';
  creditDebt?: Maybe<Scalars['Boolean']>;
  personalLoanDebt?: Maybe<Scalars['Boolean']>;
  autoLoanDebt?: Maybe<Scalars['Boolean']>;
  studentLoanDebt?: Maybe<Scalars['Boolean']>;
  mortgageDebt?: Maybe<Scalars['Boolean']>;
  medicalDebt?: Maybe<Scalars['Boolean']>;
  paydayLoanDebt?: Maybe<Scalars['Boolean']>;
  otherDebt?: Maybe<Scalars['Boolean']>;
};

/** The `FinancialIdentityProfile` type represents the user's financial profile */
export type FinancialIdentityProfile = {
  __typename?: 'FinancialIdentityProfile';
  id?: Maybe<Scalars['ID']>;
  annualIncome?: Maybe<Scalars['Float']>;
  monthlyNetIncome?: Maybe<Scalars['Float']>;
  currentSpousesAnnualIncome?: Maybe<Scalars['Int']>;
  employmentType?: Maybe<Scalars['String']>;
  cashSavingPattern?: Maybe<Scalars['String']>;
  currentSpendingPattern?: Maybe<Scalars['String']>;
  creditScore?: Maybe<Scalars['Int']>;
  creditScoreRange?: Maybe<Scalars['String']>;
  amountOwed?: Maybe<Scalars['Int']>;
  debtTypes?: Maybe<FinancialIdentityDebtTypes>;
  totalSavings?: Maybe<Scalars['Int']>;
  savingTypes?: Maybe<FinancialIdentitySavingTypes>;
  monthlyHousingCost?: Maybe<Scalars['Float']>;
  residenceOwnershipType?: Maybe<Scalars['String']>;
  accounts?: Maybe<Array<Maybe<UserReportedFinancialAccount>>>;
};

/** The `FinancialIdentitySavingTypes` type represents saving types of a user */
export type FinancialIdentitySavingTypes = {
  __typename?: 'FinancialIdentitySavingTypes';
  monthlyBills?: Maybe<Scalars['Boolean']>;
  travel?: Maybe<Scalars['Boolean']>;
  carExpenses?: Maybe<Scalars['Boolean']>;
  homeCosts?: Maybe<Scalars['Boolean']>;
  creditCardInterest?: Maybe<Scalars['Boolean']>;
  studentLoans?: Maybe<Scalars['Boolean']>;
};

/** A user insight sourced from financial-insights service */
export type FinancialInsight = UserInsightInterface & {
  __typename?: 'FinancialInsight';
  /**
   * A human-readable identifier for a particular insight inventory item.  Primarily used for analytics.
   *
   * Note that the slug field is the same across all instances of a particular insight (whereas the id field is unique).
   *
   * Example: credit-score-utilization-increase-by-ten-or-more-points
   */
  slug?: Maybe<Scalars['String']>;
  /**
   * The primary identifier for a UserInsight.  Primarily used for tracking user engagement.
   *
   * Because insight inventory items are typically stateless and do not have proper database IDs, this field will generally
   * be inferred by source-specific heuristics.
   *
   * Note that the id field is unique across all instances of a particular insight (whereas the slug field is not).
   */
  id: Scalars['ID'];
  /** Language that summarizes or introduces the insight. */
  title?: Maybe<Scalars['String']>;
  /** The insights regeneration group. */
  regenerationGroup?: Maybe<UserInsightRegenerationGroupEnum>;
  /** Language that describes the insight in detail. */
  description?: Maybe<Scalars['String']>;
  /** General suggestions related to this insight that are not immediately actionable are surfaced as a "tip" */
  tip?: Maybe<UserInsightTip>;
  /**
   * A measure of how impactful this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * impact)
   *
   * For example, a large transaction alert would be high-urgency while a credit card recommendation would be low-urgency.
   */
  impact?: Maybe<Scalars['Float']>;
  /**
   * A measure of how urgent this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * urgency)
   *
   * For example, a large transaction alert would be high-urgency while a credit card recommendation would be
   * low-urgency.
   */
  urgency?: Maybe<Scalars['Float']>;
  /**
   * Information about the ML model used to produce a personalized ranking score for the current user about a particular
   * insight.
   */
  personalizedRankingScore?: Maybe<UserInsightPersonalizedRankingScore>;
  /**
   * A qualitative indication of how the user should feel about a particular insight.  Used primarily to inform UI
   * treatment (e.g. red vs. yellow vs. blue accent color).
   *
   * Note that a NEUTRAL sentiment value means that the insight is explicitly assessed to be of neutral sentiment, whereas
   * the absence of a sentiment value means that the sentiment is unknown.
   */
  sentiment?: Maybe<UserInsightSentimentEnum>;
  /** The actions that we recommend for the user to perform based on this insight. */
  actions: Array<UserAction>;
  /** Insights may be related to one or more features, which are represented via this field. */
  relatedFeatures?: Maybe<Array<MembershipFeatureEnum>>;
  /**
   * The source of truth for this particular insight (typically a service or a CMS).
   *
   * Used primarily to infer the type of a particular UserInsightInterface instance.
   */
  inventorySource: UserInsightInventorySourceEnum;
  /** An object containing the data necessary to render the data visualization for this insight. */
  dataVisualization?: Maybe<UserInsightDataVisualizationInterface>;
  /** An image to be displayed with the insight near the description. */
  bodyImage?: Maybe<UserInsightImage>;
  /**
   * This field encapsulates the concept of an increase or gain to a user’s personal finances.
   *
   * This could range from credit score increases to an increase in savings or debt.
   */
  gain?: Maybe<UserInsightGain>;
  /** The UX modules that this insight may appear in. */
  eligibleModules?: Maybe<Array<UserInsightEligibleModulesEnum>>;
  /** The eligibility configuration for the current client */
  clientEligibilityConfig?: Maybe<ClientEligibilityConfig>;
};

/** Correlates to each of the "products" Plaid offers. Plaid breaks down the status of an institution on a per product basis. */
export type FinancialInstitutionStatusByProduct = {
  __typename?: 'FinancialInstitutionStatusByProduct';
  auth?: Maybe<FinancialInstitutionStatusByProductDetails>;
  balance?: Maybe<FinancialInstitutionStatusByProductDetails>;
  identity?: Maybe<FinancialInstitutionStatusByProductDetails>;
  itemLogins?: Maybe<FinancialInstitutionStatusByProductDetails>;
  transactionsUpdates?: Maybe<FinancialInstitutionStatusByProductDetails>;
};

export type FinancialInstitutionStatusByProductDetails = {
  __typename?: 'FinancialInstitutionStatusByProductDetails';
  lastStatusChange?: Maybe<Scalars['DateTime']>;
  status?: Maybe<PlaidInstitutionHealthStatus>;
};

export type FinancialInstitutionStatusResponse = {
  __typename?: 'FinancialInstitutionStatusResponse';
  status?: Maybe<FinancialInstitutionStatusByProduct>;
};

/**
 * Field documentation:
 * https://docs.nerdwallet.io/financial-data-platform/branches/master/swagger-crud/#tag/financial_portals
 */
export type FinancialPortal = {
  __typename?: 'FinancialPortal';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  identityId: Scalars['ID'];
  primarySource?: Maybe<FinancialDataSource>;
  sequenceNumber: Scalars['Int'];
  source?: Maybe<FinancialDataSource>;
  sourceEntityId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  /**  Accounts synchronization state for the portal  */
  accountsState?: Maybe<FinancialPortalProductState>;
  /**  A portal's migration state  */
  activeMigration?: Maybe<Scalars['Boolean']>;
  /**  The alert message returned by the souce.  */
  alertMessage?: Maybe<FinancialPortalAlertMessage>;
  /**  The type of alert returned  */
  alertName?: Maybe<Scalars['String']>;
  /**  The priority of the alert  */
  alertPriority?: Maybe<Scalars['String']>;
  /**  Authentication state of the portal  */
  authState?: Maybe<FinancialPortalAuthState>;
  /**  The time at which the authentication state was set (ms precision)  */
  authStateSetAt?: Maybe<Scalars['DateTime']>;
  /**  The id of the canonical institution this portal is associated with  */
  canonicalInstitutionId?: Maybe<Scalars['ID']>;
  /**  The error message returned by the source if auth state went into "ERROR"  */
  errorMessage?: Maybe<FinancialPortalErrorMessage>;
  /**  The type of error returned if the auth state went into "ERROR"  */
  errorName?: Maybe<Scalars['String']>;
  /**  The priority of the error  */
  errorPriority?: Maybe<Scalars['String']>;
  /**  Whether the portal's data is being fetched for the first time  */
  isActiveSync?: Maybe<Scalars['Boolean']>;
  /**  Whether the financial portal is being automatically refreshed  */
  isAutoRefreshing?: Maybe<Scalars['Boolean']>;
  /**  Whether the financial portal's balance is being refreshed  */
  isBalanceRefreshing?: Maybe<Scalars['Boolean']>;
  /**  Whether the financial portal is being manually refreshed  */
  isManualRefreshing?: Maybe<Scalars['Boolean']>;
  /**  Whether the portal is refreshable  */
  isRefreshable?: Maybe<Scalars['Boolean']>;
  /**  Whether the portal is current refreshing (an OR of all types of refreshing)  */
  isRefreshing?: Maybe<Scalars['Boolean']>;
  /**  The time at which the portal was last refreshed  */
  lastRefreshedAt?: Maybe<Scalars['DateTime']>;
  /**  The account aggregation institution this portal is associated with  */
  marketplaceInstitution?: Maybe<AccountAggregationInstitution>;
  /**
   * The id of the acct agg institution this portal is associated with. This can be used instead of
   * marketplaceInstitution.id to avoid an extra network request to marketplace
   */
  marketplaceInstitutionId?: Maybe<Scalars['ID']>;
  /**  Information on the state of a portal being migrated from vendor to vendor, if relevant  */
  migrationDetails?: Maybe<FinancialPortalMigrationDetails>;
  /**  The primary action for a client to take for an institution in a sub-optimal state  */
  primaryClientAction?: Maybe<FinancialPortalPrimaryClientAction>;
  /**  The secondary action for a client to take for an institution in a sub-optimal state  */
  secondaryClientAction?: Maybe<Scalars['String']>;
  /**  The source institution id for the portal  */
  sourceInstitutionId: Scalars['String'];
  /**  Contains metadata about the portal. Requires elevated permissions to query.  */
  sourceMeta?: Maybe<FinancialPortalSourceMeta>;
  /**  The transactions synchronization state for the portal  */
  transactionsState?: Maybe<FinancialPortalProductState>;
  /**  The financial accounts associated with this portal  */
  accounts?: Maybe<Array<FinancialAccount>>;
};

export enum FinancialPortalAlertMessage {
  NewAccount = 'NEW_ACCOUNT'
}

export enum FinancialPortalAuthState {
  Authenticated = 'AUTHENTICATED',
  Error = 'ERROR',
  Init = 'INIT',
  Null = 'NULL',
  UserActionRequired = 'USER_ACTION_REQUIRED'
}

export enum FinancialPortalErrorMessage {
  DataNotReady = 'DATA_NOT_READY',
  DataRetrievalFailed = 'DATA_RETRIEVAL_FAILED',
  InstitutionDown = 'INSTITUTION_DOWN',
  InstitutionNotSupported = 'INSTITUTION_NOT_SUPPORTED',
  InstitutionRequiresUserAction = 'INSTITUTION_REQUIRES_USER_ACTION',
  InternalError = 'INTERNAL_ERROR',
  InvalidCredentials = 'INVALID_CREDENTIALS',
  InvalidMfa = 'INVALID_MFA',
  InvalidMicrodepositAmount = 'INVALID_MICRODEPOSIT_AMOUNT',
  LoginRequired = 'LOGIN_REQUIRED',
  MfaNotSupported = 'MFA_NOT_SUPPORTED',
  MfaRequired = 'MFA_REQUIRED',
  NoDataOrAccount = 'NO_DATA_OR_ACCOUNT',
  NoEligibleAccounts = 'NO_ELIGIBLE_ACCOUNTS',
  NoInvestmentAccounts = 'NO_INVESTMENT_ACCOUNTS',
  NoLiabilityAccounts = 'NO_LIABILITY_ACCOUNTS',
  NoPropertyValue = 'NO_PROPERTY_VALUE',
  OtherError = 'OTHER_ERROR',
  PortalBlocked = 'PORTAL_BLOCKED',
  PortalLocked = 'PORTAL_LOCKED',
  ProductNotSupported = 'PRODUCT_NOT_SUPPORTED',
  TooManyVerificationAttempts = 'TOO_MANY_VERIFICATION_ATTEMPTS'
}

/**
 * Used to filter a financial portal by fields such as its institution ID. The fields listed here are a subset of the complete list found here:
 * https://docs.nerdwallet.io/financial-data-platform/branches/master/swagger-crud/#operation/listFinancialPortals
 */
export type FinancialPortalFilterInput = {
  mpInstitutionId?: InputMaybe<Scalars['ID']>;
};

export type FinancialPortalMessageResponse = {
  __typename?: 'FinancialPortalMessageResponse';
  portal?: Maybe<FinancialPortal>;
  success: Scalars['Boolean'];
};

export type FinancialPortalMigrationDetails = {
  __typename?: 'FinancialPortalMigrationDetails';
  /**  A map of previous account id to new account id  */
  accountsMapping?: Maybe<Scalars['JSON']>;
  /**  Whether the user has confirmed the migration is acceptable or not  */
  hasUserConfirmed: Scalars['Boolean'];
  /**  Whether data for the new portal is currently being ported over   */
  isDataPortInProgress: Scalars['Boolean'];
  /**  Whether data for the new portal has been retrieved  */
  isDataRetrieved: Scalars['Boolean'];
  /**  The id of the portal being migrated from  */
  migratedFromFinancialPortalId?: Maybe<Scalars['ID']>;
  /**  The id of the portal being migrated to  */
  migratedToFinancialPortalId?: Maybe<Scalars['ID']>;
  /**  List of new account ids  */
  newAccountIds?: Maybe<Array<Scalars['ID']>>;
  /**  List of old account ids  */
  oldAccountIds?: Maybe<Array<Scalars['ID']>>;
  /**  The id of the marketplace account aggregation institution to migrate to, if a canonical id mapping exists  */
  recommendedMarketplaceInstitutionId?: Maybe<Scalars['ID']>;
  /**  The source (e.g. Plaid) id of the institution to migrate to  */
  recommendedSourceInstitutionId?: Maybe<Scalars['ID']>;
};

export enum FinancialPortalPrimaryClientAction {
  Fix = 'FIX',
  GoToSite = 'GO_TO_SITE',
  Migrate = 'MIGRATE',
  Refresh = 'REFRESH',
  SearchToMigrate = 'SEARCH_TO_MIGRATE',
  TryOtherInstitution = 'TRY_OTHER_INSTITUTION',
  Unlink = 'UNLINK',
  UserConfirmation = 'USER_CONFIRMATION',
  LegacyFix = 'LEGACY_FIX'
}

export enum FinancialPortalProductState {
  DataRetrieved = 'DATA_RETRIEVED',
  Null = 'NULL',
  PartialDataRetrieved = 'PARTIAL_DATA_RETRIEVED',
  RetrievalFailed = 'RETRIEVAL_FAILED',
  RetrievalInProgress = 'RETRIEVAL_IN_PROGRESS'
}

export type FinancialPortalSourceMeta = {
  __typename?: 'FinancialPortalSourceMeta';
  /**  Failed login attempts in the past 30 days  */
  failedLoginAttemptsPast30Days?: Maybe<Scalars['Int']>;
  /**  Failed login attempts in the past hour  */
  failedLoginAttemptsPastHour?: Maybe<Scalars['Int']>;
  /**  Date of last failed login  */
  lastFailedLogin?: Maybe<Scalars['DateTime']>;
  /**  Date of last successful login  */
  lastSuccessfulLogin?: Maybe<Scalars['DateTime']>;
  /**  The previous auth state  */
  portalPreviousAuthState?: Maybe<FinancialPortalAuthState>;
  /**  The Yodlee status code  */
  portalStatusCode?: Maybe<Scalars['String']>;
  /**  The Yodlee status message  */
  portalStatusMessage?: Maybe<Scalars['String']>;
  /**  The source access token  */
  sourceAccessToken?: Maybe<Scalars['String']>;
  /**  The source entity id  */
  sourceEntityId?: Maybe<Scalars['String']>;
  /**  The Yodlee username (corresponds to the owner of this portal)  */
  username?: Maybe<Scalars['String']>;
};

/**
 * Field documentation:
 * https://docs.nerdwallet.io/financial-data-platform/branches/master/swagger-crud/#tag/transactions
 */
export type FinancialTransaction = {
  __typename?: 'FinancialTransaction';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  identityId: Scalars['ID'];
  primarySource?: Maybe<FinancialDataSource>;
  sequenceNumber: Scalars['Int'];
  source?: Maybe<FinancialDataSource>;
  sourceEntityId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  /**  The financial account under which the transaction resides  */
  account?: Maybe<FinancialAccount>;
  /**  The ID of the account associated with this transaction. Useful if you need the id but don't want to invoke an extra network request to fetch accounts  */
  accountId?: Maybe<Scalars['ID']>;
  /**  The "cent-normalized" amount of the transaction as an integer. e.g. 100 equals $1.00  */
  amount: Scalars['Int'];
  /**  The NW category of the transaction. Nullable if reading an enrichment, otherwise guaranteed  */
  category?: Maybe<FinancialTransactionCategory>;
  /**  The currency of the account to which the transaction belongs  */
  currency?: Maybe<Scalars['FinancialCurrency']>;
  /**  The date that the transaction took place  */
  date: Scalars['DateTime'];
  /**  The type of account, e.g. "bank" or "investment"  */
  accountType?: Maybe<FinancialAccountType>;
  /**  A short description of the transaction  */
  description?: Maybe<Scalars['String']>;
  /**  Whether or not the transaction is in a pending status, or if it has posted.  */
  isPending?: Maybe<Scalars['Boolean']>;
  /**  Whether or not the transaction is hidden. */
  isHidden?: Maybe<Scalars['Boolean']>;
  /**  The name of the merchant associated to the transaction  */
  merchantName?: Maybe<Scalars['String']>;
  /**  Generally, whether this is a credit or a debt  */
  type?: Maybe<FinancialTransactionType>;
  /**  Used to label additional information about a transaction. e.g. REFUND  */
  tags?: Maybe<Array<FinancialTransactionTag>>;
};

export enum FinancialTransactionCategory {
  Childcare = 'CHILDCARE',
  Donations = 'DONATIONS',
  Entertainment = 'ENTERTAINMENT',
  Fees = 'FEES',
  Groceries = 'GROCERIES',
  Health = 'HEALTH',
  Housing = 'HOUSING',
  Income = 'INCOME',
  Insurance = 'INSURANCE',
  Other = 'OTHER',
  Pets = 'PETS',
  Restaurants = 'RESTAURANTS',
  Shopping = 'SHOPPING',
  Subscriptions = 'SUBSCRIPTIONS',
  Transfers = 'TRANSFERS',
  Transport = 'TRANSPORT',
  Travel = 'TRAVEL',
  Uncategorized = 'UNCATEGORIZED',
  Utilities = 'UTILITIES'
}

export type FinancialTransactionsAverageSpendingByDayOfTheMonth = {
  __typename?: 'FinancialTransactionsAverageSpendingByDayOfTheMonth';
  averageSpendingByDayOfTheMonth: Array<FinancialTransactionsSpendingForDayOfTheMonth>;
};

export type FinancialTransactionsBudgetBreakdown = {
  __typename?: 'FinancialTransactionsBudgetBreakdown';
  wants: FinancialTransactionsBudgetBreakdownItem;
  needs: FinancialTransactionsBudgetBreakdownItem;
  savingsAndDebt: FinancialTransactionsBudgetBreakdownItem;
};

export type FinancialTransactionsBudgetBreakdownItem = {
  __typename?: 'FinancialTransactionsBudgetBreakdownItem';
  total: Scalars['Float'];
  categories: Array<FinancialTransactionsCategorySpendingAmount>;
};

export type FinancialTransactionsCategorySpendingAmount = {
  __typename?: 'FinancialTransactionsCategorySpendingAmount';
  amount: Scalars['Float'];
  category: FinancialTransactionCategory;
};

/**
 * Note: this is not a complete set of available filters of the underlying API
 *
 * See docs for full support: https://docs.nerdwallet.io/financial-data-platform/branches/master/swagger-crud/#operation/listTransactions
 */
export type FinancialTransactionsFilterInput = {
  /** The account ID by which to filter the transactions. */
  accountId?: InputMaybe<Scalars['ID']>;
  /**
   * To be deprecated. Please use "accountTypes".
   * Only return transactions from an account with one of these types.
   */
  accountType?: InputMaybe<Array<FinancialAccountType>>;
  /** Only return transactions from an account with one of these types. */
  accountTypes?: InputMaybe<Array<FinancialAccountType>>;
  /**
   * To be deprecated. Please use "excludeAccountTypes".
   * Exclude transactions from any accounts with one of these types.
   */
  excludeAccountType?: InputMaybe<Array<FinancialAccountType>>;
  /** Exclude transactions from any accounts with one of these types. */
  excludeAccountTypes?: InputMaybe<Array<FinancialAccountType>>;
  /** The merchant by which to filter the transactions. */
  merchantName?: InputMaybe<Scalars['String']>;
  /** The merchant names by which to filter the transactions. */
  merchantNames?: InputMaybe<Array<Scalars['String']>>;
  /**
   * To be deprecated. Please use "categories".
   * Only return transactions in one of these categories.
   */
  category?: InputMaybe<Array<FinancialTransactionCategory>>;
  /** Only return transactions in one of these categories. */
  categories?: InputMaybe<Array<FinancialTransactionCategory>>;
  /**
   * To be deprecated. Please use "excludeCategories".
   * Exclude transactions in any of these categories.
   */
  excludeCategory?: InputMaybe<Array<FinancialTransactionCategory>>;
  /** Exclude transactions in any of these categories. */
  excludeCategories?: InputMaybe<Array<FinancialTransactionCategory>>;
  /** The type by which to filter the transactions. */
  type?: InputMaybe<Scalars['String']>;
  /** Whether to include transactions for hidden accounts. */
  includeHiddenAccounts?: InputMaybe<Scalars['Boolean']>;
  /** Whether or not to include transactions marked as hidden. Defaults to false. */
  excludeHiddenTransactions?: InputMaybe<Scalars['Boolean']>;
  /** Whether or not to include pending transactions. Defaults to false. */
  includePending?: InputMaybe<Scalars['Boolean']>;
  /** The beginning bound of the transaction date (ISO 8601) */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** The end bound of the transaction date (ISO 8601) */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Only return transactions with one of these tags. */
  includeTags?: InputMaybe<Array<FinancialTransactionTag>>;
  /** Exclude transactions with any one of these tags. */
  excludeTags?: InputMaybe<Array<FinancialTransactionTag>>;
  /** Transactions that have been modified since this date (ISO 8601). */
  updatedSince?: InputMaybe<Scalars['DateTime']>;
  /** Whether or not to include accounts marked as disabled. Defaults to false. */
  includeDisabledAccounts?: InputMaybe<Scalars['Boolean']>;
};

export type FinancialTransactionsMerchantSpendingAmount = {
  __typename?: 'FinancialTransactionsMerchantSpendingAmount';
  amount: Scalars['Float'];
  merchantName: Scalars['String'];
};

export type FinancialTransactionsProjectionForMonth = {
  __typename?: 'FinancialTransactionsProjectionForMonth';
  earning: Scalars['Float'];
};

export type FinancialTransactionsSpendingAndEarning = {
  __typename?: 'FinancialTransactionsSpendingAndEarning';
  spending: Scalars['Float'];
  earning: Scalars['Float'];
};

export type FinancialTransactionsSpendingAndEarningForDate = {
  __typename?: 'FinancialTransactionsSpendingAndEarningForDate';
  date: Scalars['Date'];
  spending: Scalars['Float'];
  earning: Scalars['Float'];
};

export type FinancialTransactionsSpendingAndEarningForMonthRangeResponse = {
  __typename?: 'FinancialTransactionsSpendingAndEarningForMonthRangeResponse';
  spendingAndEarningForMonthRange: FinancialTransactionsSpendingAndEarning;
};

export type FinancialTransactionsSpendingByCategory = {
  __typename?: 'FinancialTransactionsSpendingByCategory';
  entertainment: Scalars['Float'];
  fees: Scalars['Float'];
  groceries: Scalars['Float'];
  health: Scalars['Float'];
  housing: Scalars['Float'];
  income: Scalars['Float'];
  other: Scalars['Float'];
  restaurants: Scalars['Float'];
  shopping: Scalars['Float'];
  transfers: Scalars['Float'];
  transport: Scalars['Float'];
  travel: Scalars['Float'];
  utilities: Scalars['Float'];
};

export type FinancialTransactionsSpendingByCategoryForMonth = {
  __typename?: 'FinancialTransactionsSpendingByCategoryForMonth';
  spendingByCategoryForMonth: FinancialTransactionsSpendingByCategory;
};

export type FinancialTransactionsSpendingByDayOfTheMonthForMonth = {
  __typename?: 'FinancialTransactionsSpendingByDayOfTheMonthForMonth';
  spendingByDayOfTheMonthForPriorMonth: Array<FinancialTransactionsSpendingForDayOfTheMonth>;
  spendingByDayOfTheMonthForTargetMonth: Array<FinancialTransactionsSpendingForDayOfTheMonth>;
};

export type FinancialTransactionsSpendingByMonth = {
  __typename?: 'FinancialTransactionsSpendingByMonth';
  spendingByMonth: Array<FinancialTransactionsSpendingOnDate>;
};

export type FinancialTransactionsSpendingForDayOfTheMonth = {
  __typename?: 'FinancialTransactionsSpendingForDayOfTheMonth';
  amount: Scalars['Float'];
  dayOfTheMonth: Scalars['Int'];
};

export type FinancialTransactionsSpendingOnDate = {
  __typename?: 'FinancialTransactionsSpendingOnDate';
  amount: Scalars['Float'];
  date: Scalars['Date'];
};

export type FinancialTransactionsTopCategoriesBySpending = {
  __typename?: 'FinancialTransactionsTopCategoriesBySpending';
  topCategoriesBySpending: Array<FinancialTransactionsCategorySpendingAmount>;
};

export type FinancialTransactionsTopMerchantsBySpending = {
  __typename?: 'FinancialTransactionsTopMerchantsBySpending';
  topMerchantsBySpending: Array<FinancialTransactionsMerchantSpendingAmount>;
};

export enum FinancialTransactionTag {
  AccountFee = 'ACCOUNT_FEE',
  AccountFeeAnnual = 'ACCOUNT_FEE_ANNUAL',
  BankFeeAtm = 'BANK_FEE_ATM',
  BankFeeOverdraft = 'BANK_FEE_OVERDRAFT',
  CashWithdrawal = 'CASH_WITHDRAWAL',
  CheckPayment = 'CHECK_PAYMENT',
  Deposit = 'DEPOSIT',
  Education = 'EDUCATION',
  InvestmentIncome = 'INVESTMENT_INCOME',
  PayrollDeposit = 'PAYROLL_DEPOSIT',
  RebalanceTransfer = 'REBALANCE_TRANSFER',
  Refund = 'REFUND',
  RentPayment = 'RENT_PAYMENT',
  TaxRefund = 'TAX_REFUND'
}

export enum FinancialTransactionType {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type FinancialUserMeta = {
  __typename?: 'FinancialUserMeta';
  /** The Source (YODLEE, PLAID, etc) */
  source?: Maybe<FinancialDataSource>;
  /** The Source username */
  username?: Maybe<Scalars['String']>;
};

export type FinishPortalMigrationResponse = {
  __typename?: 'FinishPortalMigrationResponse';
  portal?: Maybe<FinancialPortal>;
};

export enum GenderEnum {
  Male = 'MALE',
  Female = 'FEMALE',
  NonBinary = 'NON_BINARY'
}

/** Input to determine if geotargeting test is active and it's marketing region */
export type GeotargetingAbTestInput = {
  isTestActive?: InputMaybe<Scalars['Boolean']>;
  marketingRegion?: InputMaybe<Scalars['String']>;
};

export type GetFinancialAccountsResponse = {
  __typename?: 'GetFinancialAccountsResponse';
  accounts?: Maybe<Array<FinancialAccount>>;
};

export type GetFinancialUserMetaResponse = {
  __typename?: 'GetFinancialUserMetaResponse';
  users?: Maybe<Array<FinancialUserMeta>>;
};

export type GetInstitutionHealthDetailsResponse = {
  __typename?: 'GetInstitutionHealthDetailsResponse';
  institution?: Maybe<FinancialInstitutionStatusResponse>;
};

export type GetNotificationsResponse = {
  __typename?: 'GetNotificationsResponse';
  /** List of notifications in reverse chronological order. */
  items?: Maybe<Array<Notification>>;
  /** The newest notification ID is used as the "after" value in subsequent queries. */
  newest?: Maybe<Scalars['ID']>;
  /** The oldest notification ID is used as the "before" value in subsequent queries. */
  oldest?: Maybe<Scalars['ID']>;
  /** The number of unread notifications for the user. */
  unreadCount?: Maybe<Scalars['Int']>;
};

export type GetPortalsResponse = {
  __typename?: 'GetPortalsResponse';
  portals?: Maybe<Array<FinancialPortal>>;
};

export type GetStateFromZipCodeResponse = {
  __typename?: 'GetStateFromZipCodeResponse';
  state?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
};

export type GetTransactionsResponse = {
  __typename?: 'GetTransactionsResponse';
  /**
   * The pagination metadata associated with the request. If underlying data has changed, this will not match the
   * requested pagination (offset will be set to 0 and a new result set token will be generated)
   */
  pagination: AdvancedOffsetPaginationInfo;
  /**  The list of transactions associated with this result set  */
  transactions: Array<FinancialTransaction>;
};

/** The `GlobalIdentityProfile` type represents the global identity profile */
export type GlobalIdentityProfile = {
  __typename?: 'GlobalIdentityProfile';
  phoneNumber?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  citizenship?: Maybe<Scalars['String']>;
  mailingAddress?: Maybe<IdentityAddress>;
  age?: Maybe<Scalars['Int']>;
  maritalStatus?: Maybe<Scalars['String']>;
  previousAddress?: Maybe<IdentityAddress>;
  dateOfBirth?: Maybe<Scalars['String']>;
  currentLocation?: Maybe<Scalars['String']>;
  legalFirstName?: Maybe<Scalars['String']>;
  education?: Maybe<Scalars['String']>;
  ageBucket?: Maybe<Scalars['String']>;
};

/**
 * Options accepted by the GlobalMarkupOptions component.
 * These are generally the options passed to nlOpts when configuring nw-app-module
 */
export type GlobalMarkupOptions = {
  __typename?: 'GlobalMarkupOptions';
  /** The title of the page */
  title?: Maybe<Scalars['String']>;
  /** The description of the page */
  description?: Maybe<Scalars['String']>;
  /** The canonical URL of the page */
  canonicalUrl?: Maybe<Scalars['String']>;
  /** Page meta tags */
  dynamicMeta?: Maybe<Array<GlobalMarkupOptionsDynamicMeta>>;
  /** Taxonomy data for SEO */
  pageTaxonomy?: Maybe<GlobalMarkupOptionsPageTaxonomy>;
  /** robots commands */
  robots?: Maybe<GlobalMarkupOptionsRobots>;
  /** Facebook Open Graph tags */
  ogTags?: Maybe<GlobalMarkupOptionsOgTags>;
  /** Props to pass directly to the global nav React component */
  globalNavProps?: Maybe<GlobalMarkupOptionsGlobalNavProps>;
};

export type GlobalMarkupOptionsDynamicMeta = {
  __typename?: 'GlobalMarkupOptionsDynamicMeta';
  name: Scalars['String'];
  property?: Maybe<Scalars['String']>;
  content: Scalars['String'];
};

export type GlobalMarkupOptionsGlobalNavProps = {
  __typename?: 'GlobalMarkupOptionsGlobalNavProps';
  /** Navigational breadcrumbs to display below the global header */
  breadcrumbs?: Maybe<Breadcrumb>;
  /** Whether the global footer should be disabled */
  disableFooter?: Maybe<Scalars['Boolean']>;
  /** Whether the global header should be disabled */
  disableHeader?: Maybe<Scalars['Boolean']>;
};

export type GlobalMarkupOptionsOgTags = {
  __typename?: 'GlobalMarkupOptionsOgTags';
  /** The title of your article without any branding such as your site name. */
  title?: Maybe<Scalars['String']>;
  /** A brief description of the content. This will displayed below the title of the post on Facebook. */
  description?: Maybe<Scalars['String']>;
  /** The URL of the image that should appear when someone shares the content to Facebook */
  image?: Maybe<Scalars['URL']>;
  /** https:// URL for the image */
  image_secure_url?: Maybe<Scalars['URL']>;
  /** Width of image in pixels */
  image_width?: Maybe<Scalars['Int']>;
  /** Height of image in pixels */
  image_height?: Maybe<Scalars['Int']>;
  /** The locale of the resource */
  locale?: Maybe<Scalars['String']>;
  /** The type of media of your content. This tag impacts how your content shows up in News Feed. */
  type?: Maybe<Scalars['String']>;
  /** The canonical URL for the page */
  url?: Maybe<Scalars['URL']>;
};

export type GlobalMarkupOptionsPageTaxonomy = {
  __typename?: 'GlobalMarkupOptionsPageTaxonomy';
  /** Page vertical */
  attrVertical?: Maybe<Scalars['String']>;
  /** Page topic */
  attrTopic?: Maybe<Scalars['String']>;
  /** Primary content cluster for the page */
  primaryContentCluster?: Maybe<Scalars['String']>;
  /** Other secondary content clusters for the page */
  otherContentClusters: Array<Scalars['String']>;
};

export type GlobalMarkupOptionsRobots = {
  __typename?: 'GlobalMarkupOptionsRobots';
  /** Do not show this page, media, or resource in search results */
  noindex?: Maybe<Scalars['Boolean']>;
  /** Do not follow the links on this page */
  nofollow?: Maybe<Scalars['Boolean']>;
};

/** Type modeling the data for posts within the nw_gnav_item post type from WordPress. */
export type GlobalNavItem = PostInterface & PostWithTitleInterface & {
  __typename?: 'GlobalNavItem';
  /** Global Nav L0 item's L1 children. */
  children?: Maybe<Array<GlobalNavItem>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** Global Nav item link. */
  itemLink?: Maybe<GlobalNavItemItemLinkUnion>;
  /** Global Nav item level. */
  level?: Maybe<GlobalNavItemLevelEnum>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** Global Nav mobile config. */
  mobileConfig?: Maybe<Array<GlobalNavItemMobileConfig>>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** Global Nav L1 item sections. */
  sections?: Maybe<Array<GlobalNavItemSection>>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** Global Nav item sub text. */
  subText?: Maybe<Scalars['String']>;
  /** Global Nav item text. */
  text?: Maybe<Scalars['String']>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
};


/** Type modeling the data for posts within the nw_gnav_item post type from WordPress. */
export type GlobalNavItemDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_gnav_item post type from WordPress. */
export type GlobalNavItemModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_gnav_item post type from WordPress. */
export type GlobalNavItemTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type GlobalNavItemConnectionResponse = {
  __typename?: 'GlobalNavItemConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The GlobalNavItem returned for the connection. */
  items?: Maybe<Array<GlobalNavItem>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of GlobalNavItem objects. */
export type GlobalNavItemFilterInput = {
  /** Limit collection to GlobalNavItems with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
};

/** The union containing the Type members that can be returned by the itemLink field on the GlobalNavItem type. */
export type GlobalNavItemItemLinkUnion = Article | Hub | InsurancePage | LandingPage | Page | Post | Review | Roundup | UrlRecord;

/** Enum values for level field on GlobalNavItem type. */
export enum GlobalNavItemLevelEnum {
  Default = 'DEFAULT',
  L0 = 'L0',
  L1 = 'L1',
  L2 = 'L2',
  L3 = 'L3'
}

/** Type modeling the data within the mobileConfig group of fields on the GlobalNavItem type. */
export type GlobalNavItemMobileConfig = {
  __typename?: 'GlobalNavItemMobileConfig';
  backgroundColor?: Maybe<Scalars['String']>;
  foregroundColor?: Maybe<Scalars['String']>;
  /** Global Nav mobile config supported icons are Calculator, CreditCard, StudentLoans, Wallet */
  icon?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

/** Type modeling the data within the sections group of fields on the GlobalNavItem type. */
export type GlobalNavItemSection = {
  __typename?: 'GlobalNavItemSection';
  /** Global Nav L1 item's L2 section children. */
  children?: Maybe<Array<GlobalNavItem>>;
  /** Global Nav L1 item section label. */
  label?: Maybe<Scalars['String']>;
};

export type GoogleLoginInfoInput = {
  /** The app used to log in with Google */
  appType: AppTypeEnum;
  /** The google OAuth token required for log in/registration */
  googleOAuthToken: Scalars['String'];
  /** The password used to log in with third party credentials (required for the first log in to existing passworded identities) */
  password?: InputMaybe<Scalars['String']>;
  /** Determines if user should stay logged in */
  rememberMe: Scalars['Boolean'];
};

export type GreenhouseDepartment = {
  __typename?: 'GreenhouseDepartment';
  /** Unique ID of a GreenhouseDepartment */
  id: Scalars['ID'];
  /** Name of a GreenhouseDepartment */
  name: Scalars['String'];
  /** Kebab Name of a GreenhouseDepartment */
  kebabName: Scalars['String'];
  /** List of jobs available within a GreenhouseDepartment */
  jobs?: Maybe<Array<GreenhouseJob>>;
};

export type GreenhouseJob = {
  __typename?: 'GreenhouseJob';
  /** Unique ID of a GreenhouseJob */
  id: Scalars['ID'];
  /** URL to the job page on nerdwallet.com, of the form `http://www.nerdwallet.com/careers/job/2930840?gh_jid=2930840` */
  absoluteUrl: Scalars['URL'];
  /** Last update date */
  updatedAt: Scalars['DateTime'];
  /** Title of a GreenhouseJob */
  title: Scalars['String'];
  /** Content body of a GreenhouseJob. Contains html-encoded html, e.g. `&lt;p&gt;&lt;span style=&quot;font-weight: 400;&quot;&gt;` */
  content?: Maybe<Scalars['String']>;
  /** Location of the GreenhouseJob */
  location?: Maybe<Scalars['String']>;
  /** Department name */
  department?: Maybe<GreenhouseDepartment>;
};

/** Metadata properties for the given HealthabilityReport */
export type HealthabilityMeta = {
  __typename?: 'HealthabilityMeta';
  /** Indy version used to generate the HealthabilityReport */
  indyVersion: Scalars['String'];
  /** Name of the repo Healthability ran on to generate the given HealthabilityReport */
  repoName: Scalars['String'];
  /** Repo version Healthability ran on to generate the given HealthabilityReport */
  repoVersion: Scalars['String'];
  /** Time when the HealthabilityReport was generated */
  time: Scalars['String'];
};

/** Generated report containing Healthability information for a given repo */
export type HealthabilityReport = {
  __typename?: 'HealthabilityReport';
  /** Metadata properties for the given HealthabilityReport */
  meta?: Maybe<HealthabilityMeta>;
  /** An array of HealthabilitySpecs containing information about the given repo */
  specs?: Maybe<Array<HealthabilitySpec>>;
  /** An array containing all the BuildSpecs that were active when Healthability ran */
  buildSpecs?: Maybe<Array<BuildSpec>>;
  /** The number of views that this application received in the last 30 days, if applicable */
  cumulativeViewCount?: Maybe<Scalars['Int']>;
};

export type HealthabilityRepository = {
  __typename?: 'HealthabilityRepository';
  name: Scalars['ID'];
  cumulativeViewCount?: Maybe<Scalars['Int']>;
};

/** Encapsulate information regarding a specific type of technical debt */
export type HealthabilitySpec = {
  __typename?: 'HealthabilitySpec';
  /** Name of the HealthabilitySpec */
  name: Scalars['String'];
  /** Human-readable title of the HealthabilitySpec */
  title: Scalars['String'];
  /** Indicates whether the HealthabilitySpec is scored or unscored */
  scored: Scalars['Boolean'];
  /** Maximum points possible for the given HealthabilitySpec */
  maxPoints: Scalars['Int'];
  /** Points achieved by the repo for the given HealthabilitySpec */
  points: Scalars['Int'];
  /** Indicates whether the results of the HealthabilitySpec is displayed to console, and on PR comments */
  disabled: Scalars['Boolean'];
  /** Detailed feedback surfacing detected technical debt and suggested improvements for the given HealthabilitySpec */
  comments: Scalars['String'];
  /** Indicates whether the HealthabilitySpec errored during execution */
  errored: Scalars['Boolean'];
  /** Optional summary of the comments for the spec */
  summary?: Maybe<Scalars['String']>;
};

/** Query variables for InsurancePrequalOffers */
export type HomeInsurancePrequalOfferInput = {
  contactName?: InputMaybe<PrequalUserNameInput>;
  /** currentInsurer is a string defined by QuinStreet that will be validated on the unified prequal service */
  currentInsurer?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['String']>;
  inventoryType?: InputMaybe<Scalars['String']>;
  isHomeOwner?: InputMaybe<Scalars['Boolean']>;
  isMarried?: InputMaybe<Scalars['Boolean']>;
  /** pricingCode is QuinStreet's way of identifying the purpose of the request */
  pricingCode?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
  qsClickKey?: InputMaybe<Scalars['String']>;
};

export type HomeLeadMatchInput = {
  /** User's annual income */
  annualIncome?: InputMaybe<Scalars['Int']>;
  /** Amount of cash-out the user wants */
  cashout?: InputMaybe<Scalars['Int']>;
  /** User's credit score */
  creditScore?: InputMaybe<Scalars['Int']>;
  /** Down payment on the home.  Only applicable to purchase loans. */
  downPayment?: InputMaybe<Scalars['Int']>;
  /** Employment type */
  employmentType?: InputMaybe<MortgageEmploymentTypeEnum>;
  /** Does the user want cashout with their refinance? */
  isCashoutRefinance?: InputMaybe<Scalars['Boolean']>;
  /** Purpose of the loan, e.g. purchase or refinance */
  loanPurpose?: InputMaybe<MortgageLoanPurposeEnum>;
  /** User's current mortgage balance.  Only applicable to refinance loans */
  mortgageBalance?: InputMaybe<Scalars['Int']>;
  /** Property purpose */
  propertyPurpose?: InputMaybe<MortgagePropertyPurposeEnum>;
  /** Purchase price of the home.  Only applicable to purchase loans. */
  purchasePrice?: InputMaybe<Scalars['Int']>;
  /** US state abbrieviation */
  state?: InputMaybe<Scalars['String']>;
  /** Should we match VA (Veterans Affairs) loans? */
  veteran?: InputMaybe<Scalars['Boolean']>;
};

/** Type modeling the data for posts within the nw_house_ad post type from WordPress. */
export type HouseAd = PostInterface & PostWithAuthorsInterface & PostWithFeaturedImageInterface & PostWithTitleInterface & {
  __typename?: 'HouseAd';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The body text for the house ad. */
  body?: Maybe<Scalars['String']>;
  /** The auth link for the house ad CTA. */
  ctaAuthLink?: Maybe<Scalars['StructuredContentDocument']>;
  /** CTA text for the house ad. */
  ctaText?: Maybe<Scalars['String']>;
  /** The type of CTA for the house ad. Either web link or auth link. */
  ctaType?: Maybe<HouseAdCtaTypeEnum>;
  /** The web url for the house ad CTA link. */
  ctaUrl?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The headline to use for the house ad. */
  headline?: Maybe<Scalars['String']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** Which template to use for the house ad. */
  template?: Maybe<HouseAdTemplateEnum>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
};


/** Type modeling the data for posts within the nw_house_ad post type from WordPress. */
export type HouseAdDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_house_ad post type from WordPress. */
export type HouseAdModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_house_ad post type from WordPress. */
export type HouseAdTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type HouseAdConnectionResponse = {
  __typename?: 'HouseAdConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The HouseAd returned for the connection. */
  items?: Maybe<Array<HouseAd>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Enum values for ctaType field on HouseAd type. */
export enum HouseAdCtaTypeEnum {
  AuthLink = 'AUTH_LINK',
  WebLink = 'WEB_LINK'
}

/** Query to fetch a collection of HouseAd objects. */
export type HouseAdFilterInput = {
  /** Limit collection to HouseAds published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to HouseAds with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
};

/** Enum values for template field on HouseAd type. */
export enum HouseAdTemplateEnum {
  Card = 'CARD',
  EntryBanner = 'ENTRY_BANNER',
  Horizontal = 'HORIZONTAL',
  Vertical = 'VERTICAL'
}

/** Type modeling the data for posts within the nw_hub post type from WordPress. */
export type Hub = PostInterface & PostWithAuthorsInterface & PostWithContentClassificationInterface & PostWithFeaturedImageInterface & PostWithSeoInterface & PostWithTitleInterface & {
  __typename?: 'Hub';
  /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
  attributionTopic?: Maybe<Scalars['String']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** Additional content clusters for this piece of content. */
  contentClusters?: Maybe<Array<Scalars['String']>>;
  /** The custom content to display below the featured boxes. */
  customContentBelowFeaturedBoxes?: Maybe<Scalars['StructuredContentDocument']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']>;
  /** The boxes to display on the Hub. */
  featuredBoxes?: Maybe<Array<HubFeaturedBox>>;
  /** Represents each of the content sections on the page. */
  featuredContent?: Maybe<Array<HubFeaturedContent>>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']>;
  /** The content to display in the header of the hub below the title. */
  headerSubtitle?: Maybe<Scalars['StructuredContentDocument']>;
  /** Whether this is a Topic hub or Category hub. */
  hubType?: Maybe<HubTypeEnum>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
  isArchivesEligible?: Maybe<Scalars['Boolean']>;
  /** Whether or not to prevent this piece of content from being recommended to users. */
  isRecommendationEligible?: Maybe<Scalars['Boolean']>;
  /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
  isSearchEligible?: Maybe<Scalars['Boolean']>;
  /** The categories to display the latest content from. */
  latestContentCategories?: Maybe<Array<Scalars['String']>>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The marketplace entities to display for this hub. */
  marketplaceEntities?: Maybe<Array<HubMarketplaceEntity>>;
  /** The title of the Marketplace section. */
  marketplaceSectionTitle?: Maybe<Scalars['String']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']>;
  /** The post types to display the latest content from. */
  postTypes?: Maybe<Array<PostTypeEnum>>;
  /** The primary content cluster for this piece of content. */
  primaryContentCluster?: Maybe<Scalars['String']>;
  /** The Q&A to display on this Hub. */
  questions?: Maybe<Array<HubQuestion>>;
  /** A date after which this content should no longer be recommended. */
  recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']>;
  /** The curated list of reviews to display. */
  reviews?: Maybe<Array<Review>>;
  /** The section title for the reviews section. */
  reviewSectionTitle?: Maybe<Scalars['String']>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']>>;
};


/** Type modeling the data for posts within the nw_hub post type from WordPress. */
export type HubDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_hub post type from WordPress. */
export type HubModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_hub post type from WordPress. */
export type HubTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type HubConnectionResponse = {
  __typename?: 'HubConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The Hub returned for the connection. */
  items?: Maybe<Array<Hub>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Type modeling the data within the featuredBoxes group of fields on the Hub type. */
export type HubFeaturedBox = {
  __typename?: 'HubFeaturedBox';
  /** The description text for the featured box. */
  description?: Maybe<Scalars['String']>;
  /** The icon to display within the featured box. */
  icon?: Maybe<Scalars['String']>;
  /** The label text for the featured box. */
  iconLabel?: Maybe<Scalars['String']>;
  /** The post entity the featured box should link to. */
  link?: Maybe<HubLinkUnion>;
  /** The content this featured box should link to. */
  linkedContent?: Maybe<ContentSearchResult>;
  /** The title text for the featured box. */
  title?: Maybe<Scalars['String']>;
};

/** Type modeling the data within the featuredContent group of fields on the Hub type. */
export type HubFeaturedContent = {
  __typename?: 'HubFeaturedContent';
  /** The category the latest content in this section should be displayed from. */
  category?: Maybe<Category>;
  /** The content to display in this section. */
  content?: Maybe<Array<ContentSearchResult>>;
  /** The selected display layout for the section */
  layout?: Maybe<HubLayoutEnum>;
  title?: Maybe<Scalars['String']>;
  /** Whether to display a curated list of content for the section or a latest list of content in a particular category. */
  whatToShow?: Maybe<HubWhatToShowEnum>;
};

/** Query to fetch a collection of Hub objects. */
export type HubFilterInput = {
  /** Limit collection to Hubs published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit results to those with the specified cluster. */
  cluster?: InputMaybe<Scalars['String']>;
  /** Limit collection to Hubs with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']>;
  /** Limit collection to Hubs with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

/** Enum values for layout field on Hub type. */
export enum HubLayoutEnum {
  Default = 'DEFAULT',
  FeatureVertical = 'FEATURE_VERTICAL',
  ThreeInline = 'THREE_INLINE',
  TwoInline = 'TWO_INLINE'
}

/** The union containing the Type members that can be returned by the link field on the Hub type. */
export type HubLinkUnion = Article | Hub | InsurancePage | LandingPage | Page | Post | Review | Roundup | UrlRecord;

/** Type modeling the data within the marketplaceEntities group of fields on the Hub type. */
export type HubMarketplaceEntity = {
  __typename?: 'HubMarketplaceEntity';
  /** The entity id. */
  entity?: Maybe<MarketplaceEntityInterface>;
  /** The entity id. */
  id?: Maybe<Scalars['String']>;
  /** The entity title. */
  title?: Maybe<Scalars['String']>;
};

export type HubPage = StructuredContentPageInterface & {
  __typename?: 'HubPage';
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID'];
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
};

/** Type modeling the data within the questions group of fields on the Hub type. */
export type HubQuestion = {
  __typename?: 'HubQuestion';
  /** The answer for the question prompt. */
  answer?: Maybe<Scalars['StructuredContentDocument']>;
  /** The content this question should link to. */
  linkedContent?: Maybe<ContentSearchResult>;
  /** The question prompt. */
  question?: Maybe<Scalars['String']>;
};

/** Enum values for hubType field on Hub type. */
export enum HubTypeEnum {
  Category = 'CATEGORY',
  Topic = 'TOPIC'
}

/** Enum values for whatToShow field on Hub type. */
export enum HubWhatToShowEnum {
  Default = 'DEFAULT',
  LatestContent = 'LATEST_CONTENT',
  Manual = 'MANUAL'
}

export type IavDetailsResponse = {
  __typename?: 'IAVDetailsResponse';
  accountNumber: Scalars['String'];
  holderNames: Array<Scalars['String']>;
  routingNumber: Scalars['String'];
};

/** The `IdentityAddress` type represents the address for a global identity profile */
export type IdentityAddress = {
  __typename?: 'IdentityAddress';
  city: Scalars['String'];
  longitude?: Maybe<Scalars['Float']>;
  state: Scalars['String'];
  isValidated?: Maybe<Scalars['Boolean']>;
  validatedAt?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  validatedBy?: Maybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

/** The `IdentityAddressInput` input defines the ingress Address model. */
export type IdentityAddressInput = {
  city: Scalars['String'];
  longitude?: InputMaybe<Scalars['Float']>;
  state: Scalars['String'];
  isValidated?: InputMaybe<Scalars['Boolean']>;
  validatedAt?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  zipCode: Scalars['String'];
  validatedBy?: InputMaybe<Scalars['String']>;
};

/** The input for filtering results by ID. */
export type IdFilterInput = {
  /** Exclude items with specific IDs from the collection. */
  exclude?: InputMaybe<Array<Scalars['Int']>>;
  /** Limit collection to items with specific IDs. */
  include?: InputMaybe<Array<Scalars['Int']>>;
};

export type InitializeLinkTokenResponse = {
  __typename?: 'InitializeLinkTokenResponse';
  token: Scalars['String'];
};

export enum InstitutionCountryCode {
  Ca = 'CA',
  Us = 'US'
}

/** Institution contains the common base fields for all institutions. */
export type InstitutionInterface = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
  canonicalInstitutionId?: Maybe<Scalars['String']>;
};

/** A Insurance institution */
export type InsuranceInstitutionV2 = MarketplaceEntityInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceInstitutionInterface & {
  __typename?: 'InsuranceInstitutionV2';
  /** Cons bullet points */
  consBullets?: Maybe<Array<Scalars['String']>>;
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  imageSource?: Maybe<Scalars['URL']>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** Pros bullet points */
  prosBullets?: Maybe<Array<Scalars['String']>>;
  /** The overall editorial rating for the institution */
  starRating?: Maybe<Scalars['Float']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** Short summary of why NerdWallet recommends this insurance provider */
  tagline?: Maybe<Scalars['String']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']>;
};

/** Particular prequal job with it's offers populated (v2) */
export type InsuranceJobWithOffers = {
  __typename?: 'InsuranceJobWithOffers';
  status?: Maybe<PrequalOfferStatus>;
  offers?: Maybe<Array<InsuranceOfferV2>>;
  job?: Maybe<PrequalJob>;
};

/** A Insurance offer */
export type InsuranceOfferV2 = MarketplaceEntityInterface & MarketplaceEntityWithBestOfAwards2021Interface & MarketplaceEntityWithBestOfAwardsInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceOfferInterface & {
  __typename?: 'InsuranceOfferV2';
  /** Redirect link for this Offer */
  applyLink?: Maybe<Scalars['URL']>;
  /** The list of NW Best-Of Awards this offer has won for 2021 */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']>>;
  /** Cons bullet points */
  consBullets?: Maybe<Array<Scalars['String']>>;
  /** The display name for the entity */
  displayName?: Maybe<Scalars['String']>;
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /** Whether this Offer is monetizing. Client apps use this field to decide display behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA */
  isMonetizing?: Maybe<Scalars['Boolean']>;
  /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
  monetizable: Scalars['String'];
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  /** Phone number by carrier */
  phoneNumber?: Maybe<Scalars['String']>;
  product: InsuranceProductV2;
  /** Product type */
  productType: Scalars['String'];
  /** Pros bullet points */
  prosBullets?: Maybe<Array<Scalars['String']>>;
  /** The URL to the NerdWallet review of this offer's product. */
  reviewLink?: Maybe<Scalars['URL']>;
  /** The overall editorial rating for this Offer. */
  starRating?: Maybe<Scalars['Float']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
  /** Short summary of why NerdWallet recommends this insurance provider */
  tagline?: Maybe<Scalars['String']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The Best Of Awards that this offer has won */
  bestOfAwards?: Maybe<Array<BestOfAward>>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The tooltip value that should be displayed alongside the entity name */
  displayNameTooltip?: Maybe<Scalars['String']>;
  /** The driver can buy online associated with the entity */
  driverCanBuyOnline?: Maybe<EntityPlacementDriver>;
  /** The driver coverage options associated with the entity */
  driverCoverageOptions?: Maybe<EntityPlacementDriver>;
  /** The driver discounts associated with the entity */
  driverDiscounts?: Maybe<EntityPlacementDriver>;
  /** The driver ease of use associated with the entity */
  driverEaseOfUse?: Maybe<EntityPlacementDriver>;
  /** The driver NAIC complaints associated with the entity */
  driverNAICComplaints?: Maybe<EntityPlacementDriver>;
  /** The driver financial strength rating associated with the entity */
  driverFinancialStrengthRating?: Maybe<EntityPlacementDriver>;
  /** The driver policies offered associated with the entity */
  driverPoliciesOffered?: Maybe<EntityPlacementDriver>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /**
   * The drivers associated with the entity
   * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
   */
  placementDrivers: Array<EntityPlacementDriver>;
  /** A boolean indicating if the display name should be shown in the comparison table component */
  showNameInComparisonTable: Scalars['Boolean'];
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']>;
  /** Flag for whether to use the large product card image styles */
  useLargeImageFootprint: Scalars['Boolean'];
};

/** Type modeling the data for posts within the nw_ins_page post type from WordPress. */
export type InsurancePage = PostInterface & PostWithAuthorsInterface & PostWithContentClassificationInterface & PostWithContentInterface & PostWithFeaturedImageInterface & PostWithSeoInterface & PostWithTitleInterface & {
  __typename?: 'InsurancePage';
  /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
  attributionTopic?: Maybe<Scalars['String']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the InsurancePage object. */
  categories?: Maybe<Array<Category>>;
  /** The city the content on the insurance page is for. */
  city?: Maybe<Scalars['String']>;
  /** The structured content for the resource. */
  content?: Maybe<Scalars['StructuredContentDocument']>;
  /** Additional content clusters for this piece of content. */
  contentClusters?: Maybe<Array<Scalars['String']>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
  isArchivesEligible?: Maybe<Scalars['Boolean']>;
  /** Whether or not to prevent this piece of content from being recommended to users. */
  isRecommendationEligible?: Maybe<Scalars['Boolean']>;
  /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
  isSearchEligible?: Maybe<Scalars['Boolean']>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']>;
  /** The pricing code for an insurance page. Default: 665689. */
  pricingCode?: Maybe<Scalars['String']>;
  /** The primary content cluster for this piece of content. */
  primaryContentCluster?: Maybe<Scalars['String']>;
  /** A date after which this content should no longer be recommended. */
  recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The state the content on the insurance page is for. */
  state?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The content to display below the title of a piece of content. */
  synopsis?: Maybe<Scalars['StructuredContentDocument']>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
  /** The URL path to query for Insurance Pages by. */
  url?: Maybe<Scalars['URL']>;
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']>>;
};


/** Type modeling the data for posts within the nw_ins_page post type from WordPress. */
export type InsurancePageDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_ins_page post type from WordPress. */
export type InsurancePageModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_ins_page post type from WordPress. */
export type InsurancePageTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type InsurancePageConnectionResponse = {
  __typename?: 'InsurancePageConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The InsurancePage returned for the connection. */
  items?: Maybe<Array<InsurancePage>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of InsurancePage objects. */
export type InsurancePageFilterInput = {
  /** Limit collection to InsurancePages published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to InsurancePages within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']>>;
  /** Limit results to those with the specified cluster. */
  cluster?: InputMaybe<Scalars['String']>;
  /** Limit collection to InsurancePages with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']>;
  /** Limit collection to InsurancePages with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
  /** Limit result set to the item with the specified URL. */
  urlPath?: InputMaybe<Scalars['String']>;
};

/** Format of response to insurancePrequalOffersByJobIdResponse (v2) */
export type InsurancePrequalOffersByJobIdResponse = {
  __typename?: 'InsurancePrequalOffersByJobIdResponse';
  jobs?: Maybe<Array<InsuranceJobWithOffers>>;
};

/** Format of response to insurancePrequalOffersJob query (v2) */
export type InsurancePrequalOffersJobResponse = {
  __typename?: 'InsurancePrequalOffersJobResponse';
  status?: Maybe<PrequalOfferStatus>;
  jobs?: Maybe<Array<PrequalJob>>;
};

/** Format of response to insurancePrequalOffers query (v1) */
export type InsurancePrequalOffersResponse = {
  __typename?: 'InsurancePrequalOffersResponse';
  status?: Maybe<PrequalOfferStatus>;
  offers?: Maybe<Array<InsuranceOfferV2>>;
};

/** A Insurance product */
export type InsuranceProductV2 = MarketplaceEntityInterface & MarketplaceEntityWithReviewInterface & MarketplaceProductInterface & {
  __typename?: 'InsuranceProductV2';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  institution: InsuranceInstitutionV2;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  /** Phone number by carrier */
  phoneNumber?: Maybe<Scalars['String']>;
  /** Product type */
  productType: Scalars['String'];
  /** The URL to the NerdWallet review of this product. */
  reviewLink?: Maybe<Scalars['URL']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

/** Enum of providerIds that are accepted by the insurance offers routes */
export enum InsuranceProviderEnum {
  Mock = 'MOCK',
  Quinstreet = 'QUINSTREET'
}

/** Enum to differentiate between different verticals for the v1 insurance endpoint */
export enum InsuranceVerticalEnum {
  HomeInsurance = 'HOME_INSURANCE',
  AutoInsurance = 'AUTO_INSURANCE',
  LifeInsurance = 'LIFE_INSURANCE'
}

/** Type modeling the data within the internationalVersions group of fields on the Article type. */
export type InternationalVersion = {
  __typename?: 'InternationalVersion';
  /** Locale associated with this alternate version. */
  locale?: Maybe<Scalars['String']>;
  /** URL for this content in the associated locale. */
  url?: Maybe<Scalars['URL']>;
};

/** A Investing institution */
export type InvestingInstitutionV2 = MarketplaceEntityInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceInstitutionInterface & {
  __typename?: 'InvestingInstitutionV2';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** A URL that points to the logo for the institution */
  imageSource?: Maybe<Scalars['URL']>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** The overall, editorial rating for the institution. */
  starRating?: Maybe<Scalars['Float']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']>;
};

/** A Investing offer */
export type InvestingOfferV2 = MarketplaceEntityInterface & MarketplaceEntityWithBestOfAwards2021Interface & MarketplaceEntityWithBestOfAwardsInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceOfferInterface & {
  __typename?: 'InvestingOfferV2';
  /** Redirect link for this Offer */
  applyLink?: Maybe<Scalars['URL']>;
  /** Short description of what the offer is best for e.g. customer service */
  bestForBullets?: Maybe<Array<Scalars['String']>>;
  /** The list of NW Best-Of Awards this offer has won for 2021 */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']>>;
  /** A list of brokerage features for this offer such as promotion, low cost, advisor, etc. */
  brokerageFeatures?: Maybe<Array<Scalars['String']>>;
  /** Brokerage feature for this offer such as self or robo management. */
  brokerageManagement?: Maybe<Scalars['String']>;
  /** The categories that apply to this investing offer. */
  categories?: Maybe<Array<Scalars['String']>>;
  /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  consBullets?: Maybe<Array<Scalars['String']>>;
  /** The display name for the entity (auto-generated) */
  displayName?: Maybe<Scalars['String']>;
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /** Whether this Offer is monetizing. Client apps use this field to decide display behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA */
  isMonetizing?: Maybe<Scalars['Boolean']>;
  /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
  monetizable: Scalars['String'];
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  product: InvestingProductV2;
  /** Product type */
  productType: Scalars['String'];
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  prosBullets?: Maybe<Array<Scalars['String']>>;
  /** The URL to the NerdWallet review of this offer's product */
  reviewLink?: Maybe<Scalars['URL']>;
  /** The overall editorial rating for this Offer. */
  starRating?: Maybe<Scalars['Float']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
  /** Short sentence summary of the Investing Offer */
  summaryShort?: Maybe<Scalars['String']>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  tagline?: Maybe<Scalars['String']>;
  /** Trading frequency such as weekly, monthly or occasionally. */
  tradingFrequency?: Maybe<Scalars['String']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The Best Of Awards that this offer has won */
  bestOfAwards?: Maybe<Array<BestOfAward>>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The driver account minimum associated with the entity */
  driverAccountMinimum?: Maybe<EntityPlacementDriver>;
  /** The driver fees associated with the entity */
  driverFees?: Maybe<EntityPlacementDriver>;
  /** The options contract driver fees associated with the entity */
  driverOptionsContractFee?: Maybe<EntityPlacementDriver>;
  /** The driver promotion associated with the entity */
  driverPromotion?: Maybe<EntityPlacementDriver>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /**
   * Renders an Investing Offer Driver in non structured content format.
   * TODO: We eventually want to be consistent and use structured content
   * formatting going forward.  However this most likely will not be implemented
   * until we have our Currency OfferCard completed
   */
  legacyDrivers: Array<LegacyDriver>;
  /** The month and year range the reviewedAtDate covers */
  periodConsideredDate?: Maybe<Scalars['String']>;
  /**
   * The drivers associated with the entity
   * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
   */
  placementDrivers: Array<EntityPlacementDriver>;
  /** The month and date that an offer was reviewed in string format */
  reviewedAtDate?: Maybe<Scalars['String']>;
  /** A boolean indicating if the display name should be shown in the comparison table component */
  showNameInComparisonTable: Scalars['Boolean'];
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']>;
  /** Flag for whether to use the large product card image styles */
  useLargeImageFootprint: Scalars['Boolean'];
};

/** A Investing product */
export type InvestingProductV2 = MarketplaceEntityInterface & MarketplaceEntityWithReviewInterface & MarketplaceProductInterface & {
  __typename?: 'InvestingProductV2';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  institution: InvestingInstitutionV2;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** The URL to the NerdWallet review of this product. */
  reviewLink?: Maybe<Scalars['URL']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

export type InvestmentAccountInstitution = InstitutionInterface & {
  __typename?: 'InvestmentAccountInstitution';
  canonicalInstitutionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
};

export type InvestmentAccountOffer = OfferInterface & AccountOfferInterface & {
  __typename?: 'InvestmentAccountOffer';
  advisorFee?: Maybe<Scalars['String']>;
  applyLink?: Maybe<Scalars['URL']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  flatTradePrice?: Maybe<Scalars['Float']>;
  institution?: Maybe<InvestmentAccountInstitution>;
  details?: Maybe<InvestmentAccountOfferDetails>;
  imageUrl?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Float']>;
  reviewUrl?: Maybe<Scalars['String']>;
  providerName?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
  productId?: Maybe<Scalars['ID']>;
  isMonetizing?: Maybe<Scalars['Boolean']>;
};

export type InvestmentAccountOfferDetails = {
  __typename?: 'InvestmentAccountOfferDetails';
  /** Names of the award badge names this offer won in 2020. */
  bestOfBadgeWinner2020?: Maybe<Array<Scalars['String']>>;
  /** Names of the award badge names this offer won in 2021. */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']>>;
};

/** Type modeling the data for posts within the nw_landing post type from WordPress. */
export type LandingPage = PostInterface & PostWithAuthorsInterface & PostWithContentClassificationInterface & PostWithFeaturedImageInterface & PostWithSeoInterface & PostWithTitleInterface & {
  __typename?: 'LandingPage';
  /** The assigning editor set on the content. */
  assigningEditor?: Maybe<Author>;
  /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
  attributionTopic?: Maybe<Scalars['String']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the LandingPage object. */
  categories?: Maybe<Array<Category>>;
  /** Additional content clusters for this piece of content. */
  contentClusters?: Maybe<Array<Scalars['String']>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
  isArchivesEligible?: Maybe<Scalars['Boolean']>;
  /** Whether or not to prevent this piece of content from being recommended to users. */
  isRecommendationEligible?: Maybe<Scalars['Boolean']>;
  /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
  isSearchEligible?: Maybe<Scalars['Boolean']>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']>;
  /** The primary content cluster for this piece of content. */
  primaryContentCluster?: Maybe<Scalars['String']>;
  /** A date after which this content should no longer be recommended. */
  recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The content to display below the title of a piece of content. */
  synopsis?: Maybe<Scalars['String']>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']>>;
};


/** Type modeling the data for posts within the nw_landing post type from WordPress. */
export type LandingPageDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_landing post type from WordPress. */
export type LandingPageModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_landing post type from WordPress. */
export type LandingPageTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type LandingPageConnectionResponse = {
  __typename?: 'LandingPageConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The LandingPage returned for the connection. */
  items?: Maybe<Array<LandingPage>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of LandingPage objects. */
export type LandingPageFilterInput = {
  /** Limit collection to LandingPages published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit results to those with the specified cluster. */
  cluster?: InputMaybe<Scalars['String']>;
  /** Limit results to those with the specified Assigning Editor, filtered by ID. */
  editorIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Limit collection to LandingPages with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']>;
  /** Limit collection to LandingPages with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

/** Type modeling the data within a particular column in the layout */
export type LayoutColumn = {
  __typename?: 'LayoutColumn';
  /** Name of the column within the row. This will be used for analytics purposes and debugging */
  name: Scalars['String'];
  /** The structured content document to render within this column */
  content?: Maybe<Scalars['StructuredContentDocument']>;
  /** The width properties for the column */
  width?: Maybe<LayoutColumnWidth>;
  /** How the contents within the column should be aligned vertically */
  verticalAlign?: Maybe<LayoutVerticalAlignEnum>;
};

/** Type containing the width settings for the column. */
export type LayoutColumnWidth = {
  __typename?: 'LayoutColumnWidth';
  /** The width of the column within the desktop breakpoint */
  desktop?: Maybe<Scalars['Int']>;
  /** The width of the column within the mobile breakpoint */
  mobile?: Maybe<Scalars['Int']>;
};

/** Type modelling the fields for a row within a page layout */
export type LayoutRow = {
  __typename?: 'LayoutRow';
  /** The name of the section in the layout. This will be used for analytics purposes */
  name: Scalars['String'];
  /** Param to toggle full width or centered container */
  fullWidth?: Maybe<Scalars['Boolean']>;
  /** The columns to display within the row. */
  columns?: Maybe<Array<LayoutColumn>>;
};

/** The vertical alignment options for a column */
export enum LayoutVerticalAlignEnum {
  Bottom = 'BOTTOM',
  Center = 'CENTER',
  Top = 'TOP'
}

export type LegacyDriver = {
  __typename?: 'LegacyDriver';
  /** The driver description */
  description?: Maybe<Scalars['String']>;
  /** The driver label */
  label: Scalars['String'];
  /** The value of the driver */
  value?: Maybe<Scalars['String']>;
  /** Tooltip for the value of the driver */
  tooltip?: Maybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_lender post type from WordPress. */
export type LegacyLender = PostInterface & PostWithAuthorsInterface & PostWithFeaturedImageInterface & PostWithTitleInterface & {
  __typename?: 'LegacyLender';
  applyDisclaimerText?: Maybe<Scalars['String']>;
  applyText?: Maybe<Scalars['String']>;
  applyUrl?: Maybe<Scalars['String']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the LegacyLender object. */
  categories?: Maybe<Array<Category>>;
  /** The negative bullet points about the product. */
  cons?: Maybe<Array<Scalars['String']>>;
  /** The custom URL to use for linking to a review. */
  customReviewUrl?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  lenderId?: Maybe<Scalars['String']>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** Field connecting to the LegacyLenderMaxLTV Type and all of its nested fields. */
  maxLTV?: Maybe<LegacyLenderMaxLtv>;
  /** Field connecting to the LegacyLenderMinCreditScore Type and all of its nested fields. */
  minCreditScore?: Maybe<LegacyLenderMinCreditScore>;
  /** Field connecting to the LegacyLenderMinDownPayment Type and all of its nested fields. */
  minDownPayment?: Maybe<LegacyLenderMinDownPayment>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** Field connecting to the LegacyLenderNationalRegional Type and all of its nested fields. */
  nationalRegional?: Maybe<LegacyLenderNationalRegional>;
  personalizedRatesEnabled?: Maybe<Scalars['Boolean']>;
  productEntity?: Maybe<MarketplaceEntityInterface>;
  productId?: Maybe<Scalars['String']>;
  /** The positive bullet points about the product. */
  pros?: Maybe<Array<Scalars['String']>>;
  /** The NerdWallet rating for the product. */
  rating?: Maybe<Scalars['Float']>;
  /** Reviews associated with this content. */
  review?: Maybe<LegacyLenderReviewUnion>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
  whyWeLikeIt?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_lender post type from WordPress. */
export type LegacyLenderDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_lender post type from WordPress. */
export type LegacyLenderModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_lender post type from WordPress. */
export type LegacyLenderTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type LegacyLenderConnectionResponse = {
  __typename?: 'LegacyLenderConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The LegacyLender returned for the connection. */
  items?: Maybe<Array<LegacyLender>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of LegacyLender objects. */
export type LegacyLenderFilterInput = {
  /** Limit collection to LegacyLenders published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to LegacyLenders within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']>>;
  /** Limit collection to LegacyLenders with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to LegacyLenders with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

export type LegacyLenderMaxLtv = {
  __typename?: 'LegacyLenderMaxLTV';
  header?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type LegacyLenderMinCreditScore = {
  __typename?: 'LegacyLenderMinCreditScore';
  conventional?: Maybe<Scalars['String']>;
  fha?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  hel?: Maybe<Scalars['String']>;
  heloc?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  usda?: Maybe<Scalars['String']>;
  va?: Maybe<Scalars['String']>;
};

export type LegacyLenderMinDownPayment = {
  __typename?: 'LegacyLenderMinDownPayment';
  conventional?: Maybe<Scalars['String']>;
  fha?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  va?: Maybe<Scalars['String']>;
};

export type LegacyLenderNationalRegional = {
  __typename?: 'LegacyLenderNationalRegional';
  header?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

/** The union containing the Type members that can be returned by the review field on the LegacyLender type. */
export type LegacyLenderReviewUnion = Post | Review;

export enum LicenseStatusEnum {
  Valid = 'VALID',
  Temporary = 'TEMPORARY',
  Suspended = 'SUSPENDED',
  NoLicense = 'NO_LICENSE',
  Permit = 'PERMIT'
}

/** Query variables for InsurancePrequalOffers */
export type LifeInsurancePrequalOfferInput = {
  tobaccoUse?: InputMaybe<Scalars['Boolean']>;
  age?: InputMaybe<Scalars['Int']>;
};

export type LogInUserResponse = AuthenticationResponseInterface & {
  __typename?: 'LogInUserResponse';
  /** Determines whether user registration was successful */
  success: Scalars['Boolean'];
  /** The A/B experiments associated with the current user */
  abExperiments?: Maybe<Array<Experiment>>;
  /** The feature flags associated with the current user for the calling application */
  featureFlags?: Maybe<Array<FeatureFlag>>;
};

export type LogOutUserResponse = {
  __typename?: 'LogOutUserResponse';
  /** Determines whether user log out was successful */
  success: Scalars['Boolean'];
};

/** The aggregator type should only be one of a subset of all marketplace institution types */
export enum MarketplaceAggregatorType {
  Plaid = 'plaid',
  Yodlee = 'yodlee',
  Unknown = 'unknown'
}

/** Interface for all Marketplace entity types (Institution, Product, and Offer) */
export type MarketplaceEntityInterface = {
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

export type MarketplaceEntityRelatedReviewUnion = Review | ReviewRedirect;

/** Enum values for entityType field on Review type. */
export enum MarketplaceEntityTypeEnum {
  Default = 'DEFAULT',
  Institutions = 'INSTITUTIONS',
  Offers = 'OFFERS',
  Products = 'PRODUCTS'
}

/** Common interface for marketplace entities that can win a Best Of Awards Badge for 2021 */
export type MarketplaceEntityWithBestOfAwards2021Interface = {
  /**
   * The list of NW Best-Of Awards this offer has won for 2021
   * @deprecated This year specific best of badge field is now succeeded by a generic best of awards field. Use the bestOfAwards field on the MarketplaceEntityWithBestOfAwardsInterface interface instead.
   */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']>>;
};

/** Common interface for marketplace entities that can win a Best Of Awards Badge */
export type MarketplaceEntityWithBestOfAwardsInterface = {
  /** The list of NW Best Of Awards this offer has won */
  bestOfAwards?: Maybe<Array<BestOfAward>>;
};

/** Common interface for marketplace entities that can be used in a placement */
export type MarketplaceEntityWithPlacementInterface = {
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The display name for the entity */
  displayName?: Maybe<Scalars['String']>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /** Monetizable status that conforms to one of the values defined by NerdWallet analytics */
  monetizable: Scalars['String'];
  /** The drivers associated with the entity */
  placementDrivers: Array<Maybe<EntityPlacementDriver>>;
  /** A boolean indicating if the display name should be shown in the comparison table component */
  showNameInComparisonTable: Scalars['Boolean'];
  /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
  /** Flag for whether to use the large product card image styles */
  useLargeImageFootprint: Scalars['Boolean'];
};

/** Common interface for marketplace entities with qualification bullets */
export type MarketplaceEntityWithQualificationsInterface = {
  /** List of qualifications for the offer */
  qualificationsBullets?: Maybe<Array<Scalars['String']>>;
};

/** Common interface for marketplace entities with review links */
export type MarketplaceEntityWithReviewInterface = {
  reviewLink?: Maybe<Scalars['URL']>;
};

/** Common interface for marketplace entities with a star rating */
export type MarketplaceEntityWithStarRatingInterface = {
  /** NerdWallet review rating stars */
  starRating?: Maybe<Scalars['Float']>;
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_mkt_entry post type from WordPress. */
export type MarketplaceEntryPoint = PostInterface & PostWithAuthorsInterface & PostWithFeaturedImageInterface & PostWithTitleInterface & {
  __typename?: 'MarketplaceEntryPoint';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The body text to use in this Marketplace Entry Point. */
  body?: Maybe<Scalars['String']>;
  /** The CTA annotation to use in this Marketplace Entry Point. */
  ctaAnnotation?: Maybe<Scalars['String']>;
  /** The CTA text to use in this Marketplace Entry Point. */
  ctaText?: Maybe<Scalars['String']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The heading text to use in this Marketplace Entry Point. */
  heading?: Maybe<Scalars['String']>;
  /** The text to use in the Highlights section in this Marketplace Entry Point. */
  highlights?: Maybe<Array<Scalars['String']>>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The Marketplace entity associated with this Marketplace Entry Point. */
  marketplaceEntity?: Maybe<MarketplaceEntityInterface>;
  /** The Marketplace entity associated with this Marketplace Entry Point. */
  marketplaceEntityId?: Maybe<Scalars['String']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The short body text to use in this Marketplace Entry Point. Rendered in the "Minimal" template only. */
  shortBody?: Maybe<Scalars['String']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The template to use for this entry point. */
  template?: Maybe<MarketplaceEntryPointTemplateEnum>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
};


/** Type modeling the data for posts within the nw_mkt_entry post type from WordPress. */
export type MarketplaceEntryPointDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_mkt_entry post type from WordPress. */
export type MarketplaceEntryPointModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_mkt_entry post type from WordPress. */
export type MarketplaceEntryPointTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type MarketplaceEntryPointConnectionResponse = {
  __typename?: 'MarketplaceEntryPointConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The MarketplaceEntryPoint returned for the connection. */
  items?: Maybe<Array<MarketplaceEntryPoint>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of MarketplaceEntryPoint objects. */
export type MarketplaceEntryPointFilterInput = {
  /** Limit collection to MarketplaceEntryPoints published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to MarketplaceEntryPoints with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
};

/** Enum values for template field on MarketplaceEntryPoint type. */
export enum MarketplaceEntryPointTemplateEnum {
  Card = 'CARD',
  Default = 'DEFAULT',
  Detailed = 'DETAILED',
  Horizontal = 'HORIZONTAL',
  Minimal = 'MINIMAL',
  Vertical = 'VERTICAL'
}

/** marketplaceField query response */
export type MarketplaceFieldResponse = {
  __typename?: 'MarketplaceFieldResponse';
  /** Boolean value that indicates if the marketplace entity is active */
  isActive: Scalars['Boolean'];
  /** Name of the marketplace entity */
  name: Scalars['String'];
  /** A string value of the requested marketplace field. */
  value: Scalars['String'];
};

/** Interface for all Marketplace institution types */
export type MarketplaceInstitutionInterface = {
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']>;
};

/** Interface for all Marketplace Offer types */
export type MarketplaceOfferInterface = {
  /** Redirect link for this Offer */
  applyLink?: Maybe<Scalars['URL']>;
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /** Whether this Offer is monetizing. Client apps use this field to decide display behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA */
  isMonetizing?: Maybe<Scalars['Boolean']>;
  /** The parent Product of this Offer */
  product: MarketplaceProductInterface;
  /** The overall editorial rating for this Offer. */
  starRating?: Maybe<Scalars['Float']>;
};

/** Interface for all Marketplace Product types */
export type MarketplaceProductInterface = {
  /** The parent Institution of this Product */
  institution: MarketplaceEntityInterface;
};

/** Enum values for productType field on Review type. */
export enum MarketplaceProductTypeEnum {
  AutoLoans = 'AUTO_LOANS',
  Banking = 'BANKING',
  CreditCards = 'CREDIT_CARDS',
  Default = 'DEFAULT',
  EducationLoans = 'EDUCATION_LOANS',
  Expansion = 'EXPANSION',
  FirstTimeHomeBuyerPrograms = 'FIRST_TIME_HOME_BUYER_PROGRAMS',
  Insurance = 'INSURANCE',
  Investing = 'INVESTING',
  Mortgages = 'MORTGAGES',
  Moving = 'MOVING',
  PersonalLoans = 'PERSONAL_LOANS',
  SmallMediumBusinessLoans = 'SMALL_MEDIUM_BUSINESS_LOANS',
  Software = 'SOFTWARE',
  Taxes = 'TAXES',
  Utilities = 'UTILITIES'
}

/** Input for marketplace query */
export type MarketplaceQueryInput = {
  field: Scalars['String'];
  type: Scalars['String'];
  value: Scalars['JSON'];
};

/** marketplaceSearch query response */
export type MarketplaceSearchResponse = {
  __typename?: 'MarketplaceSearchResponse';
  /** The total number of marketplace entities that match your query. */
  total: Scalars['Int'];
  /** List of marketplace entities that match your query. */
  entities?: Maybe<Array<MarketplaceEntityInterface>>;
};

/** Input for marketplace sort */
export type MarketplaceSortInput = {
  field: Scalars['String'];
  order: OrderDirectionEnum;
};

export enum MarketplaceStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type MarkNotificationAsDismissedResponse = {
  __typename?: 'MarkNotificationAsDismissedResponse';
  /** The updated number of unread notifications for the user. */
  unreadCount: Scalars['Int'];
  /** The updated notification that has been marked as dismissed. */
  item: Notification;
};

export type MarkNotificationAsReadResponse = {
  __typename?: 'MarkNotificationAsReadResponse';
  /** The updated number of unread notifications for the user. */
  unreadCount: Scalars['Int'];
  /** The updated notification that has been marked as read. */
  item: Notification;
};

export type MarkNotificationAsUndismissedResponse = {
  __typename?: 'MarkNotificationAsUndismissedResponse';
  /** The updated number of unread notifications for the user. */
  unreadCount: Scalars['Int'];
  /** The updated notification that has been marked as undismissed. */
  item: Notification;
};

export type MarkNotificationAsUnreadResponse = {
  __typename?: 'MarkNotificationAsUnreadResponse';
  /** The updated number of unread notifications for the user. */
  unreadCount: Scalars['Int'];
  /** The updated notification that has been marked as unread. */
  item: Notification;
};

/** The media details type for media items. */
export type MediaDetails = {
  __typename?: 'MediaDetails';
  /**
   * The file path to the image within the uploads directory.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  file?: Maybe<Scalars['String']>;
  /**
   * The height of the original image in pixels.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  height?: Maybe<Scalars['Int']>;
  /**
   * All of the different image crop sizes for a particular media item.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  sizes?: Maybe<Array<MediaSize>>;
  /**
   * The width of the original image in pixels.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  width?: Maybe<Scalars['Int']>;
  /**
   * A unique ID. A hash of the 'file' key.
   * This is necessary in order for ApolloClient 3 to cache the object
   */
  id: Scalars['ID'];
  /**
   * A srcSet string including the image sizes requested
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  srcSet?: Maybe<Scalars['String']>;
};


/** The media details type for media items. */
export type MediaDetailsSizesArgs = {
  sizes?: InputMaybe<Array<Scalars['String']>>;
};


/** The media details type for media items. */
export type MediaDetailsSrcSetArgs = {
  sizes?: InputMaybe<Array<Scalars['String']>>;
};

/** The WordPress media item type. */
export type MediaItem = PostInterface & PostWithAuthorsInterface & PostWithTitleInterface & {
  __typename?: 'MediaItem';
  /** The alt text for the image. */
  altText?: Maybe<Scalars['String']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The caption for the image. */
  caption?: Maybe<Scalars['String']>;
  /** The cropped version of an image filtered by size. */
  croppedImage?: Maybe<CroppedImageSize>;
  /** An array of cropped versions of an image filtered by size. */
  croppedImages?: Maybe<Array<CroppedImageSize>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']>;
  /** The height of the original image in pixels. */
  height?: Maybe<Scalars['Int']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /**
   * Details about the media item.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  mediaDetails?: Maybe<MediaDetails>;
  /** The type of media. */
  mediaType?: Maybe<Scalars['String']>;
  /** The mime type of media item. */
  mimeType?: Maybe<Scalars['String']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The permalink for where the image lives. */
  sourceUrl?: Maybe<Scalars['URL']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
  /** The width of the original image in pixels. */
  width?: Maybe<Scalars['Int']>;
  /** A srcSet string including the image sizes requested */
  srcSet?: Maybe<Scalars['String']>;
  /** List of available image sizes for a particular image. */
  availableSizes: Array<Scalars['String']>;
};


/** The WordPress media item type. */
export type MediaItemCaptionArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};


/** The WordPress media item type. */
export type MediaItemCroppedImageArgs = {
  size?: InputMaybe<MediaItemImageSizeEnum>;
};


/** The WordPress media item type. */
export type MediaItemCroppedImagesArgs = {
  sizes?: InputMaybe<Array<MediaItemImageSizeEnum>>;
};


/** The WordPress media item type. */
export type MediaItemDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** The WordPress media item type. */
export type MediaItemModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** The WordPress media item type. */
export type MediaItemTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};


/** The WordPress media item type. */
export type MediaItemSrcSetArgs = {
  sizes?: InputMaybe<Array<MediaItemImageSizeEnum>>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type MediaItemConnectionResponse = {
  __typename?: 'MediaItemConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The MediaItem returned for the connection. */
  items?: Maybe<Array<MediaItem>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of MediaItem objects. */
export type MediaItemFilterInput = {
  /** Limit collection to MediaItems published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to MediaItems with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to MediaItems with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

/** Image crop sizes supported by WP */
export enum MediaItemImageSizeEnum {
  BbArticle = 'BB_ARTICLE',
  Full = 'FULL',
  Large = 'LARGE',
  Medium = 'MEDIUM',
  MediumLarge = 'MEDIUM_LARGE',
  PrimaryL = 'PRIMARY_L',
  PrimaryLUncropped = 'PRIMARY_L_UNCROPPED',
  PrimaryM = 'PRIMARY_M',
  PrimaryMUncropped = 'PRIMARY_M_UNCROPPED',
  PrimaryS = 'PRIMARY_S',
  PrimarySUncropped = 'PRIMARY_S_UNCROPPED',
  PrimaryXl = 'PRIMARY_XL',
  PrimaryXlUncropped = 'PRIMARY_XL_UNCROPPED',
  PrimaryXs = 'PRIMARY_XS',
  PrimaryXsUncropped = 'PRIMARY_XS_UNCROPPED',
  PrimaryXxl = 'PRIMARY_XXL',
  PrimaryXxs = 'PRIMARY_XXS',
  PrimaryXxsUncropped = 'PRIMARY_XXS_UNCROPPED',
  PrimaryXxxl = 'PRIMARY_XXXL',
  Square = 'SQUARE',
  Square_160 = 'SQUARE_160',
  Square_350 = 'SQUARE_350'
}

/** Type modeling the data for terms within the nw_media_site taxonomy from WordPress. */
export type MediaSite = TermInterface & {
  __typename?: 'MediaSite';
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** The WordPress front end URL for this resource. */
  link: Scalars['URL'];
  /** The logo to display for the media site. */
  logo?: Maybe<MediaItem>;
  /** The name of the term. */
  name?: Maybe<Scalars['String']>;
  /** The MediaSite object for the parent of this entity. */
  parent?: Maybe<MediaSite>;
  /** The slug for the term. */
  slug?: Maybe<Scalars['String']>;
  /** The taxonomy the term is in. */
  taxonomy: Scalars['String'];
};

/** The media size type for media details. */
export type MediaSize = {
  __typename?: 'MediaSize';
  /**
   * The file name for this crop size.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  file?: Maybe<Scalars['String']>;
  /**
   * The height of this crop size in pixels.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  height?: Maybe<Scalars['Int']>;
  /**
   * The mime type for this crop size.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  mimeType?: Maybe<Scalars['String']>;
  /**
   * The name of the crop size.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  size?: Maybe<Scalars['String']>;
  /**
   * The full url path to the crop of this image.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  sourceUrl?: Maybe<Scalars['URL']>;
  /**
   * The width of this crop size in pixels.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  width?: Maybe<Scalars['Int']>;
};

/** The expected payload for the `updateMembershipAppActivity` mutation. */
export type MembershipAppActivityInput = {
  activationChecklistLastSessionAt?: InputMaybe<Scalars['DateTime']>;
  activationChecklistSessionCount?: InputMaybe<Scalars['Int']>;
  creditCardMatchBannerDismissedAt?: InputMaybe<Scalars['DateTime']>;
  creditFactorChangesSeenAt?: InputMaybe<Scalars['DateTime']>;
  downloadAppQrTakeoverDismissedAt?: InputMaybe<Scalars['DateTime']>;
  hideTransactionTipSeenAt?: InputMaybe<Scalars['DateTime']>;
  isTransactionsFilterTooltipSeen?: InputMaybe<Scalars['Boolean']>;
  netWorthGhostCtasDismissed?: InputMaybe<Scalars['JSON']>;
  netWorthHideAccountTipDismissedAt?: InputMaybe<Scalars['DateTime']>;
  netWorthOtherAccountCategorizationModuleDismissedAt?: InputMaybe<Scalars['DateTime']>;
  netWorthSnapshotNotificationDismissedAt?: InputMaybe<Scalars['DateTime']>;
  studentLoanHubBannerDismissedAt?: InputMaybe<Scalars['DateTime']>;
  valuePropTakeoverDismissedAt?: InputMaybe<Scalars['DateTime']>;
};

/**
 * The MembershipAppActivityResponse type records "activity" within the app,
 * such as feature dismissal, or flow progress.
 */
export type MembershipAppActivityResponse = {
  __typename?: 'MembershipAppActivityResponse';
  activationChecklistLastSessionAt?: Maybe<Scalars['DateTime']>;
  activationChecklistSessionCount?: Maybe<Scalars['Int']>;
  creditCardMatchBannerDismissedAt?: Maybe<Scalars['DateTime']>;
  creditFactorChangesSeenAt?: Maybe<Scalars['DateTime']>;
  downloadAppQrTakeoverDismissedAt?: Maybe<Scalars['DateTime']>;
  hideTransactionTipSeenAt?: Maybe<Scalars['DateTime']>;
  isTransactionsFilterTooltipSeen?: Maybe<Scalars['Boolean']>;
  netWorthGhostCtasDismissed?: Maybe<Scalars['JSON']>;
  netWorthHideAccountTipDismissedAt?: Maybe<Scalars['DateTime']>;
  netWorthOtherAccountCategorizationModuleDismissedAt?: Maybe<Scalars['DateTime']>;
  netWorthSnapshotNotificationDismissedAt?: Maybe<Scalars['DateTime']>;
  studentLoanHubBannerDismissedAt?: Maybe<Scalars['DateTime']>;
  valuePropTakeoverDismissedAt?: Maybe<Scalars['DateTime']>;
};

/** This enum represents the possible activation statuses of a particular feature */
export enum MembershipFeatureActivationStatusEnum {
  Unactivated = 'UNACTIVATED',
  Degraded = 'DEGRADED',
  Blocked = 'BLOCKED',
  Activated = 'ACTIVATED'
}

export type MembershipFeatureActivationStatusInterface = {
  id: MembershipFeatureEnum;
  status: MembershipFeatureActivationStatusEnum;
};

/**
 * The set of NerdWallet features.  This enum should be a superset of the _enrollable_ features, which are defined in
 * the feature_enrollment_changed analytics event:
 * https://github.com/NerdWallet/app-schemata/blob/master/analytic_pipeline/feature_enrollment_changed.yaml
 */
export enum MembershipFeatureEnum {
  AppLock = 'APP_LOCK',
  AutoValue = 'AUTO_VALUE',
  Bills = 'BILLS',
  Billshark = 'BILLSHARK',
  CardLinkedOffers = 'CARD_LINKED_OFFERS',
  CashFlow = 'CASH_FLOW',
  CreditScore = 'CREDIT_SCORE',
  Debt = 'DEBT',
  EmailNotifications = 'EMAIL_NOTIFICATIONS',
  Eoru = 'EORU',
  FinancialAccountAggregation = 'FINANCIAL_ACCOUNT_AGGREGATION',
  HomeEquity = 'HOME_EQUITY',
  HomeValue = 'HOME_VALUE',
  GeolocationBrowser = 'GEOLOCATION_BROWSER',
  GeolocationNative = 'GEOLOCATION_NATIVE',
  Membership = 'MEMBERSHIP',
  MoneyTransfer = 'MONEY_TRANSFER',
  NetWorth = 'NET_WORTH',
  PlayYourCardsRight = 'PLAY_YOUR_CARDS_RIGHT',
  PushNotifications = 'PUSH_NOTIFICATIONS'
}

export type MigrateFinancialPortalResponse = {
  __typename?: 'MigrateFinancialPortalResponse';
  portal?: Maybe<FinancialPortal>;
};

/** The `MobileAppIdentityProfile` type represents the user's registered devices */
export type MobileAppIdentityProfile = {
  __typename?: 'MobileAppIdentityProfile';
  id?: Maybe<Scalars['String']>;
  devices: Array<MobileAppProfileDevice>;
  newestAppVersionUsed?: Maybe<Scalars['String']>;
  newestAppVersionUsedOnDeviceType?: Maybe<Scalars['String']>;
};

/** The `MobileAppProfileDevice` type represents a device a user has */
export type MobileAppProfileDevice = {
  __typename?: 'MobileAppProfileDevice';
  deviceId: Scalars['String'];
  deviceType: Scalars['String'];
  pushNotificationsEnabled?: Maybe<Scalars['Boolean']>;
  appVersion: Scalars['String'];
  deviceLastLogin?: Maybe<Scalars['String']>;
};

/** The expected payload for the `addMobileAppDevice` mutations */
export type MobileAppProfileDeviceInput = {
  deviceId: Scalars['String'];
  deviceType: Scalars['String'];
  pushNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
  appVersion: Scalars['String'];
  deviceLastLogin?: InputMaybe<Scalars['String']>;
};

export type MoneyTransferAccount = {
  __typename?: 'MoneyTransferAccount';
  /** The unique identifier for this linked-account in money-management */
  id: Scalars['ID'];
  /** The computed status for this account (combination of money-management + ach statuses) */
  computedStatus?: Maybe<MoneyTransferAccountStatusEnum>;
  /** The identifier found in FDP or legacy-Yodlee */
  financialAccountId: Scalars['ID'];
  /** The type of this account (CHECKING or SAVINGS) */
  financialAccountType: MoneyTransferFinancialAccountTypeEnum;
  /** The last four digits of the account number */
  financialAccountLastFour?: Maybe<Scalars['String']>;
  /** The institution name (e.g. Wells Fargo) */
  institutionName?: Maybe<Scalars['String']>;
  /** Indicates whether the account passed the holder name match check */
  nameMatchSuccess?: Maybe<Scalars['Boolean']>;
};

export type MoneyTransferAccountEligibility = {
  __typename?: 'MoneyTransferAccountEligibility';
  eligibility: MoneyTransferAccountEligibilityStatusEnum;
  id: Scalars['ID'];
  financialAccountType?: Maybe<MoneyTransferFinancialAccountTypeEnum>;
};

export type MoneyTransferAccountEligibilityResponse = {
  __typename?: 'MoneyTransferAccountEligibilityResponse';
  accounts: Array<MoneyTransferAccountEligibility>;
};

export enum MoneyTransferAccountEligibilityStatusEnum {
  Eligible = 'ELIGIBLE',
  AccountDetailsUnavailable = 'ACCOUNT_DETAILS_UNAVAILABLE',
  AccountNotVerified = 'ACCOUNT_NOT_VERIFIED',
  InsufficientIavData = 'INSUFFICIENT_IAV_DATA',
  AccountNameNotMatching = 'ACCOUNT_NAME_NOT_MATCHING',
  Unknown = 'UNKNOWN',
  UnsupportedAccountType = 'UNSUPPORTED_ACCOUNT_TYPE',
  UnsupportedMoneyMarketAccount = 'UNSUPPORTED_MONEY_MARKET_ACCOUNT'
}

export enum MoneyTransferAccountStatusEnum {
  AccountAchUnverified = 'ACCOUNT_ACH_UNVERIFIED',
  AccountInactive = 'ACCOUNT_INACTIVE',
  AccountNameMatchFailed = 'ACCOUNT_NAME_MATCH_FAILED',
  AccountNotInAchSystem = 'ACCOUNT_NOT_IN_ACH_SYSTEM',
  AccountReady = 'ACCOUNT_READY',
  AccountRemovedInAch = 'ACCOUNT_REMOVED_IN_ACH',
  AccountUninitialized = 'ACCOUNT_UNINITIALIZED',
  AccountUnlinked = 'ACCOUNT_UNLINKED',
  Unknown = 'UNKNOWN'
}

export type MoneyTransferCancelTransferResponse = {
  __typename?: 'MoneyTransferCancelTransferResponse';
  success: Scalars['Boolean'];
};

export type MoneyTransferCreateUserInput = {
  address: Scalars['String'];
  birthdate: Scalars['String'];
  city: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  fullSsn?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  postalCode: Scalars['String'];
  shortSsn: Scalars['String'];
  state: Scalars['String'];
};

export type MoneyTransferCreateUserResponse = {
  __typename?: 'MoneyTransferCreateUserResponse';
  user?: Maybe<MoneyTransferUser>;
};

export type MoneyTransferDefaultTransferLimits = {
  __typename?: 'MoneyTransferDefaultTransferLimits';
  userDailyLimit: Scalars['Int'];
  checkingAccountDailyLimit: Scalars['Int'];
  savingsAccountDailyLimit: Scalars['Int'];
  userWeeklyLimit: Scalars['Int'];
  checkingAccountWeeklyLimit: Scalars['Int'];
  savingsAccountWeeklyLimit: Scalars['Int'];
  userMonthlyLimit: Scalars['Int'];
  checkingAccountMonthlyLimit: Scalars['Int'];
  savingsAccountMonthlyLimit: Scalars['Int'];
  maxMonthlyTransferAmountDollars: Scalars['Int'];
  minSingleTransferAmountDollars: Scalars['Int'];
  maxSingleTransferAmountDollars: Scalars['Int'];
  balanceCheckBufferAmountDollars: Scalars['Int'];
  balanceCheckBufferAmountDollarsWarning: Scalars['Int'];
};

export type MoneyTransferFinancialAccountTransferLimits = {
  __typename?: 'MoneyTransferFinancialAccountTransferLimits';
  id: Scalars['ID'];
  dayLimit: Scalars['Int'];
  maxTransferAmountDollars: Scalars['Int'];
  weekLimit: Scalars['Int'];
  monthLimit: Scalars['Int'];
};

export enum MoneyTransferFinancialAccountTypeEnum {
  Checking = 'CHECKING',
  Savings = 'SAVINGS'
}

export type MoneyTransferKbaAnswer = {
  __typename?: 'MoneyTransferKbaAnswer';
  text: Scalars['String'];
  id: Scalars['ID'];
};

export type MoneyTransferKbaQuestion = {
  __typename?: 'MoneyTransferKbaQuestion';
  text: Scalars['String'];
  id: Scalars['ID'];
  answers: Array<MoneyTransferKbaAnswer>;
};

export type MoneyTransferKbaQuestionsResponse = {
  __typename?: 'MoneyTransferKbaQuestionsResponse';
  questions: Array<MoneyTransferKbaQuestion>;
};

export type MoneyTransferTransfer = {
  __typename?: 'MoneyTransferTransfer';
  /** The unique identifier for this transfer in money-management */
  id: Scalars['ID'];
  /** The current (high-level) status for this transfer (combination of money-management + ach statuses) */
  status: MoneyTransferTransferStatusEnum;
  /** The transfer amount in USD */
  amount: Scalars['Float'];
  /** The source account from where the money is retrieved */
  sourceAccount: MoneyTransferAccount;
  /** The destination account to where the money is deposited */
  destinationAccount: MoneyTransferAccount;
  /** Indicates the speed of the transfer */
  type?: Maybe<MoneyTransferTransferTypeEnum>;
  /** Timestamp indicating when the user attempted to initiate the transfer */
  userInitiatedAt: Scalars['DateTime'];
  /** Timestamp indicating when the (high-level) status was last updated */
  lastStatusUpdatedAt: Scalars['DateTime'];
  /** A JSON blob with additional transfer details */
  achData?: Maybe<Scalars['JSON']>;
  /** Indicates if the user can still cancel this transfer */
  canCancel?: Maybe<Scalars['Boolean']>;
  /**
   * The status histories define when and what state changes occurred over the lifecycle
   * of the transfer
   */
  statusHistory: Array<MoneyTransferTransferStatusHistory>;
};

export type MoneyTransferTransferLimits = {
  __typename?: 'MoneyTransferTransferLimits';
  defaultLimits: MoneyTransferDefaultTransferLimits;
  userLimits: MoneyTransferUserTransferLimits;
  financialAccountLimits: Array<MoneyTransferFinancialAccountTransferLimits>;
};

export type MoneyTransferTransferLimitsResponse = {
  __typename?: 'MoneyTransferTransferLimitsResponse';
  transferLimits: MoneyTransferTransferLimits;
};

export enum MoneyTransferTransferStatusEnum {
  Created = 'CREATED',
  Cancelled = 'CANCELLED',
  CancelInitiatedBySecurity = 'CANCEL_INITIATED_BY_SECURITY',
  CancelInitiatedByUser = 'CANCEL_INITIATED_BY_USER',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  FailedDuringActivation = 'FAILED_DURING_ACTIVATION',
  MockTransfer = 'MOCK_TRANSFER',
  Pending = 'PENDING',
  PendingBalanceCheck = 'PENDING_BALANCE_CHECK',
  Uninitialized = 'UNINITIALIZED'
}

export type MoneyTransferTransferStatusHistory = {
  __typename?: 'MoneyTransferTransferStatusHistory';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  status: MoneyTransferTransferStatusEnum;
  transferId: Scalars['ID'];
};

export enum MoneyTransferTransferTypeEnum {
  NextDay = 'NEXT_DAY',
  Standard = 'STANDARD'
}

export type MoneyTransferUser = {
  __typename?: 'MoneyTransferUser';
  /** KYC first name */
  firstName: Scalars['String'];
  /** KYC last name */
  lastName: Scalars['String'];
  /** Computed status for this user (combination of money-management + ach statuses) */
  computedStatus: MoneyTransferUserStatus;
};

export enum MoneyTransferUserStatus {
  Unknown = 'UNKNOWN',
  UserAchDisabled = 'USER_ACH_DISABLED',
  UserAchEnabled = 'USER_ACH_ENABLED',
  UserAchKba = 'USER_ACH_KBA',
  UserAchRetryWithFullSsn = 'USER_ACH_RETRY_WITH_FULL_SSN',
  UserInactive = 'USER_INACTIVE',
  UserNotInAchSystem = 'USER_NOT_IN_ACH_SYSTEM',
  UserReady = 'USER_READY',
  UserUninitialized = 'USER_UNINITIALIZED'
}

export type MoneyTransferUserTransferLimits = {
  __typename?: 'MoneyTransferUserTransferLimits';
  userDailyLimit: Scalars['Int'];
  userWeeklyLimit: Scalars['Int'];
  userMonthlyLimit: Scalars['Int'];
  maxMonthlyTransferAmountDollars: Scalars['Int'];
  maxSingleTransferAmountDollars: Scalars['Int'];
};

/** Employment type */
export enum MortgageEmploymentTypeEnum {
  FullTime = 'FULL_TIME',
  PartTime = 'PART_TIME',
  SelfEmployed = 'SELF_EMPLOYED',
  Unemployed = 'UNEMPLOYED'
}

/** Inputs for Mortgage lender match logic.  Subset of Mortgage OSX inputs */
export type MortgageLenderMatchInput = {
  /** User's annual income */
  annualIncome?: InputMaybe<Scalars['Int']>;
  /** Amount of cash-out the user wants */
  cashout?: InputMaybe<Scalars['Int']>;
  /** User's credit score */
  creditScore?: InputMaybe<Scalars['Int']>;
  /** Down payment on the home.  Only applicable to purchase loans. */
  downPayment?: InputMaybe<Scalars['Int']>;
  /** Employment type */
  employmentType?: InputMaybe<MortgageEmploymentTypeEnum>;
  /** Should we match FHA loans? */
  fha?: InputMaybe<Scalars['Boolean']>;
  /** Does the user want cashout with their refinance? */
  isCashoutRefinance?: InputMaybe<Scalars['Boolean']>;
  /** Purpose of the loan, e.g. purchase or refinance */
  loanPurpose?: InputMaybe<MortgageLoanPurposeEnum>;
  /** Offer loan_type */
  loanType?: InputMaybe<MortgagesOfferV2LoanTypeEnum>;
  /** User's current mortgage balance.  Only applicable to refinance loans */
  mortgageBalance?: InputMaybe<Scalars['Int']>;
  /** Property purpose */
  propertyPurpose?: InputMaybe<MortgagePropertyPurposeEnum>;
  /** Purchase price of the home.  Only applicable to purchase loans. */
  purchasePrice?: InputMaybe<Scalars['Int']>;
  /** US state abbrieviation */
  state?: InputMaybe<Scalars['String']>;
  /** Should we match VA (Veterans Affairs) loans? */
  veteran?: InputMaybe<Scalars['Boolean']>;
};

export type MortgageLicensed = {
  __typename?: 'MortgageLicensed';
  /** State looked up from user's zipCode */
  state?: Maybe<Scalars['String']>;
  /** Whether NerdWallet a licensed mortgage broker */
  isLicensed: Scalars['Boolean'];
};

/** FIXME: this violates enum best practices by having lowercase values */
export enum MortgageLoanPurposeEnum {
  Purchase = 'purchase',
  Refinance = 'refinance'
}

/** The `MortgageProduct` type contains mortgage specific fields from marketplace */
export type MortgageProduct = ProductInterface & {
  __typename?: 'MortgageProduct';
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
  details?: Maybe<MortgageProductDetails>;
};

export type MortgageProductDetails = {
  __typename?: 'MortgageProductDetails';
  logo?: Maybe<Scalars['String']>;
  lenderId?: Maybe<Scalars['String']>;
};

/** Property purpose */
export enum MortgagePropertyPurposeEnum {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  Investment = 'INVESTMENT'
}

export type MortgageSavedLeadMatchInput = {
  id?: InputMaybe<Scalars['ID']>;
};

/** Response type for a list of mortgage offers */
export type MortgageSavedLendersResponse = {
  __typename?: 'MortgageSavedLendersResponse';
  /** List of mortgage offers */
  offers?: Maybe<Array<MortgagesOfferV2>>;
};

/** Response type for a list of mortgage offers */
export type MortgageSavedRecommendedLendersResponse = {
  __typename?: 'MortgageSavedRecommendedLendersResponse';
  /** List of mortgage offers */
  offers?: Maybe<Array<MortgagesOfferV2>>;
};

/** A Mortgages institution */
export type MortgagesInstitutionV2 = MarketplaceEntityInterface & MarketplaceInstitutionInterface & {
  __typename?: 'MortgagesInstitutionV2';
  /** Lender name to display */
  displayName?: Maybe<Scalars['String']>;
  /** Entity type */
  entityType: Scalars['String'];
  /** Loan programs and types to feature for the lender */
  featuredLoanAttributes?: Maybe<Array<Scalars['String']>>;
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** A URL that points to the logo for the institution */
  imageSource?: Maybe<Scalars['URL']>;
  /** Are personalized rates enabled? */
  isRatesEnabled?: Maybe<Scalars['Boolean']>;
  /** The API provider name for mortgage lenders that support lead form or lead match */
  leadProviderName?: Maybe<Scalars['String']>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  /** NMLS Unique Identifier */
  nmlsId?: Maybe<Scalars['String']>;
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

/** A Mortgages offer */
export type MortgagesOfferV2 = MarketplaceEntityInterface & MarketplaceEntityWithBestOfAwards2021Interface & MarketplaceEntityWithBestOfAwardsInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceOfferInterface & {
  __typename?: 'MortgagesOfferV2';
  /** Long-form text about the lender, each item is a paragraph */
  aboutLender?: Maybe<Array<Scalars['String']>>;
  applyLink?: Maybe<Scalars['URL']>;
  /** Short description of what the lender is best for e.g. customer service */
  bestForBullets?: Maybe<Array<Scalars['String']>>;
  bestOfBadgeWinner2020?: Maybe<Array<Scalars['String']>>;
  /** The list of NW Best-Of Awards this offer has won for 2021 */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']>>;
  /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  consBullets?: Maybe<Array<Scalars['String']>>;
  /** Coverage area for the lender */
  coverageArea?: Maybe<Scalars['String']>;
  /** The display name for the entity */
  displayName?: Maybe<Scalars['String']>;
  /** Which drivers should be highlighted for this offer */
  drivers?: Maybe<Array<Scalars['String']>>;
  /** Entity type */
  entityType: Scalars['String'];
  /** US States that the lender will not service */
  excludedStates?: Maybe<Array<Scalars['String']>>;
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /** Used to determine if placement is monetizing */
  isMonetizing?: Maybe<Scalars['Boolean']>;
  /** Loan type this offer represents */
  loanType?: Maybe<MortgagesOfferV2LoanTypeEnum>;
  /** Display value for maximum loan-to-value */
  maxLtv?: Maybe<Scalars['String']>;
  /** Overrides tooltip value for maximum loan-to-value */
  maxLtvTooltip?: Maybe<Scalars['String']>;
  /** Display value for minimum credit score */
  minCreditScore?: Maybe<Scalars['String']>;
  /** Overrides tooltip value for minimum credit score */
  minCreditScoreTooltip?: Maybe<Scalars['String']>;
  /** Display value for minimum down payment. Only applicable to PURCHASE loans */
  minDownPayment?: Maybe<Scalars['String']>;
  /** Overrides tooltip value for minimum down payment */
  minDownPaymentTooltip?: Maybe<Scalars['String']>;
  /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
  monetizable: Scalars['String'];
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  /** NMLS (Nationwide Mortgage Licensing System and Registry) Unique Identifier */
  nmlsId?: Maybe<Scalars['String']>;
  /** Bullet points providing an overview of the lender */
  overview?: Maybe<Array<Scalars['String']>>;
  /** Lender's phone number */
  payPerCall?: Maybe<Scalars['String']>;
  product: MortgagesProductV2;
  /** Product type */
  productType: Scalars['String'];
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  prosBullets?: Maybe<Array<Scalars['String']>>;
  /** Disclaimer for the NerdWallet rating */
  ratingDisclaimer?: Maybe<Scalars['String']>;
  /** The URL to the NerdWallet review of this offer. */
  reviewLink?: Maybe<Scalars['URL']>;
  /** NerdWallet review rating stars */
  starRating?: Maybe<Scalars['Float']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
  /** Short summary of why NerdWallet recommends this lender */
  tagline?: Maybe<Scalars['String']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The Best Of Awards that this offer has won */
  bestOfAwards?: Maybe<Array<BestOfAward>>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The driver max ltv associated with the entity */
  driverMaxLtv?: Maybe<EntityPlacementDriver>;
  /** The driver min credit score associated with the entity */
  driverMinCreditScore?: Maybe<EntityPlacementDriver>;
  /** The driver min down payment associated with the entity */
  driverMinDownPayment?: Maybe<EntityPlacementDriver>;
  /** The driver national regional associated with the entity */
  driverNationalRegional?: Maybe<EntityPlacementDriver>;
  /** The driver max loan amount associated with the entity */
  driverMaxLoanAmount?: Maybe<EntityPlacementDriver>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /**
   * The drivers associated with the entity
   * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
   */
  placementDrivers: Array<EntityPlacementDriver>;
  /** A boolean indicating if the display name should be shown in the comparison table component */
  showNameInComparisonTable: Scalars['Boolean'];
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']>;
  /** Flag for whether to use the large product card image styles */
  useLargeImageFootprint: Scalars['Boolean'];
};

export enum MortgagesOfferV2LoanTypeEnum {
  Cashout = 'CASHOUT',
  Conventional = 'CONVENTIONAL',
  Fha = 'FHA',
  Hel = 'HEL',
  Heloc = 'HELOC',
  Jumbo = 'JUMBO',
  Usda = 'USDA',
  Va = 'VA',
  VaCashout = 'VA_CASHOUT'
}

export type MortgagesOfferWithRates = {
  __typename?: 'MortgagesOfferWithRates';
  placementId?: Maybe<Scalars['String']>;
  marketplaceOffer?: Maybe<MortgagesOfferV2>;
};

/** A Mortgages product */
export type MortgagesProductV2 = MarketplaceEntityInterface & MarketplaceProductInterface & {
  __typename?: 'MortgagesProductV2';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  institution: MortgagesInstitutionV2;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  /** The lender's phone number */
  phoneNumber?: Maybe<Scalars['String']>;
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** The type of loan */
  type?: Maybe<MortgagesProductV2TypeEnum>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

export enum MortgagesProductV2TypeEnum {
  HomeEquity = 'HOME_EQUITY',
  Purchase = 'PURCHASE',
  Refinance = 'REFINANCE'
}

/** Partial address, currently only supports zipCode */
export type MortgageUserAddressInput = {
  zipCode: Scalars['String'];
};

/** Empty field. Not to be used. */
export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']>;
  /** Registers a new user via first party credentials */
  registerUser?: Maybe<RegisterUserResponse>;
  /** Logs out the current user */
  logOutUser?: Maybe<LogOutUserResponse>;
  /** Log in an existing user via first party credentials */
  logInUser?: Maybe<LogInUserResponse>;
  /** Log in/register a user via Google credentials */
  logInUserViaGoogle?: Maybe<LogInUserResponse>;
  /** Log in/register a user via Apple credentials */
  logInUserViaApple?: Maybe<LogInUserResponse>;
  /** Log in an existing user via a refresh token */
  logInUserViaRefreshToken?: Maybe<LogInUserResponse>;
  /** Updates the current user's password */
  updatePassword?: Maybe<Scalars['Boolean']>;
  /** Resets the current user's password */
  resetPassword?: Maybe<Scalars['Boolean']>;
  /** Send a password reset email to the provided email */
  sendPasswordResetEmail?: Maybe<Scalars['Boolean']>;
  /** Sets the user's security question and answer */
  setSecurityQuestion?: Maybe<Scalars['Boolean']>;
  /** Deactivates the current user's account */
  deactivateUser?: Maybe<Scalars['Boolean']>;
  /** Generate a one-time login token for the current user */
  generateOneTimeLoginToken?: Maybe<Scalars['Boolean']>;
  /** Generate a one-time transfer token for a cookie id */
  generateOneTimeCookieIdTransferToken?: Maybe<Scalars['Boolean']>;
  /** Initializes a CSRF session for the current user */
  initializeCsrfSession?: Maybe<Scalars['Boolean']>;
  /**
   * Accepts the new set of Credit Card Match quiz flow answers and attempts to persist it,
   * either replacing a previous set of answers or writing it new.
   * If this is successful, the response will return with the set of answers.
   */
  updateCreditCardMatchQuizAnswers: CreditCardMatchQuizAnswersResponse;
  /**
   * Retrieves a unique "trust session ID" for the user from Transunion, which is stamped onto future requests and
   * helps protect against fraudulent use of NerdWallet's TU integration.
   */
  createTrustSessionId: TrustSessionIdResponse;
  /**
   * Accepts the users details and attempts to initialize their TU profile.
   * If this is successful, TU will return security questions to present to
   * the user and put the user in status = PENDING.
   */
  initializeCreditProfile: CreditProfileAuthStatusProfile;
  /**
   * Accepts a list of question / answer pairs and posts question to TU.
   * If this is successful, the user will be put in status = AUTHENTICATED.
   * Next it will attempt to enroll the user. If this is successful, then
   * the user will be put in status = ACTIVE and the credit report will
   * be returned.
   * @deprecated This mutation does not correctly reflect the response type from Identity, which can return two different response objects.  Use authenticateCreditProfileQuestions instead.
   */
  authenticateCreditProfile: TuCreditReportIdentityProfile;
  /**
   * Accepts a list of question / answer pairs and posts question to TU.
   * If this is successful, the user will be put in status = AUTHENTICATED.
   * Next it will attempt to enroll the user. If this is successful, then
   * the user will be put in status = ACTIVE and the credit report (TuCreditReportIdentityProfile) will
   * be returned.  If there are additional verification questions a user must continue to answer,
   * then a CreditProfileAuthStatusProfile will be returned.
   */
  authenticateCreditProfileQuestions: AuthenticateCreditProfileResponseUnion;
  /**
   * This is only needed if authenticateCreditProfile left the user in
   * status = AUTHENTICATED (instead of ACTIVE).
   */
  enrollCreditProfile: TuCreditReportIdentityProfile;
  /** Refreshes the user's TU credit profile. If successful, then the refreshed credit report will be returned. */
  refreshCreditProfile: TuCreditReportIdentityProfile;
  /** Deactivates the user's TU credit profile. If successful, then the user will be put in status = DEACTIVATED. */
  deactivateCreditProfile: CreditProfileAuthStatusProfile;
  /**
   * Publish a simple CRM event (CRM events that just have identity_id in its payload)
   * publishSimpleCRMEvent will be deprecated and replaced by publishCRMEvent, which can handle payloads with just identity_id, and payloads with identity_id and other custom fields.
   *
   * Publish messages to a private Yak exchange.
   * If message fails to publish due to an error, the mutation will result in an error located at
   * `errors[0].message` indicating why the message failed.
   */
  publishSimpleCRMEvent: PublishYakMessageResult;
  /**
   * Publish a CRM Event
   *
   * Publish messages to a private Yak exchange.
   * If message fails to publish due to an error, the mutation will result in an error located at
   * `errors[0].message` indicating why the message failed.
   */
  publishCRMEvent: PublishYakMessageResult;
  /** Update whether a financial account is hidden. */
  updateFinancialAccountVisibility?: Maybe<FinancialAccount>;
  /** Create a "user" financial account that will be associated with manual transactions. */
  createManualTransactionAccount?: Maybe<CreateManualTransactionAccountResponse>;
  /** Create a "user" financial account. */
  createUserFinancialAccount?: Maybe<CreateUserFinancialAccountResponse>;
  /** Update a "user" financial account. */
  updateUserFinancialAccount?: Maybe<UpdateFinancialAccountResponse>;
  /** Delete a "user" financial account. */
  deleteUserFinancialAccount?: Maybe<DeleteUserFinancialAccountResponse>;
  /** Create a portal for a particular institution */
  initializeFinancialPortal?: Maybe<FinancialPortal>;
  /** Reinitialize a portal for fixing a broken link */
  reinitializeFinancialPortal?: Maybe<ReinitializeFinancialPortalResponse>;
  /** Initializes the migration of a portal to a new primary source */
  migrateFinancialPortal?: Maybe<MigrateFinancialPortalResponse>;
  /** Finishes the migration of a portal to a new primary source despite data loss */
  finishPortalMigration?: Maybe<FinishPortalMigrationResponse>;
  /** Delete a financial portal (for unlinking) */
  deleteFinancialPortal?: Maybe<DeleteFinancialPortalResponse>;
  /** Attempt to trigger a refresh of the data associated with a financial portal */
  refreshFinancialPortal?: Maybe<FinancialPortal>;
  /**
   * Sends information to the appropriate plugin for the financial portal. Typically used for
   * facilitating and sending progress on the linking flow.
   * https://docs.nerdwallet.io/financial-data-platform/branches/master/swagger-proxy/#operation/event
   */
  publishFinancialDataLinkEvent?: Maybe<FinancialPortalMessageResponse>;
  /** Creates a FinancialTransaction and links it to the account given by accountId. */
  createFinancialTransaction?: Maybe<FinancialTransaction>;
  /** Attempts to delete a FinancialTransaction by id. */
  deleteFinancialTransaction?: Maybe<DeleteFinancialTransactionResponse>;
  /**
   * Updates the visibility of a transaction.
   * Transactions that are hidden are excluded from transaction calculations and aggregations.
   */
  updateFinancialTransactionVisibility?: Maybe<FinancialTransaction>;
  /**  Updates the category of a transaction.  */
  updateFinancialTransactionCategory?: Maybe<FinancialTransaction>;
  /**
   * Updates the category of a merchant.
   * All transactions for that merchant will be given the category of the merchant, unless they have their
   * own respective transaction category override specified.
   * @deprecated replaced in the product with the Edit feature that uses updateFinancialTransaction. Can be removed once all clients are on the latest release
   */
  updateFinancialMerchantTransactionCategory?: Maybe<UpdateFinancialMerchantTransactionCategoryResponse>;
  /** Updates the amount, category, and date fields of the transaction given by transactionId. */
  updateFinancialTransaction?: Maybe<FinancialTransaction>;
  /** Update subscription_profile_v3 of the user. Only changed fields are required. */
  updateSubscriptionProfile?: Maybe<SubscriptionIdentityProfile>;
  /** Update subscription settings for a user via a one time use token path. */
  updateSubscriptionWithoutIdentity?: Maybe<SubscriptionIdentityProfile>;
  /** Unsubscribes from a specific notification type */
  unsubscribeFromNotification?: Maybe<SubscriptionIdentityProfile>;
  addMobileAppDevice?: Maybe<MobileAppIdentityProfile>;
  /** Update my_nerdwallet_profile fields for the user. */
  updateMembershipAppActivity?: Maybe<MembershipAppActivityResponse>;
  updateDismissAccountAggCta?: Maybe<AccountAggCtaDismissedResponse>;
  /** Update the user's income information. */
  updateIncome: UpdateIncomeResponse;
  /** Update the user's name. */
  updateName: UpdateNameResponse;
  /** Acknowledges the specified terms of service */
  acknowledgeTermsOfService?: Maybe<AcknowledgeTermsOfServiceResponse>;
  /** Creates a money transfer account to be used in a money transfer */
  moneyTransferCreateAccount?: Maybe<CreateMoneyTransferAccountResponse>;
  /** Cancels a transfer */
  moneyTransferCancelTransfer?: Maybe<MoneyTransferCancelTransferResponse>;
  /** Creates a transfer */
  moneyTransferCreateTransfer?: Maybe<CreateMoneyTransferResponse>;
  moneyTransferCreateUser?: Maybe<MoneyTransferCreateUserResponse>;
  /**
   * Accepts the account hidden value and attempts to patch the account in Wealth Recommender.
   * If this is successful, the response will return with the updated account object.
   */
  updateNetWorthAccountVisibility?: Maybe<UpdateNetWorthAccountVisibilityResponse>;
  /**
   * Accepts the data object representing a linked Real Asset of type Home in Wealth Recommender and attempts to add it.
   * If this is successful, the response will return with the newly-persisted asset object.
   */
  addNetWorthHomeIntegrated?: Maybe<AddNetWorthHomeIntegratedResponse>;
  /**
   * Accepts an asset type, nickname, and amount and attempts to add it.
   * If this is successful, the response will return with the newly-persisted asset object.
   */
  addNetWorthRealAssetSelfReported?: Maybe<AddNetWorthRealAssetSelfReportedResponse>;
  /**
   * Accepts the new real asset isHiddenFromNetWorth value and attempts to update it.
   * If this is successful, the response will return with the updated asset object.
   */
  updateNetWorthRealAssetIsHiddenFromNetWorth?: Maybe<UpdateNetWorthRealAssetResponse>;
  /**
   * Accepts a new nickname and/or amount and attempts to update the asset with
   * id netWorthRealAssetId.
   * If this is successful, the response will return with the updated asset object.
   */
  editNetWorthRealAssetSelfReported?: Maybe<EditNetWorthRealAssetSelfReportedResponse>;
  /**
   * Accepts the id of the real asset in Wealth Recommender and attempts to delete it.
   * If this is successful, the response will be an object containing a boolean "success"
   * property.
   */
  deleteNetWorthRealAsset?: Maybe<DeleteNetWorthRealAssetResponse>;
  /**
   * Marks a notification as read.
   * Input is the ID of the notification to mark as read.
   * Output is the updated notification and the updated unread count.
   */
  markNotificationAsRead: MarkNotificationAsReadResponse;
  /**
   * Marks a notification as read.
   * Input is the ID of the notification to mark as unread.
   * Output is the updated notification and the updated unread count.
   */
  markNotificationAsUnread: MarkNotificationAsUnreadResponse;
  /**
   * Marks a notification as dismissed.
   * Input is the ID of the notification to mark as dismissed.
   * Output is the updated notification and the updated unread count.
   */
  markNotificationAsDismissed: MarkNotificationAsDismissedResponse;
  /**
   * Marks a notification as undismissed.
   * Input is the ID of the notification to mark as undismissed.
   * Output is the updated notification and the updated unread count.
   */
  markNotificationAsUndismissed: MarkNotificationAsUndismissedResponse;
  /**
   * Marks all of notifications as read.
   * Inputs are the IDs of the notifications known to the frontend, and the ID before which to perform the action (inclusive).
   * Output is the updated notifications and the updated unread count.
   */
  markAllNotificationsAsRead: BulkActionResponse;
  /**
   * Marks all of notifications as dismissed.
   * Inputs are the IDs of the notifications known to the frontend, and the ID before which to perform the action (inclusive).
   * Output is the updated notifications, the updated unread count and the associated operation ID.
   */
  markAllNotificationsAsDismissed: BulkDismissResponse;
  /**
   * Undoes the last bulk action performed by the user.
   * Inputs are the IDs of the notifications known to the frontend, and the operation ID of the bulk action to undo.
   * Output is the updated notifications and the updated unread count.
   */
  undoMarkAllNotificationsAsDismissed: BulkActionResponse;
  /**
   * Initiate prequal jobs, which can be polled by ID, from user input to personal
   * loans prequal service. The underlying service adds any personal loan offers
   * to the user profile.
   */
  initiatePersonalLoansPrequalRequest: Array<PrequalJob>;
  /**
   * Accepts the a set of Project ted flow answers and attempts to persist it,
   * writes a new record in Airtable.
   * If this is successful, the response will return with the set of answers and a success status
   */
  addProjectTedForm: ProjectTedFormResponse;
  /** Add new credit cards to a list of self-reported cards a user owns. */
  addUserReportedCreditCards?: Maybe<UserReportedCreditCardsResult>;
  /**
   * Update in full, the list of self-reported cards a user owns.
   * This will replace the current list of cards a user has reported owning.
   */
  setUserReportedCreditCards?: Maybe<UserReportedCreditCardsResult>;
  /** Remove an individual card from the list of self-reported credit cards a user owns. */
  removeUserReportedCreditCard?: Maybe<RemoveUserReportedCreditCardResult>;
  /** Remove all self-reported credit cards from the user profile */
  removeAllUserReportedCreditCards: RewardsMutationSuccessResponse;
  publishViewedPYCRExperience: Scalars['String'];
  /** Adds a new wallet card to the user's cards in the my cards service */
  addUserWalletCard?: Maybe<AddUserWalletCardResponse>;
  /** Updates an existing wallet card from the user's cards in the my cards service */
  updateUserWalletCard?: Maybe<UpdateUserWalletCardResponse>;
  /** Removes a wallet card from the user's cards in the my cards service */
  removeUserWalletCard?: Maybe<RemoveUserWalletCardResponse>;
  /**
   * Publish messages to a Yak exchange.
   *
   * If any message fails to publish due to an error, the mutation will result in an error with an
   * array of results (of equal length as the messages input) located at
   * `errors[0].extensions.exception.results` indicating which message(s) failed and why.
   */
  publishYakMessages: Array<PublishYakMessageResult>;
};


/** Empty field. Not to be used. */
export type MutationRegisterUserArgs = {
  registerInfo: NwRegisterInfoInput;
};


/** Empty field. Not to be used. */
export type MutationLogInUserArgs = {
  loginInfo: NwLoginInfoInput;
};


/** Empty field. Not to be used. */
export type MutationLogInUserViaGoogleArgs = {
  loginInfo: GoogleLoginInfoInput;
};


/** Empty field. Not to be used. */
export type MutationLogInUserViaAppleArgs = {
  loginInfo: AppleLoginInfoInput;
};


/** Empty field. Not to be used. */
export type MutationLogInUserViaRefreshTokenArgs = {
  loginInfo: RefreshTokenLoginInfoInput;
};


/** Empty field. Not to be used. */
export type MutationUpdatePasswordArgs = {
  passwordInfo: UpdatePasswordInfoInput;
};


/** Empty field. Not to be used. */
export type MutationResetPasswordArgs = {
  resetInfo: ResetPasswordInfoInput;
};


/** Empty field. Not to be used. */
export type MutationSendPasswordResetEmailArgs = {
  resetInfo: SendResetPasswordEmailInfoInput;
};


/** Empty field. Not to be used. */
export type MutationSetSecurityQuestionArgs = {
  securityInfo: SecurityQuestionInfoInput;
};


/** Empty field. Not to be used. */
export type MutationUpdateCreditCardMatchQuizAnswersArgs = {
  answers?: InputMaybe<Scalars['JSON']>;
  quizVersion: Scalars['Int'];
};


/** Empty field. Not to be used. */
export type MutationCreateTrustSessionIdArgs = {
  input: TrustSessionIdInput;
};


/** Empty field. Not to be used. */
export type MutationInitializeCreditProfileArgs = {
  customer: CreditProfileAuthCustomerInput;
  trustSessionId?: InputMaybe<Scalars['String']>;
};


/** Empty field. Not to be used. */
export type MutationAuthenticateCreditProfileArgs = {
  answers: Array<CreditProfileAuthAnswerInput>;
};


/** Empty field. Not to be used. */
export type MutationAuthenticateCreditProfileQuestionsArgs = {
  answers: Array<CreditProfileAuthAnswerInput>;
};


/** Empty field. Not to be used. */
export type MutationPublishSimpleCrmEventArgs = {
  eventName: Scalars['String'];
};


/** Empty field. Not to be used. */
export type MutationPublishCrmEventArgs = {
  eventName: Scalars['String'];
  customPayload?: InputMaybe<Scalars['JSON']>;
};


/** Empty field. Not to be used. */
export type MutationUpdateFinancialAccountVisibilityArgs = {
  financialAccountId: Scalars['ID'];
  isHidden: Scalars['Boolean'];
};


/** Empty field. Not to be used. */
export type MutationCreateUserFinancialAccountArgs = {
  balance: Scalars['BigInt'];
  name: Scalars['String'];
  subtype: FinancialAccountSubtype;
  subtypeDetails: Scalars['String'];
  type: FinancialAccountType;
};


/** Empty field. Not to be used. */
export type MutationUpdateUserFinancialAccountArgs = {
  balance?: InputMaybe<Scalars['BigInt']>;
  financialAccountId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  subtype?: InputMaybe<FinancialAccountSubtype>;
  subtypeDetails?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<FinancialAccountType>;
};


/** Empty field. Not to be used. */
export type MutationDeleteUserFinancialAccountArgs = {
  financialAccountId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type MutationInitializeFinancialPortalArgs = {
  marketplaceInstitutionId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type MutationReinitializeFinancialPortalArgs = {
  financialPortalId: Scalars['ID'];
  redirectUri?: InputMaybe<Scalars['String']>;
  androidPackageName?: InputMaybe<Scalars['String']>;
};


/** Empty field. Not to be used. */
export type MutationMigrateFinancialPortalArgs = {
  financialPortalId: Scalars['ID'];
  marketplaceInstitutionId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type MutationFinishPortalMigrationArgs = {
  financialPortalId: Scalars['ID'];
  shouldMigrate?: InputMaybe<Scalars['Boolean']>;
};


/** Empty field. Not to be used. */
export type MutationDeleteFinancialPortalArgs = {
  financialPortalId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type MutationRefreshFinancialPortalArgs = {
  financialPortalId: Scalars['ID'];
  isAutoRefresh?: InputMaybe<Scalars['Boolean']>;
};


/** Empty field. Not to be used. */
export type MutationPublishFinancialDataLinkEventArgs = {
  event: ProxyEventType;
  eventBody?: InputMaybe<Scalars['JSON']>;
  financialPortalId?: InputMaybe<Scalars['ID']>;
  linkToken?: InputMaybe<Scalars['String']>;
  sourceEntityId?: InputMaybe<Scalars['ID']>;
  source?: InputMaybe<FinancialDataSource>;
  sourceInstitutionId?: InputMaybe<Scalars['ID']>;
  migrationMarketplaceInstitutionId?: InputMaybe<Scalars['ID']>;
  isMigrate?: InputMaybe<Scalars['Boolean']>;
};


/** Empty field. Not to be used. */
export type MutationCreateFinancialTransactionArgs = {
  accountId: Scalars['ID'];
  amount: Scalars['Int'];
  category: FinancialTransactionCategory;
  date: Scalars['DateTime'];
  description?: InputMaybe<Scalars['String']>;
  merchantName: Scalars['String'];
  type: FinancialTransactionType;
};


/** Empty field. Not to be used. */
export type MutationDeleteFinancialTransactionArgs = {
  transactionId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type MutationUpdateFinancialTransactionVisibilityArgs = {
  transactionId: Scalars['ID'];
  isHidden: Scalars['Boolean'];
};


/** Empty field. Not to be used. */
export type MutationUpdateFinancialTransactionCategoryArgs = {
  transactionId: Scalars['ID'];
  category: FinancialTransactionCategory;
};


/** Empty field. Not to be used. */
export type MutationUpdateFinancialMerchantTransactionCategoryArgs = {
  transactionId: Scalars['ID'];
  category: FinancialTransactionCategory;
  merchantName: Scalars['String'];
};


/** Empty field. Not to be used. */
export type MutationUpdateFinancialTransactionArgs = {
  transactionId: Scalars['ID'];
  amount?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<FinancialTransactionCategory>;
  date?: InputMaybe<Scalars['DateTime']>;
  merchantName?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<FinancialTransactionType>;
};


/** Empty field. Not to be used. */
export type MutationUpdateSubscriptionProfileArgs = {
  subscriptionProfile: UpdateSubscriptionProfileInput;
  identityId: Scalars['String'];
};


/** Empty field. Not to be used. */
export type MutationUpdateSubscriptionWithoutIdentityArgs = {
  subscriptionSettings: UpdateSubscriptionProfileInput;
};


/** Empty field. Not to be used. */
export type MutationUnsubscribeFromNotificationArgs = {
  subscriptionField: SubscriptionTypeEnum;
  unsubscribeToken: Scalars['String'];
};


/** Empty field. Not to be used. */
export type MutationAddMobileAppDeviceArgs = {
  device: MobileAppProfileDeviceInput;
};


/** Empty field. Not to be used. */
export type MutationUpdateMembershipAppActivityArgs = {
  membershipAppActivity: MembershipAppActivityInput;
};


/** Empty field. Not to be used. */
export type MutationUpdateDismissAccountAggCtaArgs = {
  dismissAccountAggCta: AccountAggCtaDismissedInput;
};


/** Empty field. Not to be used. */
export type MutationUpdateIncomeArgs = {
  input: UpdateIncomeInput;
};


/** Empty field. Not to be used. */
export type MutationUpdateNameArgs = {
  input: UpdateNameInput;
};


/** Empty field. Not to be used. */
export type MutationAcknowledgeTermsOfServiceArgs = {
  input: AcknowledgeTermsOfServiceInput;
};


/** Empty field. Not to be used. */
export type MutationMoneyTransferCreateAccountArgs = {
  financialAccountId: Scalars['ID'];
  moneyTransferAccountType: MoneyTransferFinancialAccountTypeEnum;
  financialAccountSource: FinancialDataSource;
};


/** Empty field. Not to be used. */
export type MutationMoneyTransferCancelTransferArgs = {
  transferId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type MutationMoneyTransferCreateTransferArgs = {
  amount: Scalars['Int'];
  sourceMoneyTransferAccountId: Scalars['ID'];
  destinationMoneyTransferAccountId: Scalars['ID'];
  idempotencyKey: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type MutationMoneyTransferCreateUserArgs = {
  userInput: MoneyTransferCreateUserInput;
};


/** Empty field. Not to be used. */
export type MutationUpdateNetWorthAccountVisibilityArgs = {
  netWorthAccountId: Scalars['ID'];
  isHiddenFromNetWorth: Scalars['Boolean'];
};


/** Empty field. Not to be used. */
export type MutationAddNetWorthHomeIntegratedArgs = {
  address: NetWorthHomeIntegratedAddressInput;
  externalInfo: NetWorthHomeIntegratedExternalInfoInput;
};


/** Empty field. Not to be used. */
export type MutationAddNetWorthRealAssetSelfReportedArgs = {
  type: NetWorthRealAssetTypeEnum;
  nickname: Scalars['String'];
  amount: Scalars['Float'];
};


/** Empty field. Not to be used. */
export type MutationUpdateNetWorthRealAssetIsHiddenFromNetWorthArgs = {
  netWorthRealAssetId: Scalars['ID'];
  isHiddenFromNetWorth: Scalars['Boolean'];
};


/** Empty field. Not to be used. */
export type MutationEditNetWorthRealAssetSelfReportedArgs = {
  amount?: InputMaybe<Scalars['Float']>;
  netWorthRealAssetId: Scalars['ID'];
  nickname?: InputMaybe<Scalars['String']>;
};


/** Empty field. Not to be used. */
export type MutationDeleteNetWorthRealAssetArgs = {
  netWorthRealAssetId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type MutationMarkNotificationAsReadArgs = {
  id: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type MutationMarkNotificationAsUnreadArgs = {
  id: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type MutationMarkNotificationAsDismissedArgs = {
  id: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type MutationMarkNotificationAsUndismissedArgs = {
  id: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type MutationMarkAllNotificationsAsReadArgs = {
  track: Array<Scalars['ID']>;
  beforeInclusive?: InputMaybe<Scalars['ID']>;
};


/** Empty field. Not to be used. */
export type MutationMarkAllNotificationsAsDismissedArgs = {
  track: Array<Scalars['ID']>;
  beforeInclusive?: InputMaybe<Scalars['ID']>;
};


/** Empty field. Not to be used. */
export type MutationUndoMarkAllNotificationsAsDismissedArgs = {
  track: Array<Scalars['ID']>;
  operationId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type MutationInitiatePersonalLoansPrequalRequestArgs = {
  userInput: PersonalLoansPrequalOfferInput;
  providerIds: Array<InputMaybe<PersonalLoansPrequalProviderIdEnum>>;
};


/** Empty field. Not to be used. */
export type MutationAddProjectTedFormArgs = {
  form?: InputMaybe<Scalars['JSON']>;
};


/** Empty field. Not to be used. */
export type MutationAddUserReportedCreditCardsArgs = {
  cards: Array<UserReportedCreditCardInput>;
};


/** Empty field. Not to be used. */
export type MutationSetUserReportedCreditCardsArgs = {
  cards?: InputMaybe<Array<UserReportedCreditCardInput>>;
};


/** Empty field. Not to be used. */
export type MutationRemoveUserReportedCreditCardArgs = {
  cardId: Scalars['Int'];
};


/** Empty field. Not to be used. */
export type MutationAddUserWalletCardArgs = {
  input: AddUserWalletCardInput;
};


/** Empty field. Not to be used. */
export type MutationUpdateUserWalletCardArgs = {
  input: UpdateUserWalletCardInput;
};


/** Empty field. Not to be used. */
export type MutationRemoveUserWalletCardArgs = {
  id: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type MutationPublishYakMessagesArgs = {
  messages: Array<YakMessageInput>;
};

export type MyCardsActivationVisualization = UserInsightDataVisualizationInterface & {
  __typename?: 'MyCardsActivationVisualization';
  /** This will always be MY_CARDS_ACTIVATION */
  dataVisualizationType: UserInsightDataVisualizationTypeEnum;
};

/** The data shape of an account in Wealth Recommender. This is not an exhaustive set of properties. */
export type NetWorthAccount = {
  __typename?: 'NetWorthAccount';
  id: Scalars['ID'];
  /**
   * Note: Id is used here instead of a GQL relation because of the current state of how clients
   * source and access financial accounts. In future it would be better practice to resolve the
   * financial account along with these annotation fields in the same query.
   */
  financialAccountId: Scalars['ID'];
  isHiddenFromNetWorth: Scalars['Boolean'];
};

/** Wraps the net worth account API response for flexibility in future property expansion */
export type NetWorthAccountResponse = {
  __typename?: 'NetWorthAccountResponse';
  account: NetWorthAccount;
};

/**
 * Wraps the set of net worth accounts and leaves the schema open for the addition of metadata or
 * other supplemental data fields in the future
 */
export type NetWorthAccountsResponse = {
  __typename?: 'NetWorthAccountsResponse';
  accounts: Array<NetWorthAccount>;
};

export type NetWorthActivationStatusResponse = MembershipFeatureActivationStatusInterface & {
  __typename?: 'NetWorthActivationStatusResponse';
  id: MembershipFeatureEnum;
  status: MembershipFeatureActivationStatusEnum;
};

export type NetWorthBalances = {
  __typename?: 'NetWorthBalances';
  /**
   * The sum of all balances in asset accounts (checking, savings, investment, retirement)
   * (based on the account's nw_type) for a user. This sum excludes the sum of the user's
   * home assets.
   * Null if a user does not have any linked asset accounts.
   */
  totalAssets?: Maybe<Scalars['Float']>;
  /**
   * The updated sum of all total monetary assets as well as home asset values.
   * Null if a user does not have any linked asset accounts nor home assets.
   */
  totalAssetsIncludingHomeValues?: Maybe<Scalars['Float']>;
  /**
   * The sum of all balances in debt accounts (loans, credit cards) (based on the account's
   * nw_type) for a user. This sum includes the sum of the user's mortgage account balances.
   * Null if a user does not have any linked debt accounts.
   */
  totalDebts?: Maybe<Scalars['Float']>;
  /**
   * The updated sum of all total debts, subtracting the balances of mortgage accounts. This is
   * for the product scenario where we want to display mortgages alongside their associated home
   * values, while still showing non-mortgage debts elsewhere.
   * Null if a user does not have any linked non-mortgage debt accounts.
   */
  totalDebtsExcludingMortgages?: Maybe<Scalars['Float']>;
  /**
   * The total value of homes subtract mortgage debts.
   * Null if a user does not have any home assets nor linked mortgage accounts.
   */
  totalHomeEquity?: Maybe<Scalars['Float']>;
  /**
   * Defined as totalAssets - totalDebts. This does not include the value of the user's home
   * equity.
   * Null if a user does not have any linked accounts.
   */
  totalNetWorth?: Maybe<Scalars['Float']>;
  /**
   * The updated net worth value, which includes home asset values.
   * Null if a user does not have any linked accounts nor homes.
   */
  totalNetWorthIncludingHomeEquity?: Maybe<Scalars['Float']>;
  /** An object containing the sums of balances in each asset account type */
  assetSums: NetWorthBalancesAssetSums;
  /** An object containing the sums of balances in each debt account type */
  debtSums: NetWorthBalancesDebtSums;
};

export type NetWorthBalancesAssetSums = {
  __typename?: 'NetWorthBalancesAssetSums';
  /**
   * The sum of all balances in checking accounts (based on each account's
   * nw_type) for a user.
   * Null if a user does not have any linked checking accounts.
   */
  checkingSum?: Maybe<Scalars['Float']>;
  /**
   * The sum of all balances in savings accounts (based on each account's
   * nw_type) for a user.
   * Null if a user does not have any linked savings accounts.
   */
  savingsSum?: Maybe<Scalars['Float']>;
  /**
   * The sum of all balances in investment accounts (based on each account's
   * nw_type) for a user.
   * Null if a user does not have any linked investment accounts.
   */
  investmentSum?: Maybe<Scalars['Float']>;
  /**
   * The sum of all balances in retirement accounts (based on each account's
   * nw_type) for a user.
   * Null if a user does not have any linked retirement accounts.
   */
  retirementSum?: Maybe<Scalars['Float']>;
  /**
   * The sum of all home asset values.
   * Null if a user does not have any linked home assets.
   */
  homeValueSum?: Maybe<Scalars['Float']>;
  /**
   * The sum of all auto asset values.
   * Null if a user does not have any auto assets.
   */
  autoValueSum?: Maybe<Scalars['Float']>;
  /**
   * The sum of all personal property asset values.
   * Null if a user does not have any personal property assets.
   */
  personalPropertyValueSum?: Maybe<Scalars['Float']>;
};

export type NetWorthBalancesDebtSums = {
  __typename?: 'NetWorthBalancesDebtSums';
  /**
   * The sum of all balances in loan accounts for a user.
   * Null if a user does not have any linked loan accounts.
   */
  loanSum?: Maybe<Scalars['Float']>;
  /**
   * The sum of all balances in credit card accounts for a user.
   * Null if a user does not have any linked credit card accounts.
   */
  creditCardSum?: Maybe<Scalars['Float']>;
  /**
   * The updated loan sum, excluding mortgage accounts.
   * Null if a user does not have any linked non-mortgage loan accounts.
   */
  nonMortgageLoanSum?: Maybe<Scalars['Float']>;
  /**
   * The sum of all balances in mortgage accounts for a user.
   * Null if a user does not have any linked mortgage accounts.
   */
  mortgageSum?: Maybe<Scalars['Float']>;
};

export type NetWorthContribution = {
  __typename?: 'NetWorthContribution';
  amount: Scalars['Float'];
  contributionId: Scalars['ID'];
  date: Scalars['Date'];
  destinationFinancialAccountData?: Maybe<NetWorthContributionFinancialAccount>;
  sourceFinancialAccountData?: Maybe<NetWorthContributionFinancialAccount>;
  status?: Maybe<NetWorthContributionStatus>;
  transferId?: Maybe<Scalars['ID']>;
  type?: Maybe<NetWorthContributionType>;
};

export type NetWorthContributionFinancialAccount = {
  __typename?: 'NetWorthContributionFinancialAccount';
  financialAccountId?: Maybe<Scalars['ID']>;
  financialAccount?: Maybe<FinancialAccount>;
  financialAccountLastFour?: Maybe<Scalars['String']>;
  financialAccountName?: Maybe<Scalars['String']>;
  financialAccountTransactionDate?: Maybe<Scalars['Date']>;
  financialAccountTransactionId?: Maybe<Scalars['ID']>;
  financialAccountType?: Maybe<NetWorthContributionFinancialAccountType>;
};

export enum NetWorthContributionFinancialAccountType {
  Checking = 'CHECKING',
  Investment = 'INVESTMENT',
  Retirement = 'RETIREMENT',
  Savings = 'SAVINGS'
}

export enum NetWorthContributionStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type NetWorthContributionSummaries = {
  __typename?: 'NetWorthContributionSummaries';
  contributionSummaries: Array<NetWorthContributionSummary>;
};

export type NetWorthContributionSummary = {
  __typename?: 'NetWorthContributionSummary';
  completedContributionSum?: Maybe<Scalars['Float']>;
  contributions: Array<NetWorthContribution>;
  date?: Maybe<Scalars['Date']>;
  month?: Maybe<Scalars['String']>;
  pendingContributionSum?: Maybe<Scalars['Float']>;
  totalContributionSum?: Maybe<Scalars['Float']>;
};

export enum NetWorthContributionType {
  Contribution = 'CONTRIBUTION',
  Deposit = 'DEPOSIT',
  Invalid = 'INVALID',
  Rebalance = 'REBALANCE'
}

export type NetWorthHistoryDataPoint = {
  __typename?: 'NetWorthHistoryDataPoint';
  date: Scalars['Date'];
  value: Scalars['Float'];
};

export enum NetWorthHistoryFiltersEnum {
  Total = 'TOTAL',
  Cash = 'CASH',
  Investments = 'INVESTMENTS',
  Property = 'PROPERTY',
  CreditCards = 'CREDIT_CARDS',
  Loans = 'LOANS'
}

export type NetWorthHistoryResponse = {
  __typename?: 'NetWorthHistoryResponse';
  netWorthFilter: NetWorthHistoryFiltersEnum;
  history: Array<Maybe<NetWorthHistoryDataPoint>>;
};

export type NetWorthHistorySnapshotNotificationResponse = {
  __typename?: 'NetWorthHistorySnapshotNotificationResponse';
  showSnapshotNotification: Scalars['Boolean'];
};

/**
 * The data shape of a Home — integrated with Redfin, in Wealth Recommender. "Integrated"
 * describes the fact that this asset's data is sourced from a 3rd-party integration with a data
 * provider, e.g. Redfin. This is meant to be a differentiator for self-reported Home values.
 */
export type NetWorthHomeIntegrated = NetWorthRealAsset & {
  __typename?: 'NetWorthHomeIntegrated';
  id: Scalars['ID'];
  type: NetWorthRealAssetTypeEnum;
  isHiddenFromNetWorth?: Maybe<Scalars['Boolean']>;
  amount?: Maybe<Scalars['Float']>;
  lastReportedOrSyncedAt?: Maybe<Scalars['DateTime']>;
  address: NetWorthHomeIntegratedAddress;
  externalInfo?: Maybe<NetWorthHomeIntegratedExternalInfo>;
  isSelfReported: Scalars['Boolean'];
};

export type NetWorthHomeIntegratedAddress = {
  __typename?: 'NetWorthHomeIntegratedAddress';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type NetWorthHomeIntegratedAddressInput = {
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  zipCode: Scalars['String'];
};

export type NetWorthHomeIntegratedExternalInfo = {
  __typename?: 'NetWorthHomeIntegratedExternalInfo';
  source: NetWorthHomeValueResultSourceEnum;
  value?: Maybe<Scalars['Float']>;
};

/**
 * These fields are the same as the fields in the NetWorthHomeValueResultResponse type. The client
 * takes these values from the search response and pipes them into the addNetWorthHomeIntegrated
 * mutation.
 */
export type NetWorthHomeIntegratedExternalInfoInput = {
  source: NetWorthHomeValueResultSourceEnum;
  propertyId?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  value: Scalars['Float'];
};

export type NetWorthHomeValuePossibilityResponseData = NetWorthHomeValueResultResponseDataInterface & {
  __typename?: 'NetWorthHomeValuePossibilityResponseData';
  /** The enum type of the response data, whether it's a Result or a Possibility. In this case it will always be Possibility. */
  type: NetWorthHomeValueResultTypeEnum;
  /** The list of possible home values for ambiguous cases */
  possibilities?: Maybe<Array<NetWorthHomeValueResultResponseData>>;
};

export type NetWorthHomeValueResultAddressInput = {
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  zipCode: Scalars['String'];
};

export type NetWorthHomeValueResultByPropertyIdResponse = {
  __typename?: 'NetWorthHomeValueResultByPropertyIdResponse';
  /**
   * The data shape for this query will not return "type", "address", nor "url" unlike the other
   * queries that POST to the same data source endpoint. This is because Redfin's API doesn't
   * return these fields when querying by "property_id".
   */
  data: NetWorthHomeValueResultByPropertyIdResponseData;
};

export type NetWorthHomeValueResultByPropertyIdResponseData = {
  __typename?: 'NetWorthHomeValueResultByPropertyIdResponseData';
  /**
   * This field denotes which data provider is associated with the search result that is returned
   * to the client. This is a no-cost schema addition that grants us flexibility for a future
   * where we may have multiple providers with different prioritizations (e.g. Zillow search
   * result over Redfin).
   */
  source: NetWorthHomeValueResultSourceEnum;
  /**
   * The source provider's ID for the given home value. This is used by WR to request updated
   * home values for snapshotting.
   */
  propertyId: Scalars['String'];
  /** The value of the home related to the provided address. */
  value: Scalars['Float'];
};

export type NetWorthHomeValueResultResponse = {
  __typename?: 'NetWorthHomeValueResultResponse';
  /**
   * The response from the search data source is actually an array of results, but for the current
   * iteration of our clients we only support 1 set of search results. This schema represents the
   * highest priority search result from the array.
   */
  data?: Maybe<NetWorthHomeValueResultResponseData>;
  /**
   * The response in the scenario where the WR search API returns a canonicalized error type that
   * is to be handled gracefully. It contains the error data that the client needs in order to
   * make UX decisions.
   */
  error?: Maybe<NetWorthHomeValueResultResponseError>;
};

export type NetWorthHomeValueResultResponseAddress = {
  __typename?: 'NetWorthHomeValueResultResponseAddress';
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  zipCode: Scalars['String'];
};

export type NetWorthHomeValueResultResponseData = NetWorthHomeValueResultResponseDataInterface & {
  __typename?: 'NetWorthHomeValueResultResponseData';
  /** The enum type of the response data, whether it's a Result or a Possibility. In this case it will always be Result. */
  type: NetWorthHomeValueResultTypeEnum;
  /**
   * This field denotes which data provider is associated with the search result that is returned
   * to the client. This is a no-cost schema addition that grants us flexibility for a future
   * where we may have multiple providers with different prioritizations (e.g. Zillow search
   * result over Redfin).
   */
  source: NetWorthHomeValueResultSourceEnum;
  /**
   * The source provider's ID for the given home value. This is used by WR to request updated
   * home values for snapshotting.
   */
  propertyId?: Maybe<Scalars['String']>;
  /** The browser URL that maps to the property's posting. */
  url?: Maybe<Scalars['String']>;
  /** The value of the home related to the provided address. */
  value?: Maybe<Scalars['Float']>;
  address?: Maybe<NetWorthHomeValueResultResponseAddress>;
};

export type NetWorthHomeValueResultResponseDataInterface = {
  type: NetWorthHomeValueResultTypeEnum;
};

/**
 * The representation of the error data that the client will need in order to make UX decisions.
 * Currently only contains the error type.
 */
export type NetWorthHomeValueResultResponseError = {
  __typename?: 'NetWorthHomeValueResultResponseError';
  errorType: NetWorthHomeValueResultResponseErrorTypeEnum;
};

/**
 * The set of canonicalized error types that WR handles.
 * FIXME: this violates enum best practices by having lowercase values
 */
export enum NetWorthHomeValueResultResponseErrorTypeEnum {
  /** These enums represent error types that return from WR */
  HomeSourceApiRetryError = 'HomeSourceApiRetryError',
  HomeSourceApiInputError = 'HomeSourceApiInputError',
  HomeSourceApiNoResultError = 'HomeSourceApiNoResultError',
  HomeSourceApiFatalError = 'HomeSourceApiFatalError',
  InvalidInputError = 'InvalidInputError',
  HomeSourceApiServiceError = 'HomeSourceApiServiceError',
  HomeAlreadyExistsError = 'HomeAlreadyExistsError',
  /**
   * This is an error that is created within the resolver based on more specific error fields.
   * In the future if we support the ability to present users with ambiguous address options,
   * we should get rid of this error.
   */
  HomeSourceApiMultipleResultsError = 'HomeSourceApiMultipleResultsError'
}

/**
 * This enum represents the set of supported home value data source providers. Currently we only
 * support Redfin but our schemas are meant to be shaped for extensibility.
 */
export enum NetWorthHomeValueResultSourceEnum {
  Redfin = 'REDFIN'
}

/** The two types of results that may return from an address search */
export enum NetWorthHomeValueResultTypeEnum {
  /** Denotes that an exact home value match has been found based on the provided address */
  Result = 'RESULT',
  /**
   * Denotes that one or more low-confidence possible results have been found based on the
   * provided address
   */
  Possibility = 'POSSIBILITY'
}

export type NetWorthHomeValueResultWithPossibilitiesResponse = {
  __typename?: 'NetWorthHomeValueResultWithPossibilitiesResponse';
  data?: Maybe<NetWorthHomeValueResultResponseDataInterface>;
  /**
   * The response in the scenario where the WR search API returns a canonicalized error type that
   * is to be handled gracefully. It contains the error data that the client needs in order to
   * make UX decisions.
   */
  error?: Maybe<NetWorthHomeValueResultResponseError>;
};

/**
 * This interface will represent the amalgamation of the various asset types supported by Wealth
 * Recommender.
 */
export type NetWorthRealAsset = {
  /**
   * Real assets have been migrated from WR to FDP, so this client-facing ID now refers to the FDP
   * account ID.
   */
  id: Scalars['ID'];
  type: NetWorthRealAssetTypeEnum;
  isHiddenFromNetWorth?: Maybe<Scalars['Boolean']>;
  amount?: Maybe<Scalars['Float']>;
  lastReportedOrSyncedAt?: Maybe<Scalars['DateTime']>;
  /** For helping the client determine if the home is self-reported or not */
  isSelfReported: Scalars['Boolean'];
};

/** Wraps the Net Worth Real Asset API response, which allows for adding fields at a later date */
export type NetWorthRealAssetResponse = {
  __typename?: 'NetWorthRealAssetResponse';
  asset: NetWorthRealAsset;
};

/**
 * The data shape of a Real Asset — self-reported by the user, in Wealth Recommender. This is a
 * different data model from the "Integrated" version of homes, which are synced with Redfin and
 * have their own set of requirements.
 */
export type NetWorthRealAssetSelfReported = NetWorthRealAsset & {
  __typename?: 'NetWorthRealAssetSelfReported';
  id: Scalars['ID'];
  type: NetWorthRealAssetTypeEnum;
  isHiddenFromNetWorth?: Maybe<Scalars['Boolean']>;
  amount?: Maybe<Scalars['Float']>;
  lastReportedOrSyncedAt?: Maybe<Scalars['DateTime']>;
  /**
   * The unique identifier for a self-reported asset in the UX. For contrast, NetWorthIntegrated
   * we use the address fields for uniqueness.
   */
  nickname: Scalars['String'];
  isSelfReported: Scalars['Boolean'];
};

/** Wraps the set of Net Worth Real Assets, which allows for adding fields at a later date */
export type NetWorthRealAssetsResponse = {
  __typename?: 'NetWorthRealAssetsResponse';
  assets: Array<NetWorthRealAsset>;
};

/** This enum represents the set of Real Asset types that the backend, WR, currently supports. */
export enum NetWorthRealAssetTypeEnum {
  Home = 'HOME',
  Auto = 'AUTO',
  PersonalProperty = 'PERSONAL_PROPERTY'
}

export type NetWorthRecommendation = {
  __typename?: 'NetWorthRecommendation';
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  details?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  identityId: Scalars['ID'];
  secureDetails?: Maybe<Scalars['JSON']>;
  status: NetWorthRecommendationStatus;
  type: NetWorthRecommendationType;
  updatedAt: Scalars['DateTime'];
  version: Scalars['Int'];
};

export enum NetWorthRecommendationCategory {
  All = 'ALL',
  BigPictureMoves = 'BIG_PICTURE_MOVES',
  Iao = 'IAO',
  QuickWins = 'QUICK_WINS'
}

export type NetWorthRecommendations = {
  __typename?: 'NetWorthRecommendations';
  /** @deprecated The underlying endpoint has been deprecated */
  recommendations: Array<NetWorthRecommendation>;
};

export type NetWorthRecommendationsFilterInput = {
  category: NetWorthRecommendationCategory;
};

export enum NetWorthRecommendationStatus {
  Completed = 'COMPLETED',
  Dismissed = 'DISMISSED',
  InProgress = 'IN_PROGRESS',
  New = 'NEW'
}

export enum NetWorthRecommendationType {
  CheckingToSavings = 'CHECKING_TO_SAVINGS',
  IntegratedAccountOpening = 'INTEGRATED_ACCOUNT_OPENING',
  LeftoverIncome = 'LEFTOVER_INCOME',
  NewDeposit = 'NEW_DEPOSIT',
  Refund = 'REFUND',
  SavingsToInvestment = 'SAVINGS_TO_INVESTMENT'
}

/** Notifications contain actionable information relevent to the user that NerdWallet sends via a notification channel. */
export type Notification = {
  __typename?: 'Notification';
  /** The action to be performed in the app when the user engages with the notification (CTA that navigates to L1, L2). */
  action?: Maybe<AppAction>;
  /**
   * The user-facing copy that describes the notification.
   *
   * This is *not* the CTA text -- that should be supplied in action.text
   */
  body?: Maybe<Scalars['String']>;
  /** The name of the CRM campaign this notification belongs to. */
  campaignName?: Maybe<Scalars['String']>;
  /** The creation time in UTC of the notification. */
  createdAt: Scalars['DateTime'];
  /**
   * The primary identifier for the notification.
   *
   * Primarily used for interacting with the API - id will now match the "newest" and "oldest" fields.
   */
  id: Scalars['ID'];
  /** The isDismissed flag denotes if a notification has been "dismissed" by the user. */
  isDismissed: Scalars['Boolean'];
  /**
   * The isRead flag denotes if a notification has been "read" by the user.
   *
   * A notification can be marked as "read" by interacting with the CTA, or manually by the user.
   */
  isRead: Scalars['Boolean'];
  /**
   * A human-readable identifier for a particular notification.
   *
   * Note that the slug field is the same across all instances of a particular notification (whereas the id field is unique).
   */
  slug?: Maybe<Scalars['String']>;
  /** The name of the Blueshift template used for this notification. */
  templateName?: Maybe<Scalars['String']>;
  /** The update history of a notification. */
  updates?: Maybe<Array<NotificationUpdate>>;
};

/**
 * The medium by which notifications are sent to users.
 *
 * Currently only includes NotificationCenter, but may be expanded to include email and/or push, as needed.
 */
export enum NotificationChannelEnum {
  NotificationCenter = 'NOTIFICATION_CENTER'
}

export type NotificationsInput = {
  /** Specifies the channel of notifications to retrieve from */
  channel: NotificationChannelEnum;
  /**
   * The Identity ID to fetch notifications for (for admin use).
   * If the ID isn't the same as the requesting user's ID, some fields will not be available.
   */
  identityId?: InputMaybe<Scalars['ID']>;
  /** Whether to include notifications that have been dismissed by the user. */
  includeDismissed?: InputMaybe<Scalars['Boolean']>;
  /** Contains parameters that assist with pagination, such as: after, before, limit. */
  pagination?: InputMaybe<CursorPaginationInput>;
};

export type NotificationUpdate = {
  __typename?: 'NotificationUpdate';
  /** The type of update (e.g. dismiss, undismiss, mark_as_read, mark_as_unread) */
  update: Scalars['String'];
  /** The time when this update occurred. */
  updatedAt: Scalars['DateTime'];
};

export type NwLoginInfoInput = {
  /** The email used to register an account */
  email: Scalars['EmailAddress'];
  /** The password used to register an account */
  password: Scalars['String'];
  /** Determines if user should stay logged in */
  rememberMe: Scalars['Boolean'];
};

export type NwRegisterInfoInput = {
  /** The email used to register an account */
  email: Scalars['EmailAddress'];
  /** The password used to register an account */
  password: Scalars['String'];
  /** The tracking metadata to include with registration */
  trackingMetadata?: InputMaybe<RegistrationTrackingMetadata>;
};

/** OfferInterface contains the common base fields for all offers. */
export type OfferInterface = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
  endsAt?: Maybe<Scalars['DateTime']>;
};

export type OffsetPaginationInput = {
  /** The maximum number of results to return. */
  limit?: InputMaybe<Scalars['Int']>;
  /** The start index of the results to return. Useful for pagination. */
  offset?: InputMaybe<Scalars['Int']>;
};

/** Enum values to express which field to order collection query results by. */
export enum OrderByFieldEnum {
  Date = 'DATE',
  Id = 'ID',
  Include = 'INCLUDE',
  ModifiedDate = 'MODIFIED_DATE',
  Slug = 'SLUG'
}

/** The direction in which to order query results. */
export enum OrderDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** The input type for ordering results. */
export type OrderInput = {
  /** Sort collection by object attribute. */
  field?: OrderByFieldEnum;
  /** Order sort attribute ascending or descending. */
  sortDirection?: OrderDirectionEnum;
};

/** Enum values for overrideLastModifiedDateWithCurrentDate field on Article type. */
export enum OverrideLastModifiedDateEnum {
  Default = 'DEFAULT',
  UseCurrentDay = 'USE_CURRENT_DAY',
  UseCurrentMonth = 'USE_CURRENT_MONTH'
}

/** Type modeling the data for posts within the page post type from WordPress. */
export type Page = PostInterface & PostWithAuthorsInterface & PostWithFeaturedImageInterface & PostWithTitleInterface & {
  __typename?: 'Page';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the Page object. */
  categories?: Maybe<Array<Category>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The Page object for the parent of this entity. */
  parent?: Maybe<Page>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
};


/** Type modeling the data for posts within the page post type from WordPress. */
export type PageDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the page post type from WordPress. */
export type PageModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the page post type from WordPress. */
export type PageTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Data related to the top level page impression event that should be fired */
export type PageImpressionData = {
  __typename?: 'PageImpressionData';
  /** Name of the top level page impression event that should be fired */
  event: Scalars['String'];
  /** Data payload to pass into the top level page impression event */
  payload?: Maybe<Scalars['JSON']>;
  /** Whether or not to fire the top level page impression event */
  enabled?: Maybe<Scalars['Boolean']>;
};

/** Layout information for Structured Content Client to use */
export type PageLayout = {
  __typename?: 'PageLayout';
  /** The name of the template the page is using. This will be used for analytics purposes */
  name: Scalars['String'];
  /** The row config for the page layout */
  rows?: Maybe<Array<LayoutRow>>;
};

/** Personal Loan Institutions */
export type PersonalLoanInstitution = InstitutionInterface & {
  __typename?: 'PersonalLoanInstitution';
  /** There were no details when this schema was constructed. */
  details: EmptyObject;
  canonicalInstitutionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
};

/** Personal Loan Offers */
export type PersonalLoanOffer = OfferInterface & {
  __typename?: 'PersonalLoanOffer';
  details: PersonalLoanOfferDetails;
  derivedDetails: PersonalLoanOfferDerivedDetails;
  endsAt?: Maybe<Scalars['DateTime']>;
  product: PersonalLoanProduct;
  startsAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
  productId?: Maybe<Scalars['ID']>;
  isMonetizing?: Maybe<Scalars['Boolean']>;
};

/**
 * Derived details about the personal loan offer.
 * Note: This are dependent on having the following query variables supplied:
 * - annualIncome
 * - loanAmount
 * - minCreditScore
 * - maxCreditScore
 * - zipCode
 */
export type PersonalLoanOfferDerivedDetails = {
  __typename?: 'PersonalLoanOfferDerivedDetails';
  applyLink?: Maybe<Scalars['URL']>;
  avgNarrowApr?: Maybe<Scalars['Float']>;
  isAllowedForZipCode?: Maybe<Scalars['Boolean']>;
  maxNarrowApr?: Maybe<Scalars['Float']>;
  minNarrowApr?: Maybe<Scalars['Float']>;
  monthlyPayment?: Maybe<Scalars['Float']>;
};

/** Details about the personal loan offer */
export type PersonalLoanOfferDetails = {
  __typename?: 'PersonalLoanOfferDetails';
  aprTooltip?: Maybe<Scalars['String']>;
  consBullets?: Maybe<Array<Maybe<Scalars['String']>>>;
  delinquencies?: Maybe<Array<Scalars['String']>>;
  disclaimer?: Maybe<Scalars['String']>;
  excludedCitizenshipStatus: Array<Scalars['String']>;
  excludedHousing: Array<Scalars['String']>;
  excludedLoanPurpose: Array<PersonalLoanPurpose>;
  feesBullets?: Maybe<Array<Scalars['String']>>;
  imageAltText?: Maybe<Scalars['String']>;
  imageIsPortrait: Scalars['Boolean'];
  imageSource?: Maybe<Scalars['URL']>;
  imageSourceLarge?: Maybe<Scalars['URL']>;
  imageSourceMedium?: Maybe<Scalars['URL']>;
  keyFactsBullets?: Maybe<Array<Scalars['String']>>;
  legacyId?: Maybe<Scalars['String']>;
  loanTermList: Array<Scalars['Int']>;
  loanTermType: Scalars['String'];
  maxApr: Scalars['Int'];
  maxFico: Scalars['Int'];
  maxHardInquiries?: Maybe<Scalars['Int']>;
  /** This time unit is months. */
  maxHardInquiriesTimeSpanMonths?: Maybe<Scalars['Int']>;
  maxLoanAmount?: Maybe<Scalars['Int']>;
  maxLoanTerm?: Maybe<Scalars['Int']>;
  maxNumberBankruptcies?: Maybe<Scalars['Int']>;
  /** The time unit is months. */
  maxNumberBankruptciesTimeSpanMonths?: Maybe<Scalars['Int']>;
  minApr: Scalars['Int'];
  /** The time unit is months. */
  minCreditHistoryMonths?: Maybe<Scalars['Int']>;
  minFico: Scalars['Int'];
  minFicoAnnotation?: Maybe<Scalars['String']>;
  minFicoDisplayed: Scalars['Int'];
  minFicoTooltip?: Maybe<Scalars['String']>;
  minIncome: Scalars['Int'];
  minLoanAmount?: Maybe<Scalars['Int']>;
  /** This time unit is months. */
  phoneNumberDesktop?: Maybe<Scalars['String']>;
  phoneNumberMobile?: Maybe<Scalars['String']>;
  minLoanTermMonths?: Maybe<Scalars['Int']>;
  primaryOffer: Scalars['Boolean'];
  prosBullets?: Maybe<Array<Maybe<Scalars['String']>>>;
  qualificationsBullets?: Maybe<Array<Maybe<Scalars['String']>>>;
  ratingStars?: Maybe<Scalars['Float']>;
  reviewLink?: Maybe<Scalars['String']>;
  reviewTitle?: Maybe<Scalars['String']>;
  simplifyApr?: Maybe<Scalars['Boolean']>;
  timeToFund?: Maybe<Scalars['Float']>;
  /** Names of the award badge names this offer won in 2020. */
  bestOfBadgeWinner2020?: Maybe<Array<Scalars['String']>>;
  /** Names of the award badge names this offer won in 2021. */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']>>;
};

/**
 * Query variables for the personal loan queries.
 * Note that some of these are required for the
 * query to work, since this query retrieves all
 * fields from the Offer API.
 */
export type PersonalLoanOffersParameters = {
  annualIncome: Scalars['Int'];
  loanAmount: Scalars['Int'];
  loanPurpose?: InputMaybe<PersonalLoanPurpose>;
  maxCreditScore: Scalars['Int'];
  minCreditScore: Scalars['Int'];
  /**
   * The zipCode variable is required if requesting the
   * isAllowedForZipCode field.
   */
  zipCode?: InputMaybe<Scalars['String']>;
};

/** The response from a personal loan offer query. */
export type PersonalLoanOffersResponse = {
  __typename?: 'PersonalLoanOffersResponse';
  /** The total number of offers that match your query. */
  total: Scalars['Int'];
  offers: Array<PersonalLoanOffer>;
  offset: Scalars['Int'];
};

/** Personal Loan Products */
export type PersonalLoanProduct = ProductInterface & {
  __typename?: 'PersonalLoanProduct';
  details: PersonalLoanProductDetails;
  institution: PersonalLoanInstitution;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
};

/** Details about the personal loan product */
export type PersonalLoanProductDetails = {
  __typename?: 'PersonalLoanProductDetails';
  allowsPrequal: Scalars['Boolean'];
};

/** Valid options for the personal loan's purpose */
export enum PersonalLoanPurpose {
  Business = 'BUSINESS',
  ConsolidateDebt = 'CONSOLIDATE_DEBT',
  EmergencyExpense = 'EMERGENCY_EXPENSE',
  HomeImprovement = 'HOME_IMPROVEMENT',
  Moving = 'MOVING',
  Other = 'OTHER',
  RefinanceCreditCard = 'REFINANCE_CREDIT_CARD',
  Vacation = 'VACATION'
}

/** A Personal Loans institution */
export type PersonalLoansInstitutionV2 = MarketplaceEntityInterface & MarketplaceInstitutionInterface & {
  __typename?: 'PersonalLoansInstitutionV2';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** A URL that points to the logo for the institution */
  imageSource?: Maybe<Scalars['URL']>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

/** A Personal Loans offer */
export type PersonalLoansOfferV2 = MarketplaceEntityInterface & MarketplaceEntityWithBestOfAwards2021Interface & MarketplaceEntityWithBestOfAwardsInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithQualificationsInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceOfferInterface & {
  __typename?: 'PersonalLoansOfferV2';
  /** Apply link for the offer */
  applyLink?: Maybe<Scalars['URL']>;
  /** Average narrow annual percentage rate (APR) range in percentage points. For example, 12.34 will represent 12.34%. */
  avgNarrowApr?: Maybe<Scalars['Float']>;
  /** The list of NW Best-Of Awards this offer has won for 2021 */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']>>;
  /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  consBullets?: Maybe<Array<Scalars['String']>>;
  /** Disclaimer for the offer */
  disclaimer?: Maybe<Scalars['String']>;
  /** The display name for the entity (auto-generated) */
  displayName?: Maybe<Scalars['String']>;
  /** Entity type */
  entityType: Scalars['String'];
  /** Category used to group offers on the expanded marketplace */
  expandedMarketplaceCategory?: Maybe<PersonalLoansOfferV2ExpandedMarketplaceCategoryEnum>;
  /** List of fees associated with the offer */
  feesBullets?: Maybe<Array<Scalars['String']>>;
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** Provider's logo */
  imageSource?: Maybe<Scalars['URL']>;
  /** Provider's logo (large) */
  imageSourceLarge?: Maybe<Scalars['URL']>;
  /** Provider's logo (medium) */
  imageSourceMedium?: Maybe<Scalars['URL']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /** Flag indicating whether or not this offer can be surfaced on the expanded marketplace page */
  isExpandedMarketplaceOffer?: Maybe<Scalars['Boolean']>;
  /** Whether this Offer is monetizing. Client apps use this field to decide display behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA */
  isMonetizing?: Maybe<Scalars['Boolean']>;
  keyFactsBullets?: Maybe<Array<Scalars['String']>>;
  /** Maximum annual percentage rate (APR) entered in basis points. For example, entering 1234 will represent 12.34%. */
  maxApr?: Maybe<Scalars['Float']>;
  /** Maximum loan amount */
  maxLoanAmount?: Maybe<Scalars['Float']>;
  /** Maximum loan term */
  maxLoanTerm?: Maybe<Scalars['Int']>;
  /** Maximum narrow annual percentage rate (APR) range in percentage points. For example, 12.34 will represent 12.34%. */
  maxNarrowApr?: Maybe<Scalars['Float']>;
  /** Minimum annual percentage rate (APR) entered in basis points. For example, entering 1234 will represent 12.34%. */
  minApr?: Maybe<Scalars['Float']>;
  /** Text for overriding the 'min_fico' value. */
  minFicoOverrideText?: Maybe<Scalars['String']>;
  /** Minimum loan amount */
  minLoanAmount?: Maybe<Scalars['Float']>;
  /** Minimum loan term in months */
  minLoanTermMonths?: Maybe<Scalars['Int']>;
  /** Minimum narrow annual percentage rate (APR) range in percentage points. For example, 12.34 will represent 12.34%. */
  minNarrowApr?: Maybe<Scalars['Float']>;
  /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
  monetizable: Scalars['String'];
  /** Estimated monthly payment */
  monthlyPayment?: Maybe<Scalars['Float']>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  /** Phone number that users can call to reach out to the partner on desktop, in place of the CTA on lender card. Enter value as 1231231234 to represent a phone number like (123) 123 - 1234. */
  phoneNumberDesktop?: Maybe<Scalars['String']>;
  /** Phone number that users can call to reach out to the partner on mobile, in place of the CTA on lender card. Enter value as 1231231234 to represent a phone number like (123) 123 - 1234. */
  phoneNumberMobile?: Maybe<Scalars['String']>;
  product: PersonalLoansProductV2;
  /** Product type */
  productType: Scalars['String'];
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  prosBullets?: Maybe<Array<Scalars['String']>>;
  /** List of qualifications for the offer */
  qualificationsBullets?: Maybe<Array<Scalars['String']>>;
  /** The URL to the NerdWallet review of this offer. */
  reviewLink?: Maybe<Scalars['URL']>;
  /** Star rating */
  starRating?: Maybe<Scalars['Float']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
  /** Short summary of why NerdWallet recommends this provider */
  tagline?: Maybe<Scalars['String']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** Available term lengths for the entity */
  availableTermLengths?: Maybe<Scalars['String']>;
  /** The Best Of Awards that this offer has won */
  bestOfAwards?: Maybe<Array<BestOfAward>>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The driver estimated apr associated with the entity */
  driverEstimatedApr?: Maybe<EntityPlacementDriver>;
  /** The driver loan amount associated with the entity */
  driverLoanAmount?: Maybe<EntityPlacementDriver>;
  /** The driver min credit score associated with the entity */
  driverMinCreditScore?: Maybe<EntityPlacementDriver>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /**
   * The drivers associated with the entity
   * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
   */
  placementDrivers: Array<EntityPlacementDriver>;
  /** A boolean indicating if the display name should be shown in the comparison table component */
  showNameInComparisonTable: Scalars['Boolean'];
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']>;
  /** Flag for whether to use the large product card image styles */
  useLargeImageFootprint: Scalars['Boolean'];
};

export enum PersonalLoansOfferV2ExpandedMarketplaceCategoryEnum {
  Bankruptcy = 'BANKRUPTCY',
  CoSignLoans = 'CO_SIGN_LOANS',
  Contingent = 'CONTINGENT',
  CreditBuilderLoans = 'CREDIT_BUILDER_LOANS',
  DebtManagementPlans = 'DEBT_MANAGEMENT_PLANS',
  FriendsFamilyLoans = 'FRIENDS_FAMILY_LOANS',
  HighInterestPersonalLoans = 'HIGH_INTEREST_PERSONAL_LOANS',
  HomeEquityLoans = 'HOME_EQUITY_LOANS',
  PaycheckAdvance = 'PAYCHECK_ADVANCE',
  SecuredLoans = 'SECURED_LOANS'
}

/** The possible "Best Bets" categories for Personal Loans Prequal Offers. */
export enum PersonalLoansPrequalBestBets {
  LowestApr = 'LOWEST_APR',
  LowestMonthlyPayment = 'LOWEST_MONTHLY_PAYMENT'
}

export enum PersonalLoansPrequalLoanPurposeEnum {
  ConsolidateDebt = 'CONSOLIDATE_DEBT',
  RefinanceCreditCard = 'REFINANCE_CREDIT_CARD',
  Vacation = 'VACATION',
  Business = 'BUSINESS',
  Moving = 'MOVING',
  HomeImprovement = 'HOME_IMPROVEMENT',
  EmergencyExpense = 'EMERGENCY_EXPENSE',
  Other = 'OTHER'
}

/** Input from the personal loans prequal interface to be sent to providers */
export type PersonalLoansPrequalOfferInput = {
  loanPurpose: PersonalLoansPrequalLoanPurposeEnum;
  loanAmount: Scalars['Int'];
  degreeType?: InputMaybe<PrequalDegreeTypeEnum>;
  annualIncome: Scalars['Int'];
  employmentType: PrequalEmploymentTypeEnum;
  residencyOwnership: PrequalResidencyOwnershipEnum;
  creditScoreRange: TuVantageScore3Buckets;
  name: PrequalUserNameInput;
  ssn: Scalars['String'];
  dateOfBirth: Scalars['Date'];
  email: Scalars['EmailAddress'];
  address: PrequalUserAddressInput;
  loggerMetadata?: InputMaybe<Scalars['JSON']>;
  citizenshipStatus?: InputMaybe<PrequalCitizenshipStatusEnum>;
  hasCoApplicant?: InputMaybe<Scalars['Boolean']>;
  coApplicantIncome?: InputMaybe<Scalars['Int']>;
  discoverAB?: InputMaybe<Scalars['Boolean']>;
};

/** Provider IDs */
export enum PersonalLoansPrequalProviderIdEnum {
  Avant = 'AVANT',
  Bestegg = 'BESTEGG',
  Discover = 'DISCOVER',
  Freedomplus = 'FREEDOMPLUS',
  Goldmansachs = 'GOLDMANSACHS',
  Lendingclub = 'LENDINGCLUB',
  Lendingpoint = 'LENDINGPOINT',
  Lightstream = 'LIGHTSTREAM',
  Onemain = 'ONEMAIN',
  Opploans = 'OPPLOANS',
  Payoff = 'PAYOFF',
  Penfed = 'PENFED',
  Prosper = 'PROSPER',
  Sofi = 'SOFI',
  Universalcredit = 'UNIVERSALCREDIT',
  Upgrade = 'UPGRADE',
  Upstart = 'UPSTART'
}

/** A Personal Loans product */
export type PersonalLoansProductV2 = MarketplaceEntityInterface & MarketplaceProductInterface & {
  __typename?: 'PersonalLoansProductV2';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  institution: PersonalLoansInstitutionV2;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

export type PlaidAccountInput = {
  balances?: InputMaybe<Array<PlaidBalanceInput>>;
  id: Scalars['String'];
  mask?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /**
   * There are a huge number of possible subtypes, and it depends on which type it is so for simplicity we're just accepting any string
   * See https://plaid.com/docs/#account-subtypes
   */
  subtype?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PlaidAccountType>;
  verificationStatus?: InputMaybe<PlaidVerificationStatus>;
};

/**  See https://plaid.com/docs/#account-types  */
export enum PlaidAccountType {
  Credit = 'CREDIT',
  Depository = 'DEPOSITORY',
  Investment = 'INVESTMENT',
  Loan = 'LOAN',
  Other = 'OTHER'
}

export type PlaidBalanceInput = {
  available?: InputMaybe<Scalars['Int']>;
  current?: InputMaybe<Scalars['Int']>;
};

export enum PlaidInstitutionHealthStatus {
  Degraded = 'DEGRADED',
  Down = 'DOWN',
  Healthy = 'HEALTHY'
}

export type PlaidInstitutionInput = {
  /** The plaid id of an institution, e.g. `ins_4` */
  institutionId: Scalars['String'];
  name: Scalars['String'];
};

/**  Documentation taken from Plaid docs: https://plaid.com/docs/#onsuccess-callback  */
export enum PlaidVerificationStatus {
  /**  an Item was successfully manually verified  */
  ManuallyVerified = 'MANUALLY_VERIFIED',
  /**  an Item is pending automated microdeposit verfication  */
  PendingAutomaticVerification = 'PENDING_AUTOMATIC_VERIFICATION',
  /**  an Item is pending manual microdeposit verification  */
  PendingManualVerification = 'PENDING_MANUAL_VERIFICATION'
}

/** Type modeling the data for posts within the post post type from WordPress. */
export type Post = PostInterface & PostWithAuthorsInterface & PostWithFeaturedImageInterface & PostWithTitleInterface & {
  __typename?: 'Post';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the Post object. */
  categories?: Maybe<Array<Category>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
};


/** Type modeling the data for posts within the post post type from WordPress. */
export type PostDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the post post type from WordPress. */
export type PostModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the post post type from WordPress. */
export type PostTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The input for fetching a single forked post. */
export type PostForkItemInput = {
  /** The WordPress ID for the forked entity. */
  forkIdentifier: Scalars['Int'];
  /** The security nonce for viewing the fork. */
  forkNonce?: InputMaybe<Scalars['String']>;
  /** Whether or not to preview the forked version of the data. */
  forkPreview?: InputMaybe<Scalars['Boolean']>;
  /** The slug for the entity this fork was created from or the WordPress ID. */
  identifier: Scalars['ID'];
  /** The security nonce for viewing the entity. */
  wpnonce?: InputMaybe<Scalars['String']>;
};

/** The Post interface for modeling other custom post types. */
export type PostInterface = {
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
};


/** The Post interface for modeling other custom post types. */
export type PostInterfaceDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** The Post interface for modeling other custom post types. */
export type PostInterfaceModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** The input for retrieving a single resource. */
export type PostItemInput = {
  /** The WordPress ID for the forked entity. */
  forkIdentifier?: InputMaybe<Scalars['Int']>;
  /** The security nonce for viewing the fork. */
  forkNonce?: InputMaybe<Scalars['String']>;
  /** Whether or not to preview the forked version of the data. */
  forkPreview?: InputMaybe<Scalars['Boolean']>;
  /** The slug for the post or the WordPress ID. */
  identifier: Scalars['ID'];
  /** Whether or not to retrieve the preview of the post. */
  preview?: InputMaybe<Scalars['Boolean']>;
  /** The security nonce for viewing a preview. */
  wpnonce?: InputMaybe<Scalars['ID']>;
};

export enum PostType {
  Article = 'ARTICLE',
  Post = 'POST'
}

/** WordPress post types supported in GraphQL. */
export enum PostTypeEnum {
  Article = 'ARTICLE',
  Banner = 'BANNER',
  BccPage = 'BCC_PAGE',
  BccPageCard = 'BCC_PAGE_CARD',
  Block = 'BLOCK',
  BlockGroup = 'BLOCK_GROUP',
  Calculator = 'CALCULATOR',
  ContentPack = 'CONTENT_PACK',
  EngPost = 'ENG_POST',
  GnavItem = 'GNAV_ITEM',
  HouseAd = 'HOUSE_AD',
  Hub = 'HUB',
  InsPage = 'INS_PAGE',
  Landing = 'LANDING',
  Lender = 'LENDER',
  MktEntry = 'MKT_ENTRY',
  Page = 'PAGE',
  Post = 'POST',
  PressRelease = 'PRESS_RELEASE',
  Review = 'REVIEW',
  Reviewer = 'REVIEWER',
  Roundup = 'ROUNDUP',
  TablepressTable = 'TABLEPRESS_TABLE',
  UrlRecord = 'URL_RECORD',
  UserPage = 'USER_PAGE'
}

/** The interface for post types that support authors. */
export type PostWithAuthorsInterface = {
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
};

/** The interface for content types that exposes social media links. */
export type PostWithContactInfoInterface = {
  /** The social media link fields to display for the content type. */
  socialMediaLinks?: Maybe<Array<AuthorSocialMediaLink>>;
};

export type PostWithContentClassificationInterface = {
  /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
  attributionTopic?: Maybe<Scalars['String']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']>;
  /** Additional content clusters for this piece of content. */
  contentClusters?: Maybe<Array<Scalars['String']>>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']>;
  /** The primary content cluster for this piece of content. */
  primaryContentCluster?: Maybe<Scalars['String']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']>>;
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']>>;
};

/** The interface for post types that support the content field. */
export type PostWithContentInterface = {
  /** The structured content for the resource. */
  content?: Maybe<Scalars['StructuredContentDocument']>;
};

/** The interface for post types that support excerpts. */
export type PostWithExcerptInterface = {
  /** The editorial excerpt of the resource. */
  excerpt?: Maybe<Scalars['String']>;
};


/** The interface for post types that support excerpts. */
export type PostWithExcerptInterfaceExcerptArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

export type PostWithFaQsInterface = {
  /** The faqs to display on this piece of content. */
  faqs?: Maybe<Array<ContentFaq>>;
  /** Whether or not to display the FAQ's. */
  showFaqs?: Maybe<Scalars['Boolean']>;
};

/** The interface for post types that support featured images. */
export type PostWithFeaturedImageInterface = {
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
};

export type PostWithInternationalVersionsInterface = {
  /** Information about alternate versions of the content that exist for other locales. */
  internationalVersions?: Maybe<Array<InternationalVersion>>;
};

/** The interface for post types that support gms page taxonomy. */
export type PostWithPageTaxonomyInterface = {
  /** Page taxonomy data. This array is designed to be passed directly to GMS. See https://github.com/NerdWallet/global-markup/tree/b3af4e1f2c68485514145ff31b9137d619e910e1#v2-options */
  pageTaxonomy?: Maybe<Scalars['JSON']>;
};

export type PostWithReviewerInterface = {
  /** The reviewers that this Article has been reviewed by. */
  reviewedBy?: Maybe<Array<ContentReviewer>>;
};

export type PostWithSeoInterface = {
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
};

/** The interface for post types that support the title field. */
export type PostWithTitleInterface = {
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
};


/** The interface for post types that support the title field. */
export type PostWithTitleInterfaceTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The interface for content types that exposes user information. */
export type PostWithUserInfoInterface = {
  /** The users's previous experience. */
  experience?: Maybe<Scalars['String']>;
  /** The user's full name */
  fullName?: Maybe<Scalars['String']>;
  /** The user's job title */
  jobTitle?: Maybe<Scalars['String']>;
};

export enum PrequalCitizenshipStatusEnum {
  Citizen = 'CITIZEN',
  PermanentResident = 'PERMANENT_RESIDENT',
  Other = 'OTHER'
}

export enum PrequalDegreeTypeEnum {
  HighSchoolDiploma = 'HIGH_SCHOOL_DIPLOMA',
  Associate = 'ASSOCIATE',
  Bachelors = 'BACHELORS',
  Masters = 'MASTERS',
  Pharmd = 'PHARMD',
  Mba = 'MBA',
  Phd = 'PHD',
  Jd = 'JD',
  Dds = 'DDS',
  Md = 'MD'
}

export enum PrequalEmploymentTypeEnum {
  FullTime = 'FULL_TIME',
  PartTime = 'PART_TIME',
  SelfEmployed = 'SELF_EMPLOYED',
  Military = 'MILITARY',
  Retired = 'RETIRED',
  Unemployed = 'UNEMPLOYED',
  Other = 'OTHER'
}

export type PrequalJob = {
  __typename?: 'PrequalJob';
  jobId: Scalars['ID'];
  service: PrequalServiceIdEnum;
  path: Scalars['String'];
};

export type PrequalJobInput = {
  jobId: Scalars['ID'];
  service: PrequalServiceIdEnum;
  path: Scalars['String'];
};

export type PrequalJobStatusResponse = {
  __typename?: 'PrequalJobStatusResponse';
  status: PrequalOfferStatus;
  totalResults: Scalars['Int'];
};

/** Generic Prequal Offer interface */
export type PrequalOffer = {
  applyLink: Scalars['String'];
  institutionName: Scalars['String'];
  institutionLogo: Scalars['String'];
  nwRating?: Maybe<Scalars['Float']>;
  providerId?: Maybe<Scalars['ID']>;
};

export type PrequalOfferDriverInfoInput = {
  age?: InputMaybe<Scalars['Int']>;
  contactAddress?: InputMaybe<PrequalUserAddressInput>;
  continuousCoverageMonths?: InputMaybe<Scalars['Int']>;
  creditScoreRange?: InputMaybe<QuinStreetCreditScoreRangeEnum>;
  driversCount?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<GenderEnum>;
  hasHadDui?: InputMaybe<Scalars['Boolean']>;
  isVeteran?: InputMaybe<Scalars['Boolean']>;
  isGoodDriver?: InputMaybe<Scalars['Boolean']>;
  licenseStatus?: InputMaybe<LicenseStatusEnum>;
  numRecentIncidents?: InputMaybe<Scalars['Int']>;
  requiresSr22?: InputMaybe<Scalars['Boolean']>;
  vehicles?: InputMaybe<Array<AutoInsuranceVehicleInput>>;
  vehiclesCount?: InputMaybe<Scalars['Int']>;
};

export type PrequalOfferJobIdStatus = {
  __typename?: 'PrequalOfferJobIdStatus';
  /** Current status of job id */
  jobId: Scalars['ID'];
  status: PrequalOverallStatusTypesEnum;
};

/** Generic Prequal Offer Status object */
export type PrequalOfferStatus = {
  __typename?: 'PrequalOfferStatus';
  /** Overall status of fetching all offers */
  overall: PrequalOverallStatusTypesEnum;
  jobIds?: Maybe<Array<Maybe<PrequalOfferJobIdStatus>>>;
};

/** Insurance user input that is shared among verticals */
export type PrequalOfferUserInfoInput = {
  contactName?: InputMaybe<PrequalUserNameInput>;
  /** currentInsurer is a string defined by QuinStreet that will be validated on the unified prequal service */
  currentInsurer?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['EmailAddress']>;
  inventoryType?: InputMaybe<Scalars['String']>;
  isHomeOwner?: InputMaybe<Scalars['Boolean']>;
  isMarried?: InputMaybe<Scalars['Boolean']>;
  /** pricingCode is QuinStreet's way of identifying the purpose of the request */
  pricingCode?: InputMaybe<Scalars['String']>;
  pricingCodeExpiration?: InputMaybe<Scalars['Date']>;
  pricingCodeExpirationDateTime?: InputMaybe<Scalars['DateTime']>;
  qsClickKey?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

/** Prequal offers overall status types */
export enum PrequalOverallStatusTypesEnum {
  /** Results are pending */
  Pending = 'PENDING',
  /** All results are resolved (regardless of success or error) */
  Resolved = 'RESOLVED',
  /**
   * An error occurred at the overall request level
   * If an error occurred for an individual provider, that will be reflected in status.providers
   */
  Error = 'ERROR'
}

/**
 * An offer that combines fields from marketplace, the prequal-service, and the
 * user's profile.  This is also referred to as a "personal loans prequal offer"
 */
export type PrequalPersonalLoansApiOffer = {
  __typename?: 'PrequalPersonalLoansApiOffer';
  /** Fields provided by marketplace */
  marketplaceOffer: PersonalLoansOfferV2;
  /** The apply link is generated based on the marketplace offer ID, the prequal ID, and the offer's redirect URL */
  applyLink: Scalars['URL'];
  /** Date and time indicating when the offer was created */
  createdAt: Scalars['String'];
  /** Disclaimer for the offer */
  disclaimer?: Maybe<Scalars['String']>;
  /** The value of expanded marketplace category is "null" if the offer is not an expanded marketplace offer */
  expandedMarketplaceCategory?: Maybe<PersonalLoansOfferV2ExpandedMarketplaceCategoryEnum>;
  /** Date and time indicating when the offer expires */
  expiredAt?: Maybe<Scalars['String']>;
  /** Unique prequal identifier */
  id: Scalars['ID'];
  /** Flag indicating whether or not this offer can be surfaced on the expanded marketplace page */
  isExpandedMarketplaceOffer: Scalars['Boolean'];
  /** Flag indicating whether the APR rate is variable */
  isVariableRate: Scalars['Boolean'];
  /** Offered loan amount */
  loanAmount: Scalars['Float'];
  /** The loan APR is calculated as the offer's APR divided by 100 */
  loanApr: Scalars['Float'];
  /** The id of the lender offering the loan */
  loanLenderId?: Maybe<Scalars['String']>;
  /** The name of the lender offering the loan */
  loanLenderProvider?: Maybe<Scalars['String']>;
  /** Includes principal loan balance and interest each month over the life of the loan */
  loanMonthlyPayment: Scalars['Float'];
  /** The offer level NW star rating for the personal loan offer */
  loanStarRating?: Maybe<Scalars['Float']>;
  /** The offer's origination fee */
  loanTotalFees: Scalars['Float'];
  /** Total interest on the loan */
  loanTotalInterest: Scalars['Float'];
  /** Length of time it will take for the user to pay off the loan in months */
  loanTermMonths: Scalars['Int'];
  /** The number of days remaining before the offer expires */
  numberOfDaysBeforeOfferExpiration?: Maybe<Scalars['Int']>;
  /** The drivers for the prequal offer in non structured content format */
  rawDrivers: Array<RawDriver>;
  /** Type of residency ownership */
  residencyOwnership: PrequalResidencyOwnershipEnum;
  /** The "best bets" categories for which the offer is eligible. */
  bestBets?: Maybe<Array<PersonalLoansPrequalBestBets>>;
};

export enum PrequalResidencyOwnershipEnum {
  Rent = 'RENT',
  OwnFully = 'OWN_FULLY',
  OwnMortgage = 'OWN_MORTGAGE'
}

export enum PrequalServiceIdEnum {
  PrequalService = 'PREQUAL_SERVICE',
  PersonalLoansService = 'PERSONAL_LOANS_SERVICE',
  StudentLoansService = 'STUDENT_LOANS_SERVICE',
  Homeownership = 'HOMEOWNERSHIP',
  CcPrequalService = 'CC_PREQUAL_SERVICE'
}

export type PrequalUserAddressInput = {
  streetAddress?: InputMaybe<Scalars['String']>;
  streetAddress2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

export type PrequalUserNameInput = {
  firstName?: InputMaybe<Scalars['String']>;
  middleInitial?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_press_release post type from WordPress. */
export type PressRelease = PostInterface & PostWithAuthorsInterface & PostWithFeaturedImageInterface & PostWithTitleInterface & {
  __typename?: 'PressRelease';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  content?: Maybe<Scalars['StructuredContentDocument']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']>;
  /** Whether or not this Press Release is considered featured. */
  featured?: Maybe<Scalars['Boolean']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** A list of MediaSite objects on the PressRelease object. */
  mediaSites?: Maybe<Array<MediaSite>>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
  /** The external URL for this Press Release. */
  url?: Maybe<Scalars['URL']>;
};


/** Type modeling the data for posts within the nw_press_release post type from WordPress. */
export type PressReleaseDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_press_release post type from WordPress. */
export type PressReleaseModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_press_release post type from WordPress. */
export type PressReleaseTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type PressReleaseConnectionResponse = {
  __typename?: 'PressReleaseConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The PressRelease returned for the connection. */
  items?: Maybe<Array<PressRelease>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of PressRelease objects. */
export type PressReleaseFilterInput = {
  /** Limit collection to PressReleases published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit results to Press Releases with a specific featured status. */
  featured?: InputMaybe<Scalars['Boolean']>;
  /** Limit collection to PressReleases with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to PressReleases within a specific MediaSite. This field accepts an array of integer ID's or slugs. */
  mediaSiteIdentifiers?: InputMaybe<Array<Scalars['ID']>>;
};

/** Types of Product Cards for a Roundup */
export enum ProductCardComponentEnum {
  Institution = 'INSTITUTION',
  Keto = 'KETO',
  MarketplaceProductCard = 'MARKETPLACE_PRODUCT_CARD',
  Slim = 'SLIM'
}

/** Types of tabbed content that may appear within Roundup product cards. */
export enum ProductCardContentTabEnum {
  KeyFacts = 'KEY_FACTS',
  ProductDetails = 'PRODUCT_DETAILS',
  ProsCons = 'PROS_CONS',
  WhyWeLikeIt = 'WHY_WE_LIKE_IT'
}

/** ProductInterface contains the common base fields for all products. */
export type ProductInterface = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
};

/** The persisted set of answers that the user submitted in the User reseach flow for project ted. */
export type ProjectTedFormResponse = {
  __typename?: 'ProjectTedFormResponse';
  formStatus?: Maybe<ProjectTedFormStatusEnum>;
};

export enum ProjectTedFormStatusEnum {
  Error = 'ERROR',
  Success = 'SUCCESS'
}

export type Provider = {
  __typename?: 'Provider';
  /** Fields provided by marketplace */
  marketplaceOffer: PersonalLoansOfferV2;
  /** The number of prequal offers provided by this provider is a calculated field */
  numOffers: Scalars['Int'];
};

/**  See https://docs.nerdwallet.io/financial-data-platform/branches/master/swagger-proxy/#operation/event  */
export enum ProxyEventType {
  AuthenticationSuccess = 'AUTHENTICATION_SUCCESS',
  SourceEvent = 'SOURCE_EVENT',
  ResetLogin = 'RESET_LOGIN',
  FlowOpened = 'FLOW_OPENED',
  FlowClosed = 'FLOW_CLOSED',
  InstitutionSearched = 'INSTITUTION_SEARCHED',
  Exit = 'EXIT'
}

/** The return type of publish a single Yak message */
export type PublishYakMessageResult = {
  __typename?: 'PublishYakMessageResult';
  /** Whether the message was published successfully */
  success: Scalars['Boolean'];
};

/** Empty field. Not to be used. */
export type Query = {
  __typename?: 'Query';
  abExperiments?: Maybe<Array<Maybe<Experiment>>>;
  healthabilityRepositories?: Maybe<Array<Maybe<HealthabilityRepository>>>;
  latestHealthabilityReports?: Maybe<Array<Maybe<HealthabilityReport>>>;
  healthabilityReports?: Maybe<Array<Maybe<HealthabilityReport>>>;
  _empty?: Maybe<Scalars['String']>;
  /** Gets the current user's security questions */
  securityQuestions?: Maybe<Array<Scalars['String']>>;
  /** Return autoInsuranceCitySummary json */
  autoInsuranceCitySummary?: Maybe<AutoInsuranceCitySummary>;
  /** Return autoInsuranceVehicleSummary json */
  autoInsuranceVehicleSummary?: Maybe<AutoInsuranceVehicleSummary>;
  /** Return compareAutoInsuranceCarriers json */
  compareAutoInsuranceCarriers?: Maybe<CompareAutoInsuranceCarriers>;
  /**
   * The breakdown of cash flow this month from the first day to the current day in dollars.
   * Optionally, currentDate variable can be passed to the query to override the user current date
   * used to calculate total amount, if not present it will default to the server current date.
   */
  cashFlowBreakdown?: Maybe<CashFlowBreakdown>;
  cashFlowHistoryBreakdown: CashFlowHistoryBreakdown;
  /** A user's top takeaways with regards to their cash flow based on the current date */
  cashFlowTopTakeaways?: Maybe<Array<CashFlowTakeaway>>;
  /** Returns a list of content packs containing relevant content */
  memberHomeContentPacks?: Maybe<ContentPackResponse>;
  /** Retrieves a list of all the WP recommended posts from the ML recommendation pipeline. */
  contentRecommendationPosts: Array<Maybe<PostInterface>>;
  /**
   * Returns the user's persisted set of quiz flow answers for the Credit Card Match quiz.
   * Datasource endpoint: recommendation-service/api/quiz-recommendations/user-answers/v1
   */
  creditCardMatchQuizAnswers?: Maybe<CreditCardMatchQuizAnswersResponse>;
  creditCardMatchQuizOffers?: Maybe<CreditCardMatchQuizOffersResponse>;
  /**
   * Retrieves a list of all credit cards that the ML API supports calculating approval
   * odds predictions for.
   */
  creditCardApprovalOddsPrediction?: Maybe<CreditCardApprovalOddsPredictionResponse>;
  /** Retrieves a list of all of the credit card IDs that support approval odds. */
  creditCardOfferIdsWithApprovalOddsPrediction?: Maybe<CreditCardOfferIdsWithApprovalOddsPredictionResponse>;
  creditFactors?: Maybe<CreditFactors>;
  /** The user's credit history represented by their credit scores for a time range */
  creditScoreHistory?: Maybe<CreditScoreHistoryResponse>;
  /** The user's TU credit report. */
  tuCreditReport?: Maybe<TuCreditReport>;
  /** Returns a simulated credit score given a value amount of a credit simulation type */
  simulateCreditScore?: Maybe<SimulateCreditScoreResponse>;
  tuAuthenticationStatusProfile?: Maybe<CreditProfileAuthStatusProfile>;
  tuCreditReportIdentityProfile?: Maybe<TuCreditReportIdentityProfile>;
  accountLinkingOpportunities?: Maybe<AccountLinkingOpportunitiesResponse>;
  debtSummary?: Maybe<DebtSummary>;
  experimentDecisions?: Maybe<Array<ExperimentDecision>>;
  financialAccounts?: Maybe<GetFinancialAccountsResponse>;
  financialAccountsByPortal?: Maybe<GetFinancialAccountsResponse>;
  financialAccountsIAVDetails?: Maybe<FinancialAccountsIavDetailsResponse>;
  financialAccountTypeSums?: Maybe<FinancialAccountTypeSumsResponse>;
  /** Fetches a user's financial account by financial account ID. */
  financialAccountById?: Maybe<FinancialAccount>;
  financialPortals?: Maybe<GetPortalsResponse>;
  /**
   * Fetches all portals that are not in the INIT state. This is useful for clients because
   * portals in the INIT state have not been fully linked by the user and should not be shown in the UI
   */
  linkedFinancialPortals?: Maybe<GetPortalsResponse>;
  /**
   * Create a portal if one does not exist for a particular institution
   * @deprecated Moved to a mutation
   */
  initializeFinancialPortal?: Maybe<FinancialPortal>;
  /** Retrieves a financial portal by the provided marketplace institution ID */
  financialPortalByInstitutionId?: Maybe<FinancialPortal>;
  /** Fetches a user's financial portal by financial portal ID. */
  financialPortalById?: Maybe<FinancialPortal>;
  /** Retrieves institution status health data for the financial portal ID and identity id specified. */
  institutionHealthDetailsByPortalId?: Maybe<GetInstitutionHealthDetailsResponse>;
  /**
   * Initializes a short lived, one-time use token that should be unique for each Plaid Link session
   * on the client.
   */
  initializeLinkToken?: Maybe<InitializeLinkTokenResponse>;
  /**
   * Returns a user's spending and earning for a given month range.
   * Datasource endpoint: /api/v1/financial_accounts/transactions/cash_flow
   */
  financialTransactionsSpendingAndEarningForMonthRange?: Maybe<FinancialTransactionsSpendingAndEarningForMonthRangeResponse>;
  /**
   * Returns a user's spending totals by category for a target month.
   * Datasource endpoint: /financial_accounts/transactions/cash_flow/by_categories
   */
  financialTransactionsSpendingByCategoryForMonth?: Maybe<FinancialTransactionsSpendingByCategoryForMonth>;
  /**
   * Returns a user's spending totals by date for a target month and the month prior to that month.
   * Datasource endpoint: /financial_accounts/transactions/cash_flow/daily
   */
  financialTransactionsSpendingByDateForMonth?: Maybe<FinancialTransactionsSpendingByDayOfTheMonthForMonth>;
  /**
   * Returns a user's mean average spending by day of the month for the target month range.
   * Datasource endpoint: /financial_accounts/transactions/cash_flow/daily/average
   */
  financialTransactionsAverageSpendingByDayOfTheMonth?: Maybe<FinancialTransactionsAverageSpendingByDayOfTheMonth>;
  /**
   * Returns a user's spending by month in a target month range.
   * Datasource endpoint: financial_accounts/transactions/spending/monthly
   */
  financialTransactionsSpendingByMonth?: Maybe<FinancialTransactionsSpendingByMonth>;
  /**
   * Returns a user's projected earning for the target month.
   *  Datasource endpoint: financial_accounts/transactions/cash_flow/projection
   */
  financialTransactionsProjectionForMonth?: Maybe<FinancialTransactionsProjectionForMonth>;
  /**
   * Returns a user's top merchants by spending for the target month range.
   *  Datasource endpoint: /financial_accounts/transactions/cash_flow/top
   */
  financialTransactionsTopMerchantsBySpending?: Maybe<FinancialTransactionsTopMerchantsBySpending>;
  /**
   * Returns a user's top categories by spending for the target month range.
   *  Datasource endpoint: /financial_accounts/transactions/cash_flow/top
   */
  financialTransactionsTopCategoriesBySpending?: Maybe<FinancialTransactionsTopCategoriesBySpending>;
  /**
   * Returns a user's budget breakdown for the last month range.
   *  Datasource endpoint: /financial_accounts/transactions/cash_flow/top
   */
  financialTransactionsBudgetBreakdown?: Maybe<FinancialTransactionsBudgetBreakdown>;
  /**  A generic query to fetch the transactions pre-filtered for what we expect  */
  financialTransactions?: Maybe<GetTransactionsResponse>;
  /**  Returns a transaction for a user by transaction ID.  */
  financialTransactionById?: Maybe<FinancialTransaction>;
  /** Fetches FDP user meta data for UserOps Dashboard */
  financialUsersForIdentityId?: Maybe<GetFinancialUserMetaResponse>;
  /** Returns the activation status of the CashFlow feature */
  cashFlowActivationStatus?: Maybe<CashFlowActivationStatusResponse>;
  /** Returns the activation status of the CreditScore feature */
  creditScoreActivationStatus?: Maybe<CreditScoreActivationStatusResponse>;
  /**
   * Returns the activation status of an EORU (Email-only Registered User).
   * "Activated" means their visitor_profile is associated with an email address.
   */
  emailOnlyRegisteredUserStatus?: Maybe<EmailOnlyRegisteredUserActivationStatusResponse>;
  /** Returns the activation status of the NetWorth feature */
  netWorthActivationStatus?: Maybe<NetWorthActivationStatusResponse>;
  /** Query to get the feature discovery for web membership experience */
  webFeatureDiscovery?: Maybe<FeatureDiscoveryResponse>;
  /**
   * The appName argument is not being used. The "X-Caller-Client-ID" request header is being used
   * to fetch the feature flags for the appropriate platform.
   * Update: I made the 'appName' input arg not required so that we can safely deprecate it's usage
   * in the native app startup queries
   */
  featureFlags?: Maybe<Array<FeatureFlag>>;
  featureFlag?: Maybe<FeatureFlag>;
  /**
   * Returns a list of cards that should be displayed in the AWAL (Also Worth A Look) section of Member Home.
   * (The term "feed" is a legacy PFM feature that predates the modern Member Home experience).
   */
  nonInsightFeedCards?: Maybe<Array<FeedCard>>;
  greenhouseDepartments?: Maybe<Array<GreenhouseDepartment>>;
  /**
   * Accepts an id, name, or kebabName field to filter for a GreenhouseDepartment.
   * If multiple fields are present, the priority is id -> name -> kebabName.
   */
  greenhouseDepartment?: Maybe<GreenhouseDepartment>;
  greenhouseJob?: Maybe<GreenhouseJob>;
  /** Fetch the state from zipCode */
  getStateFromZipCode?: Maybe<GetStateFromZipCodeResponse>;
  /**
   * The `authCookies` query returns the cookies returned when querying auth info. This could include cookies
   * such as csrf_token, access_token, jwt_access_token, refresh_token
   */
  authCookies: Array<Cookie>;
  rawIdentity?: Maybe<RawIdentity>;
  rawIdentityProfile?: Maybe<RawIdentityProfile>;
  /**
   * The `subscriptionIdentityProfile` query returns subscription_profile_v3, the query/type is not versioned
   * because of recommended GraphQL best practices
   */
  subscriptionIdentityProfile?: Maybe<SubscriptionIdentityProfile>;
  globalIdentityProfile?: Maybe<GlobalIdentityProfile>;
  mobileAppIdentityProfile?: Maybe<MobileAppIdentityProfile>;
  financialIdentityProfile?: Maybe<FinancialIdentityProfile>;
  termsOfServiceIdentityProfile?: Maybe<TermsOfServiceIdentityProfile>;
  hasLinkedFinancialAccounts: Scalars['Boolean'];
  membershipAppActivity?: Maybe<MembershipAppActivityResponse>;
  accountAggCtaDismissedFlags?: Maybe<AccountAggCtaDismissedResponse>;
  /** Return a list of UserInsights to be surfaced in a particular UX context (as expressed via the filter param) */
  userInsights: UserInsightsResponse;
  /** Query to get the info banner details from the feature flag service */
  sitewideInfoBanner: SitewideInfoBannerResponse;
  /**
   * Search for account aggregation institutions by keyword, with the use case of an autocomplete input for users
   * linking accounts in mind
   */
  institutionsForAccountLinkingByKeyword?: Maybe<AccountAggregationInstitutionsResponse>;
  /** Get a list of the top institutions used for account linking */
  topInstitutionsForAccountLinking?: Maybe<TopInstitutionsForLinkingResponse>;
  accountAggregationInstitutionById?: Maybe<AccountAggregationInstitutionByIdResponse>;
  /** Search for canonical institution by keyword, with the use case of an autocomplete input in mind */
  canonicalInstitutionsByKeyword?: Maybe<CanonicalInstitutionsResponse>;
  /**
   * Get a single credit card offer by its legacy ID
   * Returns null if it cannot be found
   */
  creditCardOfferByLegacyId?: Maybe<CreditCardOffer>;
  /**
   * Returns credit card offers associated with the account aggregation institution first by
   * checking for offers with a credit card institution matching the canonical institution ID of the account aggregation institution
   * and falling back to a search by offer name using the account aggregation institution name.
   */
  creditCardOffersForAccountAggregationInstitution?: Maybe<CreditCardOffersV2Response>;
  creditCardOffersByLegacyIds?: Maybe<CreditCardOffersResponse>;
  /**
   * Search for credit card offers by keyword,
   * with the use case of an autocomplete input in mind
   */
  creditCardOffersByKeyword?: Maybe<CreditCardOffersResponse>;
  creditCardOffersByNamedQuery?: Maybe<CreditCardOffersResponse>;
  /** Search for all active Personal Loan Offers. */
  personalLoanOffers?: Maybe<PersonalLoanOffersResponse>;
  /** Request a single personal loan offer by providing the offer's id. */
  personalLoanOffer?: Maybe<PersonalLoanOffer>;
  /** Returns recommended credit card offer bundles for the user. */
  recommendedCreditCardOfferBundles: CreditCardOfferBundlesResponse;
  savingsAccountOfferBySlug?: Maybe<SavingsAccountOffer>;
  savingsAccountOffersByNamedQuery: SavingsAccountOffersByNamedQueryResponse;
  marketplaceEntityV2?: Maybe<MarketplaceEntityInterface>;
  marketplaceEntitiesV2: Array<Maybe<MarketplaceEntityInterface>>;
  /** Get a specific marketplace field value based on entity id and field's raw path */
  marketplaceField?: Maybe<MarketplaceFieldResponse>;
  /**
   * Search for Marketplace entities by keyword
   * using Marketplace's Autocomplete endpoint.
   * https://docs.nerdwallet.io/marketplace/branches/master/api.full_text.html
   */
  marketplaceAutocompleteSearch?: Maybe<Array<MarketplaceEntityInterface>>;
  /**
   * Search for Marketplace entities
   * using Marketplace's product search endpoint.
   */
  marketplaceSearch: MarketplaceSearchResponse;
  /**
   * Returns the money management eligibility for a financial portal's accounts. AS part of
   * determining the eligibility, the money management service goes through the process of attempting
   * to IAV verify the accounts.
   */
  moneyTransferAccountEligibility?: Maybe<MoneyTransferAccountEligibilityResponse>;
  /** Return the transfer limits for the user */
  moneyTransferTransferLimits?: Maybe<MoneyTransferTransferLimitsResponse>;
  /**
   * Returns the KBA questions used by an onboarding money transfer user
   * to identify themselves if we weren't able to from SSN alone:
   * // https://nerdwallet.atlassian.net/wiki/spaces/PRODUCT/pages/620134583/KBA+in+Money+Management
   */
  moneyTransferKbaQuestions?: Maybe<MoneyTransferKbaQuestionsResponse>;
  /** Retrieve Home Lead Match offer based on offerId or legacy productId */
  mortgageSavedLeadMatch?: Maybe<MortgagesOfferV2>;
  /** Retrieve Home Lead Match offers given offer ids */
  mortgageSavedLeadMatches?: Maybe<MortgageSavedLendersResponse>;
  /** Retrieve Home Lead Match recommended lenders offers based on offerIds or legacy productIds */
  mortgageSavedRecommendedLenders?: Maybe<MortgageSavedRecommendedLendersResponse>;
  /** Find matching offers based on Mortgage OSX inputs */
  mortgageLenderMatch: Array<MortgagesOfferV2>;
  homeLeadMatch: Array<MortgagesOfferWithRates>;
  /** Checks if the user is in a state where NerdWallet is a licensed mortgage broker */
  isNerdWalletMortgageLicensed: MortgageLicensed;
  /**
   * Net worth breakdown balances, with account grouping logic based upon "nw_type"
   * @deprecated the new UI should use netWorthBalancesByFinancialAccountCategorization
   */
  netWorthBalances?: Maybe<NetWorthBalances>;
  /** Net worth breakdown balances, with account grouping logic based upon FDP account type/subtype */
  netWorthBalancesByFinancialDataCategorization?: Maybe<NetWorthBalances>;
  /**
   * Returns the user's net worth contributions summary.
   * Datasource endpoint: wealth-recommender/contributions/v1/identities/me/summary
   */
  netWorthContributionSummaries?: Maybe<NetWorthContributionSummaries>;
  /**
   * NOTE: The underlying endpoint has been deprecated. Please do not make any new requests.
   * This query will be removed after traffic has ceased.
   *
   * Returns the user's net worth recommendations.
   * Datasource endpoint: wealth-recommender/recommendations/v1/identities/me/recommendations
   */
  netWorthRecommendations?: Maybe<NetWorthRecommendations>;
  /**
   * Returns the wealth recommender user. Creates it if it doesn't already exist.
   * Datasource endpoint: wealth-recommender/users/v1/identities/me/users
   */
  wealthRecommenderUser?: Maybe<WealthRecommenderUser>;
  /**
   * Returns the user's net worth accounts. The fields provided by Wealth Recommender are
   * annotations on the accounts supplied by Identity/FDP.
   * Datasource endpoint: wealth-recommender/accounts/v1/identities/me/accounts
   */
  netWorthAccounts?: Maybe<NetWorthAccountsResponse>;
  /**
   * Returns the user's net worth account pertaining to the provided financial account ID.
   * Datasource endpoint: wealth-recommender/accounts/v1/identities/me/accounts
   */
  netWorthAccountByFinancialAccountId?: Maybe<NetWorthAccountResponse>;
  /**
   * Returns the user's net worth account pertaining to the provided net worth account ID.
   * Datasource endpoint: wealth-recommender/accounts/v1/identities/me/accounts/<net_worth_account_id>
   */
  netWorthAccountById?: Maybe<NetWorthAccountResponse>;
  /**
   * Returns the user's net worth real assets, which depicts their non-monetary assets
   * Datasource endpoint: wealth-recommender/assets/v1/identities/me/assets
   */
  netWorthRealAssets?: Maybe<NetWorthRealAssetsResponse>;
  /**
   * Returns the user's net worth real asset, which depicts their non-monetary assets
   * Datasource endpoint: wealth-recommender/assets/v1/identities/me/assets/<net_worth_real_asset_id>
   */
  netWorthRealAsset?: Maybe<NetWorthRealAssetResponse>;
  /**
   * Returns the provider home value pertaining to the specified address. Currently only
   * returns the Redfin home value, but could potentially be extended to include Zillow.
   * Datasource endpoint: wealth-recommender/home/v1/home_value
   * @deprecated the new UI should be using netWorthHomeValueResultWithPossibilitiesByAddress
   */
  netWorthHomeValueResultByAddress?: Maybe<NetWorthHomeValueResultResponse>;
  /**
   * Returns the provider home value pertaining to the specified property_id. Currently only
   * returns the Redfin home value, but could potentially be extended to include Zillow.
   * Datasource endpoint: wealth-recommender/home/v2/home_value
   */
  netWorthHomeValueResultByPropertyId?: Maybe<NetWorthHomeValueResultByPropertyIdResponse>;
  /**
   * Returns the provider home value result pertaining to the specified address, or a list of
   * possible home value results. Currently only returns Redfin home values, but could potentially
   * be extended to include Zillow. This query effectively replaces
   * netWorthHomeValueResultByAddress.
   * Datasource endpoint: wealth-recommender/home/v2/home_value
   */
  netWorthHomeValueResultWithPossibilitiesByAddress?: Maybe<NetWorthHomeValueResultWithPossibilitiesResponse>;
  /**
   * Returns the user's net worth contributions summary.
   * Datasource endpoint: wealth-recommender/contributions/v1/identities/me/summary
   */
  netWorthHistory?: Maybe<NetWorthHistoryResponse>;
  /**
   * Returns boolean that denotes whether or not to show the snapshot notification.
   * Show the notification to users who linked accounts or assets before the respective cutoff dates.
   */
  netWorthHistorySnapshotNotification?: Maybe<NetWorthHistorySnapshotNotificationResponse>;
  /**
   * Returns a list of notifications, along with newest/oldest IDs to assist with pagination,
   * and the unread notifications count.
   */
  notifications: GetNotificationsResponse;
  /** Get status of prequal jobs by specifiying a job ID, the prequal serivce, and the path */
  prequalJobStatus: PrequalJobStatusResponse;
  /** Get auto insurance prequal offers */
  autoInsurancePrequalOffers?: Maybe<AutoInsurancePrequalOffersResponse>;
  /** Get auto insurance prequal offers without cache (v2) */
  autoInsurancePrequalOffersJobIds?: Maybe<AutoInsurancePrequalOffersJobResponse>;
  /** Get offers response from a list of Prequal Jobs */
  autoInsurancePrequalOffersV2?: Maybe<AutoInsurancePrequalOffersResponseV2>;
  creditCardPrequalOffers: CreditCardPrequalOffersResponse;
  /** Search for decline loan offers that match the relevant expanded marketplace category */
  declinePersonalLoanOffersSearch?: Maybe<DeclinePersonalLoanOffers>;
  /** Get insurance prequal offers (v1) */
  insurancePrequalOffers?: Maybe<InsurancePrequalOffersResponse>;
  /** Get offers response from a list of Prequal Jobs (v2) */
  insurancePrequalOffersByJobId?: Maybe<InsurancePrequalOffersByJobIdResponse>;
  /** Get insurance prequal offers without cache (v2) */
  insurancePrequalOffersJobIds?: Maybe<InsurancePrequalOffersJobResponse>;
  /** Return saved personal loans prequal offer data for the given user */
  savedPersonalLoansPrequalOffers?: Maybe<SavedPersonalLoansPrequalOffers>;
  recommendedGuidance: Array<RecommendationGuidance>;
  rewardAccounts?: Maybe<Array<RewardAccount>>;
  userReportedCreditCards?: Maybe<UserReportedCreditCardsResult>;
  /** Retrieve content related to the given keywords from WP via the search service */
  rewardsContent: SearchServiceContentSearchResults;
  getContent: SearchServiceContentSearchResults;
  /**
   * The total amount of money spent this month from the first day to the current day in dollars.
   * Optionally, currentDate variable can be pass to the query to override the user current date
   * used to calculate total amount, if not present it will default to the server current date.
   * Example: Return value is `6000.56`
   */
  totalAmountSpentCurrentMonth?: Maybe<Scalars['Float']>;
  /**
   * The total amount of money spent last month from the first day to the same current day last month in dollars.
   * Optionally, currentDate variable can be pass to the query to override the user current date
   * used to calculate total amount, if not present it will default to the server current date.
   * Example: Return value is `6000.56`
   */
  totalAmountSpentPreviousMonthToDate?: Maybe<Scalars['Float']>;
  /**
   * Total sum of a user checking, investing, savings, retirement account balances on the passed-in date.
   * Example: Return value is `86000.56`
   */
  csirBalanceOnDate?: Maybe<Scalars['Float']>;
  /** Query for the data to render a page with structured content client */
  structuredContentPage: StructuredContentPageInterface;
  getUserOpsFDPLinkingErrorEvents: Array<UserOpsPaoEventDetails>;
  getUserOpsCommsSubscriptionPreferencesWrapperList: Array<UserOpsCommsSubscriptionPreferencesWrapper>;
  getUserOpsMessagingActivityEventsList: Array<Maybe<UserOpsMessagingActivityEvent>>;
  /** Retrieves all the of the user's wallet cards associated with their identity from the my cards service. */
  userWalletCards?: Maybe<UserWalletCardsResponse>;
  /** Query to fetch a single Article object. */
  article?: Maybe<Article>;
  /** Query to fetch a single Article object. */
  articleFork?: Maybe<Article>;
  /** Query to fetch multiple Article objects. */
  articles?: Maybe<ArticleConnectionResponse>;
  /** Query to fetch a single Author object. */
  author?: Maybe<Author>;
  /** Query to fetch a single Banner object. */
  banner?: Maybe<Banner>;
  /** Query to fetch multiple Banner objects. */
  banners?: Maybe<BannerConnectionResponse>;
  /** Query to fetch a single BccPage object. */
  bccPage?: Maybe<BccPage>;
  /** Query to fetch a single BccPageCard object. */
  bccPageCard?: Maybe<BccPageCard>;
  /** Query to fetch multiple BccPageCard objects. */
  bccPageCards?: Maybe<BccPageCardConnectionResponse>;
  /** Query to fetch multiple BccPage objects. */
  bccPages?: Maybe<BccPageConnectionResponse>;
  /** Query to fetch a single Block object. */
  block?: Maybe<Block>;
  /** Query to fetch a single BlockGroup object. */
  blockGroup?: Maybe<BlockGroup>;
  /** Query to fetch multiple BlockGroup objects. */
  blockGroups?: Maybe<BlockGroupConnectionResponse>;
  /** Query to fetch multiple Block objects. */
  blocks?: Maybe<BlockConnectionResponse>;
  /** Query to fetch a single Category object. */
  category?: Maybe<Category>;
  /** Query to fetch a single ContentPack object. */
  contentPack?: Maybe<ContentPack>;
  /** Query to fetch multiple ContentPack objects. */
  contentPacks?: Maybe<ContentPackConnectionResponse>;
  /** Query to fetch a single ContentReviewer object. */
  contentReviewer?: Maybe<ContentReviewer>;
  /** Query to fetch multiple ContentReviewer objects. */
  contentReviewers?: Maybe<ContentReviewerConnectionResponse>;
  /** Query to fetch a collection of content search results. */
  contentSearch?: Maybe<ContentSearchResultConnectionResponse>;
  /** Query to fetch a single ContentUserPage object. */
  contentUserPage?: Maybe<ContentUserPage>;
  /** Query to fetch a single ContentUserPage object. */
  contentUserPageFork?: Maybe<ContentUserPage>;
  /** Query to fetch multiple ContentUserPage objects. */
  contentUserPages?: Maybe<ContentUserPageConnectionResponse>;
  /** Query to fetch a single EngineeringPost object. */
  engineeringPost?: Maybe<EngineeringPost>;
  /** Query to fetch multiple EngineeringPost objects. */
  engineeringPosts?: Maybe<EngineeringPostConnectionResponse>;
  /** Query to fetch a single GlobalNavItem object. */
  globalNavItem?: Maybe<GlobalNavItem>;
  /** Query to fetch a single GlobalNavItem object. */
  globalNavItemFork?: Maybe<GlobalNavItem>;
  /** Query to fetch multiple GlobalNavItem objects. */
  globalNavItems?: Maybe<GlobalNavItemConnectionResponse>;
  /** Query to fetch a single HouseAd object. */
  houseAd?: Maybe<HouseAd>;
  /** Query to fetch multiple HouseAd objects. */
  houseAds?: Maybe<HouseAdConnectionResponse>;
  /** Query to fetch a single Hub object. */
  hub?: Maybe<Hub>;
  /** Query to fetch a single Hub object. */
  hubFork?: Maybe<Hub>;
  /** Query to fetch multiple Hub objects. */
  hubs?: Maybe<HubConnectionResponse>;
  /** Query to fetch a single InsurancePage object. */
  insurancePage?: Maybe<InsurancePage>;
  /** Query to fetch multiple InsurancePage objects. */
  insurancePages?: Maybe<InsurancePageConnectionResponse>;
  /** Query to fetch a single LandingPage object. */
  landingPage?: Maybe<LandingPage>;
  /** Query to fetch a single LandingPage object. */
  landingPageFork?: Maybe<LandingPage>;
  /** Query to fetch multiple LandingPage objects. */
  landingPages?: Maybe<LandingPageConnectionResponse>;
  /** Query to fetch a single LegacyLender object. */
  legacyLender?: Maybe<LegacyLender>;
  /** Query to fetch multiple LegacyLender objects. */
  legacyLenders?: Maybe<LegacyLenderConnectionResponse>;
  /** Query to fetch a single MarketplaceEntryPoint object. */
  marketplaceEntryPoint?: Maybe<MarketplaceEntryPoint>;
  /** Query to fetch multiple MarketplaceEntryPoint objects. */
  marketplaceEntryPoints?: Maybe<MarketplaceEntryPointConnectionResponse>;
  /** Query to fetch a single MediaItem object. */
  mediaItem?: Maybe<MediaItem>;
  /** Query to fetch multiple MediaItem objects. */
  mediaItems?: Maybe<MediaItemConnectionResponse>;
  /** Query to fetch a single MediaSite object. */
  mediaSite?: Maybe<MediaSite>;
  /** Query to fetch a single Page object. */
  page?: Maybe<Page>;
  /** Query to fetch a single Post object. */
  post?: Maybe<Post>;
  /** Query for a single post-like object from WP given its ID. */
  postById?: Maybe<PostInterface>;
  /** Query for a collection of post-like objects from WP given their IDs. */
  postsById?: Maybe<Array<PostInterface>>;
  /** Query to fetch a single PressRelease object. */
  pressRelease?: Maybe<PressRelease>;
  /** Query to fetch multiple PressRelease objects. */
  pressReleases?: Maybe<PressReleaseConnectionResponse>;
  /** Query to fetch a single Review object. */
  review?: Maybe<Review>;
  /** Query to fetch a single Review object. */
  reviewFork?: Maybe<Review>;
  /** Query to fetch multiple Review objects. */
  reviews?: Maybe<ReviewConnectionResponse>;
  /** Query to fetch a single Roundup object. */
  roundup?: Maybe<Roundup>;
  /** Query to fetch a single Roundup object. */
  roundupFork?: Maybe<Roundup>;
  /** Query to fetch multiple Roundup objects. */
  roundups?: Maybe<RoundupConnectionResponse>;
  /** Query to fetch a single StructuredContentCalculator object. */
  structuredContentCalculator?: Maybe<StructuredContentCalculator>;
  /** Query to fetch multiple StructuredContentCalculator objects. */
  structuredContentCalculators?: Maybe<StructuredContentCalculatorConnectionResponse>;
  /** Query to fetch a single Table object. */
  table?: Maybe<Table>;
  /** Query to fetch multiple Table objects. */
  tables?: Maybe<TableConnectionResponse>;
  /** Query to fetch a single UrlRecord object. */
  urlRecord?: Maybe<UrlRecord>;
  /** Query to fetch multiple UrlRecord objects. */
  urlRecords?: Maybe<UrlRecordConnectionResponse>;
  /**
   * Query to fetch a collection of related articles.
   * This query is meant to be a temporary implementation to support a use-case
   * in article-client. The intention is to replace it with a more robust solution
   * and remove it entirely soon after.
   */
  relatedArticles?: Maybe<Array<Article>>;
  userBestCreditCardRecommendations?: Maybe<UserBestCreditCardRecommendations>;
  /** The (Filtered) BCC Page Sections for a given post. */
  bccPageSections: Array<BccPageSection>;
  /** Query to return an insurance page by the current page path. */
  insurancePageByPath?: Maybe<InsurancePage>;
  /** Query to return a URL Record by current URL. */
  urlRecordByUrl?: Maybe<UrlRecord>;
  /** Retrieve array of HealthabilityReports from the trunk branch of all repos */
  healthability?: Maybe<Array<Maybe<HealthabilityReport>>>;
};


/** Empty field. Not to be used. */
export type QueryAbExperimentsArgs = {
  uuid?: InputMaybe<Scalars['String']>;
  testNames: Array<InputMaybe<Scalars['String']>>;
};


/** Empty field. Not to be used. */
export type QueryHealthabilityReportsArgs = {
  repository: Scalars['String'];
};


/** Empty field. Not to be used. */
export type QueryAutoInsuranceCitySummaryArgs = {
  stateCode: StateCodeEnum;
  cityName: Scalars['String'];
};


/** Empty field. Not to be used. */
export type QueryAutoInsuranceVehicleSummaryArgs = {
  make: Scalars['String'];
  model: Scalars['String'];
};


/** Empty field. Not to be used. */
export type QueryCompareAutoInsuranceCarriersArgs = {
  carrierA: Scalars['String'];
  carrierB: Scalars['String'];
  state: Scalars['String'];
};


/** Empty field. Not to be used. */
export type QueryCashFlowBreakdownArgs = {
  currentDate: Scalars['String'];
};


/** Empty field. Not to be used. */
export type QueryCashFlowHistoryBreakdownArgs = {
  currentDate: Scalars['Date'];
  numPreviousMonthsToInclude: Scalars['Int'];
};


/** Empty field. Not to be used. */
export type QueryCashFlowTopTakeawaysArgs = {
  currentDate: Scalars['String'];
};


/** Empty field. Not to be used. */
export type QueryMemberHomeContentPacksArgs = {
  options?: InputMaybe<ContentPacksOptionsInput>;
};


/** Empty field. Not to be used. */
export type QueryCreditCardMatchQuizAnswersArgs = {
  quizVersion: Scalars['Int'];
};


/** Empty field. Not to be used. */
export type QueryCreditCardMatchQuizOffersArgs = {
  quizVersion: Scalars['Int'];
};


/** Empty field. Not to be used. */
export type QueryCreditScoreHistoryArgs = {
  input: CreditScoreHistoryInput;
};


/** Empty field. Not to be used. */
export type QuerySimulateCreditScoreArgs = {
  input: CreditSimulationInput;
};


/** Empty field. Not to be used. */
export type QueryExperimentDecisionsArgs = {
  testNames: Array<Scalars['String']>;
  userAttributes: Scalars['JSON'];
};


/** Empty field. Not to be used. */
export type QueryFinancialAccountsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  identityId?: InputMaybe<Scalars['ID']>;
};


/** Empty field. Not to be used. */
export type QueryFinancialAccountsByPortalArgs = {
  financialPortalId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type QueryFinancialAccountsIavDetailsArgs = {
  financialAccountIds: Array<Scalars['ID']>;
};


/** Empty field. Not to be used. */
export type QueryFinancialAccountTypeSumsArgs = {
  identityId?: InputMaybe<Scalars['ID']>;
};


/** Empty field. Not to be used. */
export type QueryFinancialAccountByIdArgs = {
  financialAccountId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type QueryFinancialPortalsArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
  filters?: InputMaybe<FinancialPortalFilterInput>;
  identityId?: InputMaybe<Scalars['ID']>;
};


/** Empty field. Not to be used. */
export type QueryLinkedFinancialPortalsArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
  filters?: InputMaybe<FinancialPortalFilterInput>;
  identityId?: InputMaybe<Scalars['ID']>;
};


/** Empty field. Not to be used. */
export type QueryInitializeFinancialPortalArgs = {
  marketplaceInstitutionId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type QueryFinancialPortalByInstitutionIdArgs = {
  marketplaceInstitutionId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type QueryFinancialPortalByIdArgs = {
  financialPortalId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type QueryInstitutionHealthDetailsByPortalIdArgs = {
  financialPortalId: Scalars['ID'];
  identityId?: InputMaybe<Scalars['ID']>;
};


/** Empty field. Not to be used. */
export type QueryInitializeLinkTokenArgs = {
  iavEnabled?: InputMaybe<Scalars['Boolean']>;
  redirectUri?: InputMaybe<Scalars['String']>;
  androidPackageName?: InputMaybe<Scalars['String']>;
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsSpendingAndEarningForMonthRangeArgs = {
  dateInStartMonth: Scalars['Date'];
  dateInEndMonth: Scalars['Date'];
  filter?: InputMaybe<FinancialTransactionsFilterInput>;
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsSpendingByCategoryForMonthArgs = {
  dateInTargetMonth: Scalars['Date'];
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsSpendingByDateForMonthArgs = {
  dateInTargetMonth: Scalars['Date'];
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsAverageSpendingByDayOfTheMonthArgs = {
  dateInTargetStartMonth: Scalars['Date'];
  dateInTargetEndMonth: Scalars['Date'];
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsSpendingByMonthArgs = {
  dateInTargetStartMonth: Scalars['Date'];
  dateInTargetEndMonth: Scalars['Date'];
  pagination?: InputMaybe<AdvancedOffsetPaginationInput>;
  filter?: InputMaybe<FinancialTransactionsFilterInput>;
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsProjectionForMonthArgs = {
  dateInTargetMonth: Scalars['Date'];
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsTopMerchantsBySpendingArgs = {
  dateInTargetStartMonth: Scalars['Date'];
  dateInTargetEndMonth: Scalars['Date'];
  pagination?: InputMaybe<AdvancedOffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsTopCategoriesBySpendingArgs = {
  dateInTargetStartMonth: Scalars['Date'];
  dateInTargetEndMonth: Scalars['Date'];
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsArgs = {
  pagination?: InputMaybe<AdvancedOffsetPaginationInput>;
  filter?: InputMaybe<FinancialTransactionsFilterInput>;
  identityId?: InputMaybe<Scalars['ID']>;
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionByIdArgs = {
  transactionId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type QueryFinancialUsersForIdentityIdArgs = {
  identityId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type QueryFeatureFlagsArgs = {
  appName?: InputMaybe<Scalars['String']>;
};


/** Empty field. Not to be used. */
export type QueryFeatureFlagArgs = {
  featureFlagName: Scalars['String'];
};


/** Empty field. Not to be used. */
export type QueryNonInsightFeedCardsArgs = {
  onlyTemplates: Array<Scalars['String']>;
};


/** Empty field. Not to be used. */
export type QueryGreenhouseDepartmentArgs = {
  kebabName?: InputMaybe<Scalars['String']>;
};


/** Empty field. Not to be used. */
export type QueryGreenhouseJobArgs = {
  id: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type QueryGetStateFromZipCodeArgs = {
  zipCode: Scalars['String'];
};


/** Empty field. Not to be used. */
export type QueryRawIdentityProfileArgs = {
  profileType: Scalars['String'];
};


/** Empty field. Not to be used. */
export type QueryUserInsightsArgs = {
  effectiveDate?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<UserInsightsFilterInput>;
  shouldRegenerate?: InputMaybe<Scalars['Boolean']>;
  rankingModelName?: InputMaybe<Scalars['String']>;
};


/** Empty field. Not to be used. */
export type QueryInstitutionsForAccountLinkingByKeywordArgs = {
  keyword: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  namedQuery?: InputMaybe<Scalars['String']>;
};


/** Empty field. Not to be used. */
export type QueryTopInstitutionsForAccountLinkingArgs = {
  productType?: InputMaybe<AccountAggregationProductType>;
  yodleeOnly?: InputMaybe<Scalars['Boolean']>;
};


/** Empty field. Not to be used. */
export type QueryAccountAggregationInstitutionByIdArgs = {
  accountAggregationInstitutionId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type QueryCanonicalInstitutionsByKeywordArgs = {
  isFuzzy?: InputMaybe<Scalars['Boolean']>;
  keyword: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  namedQuery?: InputMaybe<Scalars['String']>;
  queryFields?: InputMaybe<Array<Scalars['String']>>;
  sort?: InputMaybe<Array<Scalars['String']>>;
};


/** Empty field. Not to be used. */
export type QueryCreditCardOfferByLegacyIdArgs = {
  input?: InputMaybe<CreditCardOffersParameters>;
  id: Scalars['Int'];
};


/** Empty field. Not to be used. */
export type QueryCreditCardOffersForAccountAggregationInstitutionArgs = {
  accountAggregationInstitutionId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** Empty field. Not to be used. */
export type QueryCreditCardOffersByLegacyIdsArgs = {
  input?: InputMaybe<CreditCardOffersParameters>;
  ids: Array<Scalars['Int']>;
};


/** Empty field. Not to be used. */
export type QueryCreditCardOffersByKeywordArgs = {
  namedQuery?: InputMaybe<Scalars['String']>;
  keyword: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** Empty field. Not to be used. */
export type QueryCreditCardOffersByNamedQueryArgs = {
  input?: InputMaybe<CreditCardOffersParameters>;
  namedQuery: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** Empty field. Not to be used. */
export type QueryPersonalLoanOffersArgs = {
  namedQuery?: InputMaybe<Scalars['String']>;
  input?: InputMaybe<PersonalLoanOffersParameters>;
};


/** Empty field. Not to be used. */
export type QueryPersonalLoanOfferArgs = {
  input?: InputMaybe<PersonalLoanOffersParameters>;
  namedQuery?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};


/** Empty field. Not to be used. */
export type QuerySavingsAccountOfferBySlugArgs = {
  slug: Scalars['String'];
};


/** Empty field. Not to be used. */
export type QuerySavingsAccountOffersByNamedQueryArgs = {
  namedQuery: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** Empty field. Not to be used. */
export type QueryMarketplaceEntityV2Args = {
  id: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type QueryMarketplaceEntitiesV2Args = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


/** Empty field. Not to be used. */
export type QueryMarketplaceFieldArgs = {
  id: Scalars['ID'];
  field: Scalars['String'];
};


/** Empty field. Not to be used. */
export type QueryMarketplaceAutocompleteSearchArgs = {
  isFuzzy?: InputMaybe<Scalars['Boolean']>;
  keyword: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  namedQuery?: InputMaybe<Scalars['String']>;
  productType: Scalars['String'];
  queryFields?: InputMaybe<Array<Scalars['String']>>;
  sort?: InputMaybe<Scalars['String']>;
};


/** Empty field. Not to be used. */
export type QueryMarketplaceSearchArgs = {
  entityType?: InputMaybe<Scalars['String']>;
  productType: Scalars['String'];
  namedQuery?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Array<MarketplaceQueryInput>>;
  sort?: InputMaybe<Array<MarketplaceSortInput>>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  parameters?: InputMaybe<Scalars['JSON']>;
};


/** Empty field. Not to be used. */
export type QueryMoneyTransferAccountEligibilityArgs = {
  financialPortalId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type QueryMortgageSavedLeadMatchArgs = {
  input: MortgageSavedLeadMatchInput;
};


/** Empty field. Not to be used. */
export type QueryMortgageSavedLeadMatchesArgs = {
  ids: Array<Scalars['ID']>;
};


/** Empty field. Not to be used. */
export type QueryMortgageSavedRecommendedLendersArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


/** Empty field. Not to be used. */
export type QueryMortgageLenderMatchArgs = {
  input: MortgageLenderMatchInput;
  namedQuery?: InputMaybe<Scalars['String']>;
};


/** Empty field. Not to be used. */
export type QueryHomeLeadMatchArgs = {
  input: HomeLeadMatchInput;
  usePep: Scalars['Boolean'];
};


/** Empty field. Not to be used. */
export type QueryIsNerdWalletMortgageLicensedArgs = {
  address: MortgageUserAddressInput;
};


/** Empty field. Not to be used. */
export type QueryNetWorthRecommendationsArgs = {
  pagination?: InputMaybe<AdvancedOffsetPaginationInput>;
  filter?: InputMaybe<NetWorthRecommendationsFilterInput>;
};


/** Empty field. Not to be used. */
export type QueryNetWorthAccountByFinancialAccountIdArgs = {
  financialAccountId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type QueryNetWorthAccountByIdArgs = {
  netWorthAccountId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type QueryNetWorthRealAssetArgs = {
  netWorthRealAssetId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type QueryNetWorthHomeValueResultByAddressArgs = {
  address: NetWorthHomeValueResultAddressInput;
  source?: InputMaybe<NetWorthHomeValueResultSourceEnum>;
};


/** Empty field. Not to be used. */
export type QueryNetWorthHomeValueResultByPropertyIdArgs = {
  propertyId: Scalars['ID'];
  source: NetWorthHomeValueResultSourceEnum;
};


/** Empty field. Not to be used. */
export type QueryNetWorthHomeValueResultWithPossibilitiesByAddressArgs = {
  address: NetWorthHomeValueResultAddressInput;
  source?: InputMaybe<NetWorthHomeValueResultSourceEnum>;
};


/** Empty field. Not to be used. */
export type QueryNetWorthHistoryArgs = {
  netWorthFilter: NetWorthHistoryFiltersEnum;
  effectiveDate: Scalars['DateTimeWithTimeOffset'];
};


/** Empty field. Not to be used. */
export type QueryNotificationsArgs = {
  options?: InputMaybe<NotificationsInput>;
};


/** Empty field. Not to be used. */
export type QueryPrequalJobStatusArgs = {
  prequalJobs: Array<PrequalJobInput>;
};


/** Empty field. Not to be used. */
export type QueryAutoInsurancePrequalOffersArgs = {
  providerIds: Array<AutoInsuranceProviderId>;
  userInput?: InputMaybe<AutoInsurancePrequalOfferInput>;
};


/** Empty field. Not to be used. */
export type QueryAutoInsurancePrequalOffersJobIdsArgs = {
  providerIds: Array<AutoInsuranceProviderId>;
  userInput?: InputMaybe<AutoInsurancePrequalOfferInput>;
};


/** Empty field. Not to be used. */
export type QueryAutoInsurancePrequalOffersV2Args = {
  prequalJobs: Array<PrequalJobInput>;
};


/** Empty field. Not to be used. */
export type QueryCreditCardPrequalOffersArgs = {
  userInput: CreditCardPrequalInput;
};


/** Empty field. Not to be used. */
export type QueryDeclinePersonalLoanOffersSearchArgs = {
  params: DeclineResultsQueryInputs;
};


/** Empty field. Not to be used. */
export type QueryInsurancePrequalOffersArgs = {
  providerIds: Array<InsuranceProviderEnum>;
  userInput?: InputMaybe<HomeInsurancePrequalOfferInput>;
  userInfo?: InputMaybe<PrequalOfferUserInfoInput>;
  homeInfo?: InputMaybe<HomeInsurancePrequalOfferInput>;
  driverInfo?: InputMaybe<PrequalOfferDriverInfoInput>;
  lifeInfo?: InputMaybe<LifeInsurancePrequalOfferInput>;
  vertical: InsuranceVerticalEnum;
};


/** Empty field. Not to be used. */
export type QueryInsurancePrequalOffersByJobIdArgs = {
  prequalJobs: Array<PrequalJobInput>;
};


/** Empty field. Not to be used. */
export type QueryInsurancePrequalOffersJobIdsArgs = {
  providerIds: Array<InsuranceProviderEnum>;
  userInput?: InputMaybe<HomeInsurancePrequalOfferInput>;
};


/** Empty field. Not to be used. */
export type QueryRewardsContentArgs = {
  cardNames: Array<Scalars['String']>;
  cardPrograms: Array<Scalars['String']>;
  allowPosts?: InputMaybe<Scalars['Boolean']>;
  sortDir?: InputMaybe<ContentSortDirection>;
  numResults?: InputMaybe<Scalars['Int']>;
};


/** Empty field. Not to be used. */
export type QueryGetContentArgs = {
  contentSearchFilter?: InputMaybe<ContentSearchInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryTotalAmountSpentCurrentMonthArgs = {
  currentDate?: InputMaybe<Scalars['Date']>;
};


/** Empty field. Not to be used. */
export type QueryTotalAmountSpentPreviousMonthToDateArgs = {
  currentDate?: InputMaybe<Scalars['Date']>;
};


/** Empty field. Not to be used. */
export type QueryCsirBalanceOnDateArgs = {
  date: Scalars['Date'];
};


/** Empty field. Not to be used. */
export type QueryStructuredContentPageArgs = {
  uri: Scalars['String'];
  urlParams?: InputMaybe<Array<UrlParamsInput>>;
};


/** Empty field. Not to be used. */
export type QueryGetUserOpsFdpLinkingErrorEventsArgs = {
  identityId: Scalars['ID'];
  portalId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type QueryGetUserOpsCommsSubscriptionPreferencesWrapperListArgs = {
  identityId: Scalars['ID'];
};


/** Empty field. Not to be used. */
export type QueryGetUserOpsMessagingActivityEventsListArgs = {
  identityId: Scalars['ID'];
  pagination: OffsetPaginationInput;
  lastDaysLimit?: InputMaybe<Scalars['Int']>;
};


/** Empty field. Not to be used. */
export type QueryArticleArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryArticleForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};


/** Empty field. Not to be used. */
export type QueryArticlesArgs = {
  filter?: InputMaybe<ArticleFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryAuthorArgs = {
  input?: InputMaybe<AuthorItemInput>;
};


/** Empty field. Not to be used. */
export type QueryBannerArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryBannersArgs = {
  filter?: InputMaybe<BannerFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryBccPageArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryBccPageCardArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryBccPageCardsArgs = {
  filter?: InputMaybe<BccPageCardFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryBccPagesArgs = {
  filter?: InputMaybe<BccPageFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryBlockArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryBlockGroupArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryBlockGroupsArgs = {
  filter?: InputMaybe<BlockGroupFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryBlocksArgs = {
  filter?: InputMaybe<BlockFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryCategoryArgs = {
  input?: InputMaybe<TermItemInput>;
};


/** Empty field. Not to be used. */
export type QueryContentPackArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryContentPacksArgs = {
  filter?: InputMaybe<ContentPackFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryContentReviewerArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryContentReviewersArgs = {
  filter?: InputMaybe<ContentReviewerFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryContentSearchArgs = {
  filter?: InputMaybe<ContentSearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  wpNonce?: InputMaybe<Scalars['ID']>;
};


/** Empty field. Not to be used. */
export type QueryContentUserPageArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryContentUserPageForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};


/** Empty field. Not to be used. */
export type QueryContentUserPagesArgs = {
  filter?: InputMaybe<ContentUserPageFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryEngineeringPostArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryEngineeringPostsArgs = {
  filter?: InputMaybe<EngineeringPostFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryGlobalNavItemArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryGlobalNavItemForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};


/** Empty field. Not to be used. */
export type QueryGlobalNavItemsArgs = {
  filter?: InputMaybe<GlobalNavItemFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryHouseAdArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryHouseAdsArgs = {
  filter?: InputMaybe<HouseAdFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryHubArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryHubForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};


/** Empty field. Not to be used. */
export type QueryHubsArgs = {
  filter?: InputMaybe<HubFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryInsurancePageArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryInsurancePagesArgs = {
  filter?: InputMaybe<InsurancePageFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryLandingPageArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryLandingPageForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};


/** Empty field. Not to be used. */
export type QueryLandingPagesArgs = {
  filter?: InputMaybe<LandingPageFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryLegacyLenderArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryLegacyLendersArgs = {
  filter?: InputMaybe<LegacyLenderFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryMarketplaceEntryPointArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryMarketplaceEntryPointsArgs = {
  filter?: InputMaybe<MarketplaceEntryPointFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryMediaItemArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryMediaItemsArgs = {
  filter?: InputMaybe<MediaItemFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryMediaSiteArgs = {
  input?: InputMaybe<TermItemInput>;
};


/** Empty field. Not to be used. */
export type QueryPageArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryPostArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryPostByIdArgs = {
  id: Scalars['Int'];
};


/** Empty field. Not to be used. */
export type QueryPostsByIdArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Empty field. Not to be used. */
export type QueryPressReleaseArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryPressReleasesArgs = {
  filter?: InputMaybe<PressReleaseFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryReviewArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryReviewForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};


/** Empty field. Not to be used. */
export type QueryReviewsArgs = {
  filter?: InputMaybe<ReviewFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryRoundupArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryRoundupForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};


/** Empty field. Not to be used. */
export type QueryRoundupsArgs = {
  filter?: InputMaybe<RoundupFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryStructuredContentCalculatorArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryStructuredContentCalculatorsArgs = {
  filter?: InputMaybe<StructuredContentCalculatorFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryTableArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryTablesArgs = {
  filter?: InputMaybe<TableFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryUrlRecordArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryUrlRecordsArgs = {
  filter?: InputMaybe<UrlRecordFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryRelatedArticlesArgs = {
  input?: InputMaybe<RelatedArticlesInput>;
};


/** Empty field. Not to be used. */
export type QueryUserBestCreditCardRecommendationsArgs = {
  input?: InputMaybe<UserBestCreditCardRecommendationsInput>;
};


/** Empty field. Not to be used. */
export type QueryBccPageSectionsArgs = {
  input?: InputMaybe<PostItemInput>;
  filteredSectionIdentifiers?: InputMaybe<Array<Scalars['String']>>;
};


/** Empty field. Not to be used. */
export type QueryInsurancePageByPathArgs = {
  path: Scalars['String'];
  wpnonce?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Empty field. Not to be used. */
export type QueryUrlRecordByUrlArgs = {
  url: Scalars['URL'];
};

/** Named credit score ranges accepted for creditScoreRange in AutoInsurancePrequalOfferInput */
export enum QuinStreetCreditScoreRangeEnum {
  Excellent = 'EXCELLENT',
  Good = 'GOOD',
  Fair = 'FAIR',
  Poor = 'POOR'
}

export type RawDriver = {
  __typename?: 'RawDriver';
  /**
   * The synthetic driver id to create a unique cache key to store this data within the Apollo cache.
   * Without this field the data in this Type will get rolled up under the parent Type,
   * and there's potential for some cache pollution since some of the field values within
   * this type are based on the minAccountBalance input.
   */
  id: Scalars['ID'];
  /** The driver description */
  description?: Maybe<Scalars['String']>;
  /** The driver label */
  label: Scalars['String'];
  /** The value of the driver */
  value?: Maybe<Scalars['String']>;
  /** Tooltip for the value of the driver */
  tooltip?: Maybe<Scalars['String']>;
};

/** The `RawIdentity` type represents the cookies and any payload related to the logged in identity. */
export type RawIdentity = {
  __typename?: 'RawIdentity';
  authCookies: Array<Cookie>;
  data?: Maybe<Scalars['JSON']>;
};

/** The `RawIdentityProfile` type represents the given profile */
export type RawIdentityProfile = {
  __typename?: 'RawIdentityProfile';
  profileType: Scalars['String'];
  data?: Maybe<Scalars['JSON']>;
};

/** Describes the details of the recap list section of a roundup */
export type RecapListDetails = {
  __typename?: 'RecapListDetails';
  /** The title to use for the recap list section */
  title: Scalars['String'];
  recapItems?: Maybe<Array<RoundupSection>>;
};


/** Describes the details of the recap list section of a roundup */
export type RecapListDetailsRecapItemsArgs = {
  abTestCCPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestBankingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestInvestingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestDeviceTypePhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  isDesktopUserAgent?: InputMaybe<Scalars['Boolean']>;
};

export type RecommendationGuidance = {
  __typename?: 'RecommendationGuidance';
  /**
   * Contains the information needed to display a CTA and details
   * to how to handle the action in mobile and web.
   */
  action?: Maybe<RecommendationGuidanceAction>;
  /** Suggested advice description to be shown for the particular guidance */
  advice: Scalars['String'];
  /**
   * Explanation about what we know from the user data that we believe this
   * particular guidance is surfaced to the user.
   */
  insight: Scalars['String'];
  /**
   * Source of the insight used for this recommendation, mostly used for tracking.
   * e.g. Credit Utilization, Age of Accounts.
   */
  insightSource: Scalars['String'];
  /** Cannonical name identifier for the particular guidance */
  name: Scalars['String'];
  /** Label used at the top of the guidance card. */
  tag?: Maybe<Scalars['String']>;
};

export type RecommendationGuidanceAction = {
  __typename?: 'RecommendationGuidanceAction';
  /**
   * Target used for the native app, most of the cases this will contain
   * a deep link.
   */
  mobileTarget: Scalars['String'];
  /** Cannonical name identifier for this action */
  name: Scalars['String'];
  /**
   * Target use for web, most of the cases will contain a url to open.
   * Also might be used as a fallback if the mobileTarget is not supported in the native app.
   */
  target: Scalars['String'];
  /** Enum for the target type to be used when handling the action targets. */
  targetType: RecommendationGuidanceTargetType;
  /** Friendly text displayed to the user as a CTA. */
  text: Scalars['String'];
};

export enum RecommendationGuidanceTargetType {
  WebLink = 'WEB_LINK'
}

/**
 * A user insight sourced from the recommendation-service and retrieved via Factory.
 *
 * Note that the prefix "Recommendation" indicates only the origin of this insight -- not that it is semantically more
 * worthy of "recommendation" than insights from other sources.
 */
export type RecommendationInsight = UserInsightInterface & {
  __typename?: 'RecommendationInsight';
  /**
   * A human-readable identifier for a particular insight inventory item.  Primarily used for analytics.
   *
   * Note that the slug field is the same across all instances of a particular insight (whereas the id field is unique).
   *
   * Example: credit-score-utilization-increase-by-ten-or-more-points
   */
  slug?: Maybe<Scalars['String']>;
  /**
   * The primary identifier for a UserInsight.  Primarily used for tracking user engagement.
   *
   * Because insight inventory items are typically stateless and do not have proper database IDs, this field will generally
   * be inferred by source-specific heuristics.
   *
   * Note that the id field is unique across all instances of a particular insight (whereas the slug field is not).
   */
  id: Scalars['ID'];
  /** Language that summarizes or introduces the insight. */
  title?: Maybe<Scalars['String']>;
  /** The insights regeneration group. */
  regenerationGroup?: Maybe<UserInsightRegenerationGroupEnum>;
  /** Language that describes the insight in detail. */
  description?: Maybe<Scalars['String']>;
  /** General suggestions related to this insight that are not immediately actionable are surfaced as a "tip" */
  tip?: Maybe<UserInsightTip>;
  /**
   * A measure of how impactful this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * impact)
   *
   * For example, a large transaction alert would be high-urgency while a credit card recommendation would be low-urgency.
   */
  impact?: Maybe<Scalars['Float']>;
  /**
   * A measure of how urgent this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * urgency)
   *
   * For example, a large transaction alert would be high-urgency while a credit card recommendation would be
   * low-urgency.
   */
  urgency?: Maybe<Scalars['Float']>;
  /**
   * Information about the ML model used to produce a personalized ranking score for the current user about a particular
   * insight.
   */
  personalizedRankingScore?: Maybe<UserInsightPersonalizedRankingScore>;
  /**
   * A qualitative indication of how the user should feel about a particular insight.  Used primarily to inform UI
   * treatment (e.g. red vs. yellow vs. blue accent color).
   *
   * Note that a NEUTRAL sentiment value means that the insight is explicitly assessed to be of neutral sentiment, whereas
   * the absence of a sentiment value means that the sentiment is unknown.
   */
  sentiment?: Maybe<UserInsightSentimentEnum>;
  /** The actions that we recommend for the user to perform based on this insight. */
  actions: Array<UserAction>;
  /** Insights may be related to one or more features, which are represented via this field. */
  relatedFeatures?: Maybe<Array<MembershipFeatureEnum>>;
  /**
   * The source of truth for this particular insight (typically a service or a CMS).
   *
   * Used primarily to infer the type of a particular UserInsightInterface instance.
   */
  inventorySource: UserInsightInventorySourceEnum;
  /** An object containing the data necessary to render the data visualization for this insight. */
  dataVisualization?: Maybe<UserInsightDataVisualizationInterface>;
  /** An image to be displayed with the insight near the description. */
  bodyImage?: Maybe<UserInsightImage>;
  /**
   * This field encapsulates the concept of an increase or gain to a user’s personal finances.
   *
   * This could range from credit score increases to an increase in savings or debt.
   */
  gain?: Maybe<UserInsightGain>;
  /** The UX modules that this insight may appear in. */
  eligibleModules?: Maybe<Array<UserInsightEligibleModulesEnum>>;
  /** The eligibility configuration for the current client */
  clientEligibilityConfig?: Maybe<ClientEligibilityConfig>;
  /** Flag for whether generated user insight is stale compared to a user's new credit report pull */
  isStale?: Maybe<Scalars['Boolean']>;
};

export type RefreshTokenLoginInfoInput = {
  /** The refresh token used to login */
  refreshToken: Scalars['String'];
  /** Determines if user should stay logged in */
  rememberMe: Scalars['Boolean'];
};

export type RegisterUserResponse = AuthenticationResponseInterface & {
  __typename?: 'RegisterUserResponse';
  /** Determines whether user registration was successful */
  success: Scalars['Boolean'];
  /** The A/B experiments associated with the current user */
  abExperiments?: Maybe<Array<Experiment>>;
  /** The feature flags associated with the current user for the calling application */
  featureFlags?: Maybe<Array<FeatureFlag>>;
};

export type RegistrationTrackingMetadata = {
  /** The tracking channel for the current user (e.g. 'mobile') */
  trackingChannel?: InputMaybe<Scalars['String']>;
  /** The tracking version for the current user */
  trackingVersion?: InputMaybe<Scalars['String']>;
  /** The tracking vertical for the current user (e.g. 'nw_native_app') */
  trackingVertical?: InputMaybe<Scalars['String']>;
  /** The page impression ID associated with the user registration event */
  pageImpressionId: Scalars['String'];
  /** The navigation source impression ID associated with the user registration event */
  navigationSourceImpressionId: Scalars['String'];
  /** The navigation source tracking code associated with the user registration event */
  navigationSourceTrackingCode?: InputMaybe<Scalars['String']>;
};

export type ReinitializeFinancialPortalResponse = {
  __typename?: 'ReinitializeFinancialPortalResponse';
  financialPortal?: Maybe<FinancialPortal>;
  details?: Maybe<ReinitializeFinancialPortalResponseDetails>;
};

export type ReinitializeFinancialPortalResponseDetails = {
  __typename?: 'ReinitializeFinancialPortalResponseDetails';
  /**  The link token used to open the Plaid fix flow with  */
  linkToken?: Maybe<Scalars['ID']>;
  /**
   *  If there is an existing Plaid Item, use this token when opening Plaid Link to enter the fix flow
   * @deprecated For backwards compatibility, the values are the same but we should now be using the linkToken field
   */
  publicToken?: Maybe<Scalars['ID']>;
  /**  For a portal that should be migrated, the suggested marketplace account aggregation institution id  */
  recommendedInstitutionId?: Maybe<Scalars['ID']>;
  /**  For a portal that should be migrated, the external (e.g. Plaid) id for the institution to link  */
  recommendedSourceInstitutionId?: Maybe<Scalars['ID']>;
};

/** The input for retrieving a collection of related articles. */
export type RelatedArticlesInput = {
  /** A WordPress ID to exclude from the query. */
  exclude: Scalars['ID'];
  /** The type of article to return. */
  articleType: Scalars['String'];
  /** Limit of number of results. Default: 6 */
  limit?: InputMaybe<Scalars['Int']>;
};

export type RemoveUserReportedCreditCardResult = {
  __typename?: 'RemoveUserReportedCreditCardResult';
  /** The legacy of the removed card */
  cardId: Scalars['Int'];
};

export type RemoveUserWalletCardResponse = {
  __typename?: 'RemoveUserWalletCardResponse';
  success: Scalars['Boolean'];
};

/** The enum for selecting the text formatting to return on rendered text fields. */
export enum RenderedTextFormatEnum {
  Html = 'HTML',
  PlainText = 'PLAIN_TEXT'
}

export type ResetPasswordInfoInput = {
  /** The password reset token used to reset the user's password */
  passwordResetToken: Scalars['String'];
  /** The user's existing password used to reset their password */
  password: Scalars['String'];
  /** The challenge answer associated with the user's password reset */
  challengeAnswer: Scalars['String'];
};

/** Type modeling the data for posts within the nw_review post type from WordPress. */
export type Review = ContentPageHeaderInterface & PostInterface & PostWithAuthorsInterface & PostWithContentClassificationInterface & PostWithContentInterface & PostWithExcerptInterface & PostWithFaQsInterface & PostWithFeaturedImageInterface & PostWithInternationalVersionsInterface & PostWithPageTaxonomyInterface & PostWithReviewerInterface & PostWithSeoInterface & PostWithTitleInterface & {
  __typename?: 'Review';
  /** The alternate products to display. */
  alternatePicks?: Maybe<Array<ReviewAlternatePick>>;
  /** The assigning editor set on the content. */
  assigningEditor?: Maybe<Author>;
  /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
  attributionTopic?: Maybe<Scalars['String']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The Benefits and Perks content section for a Review. */
  benefitsAndPerks?: Maybe<Scalars['StructuredContentDocument']>;
  /** Short summary of the roundup/review. */
  bottomLine?: Maybe<Scalars['StructuredContentDocument']>;
  /** A list of Category objects on the Review object. */
  categories?: Maybe<Array<Category>>;
  /** The source of the comparison table to display. */
  comparisonTableSource?: Maybe<Scalars['String']>;
  /** The negative bullet points about the product. */
  cons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** The structured content for the resource. */
  content?: Maybe<Scalars['StructuredContentDocument']>;
  /** Additional content clusters for this piece of content. */
  contentClusters?: Maybe<Array<Scalars['String']>>;
  /** The custom last modified date for the content. */
  customLastModifiedDate?: Maybe<Scalars['DateTime']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** The format to use when displaying the date. */
  dateDisplayFormat?: Maybe<DateDisplayFormatEnum>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The Detailed Review content section for a Review. */
  detailedReview?: Maybe<Scalars['StructuredContentDocument']>;
  /** The Drawbacks and Considerations content section for a Review. */
  drawbacksAndConsiderations?: Maybe<Scalars['StructuredContentDocument']>;
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']>;
  /** The Marketplace Entity type. */
  entityType?: Maybe<MarketplaceEntityTypeEnum>;
  /** The editorial excerpt of the resource. */
  excerpt?: Maybe<Scalars['String']>;
  /** Whether or not to exclude related products. */
  excludeRelatedProducts?: Maybe<Scalars['Boolean']>;
  /** The faqs to display on this piece of content. */
  faqs?: Maybe<Array<ContentFaq>>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']>;
  /** Whether or not to hide the date for this piece of content. */
  hideDate?: Maybe<Scalars['Boolean']>;
  /** The How to Decide content section for a Review. */
  howToDecide?: Maybe<Scalars['StructuredContentDocument']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** The content sections for an institution Review. */
  institutionBreakdownSections?: Maybe<Array<ReviewInstitutionBreakdownSection>>;
  /** The Insurance component to use on this Review. */
  insuranceComponent?: Maybe<Scalars['StructuredContentDocument']>;
  /** Information about alternate versions of the content that exist for other locales. */
  internationalVersions?: Maybe<Array<InternationalVersion>>;
  /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
  isArchivesEligible?: Maybe<Scalars['Boolean']>;
  /** Whether or not to prevent this piece of content from being recommended to users. */
  isRecommendationEligible?: Maybe<Scalars['Boolean']>;
  /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
  isSearchEligible?: Maybe<Scalars['Boolean']>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The Marketplace entity UUID. */
  marketplaceEntity?: Maybe<MarketplaceEntityInterface>;
  /** The Marketplace entity UUID. */
  marketplaceEntityId?: Maybe<Scalars['String']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** Whether to override the last modified date for the content using one of the available options. */
  overrideLastModifiedDateWithCurrentDate?: Maybe<OverrideLastModifiedDateEnum>;
  /** Page taxonomy data. This array is designed to be passed directly to GMS. See https://github.com/NerdWallet/global-markup/tree/b3af4e1f2c68485514145ff31b9137d619e910e1#v2-options */
  pageTaxonomy?: Maybe<Scalars['JSON']>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']>;
  /** The primary category object for the content. */
  primaryCategory?: Maybe<Category>;
  /** The primary content cluster for this piece of content. */
  primaryContentCluster?: Maybe<Scalars['String']>;
  /** The Marketplace product type. */
  productType?: Maybe<MarketplaceProductTypeEnum>;
  /** The positive bullet points about the product. */
  pros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** The disclaimer for how the rating was derived. */
  ratingDisclaimer?: Maybe<Scalars['String']>;
  /** A date after which this content should no longer be recommended. */
  recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']>;
  /** The products related to the current one to display on the page. */
  relatedProducts?: Maybe<Array<ReviewRelatedProduct>>;
  /** The reviewers that this Review has been reviewed by. */
  reviewedBy?: Maybe<Array<ContentReviewer>>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** Whether or not to display the FAQ's. */
  showFaqs?: Maybe<Scalars['Boolean']>;
  /** Whether or not to show the last modified date. */
  showLastModifiedDate?: Maybe<Scalars['Boolean']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The Marketplace subproduct type for the banking vertical. */
  subproductType?: Maybe<ReviewSubproductTypeEnum>;
  /** The content to display below the title of a piece of content. */
  synopsis?: Maybe<Scalars['StructuredContentDocument']>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
  /** Whether or not to use a custom last modified date for this piece of content. */
  useCustomLastModifiedDate?: Maybe<Scalars['Boolean']>;
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']>>;
  /** Type of advertiser disclosure to display (default credit_cards) */
  advertiserDisclosureType: Scalars['String'];
  /** The Breadcrumb to be displayed on a review */
  breadcrumb?: Maybe<Breadcrumb>;
  /** Data used for rendering the comparison table */
  comparisonTable?: Maybe<ComparisonTableDetails>;
  /** The location where the Comparison Table should be rendered on a Review */
  comparisonTableLocation: ComparisonTableLocationEnum;
  /** The tracking params that should be appended to this review section's marketplace entity's CTA */
  ctaTrackingParams?: Maybe<Array<TrackingParam>>;
  /** The display date (depends on checked boxes in WP, could be custom_last_modified_date, modified, or published dates) */
  displayDate?: Maybe<Scalars['DateTime']>;
  /** The drivers associated with the entity of this review */
  drivers?: Maybe<Array<EntityPlacementDriver>>;
  /** Type of article, which will determine what (if any) additional editorial standards message to display. */
  editorialDisclaimerType?: Maybe<Scalars['String']>;
  /**
   * Get the list of review content sections filtered by the provided geolocation
   * Notes:
   *   - Filtering applies to Banking only
   *   - Does not filter CD offers
   */
  filteredReviewContentSections?: Maybe<Array<ReviewInstitutionBreakdownSection>>;
  /** Whether or not the review has local offers */
  hasLocalOffers?: Maybe<Scalars['Boolean']>;
  /** Heading text for the institution breakdown */
  institutionBreakdownHeading?: Maybe<Scalars['String']>;
  /**
   * The display date (depends on checked boxes in WP, could be custom_last_modified_date, modified, or published dates)
   * @deprecated Deprecating in favor of using 'displaydate' moving forward, as it more accurately reflects the return value.
   */
  lastModifiedDate?: Maybe<Scalars['DateTime']>;
  /** The vertical-specific methodology to display for the review */
  methodology?: Maybe<Scalars['StructuredContentDocument']>;
  /** The WP (not Marketplace) star rating for the product being reviewed. */
  rating?: Maybe<Scalars['Float']>;
  /** List of related links. */
  relatedLinks?: Maybe<Array<ReviewRelatedLinkSection>>;
  /** Boolean flag to indicate if all Marketplace Entity CTAs should be omitted on the page */
  shouldOmitCta: Scalars['Boolean'];
  /** Boolean flag to show/hide the advertiser disclosure in the page header */
  showAdvertiserDisclosure: Scalars['Boolean'];
  /** Boolean flag to show/hide the author byline in the page header */
  showAuthorByline: Scalars['Boolean'];
  /** Boolean flag to show/hide the editorial disclaimer in the page header */
  showEditorialDisclaimer: Scalars['Boolean'];
  /** Whether or not the page qualifies to show a sign up banner */
  showSignUpBanner: Scalars['Boolean'];
  /** Whether the review content for the institution breakdown is nested in an accordion */
  useMobileAccordionForInstitutionBreakdown: Scalars['Boolean'];
  /** The heading for the review intro */
  introHeading?: Maybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_review post type from WordPress. */
export type ReviewDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_review post type from WordPress. */
export type ReviewExcerptArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};


/** Type modeling the data for posts within the nw_review post type from WordPress. */
export type ReviewModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_review post type from WordPress. */
export type ReviewTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};


/** Type modeling the data for posts within the nw_review post type from WordPress. */
export type ReviewCtaTrackingParamsArgs = {
  utmCampaign?: InputMaybe<Scalars['String']>;
  sourceUrl?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_review post type from WordPress. */
export type ReviewFilteredReviewContentSectionsArgs = {
  userState?: InputMaybe<StateCodeEnum>;
};

/** Type modeling the data within the alternatePicks group of fields on the Review type. */
export type ReviewAlternatePick = {
  __typename?: 'ReviewAlternatePick';
  /** The URL of the review to link to as an alternate pick. */
  ctaUrl?: Maybe<Scalars['URL']>;
  /** The description text to display for the alternate pick. */
  description?: Maybe<Scalars['StructuredContentDocument']>;
  /** The Marketplace entity type for the alternate pick. */
  entityType?: Maybe<MarketplaceEntityTypeEnum>;
  /** The label to express how the alternate product is related to the product currently being reviewed. */
  label?: Maybe<Scalars['String']>;
  /** The marketplace entity for the alternative pick. */
  marketplaceEntity?: Maybe<MarketplaceEntityInterface>;
  /** The marketplace entity for the alternative pick. */
  marketplaceEntityId?: Maybe<Scalars['String']>;
  /** The Marketplace product type for the alternate pick. */
  productType?: Maybe<MarketplaceProductTypeEnum>;
  /** The tagline text to display for the alternate pick. */
  tagline?: Maybe<Scalars['StructuredContentDocument']>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type ReviewConnectionResponse = {
  __typename?: 'ReviewConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The Review returned for the connection. */
  items?: Maybe<Array<Review>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

export type ReviewerPage = StructuredContentPageInterface & {
  __typename?: 'ReviewerPage';
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID'];
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
};

/** Query to fetch a collection of Review objects. */
export type ReviewFilterInput = {
  /** Limit collection to Reviews published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to Reviews within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']>>;
  /** Limit results to those with the specified cluster. */
  cluster?: InputMaybe<Scalars['String']>;
  /** Limit results to those with the specified Assigning Editor, filtered by ID. */
  editorIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Limit collection to Reviews with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']>;
  /** Limit results to those with the specified Reviewer, filtered by ID. */
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Limit collection to Reviews with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

/** Type modeling the data within the institutionBreakdownSections group of fields on the Review type. */
export type ReviewInstitutionBreakdownSection = {
  __typename?: 'ReviewInstitutionBreakdownSection';
  /** The content to display within the section. */
  content?: Maybe<Scalars['StructuredContentDocument']>;
  /** The marketplace entity to use for the 1-year APY value on CDs. */
  marketplace1YearApy?: Maybe<MarketplaceEntityInterface>;
  /** The marketplace entity to use for the 1-year APY value on CDs. */
  marketplace1YearApyId?: Maybe<Scalars['String']>;
  /** The marketplace entity to use for the 3-year APY value on CDs. */
  marketplace3YearApy?: Maybe<MarketplaceEntityInterface>;
  /** The marketplace entity to use for the 3-year APY value on CDs. */
  marketplace3YearApyId?: Maybe<Scalars['String']>;
  /** The marketplace entity to use for the 5-year APY value on CDs. */
  marketplace5YearApy?: Maybe<MarketplaceEntityInterface>;
  /** The marketplace entity to use for the 5-year APY value on CDs. */
  marketplace5YearApyId?: Maybe<Scalars['String']>;
  /** The marketplace entity associated with the current section. */
  marketplaceEntity?: Maybe<MarketplaceEntityInterface>;
  /** The marketplace entity associated with the current section. */
  marketplaceEntityId?: Maybe<Scalars['String']>;
  /** The section type for the current review section. */
  sectionType?: Maybe<ReviewSectionTypeEnum>;
  /** The tracking params that should be appended to this review section's marketplace entity's CTA */
  ctaTrackingParams?: Maybe<Array<TrackingParam>>;
  /** The drivers for a given institution breakdown section */
  drivers?: Maybe<Array<EntityPlacementDriver>>;
  /** Boolean flag to omit editorial content (e.g., pros/cons/bottom line) from the review */
  omitMarketplaceEditorialContent: Scalars['Boolean'];
  /** Optional title for the institution breakdown section */
  title?: Maybe<Scalars['String']>;
  /** Text size for title field */
  titleSize?: Maybe<Scalars['String']>;
};


/** Type modeling the data within the institutionBreakdownSections group of fields on the Review type. */
export type ReviewInstitutionBreakdownSectionCtaTrackingParamsArgs = {
  utmCampaign?: InputMaybe<Scalars['String']>;
  sourceUrl?: InputMaybe<Scalars['String']>;
};

export type ReviewRedirect = {
  __typename?: 'ReviewRedirect';
  reviewUrl: Scalars['URL'];
};

/** The Link type to encapsulate the properties within each of the links. */
export type ReviewRelatedLinks = {
  __typename?: 'ReviewRelatedLinks';
  text: Scalars['String'];
  url: Scalars['String'];
};

/** The RelatedLink type to encapsulate the properties within each of the related links. */
export type ReviewRelatedLinkSection = {
  __typename?: 'ReviewRelatedLinkSection';
  heading?: Maybe<Scalars['String']>;
  links?: Maybe<Array<ReviewRelatedLinks>>;
};

/** Type modeling the data within the relatedProducts group of fields on the Review type. */
export type ReviewRelatedProduct = {
  __typename?: 'ReviewRelatedProduct';
  /** The Marketplace entity type for the related product. */
  entityType?: Maybe<MarketplaceEntityTypeEnum>;
  /** The related product to display for 1 year APY on banking reviews. */
  marketplace1YearApy?: Maybe<MarketplaceEntityInterface>;
  /** The related product to display for 1 year APY on banking reviews. */
  marketplace1YearApyId?: Maybe<Scalars['String']>;
  /** The related product to display for 3 year APY on banking reviews. */
  marketplace3YearApy?: Maybe<MarketplaceEntityInterface>;
  /** The related product to display for 3 year APY on banking reviews. */
  marketplace3YearApyId?: Maybe<Scalars['String']>;
  /** The related product to display for 5 year APY on banking reviews. */
  marketplace5YearApy?: Maybe<MarketplaceEntityInterface>;
  /** The related product to display for 5 year APY on banking reviews. */
  marketplace5YearApyId?: Maybe<Scalars['String']>;
  /** The related Marketplace entity for this piece of content. */
  marketplaceEntity?: Maybe<MarketplaceEntityInterface>;
  /** The related Marketplace entity for this piece of content. */
  marketplaceEntityId?: Maybe<Scalars['String']>;
  /** The Marketplace product type for the related product. */
  productType?: Maybe<MarketplaceProductTypeEnum>;
};

/** Enum values for sectionType field on Review type. */
export enum ReviewSectionTypeEnum {
  BankExperience = 'BANK_EXPERIENCE',
  Default = 'DEFAULT',
  MarketplaceEntity = 'MARKETPLACE_ENTITY',
  OverdraftFee = 'OVERDRAFT_FEE'
}

/** Enum values for subproductType field on Review type. */
export enum ReviewSubproductTypeEnum {
  Cd = 'CD',
  Checking = 'CHECKING',
  Default = 'DEFAULT',
  Savings = 'SAVINGS'
}

/** The reward data connected to an account */
export type RewardAccount = {
  __typename?: 'RewardAccount';
  id: Scalars['ID'];
  providerName: Scalars['String'];
  accountNumber?: Maybe<Scalars['String']>;
  providerId: Scalars['ID'];
  accountStatus: RewardAccountStatus;
  providerAccountId: Scalars['ID'];
  lastUpdated?: Maybe<Scalars['DateTime']>;
  createdDate?: Maybe<Scalars['DateTime']>;
  rewardBalance?: Maybe<Array<RewardAccountBalance>>;
  dataset?: Maybe<Array<RewardAccountDataset>>;
};

export type RewardAccountBalance = {
  __typename?: 'RewardAccountBalance';
  /** Units of the account's balance */
  units?: Maybe<RewardAccountBalanceUnit>;
  /** The balance required to reach a reward level. */
  balanceToLevel?: Maybe<Scalars['String']>;
  balanceType?: Maybe<RewardAccountBalanceType>;
  balance: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  expiryDate?: Maybe<Scalars['Date']>;
  balanceToReward?: Maybe<Scalars['String']>;
};

export enum RewardAccountBalanceType {
  Balance = 'BALANCE',
  BalanceToLevel = 'BALANCE_TO_LEVEL',
  BalanceToReward = 'BALANCE_TO_REWARD',
  ExpiringBalance = 'EXPIRING_BALANCE',
  TotalBalance = 'TOTAL_BALANCE'
}

export enum RewardAccountBalanceUnit {
  Miles = 'MILES',
  Points = 'POINTS',
  Segments = 'SEGMENTS',
  Dollars = 'DOLLARS',
  Credits = 'CREDITS'
}

export type RewardAccountDataset = {
  __typename?: 'RewardAccountDataset';
  lastUpdated?: Maybe<Scalars['DateTime']>;
  nextUpdateScheduled?: Maybe<Scalars['DateTime']>;
  lastUpdateAttempt?: Maybe<Scalars['DateTime']>;
};

/** The status a reward account can be in */
export enum RewardAccountStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  ToBeClosed = 'TO_BE_CLOSED',
  Closed = 'CLOSED'
}

export type RewardCategoryCopyOverride = {
  __typename?: 'RewardCategoryCopyOverride';
  categoryName?: Maybe<Scalars['String']>;
  disclaimer?: Maybe<Scalars['String']>;
};

/** Compliance mandated overrides for specific cards */
export type RewardCategoryCopyOverrides = {
  __typename?: 'RewardCategoryCopyOverrides';
  dining?: Maybe<RewardCategoryCopyOverride>;
  entertainment?: Maybe<RewardCategoryCopyOverride>;
  gas?: Maybe<RewardCategoryCopyOverride>;
  groceries?: Maybe<RewardCategoryCopyOverride>;
  shopping?: Maybe<RewardCategoryCopyOverride>;
  travel?: Maybe<RewardCategoryCopyOverride>;
};

/** A rewards credit card that is owned by the current user, as reported by that user. */
export type RewardsCreditCard = {
  __typename?: 'RewardsCreditCard';
  /** The Marketplace UUID for a CreditCardOffer, lifted up */
  id: Scalars['ID'];
  /** The currently-active offer that pertains to the credit card *product* */
  offer: CreditCardOffer;
  /** The earning rates by category of this credit card */
  rewardCategoryRates?: Maybe<CreditCardOfferRewardCategoryRates>;
  /** Override data to display instead of default values for compliance reasons */
  categoryCopyOverrides?: Maybe<RewardCategoryCopyOverrides>;
};

/** The various components of a credit card recommendation */
export type RewardsCreditCardRecommendationDetails = {
  __typename?: 'RewardsCreditCardRecommendationDetails';
  /** The reward category of the recommended card */
  categoryType?: Maybe<CreditCardOfferRewardCategoryType>;
  /** The user's current card's legacy ID in this category */
  currentBestCardLegacyId: Scalars['Int'];
  /** The user's current card's best rate in this category */
  currentBestRate?: Maybe<Scalars['Float']>;
  /** The user's current card's reward type */
  currentBestRateUnit?: Maybe<CreditCardOfferRewardType>;
  /** The user's recommended card's best rate in this category */
  newBestRate?: Maybe<Scalars['Float']>;
  /** The user's recommended card's reward type in this category */
  newBestRateUnit?: Maybe<CreditCardOfferRewardType>;
  /** The user's 30 day average spending over the previous 90 days in this rewards category */
  categorySpendingAmount?: Maybe<Scalars['Float']>;
  /** The user's estimated +/- in rewards over two years for the recommended card */
  rewardIncrease?: Maybe<Scalars['Float']>;
  /** The amount of bonus points/miles/rewards a user can expect to receive if they meet signup bonus */
  qualifiedSigningBonusAmount?: Maybe<Scalars['Float']>;
  /** The currency of bonus points/miles/rewards a user can expect to receive if they meet signing bonus */
  qualifiedSigningBonusAmountType?: Maybe<CreditCardOfferRewardType>;
};

export enum RewardsCreditCardRecommendationType {
  All = 'ALL',
  Complementary = 'COMPLEMENTARY',
  Entertainment = 'ENTERTAINMENT',
  Dining = 'DINING',
  Gas = 'GAS',
  Groceries = 'GROCERIES',
  Travel = 'TRAVEL',
  Overall = 'OVERALL',
  Other = 'OTHER'
}

export type RewardsMutationSuccessResponse = {
  __typename?: 'RewardsMutationSuccessResponse';
  success: Scalars['Boolean'];
};

export type RewardsOffer = {
  __typename?: 'RewardsOffer';
  /** Amount, ex: '4.00%' */
  amountText?: Maybe<Scalars['String']>;
  /** Description */
  description?: Maybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type Roundup = ContentPageHeaderInterface & PostInterface & PostWithAuthorsInterface & PostWithContentClassificationInterface & PostWithExcerptInterface & PostWithFaQsInterface & PostWithFeaturedImageInterface & PostWithInternationalVersionsInterface & PostWithPageTaxonomyInterface & PostWithReviewerInterface & PostWithSeoInterface & PostWithTitleInterface & {
  __typename?: 'Roundup';
  /** The custom content to display above the Roundup sections. */
  aboveSections?: Maybe<Scalars['StructuredContentDocument']>;
  /** Marketplace Institutions to use affiliate logos from. */
  affiliateLogosInstitutions?: Maybe<Array<MarketplaceEntityInterface>>;
  /** Optional title to display above affiliate logos. */
  affiliateLogosTitle?: Maybe<Scalars['String']>;
  /** The assigning editor set on the content. */
  assigningEditor?: Maybe<Author>;
  /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
  attributionTopic?: Maybe<Scalars['String']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The content to display below the Roundup sections. */
  belowSections?: Maybe<Scalars['StructuredContentDocument']>;
  /** A list of Category objects on the Roundup object. */
  categories?: Maybe<Array<Category>>;
  /** Additional content clusters for this piece of content. */
  contentClusters?: Maybe<Array<Scalars['String']>>;
  /** The cross-sell category associated with this Roundup. Relevant only for Credit Card Roundups. */
  crossSellCcCategory?: Maybe<RoundupCrossSellCcCategoryEnum>;
  /** Marketplace named query to use on the cross sell comparison table on Marketing Roundups. */
  crossSellNamedQuery?: Maybe<Scalars['String']>;
  /** The source to use to populate cross sells on this Roundup. */
  crossSellSource?: Maybe<RoundupCrossSellSourceEnum>;
  /** The custom last modified date for the content. */
  customLastModifiedDate?: Maybe<Scalars['DateTime']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** The format to use when displaying the date. */
  dateDisplayFormat?: Maybe<DateDisplayFormatEnum>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The type driver group to configure for this roundup */
  driverGroup?: Maybe<RoundupDriverGroupEnum>;
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']>;
  /** The editorial excerpt of the resource. */
  excerpt?: Maybe<Scalars['String']>;
  /** Whether or not to include the number of Marketplace entities in the title. */
  excludeEntityCountFromTitle?: Maybe<Scalars['Boolean']>;
  /** The faqs to display on this piece of content. */
  faqs?: Maybe<Array<ContentFaq>>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** Posts to display in the footer of this Roundup. */
  footerPosts?: Maybe<Array<RoundupFooterPostsUnion>>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']>;
  /** Whether or not to split the product cards by category name. */
  hideCategoriesInProductCardsSection?: Maybe<Scalars['Boolean']>;
  /** Whether or not to hide the date for this piece of content. */
  hideDate?: Maybe<Scalars['Boolean']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** Whether or not to include the date in the SEO title. */
  includeDateInSeoTitle?: Maybe<Scalars['Boolean']>;
  /** Whether or not to include the date in the editorial title. */
  includeDateInTitle?: Maybe<Scalars['Boolean']>;
  includeExpandedProductDetails?: Maybe<Scalars['Boolean']>;
  /** The insurance component to use on the Roundup. */
  insuranceComponent?: Maybe<Scalars['StructuredContentDocument']>;
  /** Information about alternate versions of the content that exist for other locales. */
  internationalVersions?: Maybe<Array<InternationalVersion>>;
  /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
  isArchivesEligible?: Maybe<Scalars['Boolean']>;
  /** Whether or not to prevent this piece of content from being recommended to users. */
  isRecommendationEligible?: Maybe<Scalars['Boolean']>;
  /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
  isSearchEligible?: Maybe<Scalars['Boolean']>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The Marketplace product type. */
  marketplaceProductType?: Maybe<MarketplaceProductTypeEnum>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  numProductCardsToExpand?: Maybe<Scalars['Int']>;
  /** Whether to override the last modified date for the content using one of the available options. */
  overrideLastModifiedDateWithCurrentDate?: Maybe<OverrideLastModifiedDateEnum>;
  /** Page taxonomy data. This array is designed to be passed directly to GMS. See https://github.com/NerdWallet/global-markup/tree/b3af4e1f2c68485514145ff31b9137d619e910e1#v2-options */
  pageTaxonomy?: Maybe<Scalars['JSON']>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']>;
  /** The primary category object for the content. */
  primaryCategory?: Maybe<Category>;
  /** The primary content cluster for this piece of content. */
  primaryContentCluster?: Maybe<Scalars['String']>;
  /** A date after which this content should no longer be recommended. */
  recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']>;
  /** The reviewers that this Roundup has been reviewed by. */
  reviewedBy?: Maybe<Array<ContentReviewer>>;
  /** The ordered, augmented Roundup product sections to display on this Roundup. */
  roundupSections?: Maybe<Array<RoundupSection>>;
  /** The type of roundup this piece of content is. */
  roundupType?: Maybe<RoundupTypeEnum>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** Whether or not to display the FAQ's. */
  showFaqs?: Maybe<Scalars['Boolean']>;
  /** Whether or not to display the CTA at the bottom of the Roundup. */
  showFooterCta?: Maybe<Scalars['Boolean']>;
  /** Whether or not to display the CTA at the top of the Roundup. */
  showIntroCta?: Maybe<Scalars['Boolean']>;
  /** Whether or not to show the last modified date. */
  showLastModifiedDate?: Maybe<Scalars['Boolean']>;
  /** Whether or not to disable the Personal Recommendation Banner in the Roundup. */
  showPersRecsBanner?: Maybe<Scalars['Boolean']>;
  /** Whether or not to show the summary table. */
  showSummaryTable?: Maybe<Scalars['Boolean']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The quick facts to use in the summary list for banking roundups. */
  summaryListQuickFacts?: Maybe<Array<RoundupSummaryListQuickFactsEnum>>;
  /** The custom title to display for the Summary List on this Roundup. */
  summaryListTitle?: Maybe<Scalars['String']>;
  /** The choice for the behavior of the summary table positioning. */
  summaryTablePosition?: Maybe<RoundupSummaryTablePositionEnum>;
  /** The content to display below the title of a piece of content. */
  synopsis?: Maybe<Scalars['StructuredContentDocument']>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
  /** Whether or not to use ALPS for ordering the roundup sections. */
  useAlpOrderingForSections?: Maybe<Scalars['Boolean']>;
  /** Whether or not to use a custom last modified date for this piece of content. */
  useCustomLastModifiedDate?: Maybe<Scalars['Boolean']>;
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']>>;
  /** Roundup sections to display in the Additional Recommendations section of the roundup */
  additionalRecommendations?: Maybe<Array<RoundupSection>>;
  /** Type of advertiser disclosure to display (default credit_cards) */
  advertiserDisclosureType: Scalars['String'];
  /** Type of article, which will determine what (if any) additional editorial standards message to display. */
  editorialDisclaimerType?: Maybe<Scalars['String']>;
  /** The Breadcrumb to display on a Roundup */
  breadcrumb?: Maybe<Breadcrumb>;
  /** Contains display information for the cross sell section of a roundup */
  crossSellSection?: Maybe<RoundupCrossSellDetails>;
  /**
   * The DateTime in UTC to display for the roundup based on flags, custom dates,
   * and Marketplace entities set on the roundup
   */
  displayDate?: Maybe<Scalars['String']>;
  /**
   * Returns a JSON object containing entity counts keyed by location.
   * The "none" key will be used to indicate entities that are not localized.
   */
  entityCountByLocation: Scalars['JSON'];
  /** Eyebrow header text for a roundup. */
  eyebrowText?: Maybe<Scalars['String']>;
  /** Boolean flag to indicate if the roundup has local offers to display */
  hasLocalOffers: Scalars['Boolean'];
  /** The vertical-specific methodology to display for the roundup */
  methodology?: Maybe<Scalars['StructuredContentDocument']>;
  /** The model execution ids used for ALPS ordering */
  modelExecutionIds?: Maybe<Array<Scalars['String']>>;
  /** Contains display information for the product cards section of a roundup */
  productCardsSection: RoundupProductCardsDetails;
  /**
   * The deduped list of raw marketplace entities that are eligible to be displayed on the page.
   *   - exists
   *   - active
   *   - contains the appropriate display page
   * Includes localized entities that will need to be filtered in the client.
   * TODO: replace with GraphQL Marketplace V2 Entities
   * @deprecated Use entityCountByLocation to determine title count instead
   */
  rawMarketplaceEntitiesDisplayedOnPage?: Maybe<Array<Scalars['JSON']>>;
  /** Contains display information for the recap list section of a roundup */
  recapListSection: RecapListDetails;
  /** Boolean flag that determines if the first product card's details should be expanded on page load */
  shouldExpandFirstProductCard: Scalars['Boolean'];
  /** Boolean flag that determines if the CTA should be omitted throughout the roundup */
  shouldOmitCta: Scalars['Boolean'];
  /** Boolean flag that determines if ratings should be omitted throughout the roundup */
  shouldOmitRating: Scalars['Boolean'];
  /** Boolean flag to show/hide the advertiser disclosure in the page header */
  showAdvertiserDisclosure: Scalars['Boolean'];
  /** Boolean flag to show/hide author byline in the page header */
  showAuthorByline: Scalars['Boolean'];
  /** Boolean flag to show/hide editorial disclaimer in the page header */
  showEditorialDisclaimer: Scalars['Boolean'];
  /** The marketplace entity to display in the SMB aggregator partnership banner */
  smbAggregatorPartnershipEntity?: Maybe<MarketplaceEntityInterface>;
  /** Contains display information for the summary table section of a roundup */
  summaryTableSection: RoundupSummaryTableDetails;
  /** Ordered template sections for a roundup. */
  templateSections?: Maybe<Array<RoundupTemplateSectionTypeEnum>>;
  /**
   * The page title without the entity count. This is meant to be used for
   * pages with localized entities.
   */
  titleWithoutEntityCount: Scalars['String'];
  /** The title that is displayed above either the product cards or the summary table. */
  sectionTitle: Scalars['String'];
};


/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupExcerptArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};


/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupRoundupSectionsArgs = {
  abTestBankingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestCCPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestDeviceTypePhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestInvestingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  isDesktopUserAgent?: InputMaybe<Scalars['Boolean']>;
};


/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};


/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupAdditionalRecommendationsArgs = {
  abTestCCPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestBankingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestInvestingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestDeviceTypePhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  isDesktopUserAgent?: InputMaybe<Scalars['Boolean']>;
};


/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupDisplayDateArgs = {
  format?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupModelExecutionIdsArgs = {
  abTestCCPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestBankingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestInvestingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestDeviceTypePhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  isDesktopUserAgent?: InputMaybe<Scalars['Boolean']>;
};


/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupShouldExpandFirstProductCardArgs = {
  isDesktopUserAgent?: InputMaybe<Scalars['Boolean']>;
};


/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupTemplateSectionsArgs = {
  abTestBmlRedesignIsActive?: InputMaybe<Scalars['Boolean']>;
};

/** Describes a category that contains a group of roundup sections to display */
export type RoundupCategorySection = {
  __typename?: 'RoundupCategorySection';
  /** The eyebrow text that prepends the category title in the Product Cards section of a roundup */
  eyebrowText?: Maybe<Scalars['String']>;
  /** The name of the roundup category to be displayed in the Product Cards section of a roundup */
  title?: Maybe<Scalars['String']>;
  /** The description of the roundup category to be displayed in the Product Cards section of a roundup */
  description?: Maybe<Scalars['String']>;
  /** The list of product cards to display for this roundup category */
  productCards?: Maybe<Array<RoundupSection>>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type RoundupConnectionResponse = {
  __typename?: 'RoundupConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The Roundup returned for the connection. */
  items?: Maybe<Array<Roundup>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Enum values for crossSellCcCategory field on Roundup type. */
export enum RoundupCrossSellCcCategoryEnum {
  AirlineCreditCards = 'AIRLINE_CREDIT_CARDS',
  BadCreditCards = 'BAD_CREDIT_CARDS',
  BalanceTransferCreditCards = 'BALANCE_TRANSFER_CREDIT_CARDS',
  CashRewardsCreditCards = 'CASH_REWARDS_CREDIT_CARDS',
  HotelCreditCards = 'HOTEL_CREDIT_CARDS',
  None = 'NONE',
  StudentCreditCards = 'STUDENT_CREDIT_CARDS',
  TravelMilesCreditCards = 'TRAVEL_MILES_CREDIT_CARDS'
}

/** Describes the details of the cross sell section of a roundup */
export type RoundupCrossSellDetails = {
  __typename?: 'RoundupCrossSellDetails';
  productCards?: Maybe<Array<RoundupCrossSellSection>>;
  subtext: Scalars['String'];
};

/** Describes a card in the roundup's cross sell section */
export type RoundupCrossSellSection = {
  __typename?: 'RoundupCrossSellSection';
  /** The tracking params that should be appended to this cross sell section's marketplace entity's CTA */
  ctaTrackingParams?: Maybe<Array<TrackingParam>>;
  /** The marketplace entity associated with this cross sell section */
  marketplaceEntity: MarketplaceEntityInterface;
  /**
   * The raw marketplace entity for this cross sell section
   * TODO: replace with a proper marketplaceEntity schema
   */
  rawMarketplaceEntity: Scalars['JSON'];
  /**
   * The drivers to display for this marketplaceEntity's product card when drivers
   * are defined, i.e for Credit Card Roundups
   * Returns null when there are no specific drivers defined
   */
  drivers?: Maybe<Array<EntityPlacementDriver>>;
};

/** Enum values for crossSellSource field on Roundup type. */
export enum RoundupCrossSellSourceEnum {
  CcRecs = 'CC_RECS',
  Default = 'DEFAULT',
  NamedQuery = 'NAMED_QUERY',
  SpecificEntities = 'SPECIFIC_ENTITIES'
}

/** Enum values for driverGroup field on Roundup type. */
export enum RoundupDriverGroupEnum {
  BalanceTransfer = 'BALANCE_TRANSFER',
  Default = 'DEFAULT',
  Rewards = 'REWARDS'
}

/** Query to fetch a collection of Roundup objects. */
export type RoundupFilterInput = {
  /** Limit collection to Roundups published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to Roundups within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']>>;
  /** Limit results to those with the specified cluster. */
  cluster?: InputMaybe<Scalars['String']>;
  /** Limit results to those with the specified Assigning Editor, filtered by ID. */
  editorIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Limit collection to Roundups with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']>;
  /** Limit results to those with the specified Reviewer, filtered by ID. */
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Limit collection to Roundups with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

/** The union containing the Type members that can be returned by the footerPosts field on the Roundup type. */
export type RoundupFooterPostsUnion = Article | Page | Post | Roundup;

/** Describes the details of the product cards section of a roundup */
export type RoundupProductCardsDetails = {
  __typename?: 'RoundupProductCardsDetails';
  /** The list of category sections to display in the Product Cards Section */
  categorySections?: Maybe<Array<RoundupCategorySection>>;
  /** The title to use for the product cards section. */
  title?: Maybe<Scalars['String']>;
  /** The content tabs to display within the product cards. */
  contentTabs?: Maybe<Array<ProductCardContentTabEnum>>;
};


/** Describes the details of the product cards section of a roundup */
export type RoundupProductCardsDetailsCategorySectionsArgs = {
  abTestCCPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestBankingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestInvestingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestDeviceTypePhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestCCEPCProductOrderingIsActive?: InputMaybe<Scalars['Boolean']>;
  abTestBmlRedesignIsActive?: InputMaybe<Scalars['Boolean']>;
  abTestCCGeotargeting?: InputMaybe<GeotargetingAbTestInput>;
  isDesktopUserAgent?: InputMaybe<Scalars['Boolean']>;
};


/** Describes the details of the product cards section of a roundup */
export type RoundupProductCardsDetailsContentTabsArgs = {
  isDesktopUserAgent?: InputMaybe<Scalars['Boolean']>;
};

/** Type modeling the data within the roundupSections group of fields on the Roundup type. */
export type RoundupSection = {
  __typename?: 'RoundupSection';
  /** The benefits of this product. */
  benefits?: Maybe<Scalars['StructuredContentDocument']>;
  /** The category description for the Roundup category. */
  categoryDescription?: Maybe<Scalars['String']>;
  /** The name of the Roundup category within this section. */
  categoryName?: Maybe<Scalars['String']>;
  /** Where to link the CTA to. */
  ctaDestination?: Maybe<Scalars['String']>;
  /** The custom URL to use for linking to a review. */
  customReviewUrl?: Maybe<Scalars['URL']>;
  /** The drawbacks of this product. */
  drawbacks?: Maybe<Scalars['StructuredContentDocument']>;
  /** The Marketplace Entity type. */
  entityType?: Maybe<MarketplaceEntityTypeEnum>;
  /** The Marketplace entity to use for one year APY on CD Roundups. */
  fiveYearApyEntity?: Maybe<MarketplaceEntityInterface>;
  /** The Marketplace entity to use for one year APY on CD Roundups. */
  fiveYearApyId?: Maybe<Scalars['String']>;
  /** The lender associated with the roundup. */
  legacyLender?: Maybe<LegacyLender>;
  /** The Marketplace entity UUID. */
  marketplaceEntity?: Maybe<MarketplaceEntityInterface>;
  /** The Marketplace entity UUID. */
  marketplaceEntityId?: Maybe<Scalars['String']>;
  /** The Marketplace entity to use for one year APY on CD Roundups. */
  oneYearApyEntity?: Maybe<MarketplaceEntityInterface>;
  /** The Marketplace entity to use for one year APY on CD Roundups. */
  oneYearApyId?: Maybe<Scalars['String']>;
  /** The Marketplace product type. */
  productType?: Maybe<MarketplaceProductTypeEnum>;
  /** Whether or not to display this roundup section in more options instead of a product card. */
  showInAdditionalRecommendations?: Maybe<Scalars['Boolean']>;
  /** The Marketplace entity to use for one year APY on CD Roundups. */
  threeYearApyEntity?: Maybe<MarketplaceEntityInterface>;
  /** The Marketplace entity to use for one year APY on CD Roundups. */
  threeYearApyId?: Maybe<Scalars['String']>;
  /**
   * The text to show in the Why We Like It section of a product card. Overrides
   * the bottomLine provided by the Marketplace Entity.
   */
  bottomLine?: Maybe<Scalars['StructuredContentDocument']>;
  /** The list of cons that will override this roundup section's marketplace entity's cons */
  cons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** The CTA that will override this roundup section's marketplace entity's CTA */
  cta?: Maybe<EntityPlacementCta>;
  /** The tracking params that should be appended to this roundup section's marketplace entity's CTA */
  ctaTrackingParams?: Maybe<Array<TrackingParam>>;
  /**
   * The driver group for a Product Card that will override this roundup section's default drivers
   * TODO: (SHOP-13277) After the Product Cards have been updated to accept drivers return override
   *   drivers directly instead of a group
   * @deprecated This field is only used while we migrate to using the drivers field.
   */
  driverGroup?: Maybe<Scalars['String']>;
  /** The driver overrides for a given roundup section. */
  drivers?: Maybe<Array<EntityPlacementDriver>>;
  /** Boolean flag to indicate if model execution id should be excluded from impressions for this roundup section. */
  excludeModelExecutionIds: Scalars['Boolean'];
  /** The "key facts: for this roundup section. */
  keyFacts?: Maybe<Scalars['StructuredContentDocument']>;
  /** The product card Component to use for this roundup section */
  productCardComponent: ProductCardComponentEnum;
  /** The "product details" for this roundup section. */
  productDetails?: Maybe<Scalars['StructuredContentDocument']>;
  /** The list of pros that will override this roundup section's marketplace entity's pros */
  pros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /**
   * The description to show in the recap list for this roundup section - Note that this
   * field should only be used as a child of 'recapListSection.recapItems'
   */
  recapDescription?: Maybe<Scalars['String']>;
  /** Boolean flag to indicate if the "Add to Compare" button should be enabled */
  shouldEnableAddToCompare: Scalars['Boolean'];
  /** Boolean flag to indicate if the images should lazy load for this roundup section */
  shouldEnableImageLazyLoad: Scalars['Boolean'];
};


/** Type modeling the data within the roundupSections group of fields on the Roundup type. */
export type RoundupSectionDriversArgs = {
  driversVariant?: InputMaybe<DriversVariationTypeEnum>;
};


/** Type modeling the data within the roundupSections group of fields on the Roundup type. */
export type RoundupSectionProductCardComponentArgs = {
  isDesktopUserAgent?: InputMaybe<Scalars['Boolean']>;
};

/** Enum values for summaryListQuickFacts field on Roundup type. */
export enum RoundupSummaryListQuickFactsEnum {
  Apy = 'APY',
  Bonus = 'BONUS',
  Default = 'DEFAULT',
  MinimumBalance = 'MINIMUM_BALANCE',
  MonthlyFee = 'MONTHLY_FEE',
  OutOfNetworkAtmFee = 'OUT_OF_NETWORK_ATM_FEE'
}

/** Describes the details of the summary table section of a roundup */
export type RoundupSummaryTableDetails = {
  __typename?: 'RoundupSummaryTableDetails';
  /** Whether to enable row truncation behavior */
  allowTruncatingRows: Scalars['Boolean'];
  /** Text to be added at the bottom of the summary table */
  disclaimerText?: Maybe<Scalars['String']>;
  /** Title that should be used as the header for each marketplace entity */
  marketplaceEntityHeader: Scalars['String'];
  /** The maximum number of rows that can be present before any truncation can be applied */
  maxRows: Scalars['Int'];
  /** The number of rows to show after applying truncation */
  numTruncatedRows: Scalars['Int'];
  /** The rows within the summary table */
  rows?: Maybe<Array<RoundupSection>>;
  /** The title to use for the Summary Table Section */
  title: Scalars['String'];
};


/** Describes the details of the summary table section of a roundup */
export type RoundupSummaryTableDetailsRowsArgs = {
  abTestCCPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestBankingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestInvestingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestDeviceTypePhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestCCEPCProductOrderingIsActive?: InputMaybe<Scalars['Boolean']>;
  abTestCCGeotargeting?: InputMaybe<GeotargetingAbTestInput>;
  isDesktopUserAgent?: InputMaybe<Scalars['Boolean']>;
};

/** Enum values for summaryTablePosition field on Roundup type. */
export enum RoundupSummaryTablePositionEnum {
  AboveProductCards = 'ABOVE_PRODUCT_CARDS',
  BelowProductCards = 'BELOW_PRODUCT_CARDS',
  Default = 'DEFAULT'
}

/** Types of TemplateSections for a Roundup. */
export enum RoundupTemplateSectionTypeEnum {
  Header = 'HEADER',
  Insurance = 'INSURANCE',
  RecapWithAccordion = 'RECAP_WITH_ACCORDION',
  IntroContent = 'INTRO_CONTENT',
  GeodataDropdown = 'GEODATA_DROPDOWN',
  SummaryTablePretty = 'SUMMARY_TABLE_PRETTY',
  ProductCards = 'PRODUCT_CARDS',
  SmbAggregatorPartnership = 'SMB_AGGREGATOR_PARTNERSHIP',
  LearnContent = 'LEARN_CONTENT',
  CrossSellModule = 'CROSS_SELL_MODULE',
  UpdatedDate = 'UPDATED_DATE',
  Methodology = 'METHODOLOGY',
  Recap = 'RECAP',
  Faq = 'FAQ',
  AuthorBox = 'AUTHOR_BOX',
  FooterPosts = 'FOOTER_POSTS',
  CompareBar = 'COMPARE_BAR',
  SideBySideCompare = 'SIDE_BY_SIDE_COMPARE'
}

/** Enum values for roundupType field on Roundup type. */
export enum RoundupTypeEnum {
  MarketingRoundup = 'MARKETING_ROUNDUP',
  OrganicRoundup = 'ORGANIC_ROUNDUP'
}

/** Saved personal loans prequal offers include expanded marketplace offers, expanded marketplace static offers, and prequal offers */
export type SavedPersonalLoansPrequalOffers = {
  __typename?: 'SavedPersonalLoansPrequalOffers';
  /**
   * API offers include prequal, high interest, and conditional offers
   * @deprecated Use sortedPrequalOffers.
   */
  apiOffers: Array<PrequalPersonalLoansApiOffer>;
  /**
   * List of Best Bets offers (offers that are likely the best for the user),
   * containing the offer with the lowest APR and the offer with the lowest monthly payment.
   * @deprecated Use the bestBets field on PrequalPersonalLoansApiOffer within sortedPrequalOffers.
   */
  bestBetsOffers?: Maybe<BestBetsOffersResponse>;
  /** Expanded marketplace offers are displayed to the user if they do not prequalify for any offers; one provider may offer multiple expanded marketplace offers */
  expandedMarketplaceOffers: Array<PersonalLoansOfferV2>;
  /** Expanded marketplace static offers are displayed to the user if they do not prequalify for any offers; one provider will only offer one static offer */
  expandedMarketplaceStaticOffers: Array<ExpandedMarketplaceStaticOffer>;
  /** Set to true if there is at least one prequalified offer the user is qualified for; this is false otherwise */
  hasPrequalifiedOffers: Scalars['Boolean'];
  /** Flag indicating if the user is prequalified for personal loans offers */
  isUserPrequalified: Scalars['Boolean'];
  /** List of personal loans providers */
  providers: Array<Provider>;
  /**
   * PENDING RENAME: Misnomer as sorting is not done here.
   * A prequalified user's offers.
   */
  sortedPrequalOffers: Array<PrequalPersonalLoansApiOffer>;
  /** Personal loan amount requested by the user */
  requestedLoanAmount: Scalars['Float'];
};

export type SavingsAccountInstitution = InstitutionInterface & {
  __typename?: 'SavingsAccountInstitution';
  canonicalInstitutionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
};

export type SavingsAccountOffer = OfferInterface & AccountOfferInterface & {
  __typename?: 'SavingsAccountOffer';
  endsAt?: Maybe<Scalars['DateTime']>;
  applyLink?: Maybe<Scalars['URL']>;
  apy?: Maybe<Scalars['Float']>;
  institution?: Maybe<SavingsAccountInstitution>;
  details?: Maybe<SavingsAccountOfferDetails>;
  imageUrl?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Float']>;
  reviewUrl?: Maybe<Scalars['String']>;
  providerName?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
  productId?: Maybe<Scalars['ID']>;
  isMonetizing?: Maybe<Scalars['Boolean']>;
};

export type SavingsAccountOfferDetails = {
  __typename?: 'SavingsAccountOfferDetails';
  /** Names of the award badge names this offer won in 2020. */
  bestOfBadgeWinner2020?: Maybe<Array<Scalars['String']>>;
  /** Names of the award badge names this offer won in 2021. */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']>>;
};

export type SavingsAccountOffersByNamedQueryResponse = {
  __typename?: 'SavingsAccountOffersByNamedQueryResponse';
  offers?: Maybe<Array<SavingsAccountOffer>>;
};

export type SearchServiceContentSearchResults = {
  __typename?: 'SearchServiceContentSearchResults';
  /** The facets from the search result, see 'Facets' */
  facets?: Maybe<Facets>;
  /** A list of related content given the parameters of ContentSearchInput */
  searchResults?: Maybe<Array<PostInterface>>;
  /** The current offset in results */
  offset?: Maybe<Scalars['Int']>;
  /** The total number of related content */
  total: Scalars['Int'];
};


export type SearchServiceContentSearchResultsSearchResultsArgs = {
  sortDir?: InputMaybe<ContentSortDirection>;
};

export type SecurityQuestionInfoInput = {
  /** The user's security question */
  question: Scalars['String'];
  /** The user's answer to their security question */
  answer: Scalars['String'];
};

export type SendResetPasswordEmailInfoInput = {
  /** The email used to send the password reset */
  email: Scalars['EmailAddress'];
};

export type SeoSettings = {
  __typename?: 'SeoSettings';
  /** The meta description for the content, used for SEO purposes. */
  description?: Maybe<Scalars['String']>;
  /** The custom JSON-LD schema to add to the existing JSON-LD generated for the content. */
  extraJsonLd?: Maybe<Scalars['JSON']>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  facebook?: Maybe<SocialSeoSettings>;
  /** The focus keyword for the content, used for SEO purposes. */
  keyword?: Maybe<Scalars['String']>;
  /** Whether to instruct search engines like Google to not follow links in this content. */
  nofollow?: Maybe<Scalars['Boolean']>;
  /** Whether or not the content should be indexed in search engines like Google. */
  noindex?: Maybe<Scalars['Boolean']>;
  /** The meta title for the content, used for SEO purposes. */
  title?: Maybe<Scalars['String']>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  twitter?: Maybe<SocialSeoSettings>;
  /** @deprecated This field is no longer backed by a value within the WordPress API, please use the 'link' field on the parent Type instead. */
  canonical?: Maybe<Scalars['URL']>;
};

export type SimulateCreditScoreResponse = {
  __typename?: 'SimulateCreditScoreResponse';
  /** The simulated credit score when adding child support */
  addChildSupportResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when adding a foreclosure */
  addForeclosureResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when adding a tax lien */
  addTaxLienResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when adding wage garnishment */
  addWageGarnishmentResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when all accounts are past due for a number of days */
  allAccountsPastDueNumDaysResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when applying for a number of credit cards */
  applyForNumberOfCreditCardResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when closing the oldest credit card */
  closeOldestCreditCardResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when decreasing the credit card balance amount */
  decreaseCreditBalanceAmountResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when increasing the credit balance amount */
  increaseCreditBalanceAmountResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when increasing the credit card limit */
  increaseCreditCardLimitResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when moving one account into collection */
  moveOneAccountIntoCollectionResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when obtaining an auto loan limit */
  obtainAutoLoanLimitResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when obtaining a credit card limit */
  obtainCreditCardLimitResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when obtaining a mortgage limit */
  obtainMortgageLimitResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when obtaining a personal loan limit */
  obtainPersonalLoanLimitResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when making on time payments for a number of months */
  onTimePaymentsNumMonthsResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when one account is past due for a number of days */
  oneAccountPastDueNumDaysResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when paying off all credit cards */
  payOffAllCreditCardsResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when transferring a credit balance amount */
  transferCreditBalanceAmountResult?: Maybe<Scalars['Int']>;
};

/** The info banner details derived from the feature flag payload, all fields required */
export type SitewideInfoBannerDetails = {
  __typename?: 'SitewideInfoBannerDetails';
  bannerName: Scalars['String'];
  btnText: Scalars['String'];
  copy: Scalars['String'];
  link: Scalars['URL'];
  title: Scalars['String'];
};

export type SitewideInfoBannerResponse = {
  __typename?: 'SitewideInfoBannerResponse';
  isEnabled: Scalars['Boolean'];
  details?: Maybe<SitewideInfoBannerDetails>;
};

/** A Small Medium Business Loans institution */
export type SmallMediumBusinessLoansInstitutionV2 = MarketplaceEntityInterface & MarketplaceInstitutionInterface & {
  __typename?: 'SmallMediumBusinessLoansInstitutionV2';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** A URL that points to the logo for the institution */
  imageSource?: Maybe<Scalars['URL']>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

/** A Small Medium Business Loans offer */
export type SmallMediumBusinessLoansOfferV2 = MarketplaceEntityInterface & MarketplaceEntityWithBestOfAwardsInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithQualificationsInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceOfferInterface & {
  __typename?: 'SmallMediumBusinessLoansOfferV2';
  /** Redirect link for this Offer */
  applyLink?: Maybe<Scalars['URL']>;
  /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  consBullets?: Maybe<Array<Scalars['String']>>;
  /** The display name for the entity (auto-generated) */
  displayName?: Maybe<Scalars['String']>;
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /** Whether this Offer is monetizing. Client apps use this field to decide display behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA */
  isMonetizing?: Maybe<Scalars['Boolean']>;
  /** Maximum loan amount (i.e., $5,000,000 is entered as 5000000) */
  maxLoanAmount?: Maybe<Scalars['Float']>;
  /** Maximum loan term in months (i.e., 5 years is entered as 60) */
  maxLoanTerm?: Maybe<Scalars['Int']>;
  /** Minimum loan term in months (i.e., 5 years is entered as 60) */
  minLoanTerm?: Maybe<Scalars['Int']>;
  /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
  monetizable: Scalars['String'];
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  product: SmallMediumBusinessLoansProductV2;
  /** Use this if the product has any notable features you want to highlight on the product card */
  productLabel?: Maybe<Scalars['String']>;
  /** Product type */
  productType: Scalars['String'];
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  prosBullets?: Maybe<Array<Scalars['String']>>;
  /** List of qualifications for the offer */
  qualificationsBullets?: Maybe<Array<Scalars['String']>>;
  /** The URL to the NerdWallet review of this offer. */
  reviewLink?: Maybe<Scalars['URL']>;
  /** Speed to funding duration value */
  speedToFunding?: Maybe<Scalars['Int']>;
  /** Speed to funding duration type */
  speedToFundingDuration?: Maybe<Scalars['String']>;
  /** The overall editorial rating for this offer */
  starRating?: Maybe<Scalars['Float']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  tagline?: Maybe<Scalars['String']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The Best Of Awards that this offer has won */
  bestOfAwards?: Maybe<Array<BestOfAward>>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The driver estimated apr associated with the entity */
  driverEstimatedApr?: Maybe<EntityPlacementDriver>;
  /** The driver min credit score associated with the entity */
  driverMinCreditScore?: Maybe<EntityPlacementDriver>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /**
   * The drivers associated with the entity
   * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
   */
  placementDrivers: Array<EntityPlacementDriver>;
  /** A boolean indicating if the display name should be shown in the comparison table component */
  showNameInComparisonTable: Scalars['Boolean'];
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']>;
  /** Flag for whether to use the large product card image styles */
  useLargeImageFootprint: Scalars['Boolean'];
};

/** A Small Medium Business Loans product */
export type SmallMediumBusinessLoansProductV2 = MarketplaceEntityInterface & MarketplaceProductInterface & {
  __typename?: 'SmallMediumBusinessLoansProductV2';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  institution: SmallMediumBusinessLoansInstitutionV2;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

export type SmbArticlePage = StructuredContentPageInterface & {
  __typename?: 'SmbArticlePage';
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID'];
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
};

export type SocialSeoSettings = {
  __typename?: 'SocialSeoSettings';
  /** The description for the content as it should appear when this content is shared on Facebook. */
  description?: Maybe<Scalars['String']>;
  /** The title for the content as it should appear when this content is shared on Facebook. */
  title?: Maybe<Scalars['String']>;
  /** @deprecated This field is no longer backed by a value within the WordPress API, please use the 'featuredMedia' field on the parent Type instead. */
  image?: Maybe<Scalars['URL']>;
};

/** A Software institution */
export type SoftwareInstitutionV2 = MarketplaceEntityInterface & MarketplaceInstitutionInterface & {
  __typename?: 'SoftwareInstitutionV2';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** A URL that points to the logo for the institution */
  imageSource?: Maybe<Scalars['URL']>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

/** A Software offer */
export type SoftwareOfferV2 = MarketplaceEntityInterface & MarketplaceEntityWithBestOfAwardsInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceOfferInterface & {
  __typename?: 'SoftwareOfferV2';
  applyLink?: Maybe<Scalars['URL']>;
  /** Cons for the offer. */
  consBullets?: Maybe<Array<Scalars['String']>>;
  /** Text presented as part of CTA */
  ctaText?: Maybe<Scalars['String']>;
  /** The display name for the entity */
  displayName?: Maybe<Scalars['String']>;
  /** Entity type */
  entityType: Scalars['String'];
  /** The cost of any hardware the offer requires. */
  hardwareCost?: Maybe<Scalars['Float']>;
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /** Used to determine if placement is monetizing. */
  isMonetizing?: Maybe<Scalars['Boolean']>;
  /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
  monetizable: Scalars['String'];
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  /** The processing fees charged by the payment provider. */
  paymentsCost?: Maybe<Scalars['String']>;
  /** Additional context on the processing fees charged by the payment provider. */
  paymentsDetails?: Maybe<Scalars['String']>;
  product: SoftwareProductV2;
  /** Product type */
  productType: Scalars['String'];
  /** Pros for the offer. */
  prosBullets?: Maybe<Array<Scalars['String']>>;
  /** The URL to the NerdWallet review of this offer. */
  reviewLink?: Maybe<Scalars['URL']>;
  /** The cost of any required software subscription. */
  softwareCost?: Maybe<Scalars['Float']>;
  /** The overall editorial rating for this Offer. */
  starRating?: Maybe<Scalars['Float']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
  /** Product description. */
  tagline?: Maybe<Scalars['String']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The Best Of Awards that this offer has won */
  bestOfAwards?: Maybe<Array<BestOfAward>>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The driver price associated with the entity */
  driverPrice?: Maybe<EntityPlacementDriver>;
  /** The driver bonus associated with the entity */
  driverBonus?: Maybe<EntityPlacementDriver>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /**
   * The drivers associated with the entity
   * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
   */
  placementDrivers: Array<EntityPlacementDriver>;
  /** A boolean indicating if the display name should be shown in the comparison table component */
  showNameInComparisonTable: Scalars['Boolean'];
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']>;
  /** Flag for whether to use the large product card image styles */
  useLargeImageFootprint: Scalars['Boolean'];
};

/** A Software product */
export type SoftwareProductV2 = MarketplaceEntityInterface & MarketplaceProductInterface & {
  __typename?: 'SoftwareProductV2';
  /** Essentially helps create a sub vertical. */
  category?: Maybe<Scalars['String']>;
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  institution: SoftwareInstitutionV2;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

export type SpendingByMonthsDataVisualization = UserInsightDataVisualizationInterface & {
  __typename?: 'SpendingByMonthsDataVisualization';
  /** This will always be SPENDING_BY_MONTHS */
  dataVisualizationType: UserInsightDataVisualizationTypeEnum;
  /**
   * The user's total spending on each day of the current month to the current date, and each day of the _previous_
   * month (e.g. if today is 6/17, this field would include spending data for 5/1-5/30 and 6/1-6/17).
   *
   * Note that SpendingByMonthsDataVisualization utilizes the same type as the existing manifestation of this data
   * visualization in the Cash Flow product experience.
   */
  spendingByDateForTargetAndPriorMonthToDate: FinancialTransactionsSpendingByDayOfTheMonthForMonth;
};


export type SpendingByMonthsDataVisualizationSpendingByDateForTargetAndPriorMonthToDateArgs = {
  effectiveDate?: InputMaybe<Scalars['String']>;
};

export type SpendingByTopCategoriesDataVisualization = UserInsightDataVisualizationInterface & {
  __typename?: 'SpendingByTopCategoriesDataVisualization';
  /** This will always be SPENDING_BY_TOP_CATEGORIES */
  dataVisualizationType: UserInsightDataVisualizationTypeEnum;
  /**
   * The user's top spending categories for the current month, to date.
   *
   * Note that SpendingByTopCategoriesDataVisualization utilizes the same type as the existing manifestation of this data
   * visualization in the Cash Flow product experience.
   */
  topCategoriesBySpending: FinancialTransactionsTopCategoriesBySpending;
};


export type SpendingByTopCategoriesDataVisualizationTopCategoriesBySpendingArgs = {
  effectiveDate?: InputMaybe<Scalars['String']>;
};

export enum StateAbbreviationsEnum {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY'
}

/** A valid US State Code */
export enum StateCodeEnum {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  As = 'AS',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Gu = 'GU',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Pr = 'PR',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vi = 'VI',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY'
}

/** The `StatementIndexedFeedItem` type represents a generically typed item in the user's feed. */
export type StatementIndexedFeedItem = {
  __typename?: 'StatementIndexedFeedItem';
  statement: FeedStatement;
  cards: Array<FeedCard>;
};

/** Type modeling the data for posts within the nw_calculator post type from WordPress. */
export type StructuredContentCalculator = PostInterface & PostWithAuthorsInterface & PostWithContentClassificationInterface & PostWithTitleInterface & {
  __typename?: 'StructuredContentCalculator';
  /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
  attributionTopic?: Maybe<Scalars['String']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the StructuredContentCalculator object. */
  categories?: Maybe<Array<Category>>;
  /** The config JSON for the calculator. */
  config?: Maybe<Scalars['JSON']>;
  /** Additional content clusters for this piece of content. */
  contentClusters?: Maybe<Array<Scalars['String']>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']>;
  /** The primary content cluster for this piece of content. */
  primaryContentCluster?: Maybe<Scalars['String']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']>>;
};


/** Type modeling the data for posts within the nw_calculator post type from WordPress. */
export type StructuredContentCalculatorDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_calculator post type from WordPress. */
export type StructuredContentCalculatorModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_calculator post type from WordPress. */
export type StructuredContentCalculatorTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type StructuredContentCalculatorConnectionResponse = {
  __typename?: 'StructuredContentCalculatorConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The StructuredContentCalculator returned for the connection. */
  items?: Maybe<Array<StructuredContentCalculator>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of StructuredContentCalculator objects. */
export type StructuredContentCalculatorFilterInput = {
  /** Limit collection to StructuredContentCalculators published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to StructuredContentCalculators within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']>>;
  /** Limit results to those with the specified cluster. */
  cluster?: InputMaybe<Scalars['String']>;
  /** Limit collection to StructuredContentCalculators with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
};

/** Common interface Type for all explicit structured content page Types to implement */
export type StructuredContentPageInterface = {
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID'];
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
};

/**
 * The `SubscriptionIdentityProfile` type currently represents subscription_profile_v3 as mapped from
 * Identity. Not versioned to support future evolution of this type.
 */
export type SubscriptionIdentityProfile = {
  __typename?: 'SubscriptionIdentityProfile';
  emailEnabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated The Cash Back feature is deprecated */
  emailCashBackRewardsEnabled?: Maybe<Scalars['Boolean']>;
  emailCreditMonitoringEnabled?: Maybe<Scalars['Boolean']>;
  emailMarketingEnabled?: Maybe<Scalars['Boolean']>;
  emailSpendingAlertsEnabled?: Maybe<Scalars['Boolean']>;
  emailPersonalizedContentEnabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated Replaced by emailPersonalizedContentEnabled in v3 */
  emailProductAnnouncementsEnabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated Replaced by emailTransactionalMarketingEnabled in v3 */
  emailProfileUpdatesEnabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated Removed from v3 */
  emailProgressUpdatesEnabled?: Maybe<Scalars['Boolean']>;
  emailTransactionalMarketingEnabled?: Maybe<Scalars['Boolean']>;
  pushEnabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated The Cash Back feature is deprecated */
  pushCashBackRewardsEnabled?: Maybe<Scalars['Boolean']>;
  pushCreditMonitoringEnabled?: Maybe<Scalars['Boolean']>;
  pushMarketingUpdatesEnabled?: Maybe<Scalars['Boolean']>;
  pushPersonalizedContentEnabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated Replaced by pushPersonalizedContentEnabled in v3 */
  pushProductAnnouncementsEnabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated Replaced by pushTransactionalMarketingEnabled in v3 */
  pushProfileUpdatesEnabled?: Maybe<Scalars['Boolean']>;
  pushSpendingAlertsEnabled?: Maybe<Scalars['Boolean']>;
  pushTransactionalMarketingEnabled?: Maybe<Scalars['Boolean']>;
};

/** Each enum entry should be synced with each available field in SubscriptionIdentityProfile. */
export enum SubscriptionTypeEnum {
  EmailEnabled = 'EMAIL_ENABLED',
  EmailCashBackRewardsEnabled = 'EMAIL_CASH_BACK_REWARDS_ENABLED',
  EmailCreditMonitoringEnabled = 'EMAIL_CREDIT_MONITORING_ENABLED',
  EmailMarketingEnabled = 'EMAIL_MARKETING_ENABLED',
  EmailPersonalizedContentEnabled = 'EMAIL_PERSONALIZED_CONTENT_ENABLED',
  EmailProductAnnouncementsEnabled = 'EMAIL_PRODUCT_ANNOUNCEMENTS_ENABLED',
  EmailProfileUpdatesEnabled = 'EMAIL_PROFILE_UPDATES_ENABLED',
  EmailProgressUpdatesEnabled = 'EMAIL_PROGRESS_UPDATES_ENABLED',
  EmailSpendingAlertsEnabled = 'EMAIL_SPENDING_ALERTS_ENABLED',
  EmailTransactionalMarketingEnabled = 'EMAIL_TRANSACTIONAL_MARKETING_ENABLED',
  PushEnabled = 'PUSH_ENABLED',
  PushCashBackRewardsEnabled = 'PUSH_CASH_BACK_REWARDS_ENABLED',
  PushCreditMonitoringEnabled = 'PUSH_CREDIT_MONITORING_ENABLED',
  PushMarketingUpdatesEnabled = 'PUSH_MARKETING_UPDATES_ENABLED',
  PushPersonalizedContentEnabled = 'PUSH_PERSONALIZED_CONTENT_ENABLED',
  PushProductAnnouncementsEnabled = 'PUSH_PRODUCT_ANNOUNCEMENTS_ENABLED',
  PushProfileUpdatesEnabled = 'PUSH_PROFILE_UPDATES_ENABLED',
  PushSpendingAlertsEnabled = 'PUSH_SPENDING_ALERTS_ENABLED',
  PushTransactionalMarketingEnabled = 'PUSH_TRANSACTIONAL_MARKETING_ENABLED'
}

/** Type modeling the data for posts within the tablepress_table post type from WordPress. */
export type Table = PostInterface & PostWithContentInterface & PostWithExcerptInterface & PostWithTitleInterface & {
  __typename?: 'Table';
  /** The structured content for the resource. */
  content?: Maybe<Scalars['StructuredContentDocument']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']>;
  /** The editorial excerpt of the resource. */
  excerpt?: Maybe<Scalars['String']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The bolding style to apply to this table. */
  tableBolding?: Maybe<TableBoldingEnum>;
  /** The type of visibility for the table. */
  tableVisibility?: Maybe<TableVisibilityEnum>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
  /** The column centering options selected for the table. */
  columnCentering?: Maybe<TableCenteringOptionsEnum>;
  /** The columns for the table. */
  columns?: Maybe<Array<TableColumn>>;
  /** The data to display within the columns for the table. */
  data?: Maybe<Scalars['JSON']>;
  /** Whether or not the the table has a header. */
  hasTableHeader: Scalars['Boolean'];
  /** Whether or not the table should be stylized with alternating stripes. */
  isStriped: Scalars['Boolean'];
  /** Whether or not the table is structured content eligible. */
  isStructuredContentEligible: Scalars['Boolean'];
  /** The row centering options selected for the table. */
  rowCentering?: Maybe<TableCenteringOptionsEnum>;
  /** Whether or not the table has the rowHover feature enabled. */
  rowHover: Scalars['Boolean'];
  /** Whether or not the title of the table should be displayed. */
  showTableTitle: Scalars['Boolean'];
};


/** Type modeling the data for posts within the tablepress_table post type from WordPress. */
export type TableDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the tablepress_table post type from WordPress. */
export type TableExcerptArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};


/** Type modeling the data for posts within the tablepress_table post type from WordPress. */
export type TableModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the tablepress_table post type from WordPress. */
export type TableTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Enum values for tableBolding field on Table type. */
export enum TableBoldingEnum {
  Default = 'DEFAULT',
  FirstColumn = 'FIRST_COLUMN',
  FirstRow = 'FIRST_ROW',
  FirstRowColumn = 'FIRST_ROW_COLUMN',
  None = 'NONE'
}

/** The available centering options for rows and columns within a table. */
export enum TableCenteringOptionsEnum {
  First = 'FIRST',
  Last = 'LAST'
}

/** The TableColumn type to encapsulate the properties within each of the columns on a table. */
export type TableColumn = {
  __typename?: 'TableColumn';
  /** The heading for the column. */
  heading?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** The unique ID for the table to use for mapping the rows to each column, and for using as a key in React. */
  id: Scalars['ID'];
  /** Whether or not the column should be centered. */
  isCentered: Scalars['Boolean'];
  /** The number of columns a table cell should span. */
  colspan?: Maybe<Scalars['Int']>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type TableConnectionResponse = {
  __typename?: 'TableConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The Table returned for the connection. */
  items?: Maybe<Array<Table>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of Table objects. */
export type TableFilterInput = {
  /** Limit collection to Tables with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to Tables with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

/** Enum values for tableVisibility field on Table type. */
export enum TableVisibilityEnum {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

/** The Term interface for modeling terms within custom taxonomies. */
export type TermInterface = {
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** The WordPress front end URL for this resource. */
  link: Scalars['URL'];
  /** The name of the term. */
  name?: Maybe<Scalars['String']>;
  /** The slug for the term. */
  slug?: Maybe<Scalars['String']>;
  /** The taxonomy the term is in. */
  taxonomy: Scalars['String'];
};

/** The input for retrieving a single resource. */
export type TermItemInput = {
  /** The slug for the term or the WordPress ID. */
  identifier: Scalars['ID'];
};

export type TermsOfServiceAcknowledgement = {
  __typename?: 'TermsOfServiceAcknowledgement';
  /** The type of terms of service the user is acknowledging. */
  type: Scalars['String'];
  /** The client that is the source of the acknowledgement (MY_NERDWALLET, etc). */
  source: Scalars['String'];
  /** The version of the terms of service being acknowledged. */
  version: Scalars['String'];
};

export type TermsOfServiceIdentityProfile = {
  __typename?: 'TermsOfServiceIdentityProfile';
  acknowledgements?: Maybe<Array<TermsOfServiceAcknowledgement>>;
};

/** A Third Party Embeds institution */
export type ThirdPartyEmbedsInstitution = MarketplaceEntityInterface & {
  __typename?: 'ThirdPartyEmbedsInstitution';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

/** A Third Party Embeds product */
export type ThirdPartyEmbedsProduct = MarketplaceEntityInterface & {
  __typename?: 'ThirdPartyEmbedsProduct';
  /** Enter the HTML for this embed. This comes from the partner. */
  embedCode?: Maybe<Scalars['String']>;
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** Custom height for embeds. */
  iframeHeight?: Maybe<Scalars['Float']>;
  institution: ThirdPartyEmbedsInstitution;
  isMonetizing?: Maybe<Scalars['Boolean']>;
  /** Loading text for embeds. */
  loadingCopy?: Maybe<Scalars['String']>;
  /** Marketplace product type to use in analytics events. */
  marketplaceProductType?: Maybe<Scalars['String']>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** Toggles ad banner for third party embeds */
  showAdBanner?: Maybe<Scalars['Boolean']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

export enum TopCategory {
  Gas = 'GAS',
  Groceries = 'GROCERIES',
  Dining = 'DINING',
  Entertainment = 'ENTERTAINMENT',
  Shopping = 'SHOPPING',
  Travel = 'TRAVEL'
}

export type TopInstitutionsForLinkingResponse = {
  __typename?: 'TopInstitutionsForLinkingResponse';
  /** The list of top institutions for the selected product type */
  institutions: Array<AccountAggregationInstitution>;
};

export type TrackingParam = {
  __typename?: 'TrackingParam';
  key: Scalars['String'];
  value: Scalars['String'];
};

/**
 * The input supplied to the trustSessionId query.
 *
 * The blackBox string is an obfuscated device fingerprint obtained from Transunion-owned code running on the user's
 * device.
 */
export type TrustSessionIdInput = {
  blackBox: Scalars['String'];
};

/** The response from the trustSessionId query */
export type TrustSessionIdResponse = {
  __typename?: 'TrustSessionIdResponse';
  trustSessionId: Scalars['String'];
};

export enum TuCreditFactorBucket {
  Poor = 'POOR',
  Fair = 'FAIR',
  Good = 'GOOD'
}

/** Represents a TransUnion credit report as it is used in the NW product experience */
export type TuCreditReport = {
  __typename?: 'TuCreditReport';
  /** A user's numerical credit score */
  vantageScore3?: Maybe<Scalars['Int']>;
  /** A user's credit score bucket (i.e. POOR, GOOD, etc.) */
  vantageScore3Bucket?: Maybe<TuVantageScore3Buckets>;
  /**
   * The numerical change in a user's credit score between their current score and
   * their most recent prior score
   */
  vantageScore3Delta?: Maybe<Scalars['Int']>;
  /** The TU user's current address */
  currentAddress: IdentityAddress;
  /** The TU employers belonging to the user's credit report */
  employers?: Maybe<Array<TuEmployer>>;
  /** The TU credit inquiries belonging to the user's credit report */
  inquiries?: Maybe<Array<CreditFactorInquiry>>;
  /** Indicates if the user's credit report is considered stale */
  isStale?: Maybe<Scalars['Boolean']>;
  /** The timestamp that the next credit report will be pulled at */
  nextReportPullAt?: Maybe<Scalars['DateTime']>;
  /** The percent utilization based on the user's credit limit */
  percentUtilization?: Maybe<Scalars['Float']>;
  /** The TU public records belonging to the user's credit report */
  publicRecords?: Maybe<Array<TuPublicRecord>>;
  /** The timestamp that the current credit report was pulled at */
  reportPulledAt?: Maybe<Scalars['DateTime']>;
  /** The total credit balance across all accounts */
  totalCreditBalance: Scalars['Float'];
  /** The TU credit tradelines belonging to the user's credit report */
  tradelines?: Maybe<Array<CreditFactorTradeline>>;
};

/**
 * The `TuCreditReportIdentityProfile` represents a TransUnion Credit Report.
 * Github link: https://github.com/NerdWallet/identity.nerdwallet/blob/master/src/identity/canonical_objects/profiles.py
 */
export type TuCreditReportIdentityProfile = {
  __typename?: 'TuCreditReportIdentityProfile';
  avgAgeOfCredit?: Maybe<Scalars['Float']>;
  currentAddress?: Maybe<IdentityAddress>;
  id?: Maybe<Scalars['String']>;
  inquiryDate?: Maybe<Scalars['Date']>;
  /**
   * The timestamp that this credit report was pulled at.
   * Example: `2019-07-26T14:38:01.589307Z`
   */
  reportPulledAt?: Maybe<Scalars['DateTime']>;
  /**
   * The iterable timestamp the credit report was pulled at.
   * Example: `2017-01-31T09:09:21.162125Z`
   */
  reportPulledAtIterableDatetime?: Maybe<Scalars['DateTime']>;
  nextReportPullAt?: Maybe<Scalars['DateTime']>;
  isStale?: Maybe<Scalars['Boolean']>;
  safetyCheckPassed?: Maybe<Scalars['Boolean']>;
  /**
   * Flag for when NW data validation calculations of summary data fields do not match TU values.
   * Example: `false`
   */
  hasReportErrors?: Maybe<Scalars['Boolean']>;
  /**
   * A user's numerical credit score.
   * Example value: `830`
   */
  vantageScore3?: Maybe<Scalars['Int']>;
  /**
   * A word describing the user's credit bucket, based on their score.
   * Example value: `EXCELLENT`
   */
  vantageScore3Bucket?: Maybe<TuVantageScore3Buckets>;
  /**
   * The credit score percentile.
   * Example: `95`
   */
  creditScorePopulationRank?: Maybe<Scalars['Int']>;
  /**
   * The current credit score bin (a 10 point credit score range indexed
   * at the bottom of each range (e.g. 56 -> 560-569)).
   * Example: `82`
   */
  vantageScore3Bin?: Maybe<Scalars['Int']>;
  /**
   * The credit score bin 7 days ago (a 10 point credit score range indexed at the
   * bottom of each range (e.g. 56 -> 560-569)).
   * Example: `82`
   */
  vantageScore3Bin7Days?: Maybe<Scalars['Int']>;
  /**
   * The credit score bin 28 days ago (a 10 point credit score range indexed at the
   * bottom of each range (e.g. 56 -> 560-569)).
   * Example: `82`
   */
  vantageScore3Bin28Days?: Maybe<Scalars['Int']>;
  /**
   * The numerical change in a user's credit score between their current score and
   * their most recent prior score
   * Example value: `-1`
   */
  vantageScore3Delta?: Maybe<Scalars['Int']>;
  /**
   * The numerical change in a user's credit score between their current score and
   * their most recent score that is at least 7 days old
   * Example value: `-1`
   */
  vantageScore3Delta7Days?: Maybe<Scalars['Int']>;
  /**
   * The numerical change in a user's credit score between their current score and
   * their most recent score that is at least 28 days old
   * Example value: `-1`
   */
  vantageScore3Delta28Days?: Maybe<Scalars['Int']>;
  /**
   * Credit score change since registration.
   * Example: `51`
   */
  vantageScore3DeltaSinceReg?: Maybe<Scalars['Int']>;
  /**
   * The bucket in which a user's credit score delta is in
   * Example value: `NO_CHANGE`
   */
  vantageScore3DeltaBucket?: Maybe<TuVantageScore3DeltaBuckets>;
  /**
   * A description of the directional change in the user's credit score since
   * the most recent prior credit score pull
   * Example value: `DECREASE`
   */
  vantageScore3ChangeDirection?: Maybe<TuVantageScore3ChangeDirections>;
  /**
   * A description of the directional change in the user's credit score since the
   * most recent prior credit score pull at least 7 days ago
   * Example value: `DECREASE`
   */
  vantageScore3ChangeDirection7Days?: Maybe<TuVantageScore3ChangeDirections>;
  /**
   * A description of the directional change in the user's credit score since the
   * most recent prior credit score pull at least 28 days ago
   * Example value: `DECREASE`
   */
  vantageScore3ChangeDirection28Days?: Maybe<TuVantageScore3ChangeDirections>;
  /**
   * Average age of open tradelines, in months, only for tradelines where open date can
   * be inferred (`date_opened_at_normalized`).
   * Example: `13.8`
   */
  nwAvgAgeOfCreditOpenMonths?: Maybe<Scalars['Float']>;
  /**
   * A description of the average age of open credit.
   * Example: `FAIR`
   */
  nwAvgAgeOfCreditOpenBucket?: Maybe<TuCreditFactorBucket>;
  /**
   * Count of tradelines with "current" or "unknown" pay status, for non-derogatory tradelines
   * (both open and closed).
   * Example: `5`
   */
  nwNumOntimeAccounts?: Maybe<Scalars['Int']>;
  /**
   * Count of tradelines with late pay status (1,2,3,4,5) in latest credit report,
   * for open derogatory tradelines (both open and closed).
   * Example: `4`
   */
  nwNumMissedPaymentsRecent?: Maybe<Scalars['Int']>;
  /**
   * A description of number of missed payments.
   * Example: `POOR`
   */
  nwNumMissedPaymentsRecentBucket?: Maybe<TuCreditFactorBucket>;
  /**
   * Percent utilization based on open revolving tradelines and line of credit tradelines,
   * where credit limit can be inferred.
   * Example: `0.954`
   */
  nwPercentUtilization?: Maybe<Scalars['Float']>;
  /**
   * A description of the percent utilization.
   * Example: `GOOD`
   */
  nwPercentUtilizationBucket?: Maybe<TuCreditFactorBucket>;
  /**
   * Total balances for only open tradelines.
   * Example: `5400`
   */
  nwSumBalancesOpen?: Maybe<Scalars['Float']>;
  /**
   * Total balances for credit utilization calculation, based on open tradelines
   * "revolving" or "line of credit" type, where normalized credit limit is available.
   * Example: `4000`
   */
  nwSumBalancesOpenRevolvingLineOfCredit?: Maybe<Scalars['Float']>;
  /**
   * Total credit limit for credit utilization calculation, based on open tradelines
   * with "revolving" or "line of credit" type.
   * Example: `100000`
   */
  nwSumCreditLimitOpenRevolvingLineOfCredit?: Maybe<Scalars['Float']>;
  /**
   * The number of inquiries in the past 2 years.
   * Example: `6`
   */
  numInquiries?: Maybe<Scalars['Int']>;
  /**
   * The number of inquiries in the past 2 years.
   * Always the same as `numInquiries`
   * Example: `6`
   */
  numRecentInquiries?: Maybe<Scalars['Int']>;
  numPublicRecords?: Maybe<Scalars['Int']>;
  numAccounts?: Maybe<Scalars['Int']>;
  numOpenAccounts?: Maybe<Scalars['Int']>;
  /**
   * The delta between the two most recent `num_open_accounts` fields.
   * Example: `0`
   */
  numOpenAccountsDelta?: Maybe<Scalars['Int']>;
  numClosedAccounts?: Maybe<Scalars['Int']>;
  numDelinquentAccounts?: Maybe<Scalars['Int']>;
  numDerogatoryAccounts?: Maybe<Scalars['Int']>;
  numCreditCardAccounts?: Maybe<Scalars['Int']>;
  numAutoLoanAccounts?: Maybe<Scalars['Int']>;
  numPersonalLoanAccounts?: Maybe<Scalars['Int']>;
  numStudentLoanAccounts?: Maybe<Scalars['Int']>;
  numMissedPayments?: Maybe<Scalars['Int']>;
  numMortgageAccounts?: Maybe<Scalars['Int']>;
  numHelocAccounts?: Maybe<Scalars['Int']>;
  numOtherLoanAccounts?: Maybe<Scalars['Int']>;
  numUtilityAccounts?: Maybe<Scalars['Int']>;
  numOtherAccounts?: Maybe<Scalars['Int']>;
  sumAgeOfCredit?: Maybe<Scalars['Float']>;
  /**
   * The delta between the two most recent `sum_age_of_credit` fields.
   * Example: `0`
   */
  sumAgeOfCreditDelta?: Maybe<Scalars['Float']>;
  /**
   * Total balances for open and closed tradelines.
   * Example: `16577`
   */
  sumBalances?: Maybe<Scalars['Float']>;
  sumRevolvingDebtBalances?: Maybe<Scalars['Float']>;
  sumAssetBackedDebtBalances?: Maybe<Scalars['Float']>;
  sumCreditCardBalances?: Maybe<Scalars['Float']>;
  sumAutoLoanBalances?: Maybe<Scalars['Float']>;
  sumPersonalLoanBalances?: Maybe<Scalars['Float']>;
  sumStudentLoanBalances?: Maybe<Scalars['Float']>;
  sumMortgageBalances?: Maybe<Scalars['Float']>;
  sumHelocBalances?: Maybe<Scalars['Float']>;
  sumOtherLoanBalances?: Maybe<Scalars['Float']>;
  sumUtilityBalances?: Maybe<Scalars['Float']>;
  sumOtherBalances?: Maybe<Scalars['Float']>;
  sumCreditCardLimits?: Maybe<Scalars['Float']>;
  sumAvailableCredit?: Maybe<Scalars['Float']>;
  sumMonthlyPayments?: Maybe<Scalars['Float']>;
  /**
   * The percentage of tradelines that have perfect payment history
   * Example: `0.8543`
   */
  percentOnTimePayments?: Maybe<Scalars['Float']>;
  /**
   * The delta between the two most recent `percent_on_time_payments` fields.
   * Example: `0`
   */
  percentOnTimePaymentsDelta?: Maybe<Scalars['Float']>;
  percentUtilization?: Maybe<Scalars['Float']>;
  percentUtilizationDelta?: Maybe<Scalars['Float']>;
  nwPercentUtilization28Days?: Maybe<Scalars['Float']>;
  nwNumOntimeAccounts28Days?: Maybe<Scalars['Int']>;
  numAccounts28Days?: Maybe<Scalars['Int']>;
  numDerogatoryAccounts28Days?: Maybe<Scalars['Int']>;
  numOpenAccounts28Days?: Maybe<Scalars['Int']>;
  numClosedAccounts28Days?: Maybe<Scalars['Int']>;
  nwSumBalancesOpen28Days?: Maybe<Scalars['Float']>;
  nwSumCreditLimitOpenRevolvingLineOfCredit28Days?: Maybe<Scalars['Float']>;
  numInquiries28Days?: Maybe<Scalars['Int']>;
  nwAvgAgeOfCreditOpenMonths28Days?: Maybe<Scalars['Float']>;
  nwPercentUtilizationDelta28Days?: Maybe<Scalars['Float']>;
  nwNumOntimeAccountsDelta28Days?: Maybe<Scalars['Int']>;
  numAccountsDelta28Days?: Maybe<Scalars['Int']>;
  numDerogatoryAccountsDelta28Days?: Maybe<Scalars['Int']>;
  numOpenAccountsDelta28Days?: Maybe<Scalars['Int']>;
  numClosedAccountsDelta28Days?: Maybe<Scalars['Int']>;
  nwSumBalancesOpenDelta28Days?: Maybe<Scalars['Float']>;
  nwSumCreditLimitOpenRevolvingLineOfCreditDelta28Days?: Maybe<Scalars['Float']>;
  numInquiriesDelta28Days?: Maybe<Scalars['Int']>;
  nwAvgAgeOfCreditOpenMonthsDelta28Days?: Maybe<Scalars['Float']>;
  tradelines?: Maybe<Array<Maybe<TuTradeline>>>;
  inquiries?: Maybe<Array<Maybe<TuInquiry>>>;
  employers?: Maybe<Array<Maybe<TuEmployer>>>;
  publicRecords?: Maybe<Array<Maybe<TuPublicRecord>>>;
};

/**
 * Employer information used by TransUnion.
 * Github link: https://github.com/NerdWallet/identity.nerdwallet/blob/master/src/identity/canonical_objects/employer.py
 */
export type TuEmployer = {
  __typename?: 'TuEmployer';
  name?: Maybe<Scalars['String']>;
  dateReportedAt?: Maybe<Scalars['DateTime']>;
  dateUpdatedAt?: Maybe<Scalars['DateTime']>;
};

/**
 * A credit inquiry.
 * Github link: https://github.com/NerdWallet/identity.nerdwallet/blob/master/src/identity/canonical_objects/inquiry.py
 */
export type TuInquiry = {
  __typename?: 'TuInquiry';
  /**
   * The name of the Canonical Institution that corresponds to subscriberName based on known tu_synonyms.
   * Queries the Marketplace Canonical Institution Search API in order to determine this.
   */
  canonicalInstitutionName?: Maybe<Scalars['String']>;
  subscriberName?: Maybe<Scalars['String']>;
  inquiryType?: Maybe<Scalars['String']>;
  bureau?: Maybe<Scalars['String']>;
  inquiredAt?: Maybe<Scalars['DateTime']>;
  industry?: Maybe<Scalars['String']>;
  compositeKey?: Maybe<Scalars['String']>;
};

/**
 * A public record.
 * Github link: https://github.com/NerdWallet/identity.nerdwallet/blob/master/src/identity/canonical_objects/public_record.py
 */
export type TuPublicRecord = {
  __typename?: 'TuPublicRecord';
  courtName?: Maybe<Scalars['String']>;
  filedAt?: Maybe<Scalars['DateTime']>;
  referenceNumber?: Maybe<Scalars['String']>;
  subscriberCode?: Maybe<Scalars['String']>;
  bureau?: Maybe<Scalars['String']>;
  classification?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/**
 * A tradeline used by TU.
 * Github link: https://github.com/NerdWallet/identity.nerdwallet/blob/master/src/identity/canonical_objects/tradeline.py
 */
export type TuTradeline = {
  __typename?: 'TuTradeline';
  /**
   * The name of the Canonical Institution that corresponds to creditorName based on known tu_synonyms.
   * Queries the Marketplace Canonical Institution Search API in order to determine this.
   */
  canonicalInstitutionName?: Maybe<Scalars['String']>;
  accountType?: Maybe<Scalars['String']>;
  accountTypeSymbol?: Maybe<Scalars['String']>;
  accountSubtype?: Maybe<Scalars['String']>;
  accountSubtypeSymbol?: Maybe<Scalars['String']>;
  accountNumberLast4?: Maybe<Scalars['String']>;
  accountDesignator?: Maybe<Scalars['String']>;
  accountCondition?: Maybe<Scalars['String']>;
  openClosed?: Maybe<TuTradelineOpenClosed>;
  openClosedSymbol?: Maybe<TuTradelineOpenClosedSymbol>;
  highBalance?: Maybe<Scalars['Float']>;
  dateReportedAt?: Maybe<Scalars['DateTime']>;
  dateClosedAt?: Maybe<Scalars['DateTime']>;
  dateOpenedAt?: Maybe<Scalars['DateTime']>;
  dateVerifiedAt?: Maybe<Scalars['DateTime']>;
  dateAccountStatus?: Maybe<Scalars['DateTime']>;
  currentBalance?: Maybe<Scalars['Float']>;
  creditorName?: Maybe<Scalars['String']>;
  bureau?: Maybe<Scalars['String']>;
  creditLimit?: Maybe<Scalars['Float']>;
  disputeFlag?: Maybe<Scalars['String']>;
  payStatus?: Maybe<Scalars['String']>;
  payStatusDescription?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  paymentFrequency?: Maybe<Scalars['String']>;
  worstPayStatus?: Maybe<Scalars['String']>;
  worstPayStatusSymbol?: Maybe<Scalars['String']>;
  amountPastDue?: Maybe<Scalars['Float']>;
  collateral?: Maybe<Scalars['String']>;
  lastPaymentDate?: Maybe<Scalars['DateTime']>;
  late30Count?: Maybe<Scalars['Int']>;
  late60Count?: Maybe<Scalars['Int']>;
  late90Count?: Maybe<Scalars['Int']>;
  monthlyPayment?: Maybe<Scalars['Float']>;
  monthsReviewed?: Maybe<Scalars['Int']>;
  termMonths?: Maybe<Scalars['Int']>;
  worstPayStatusCount?: Maybe<Scalars['Int']>;
  payHistoryStatus?: Maybe<Scalars['String']>;
  payHistoryStartDate?: Maybe<Scalars['DateTime']>;
  payHistoryBreakDown?: Maybe<Array<TuTradelinePayment>>;
  subscriberCodeHash?: Maybe<Scalars['String']>;
  accountNumberHash?: Maybe<Scalars['String']>;
  creditType?: Maybe<Scalars['String']>;
  compositeKey?: Maybe<Scalars['String']>;
  nwCreditLimitNormalized?: Maybe<Scalars['Float']>;
  nwUtilizationPct?: Maybe<Scalars['Float']>;
  nwDateOpenedAtNormalized?: Maybe<Scalars['DateTime']>;
  nwMonthsOpened?: Maybe<Scalars['Int']>;
  derogatoryTradelineReason?: Maybe<Scalars['String']>;
  payStatusSymbol?: Maybe<Scalars['String']>;
  nwPayStatusBucket?: Maybe<Scalars['String']>;
  nwLastMissedPaymentDate?: Maybe<Scalars['DateTime']>;
  isIncludedInUtilization?: Maybe<Scalars['Boolean']>;
};

export enum TuTradelineOpenClosed {
  Open = 'Open',
  Closed = 'Closed'
}

export enum TuTradelineOpenClosedSymbol {
  O = 'O',
  C = 'C'
}

export type TuTradelinePayment = {
  __typename?: 'TuTradelinePayment';
  status: Scalars['String'];
  date: Scalars['String'];
};

export enum TuVantageScore3Buckets {
  Excellent = 'EXCELLENT',
  Average = 'AVERAGE',
  Good = 'GOOD',
  Poor = 'POOR'
}

export enum TuVantageScore3ChangeDirections {
  Increase = 'INCREASE',
  Nochange = 'NOCHANGE',
  Decrease = 'DECREASE'
}

export enum TuVantageScore3DeltaBuckets {
  SmallIncrease = 'SMALL_INCREASE',
  LargeIncrease = 'LARGE_INCREASE',
  SmallDecrease = 'SMALL_DECREASE',
  LargeDecrease = 'LARGE_DECREASE',
  NoChange = 'NO_CHANGE'
}

export type UndoBulkActionInput = {
  /** The IDs visible to the user. */
  track: Array<Scalars['ID']>;
  /** The operation ID of the bulk action to undo. */
  operationId: Scalars['ID'];
};

export type UpdateFinancialAccountResponse = {
  __typename?: 'UpdateFinancialAccountResponse';
  financialAccount: FinancialAccount;
};

export type UpdateFinancialMerchantTransactionCategoryResponse = {
  __typename?: 'UpdateFinancialMerchantTransactionCategoryResponse';
  success: Scalars['Boolean'];
};

/** The expected input for the `updateIncome` mutation */
export type UpdateIncomeInput = {
  annualIncome?: InputMaybe<Scalars['Float']>;
  monthlyNetIncome?: InputMaybe<Scalars['Float']>;
};

export type UpdateIncomeResponse = {
  __typename?: 'UpdateIncomeResponse';
  success: Scalars['Boolean'];
  annualIncome?: Maybe<Scalars['Float']>;
  monthlyNetIncome?: Maybe<Scalars['Float']>;
};

/** The expected input for the `updateName` mutation */
export type UpdateNameInput = {
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type UpdateNameResponse = {
  __typename?: 'UpdateNameResponse';
  success: Scalars['Boolean'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

/** The expected data shape of the updateNetWorthAccountVisibility mutation response */
export type UpdateNetWorthAccountVisibilityResponse = {
  __typename?: 'UpdateNetWorthAccountVisibilityResponse';
  account: NetWorthAccount;
};

/** Wraps the update net worth real API response, which allows for adding fields at a later date */
export type UpdateNetWorthRealAssetResponse = {
  __typename?: 'UpdateNetWorthRealAssetResponse';
  asset: NetWorthRealAsset;
};

export type UpdatePasswordInfoInput = {
  /** The user's old password before the update */
  oldPassword: Scalars['String'];
  /** The user's new password after the update */
  newPassword: Scalars['String'];
};

/**
 * The expected payload for the `updateSubscriptionProfile` mutation,
 * should be synced with SubscriptionIdentityProfile.
 */
export type UpdateSubscriptionProfileInput = {
  emailEnabled?: InputMaybe<Scalars['Boolean']>;
  emailCashBackRewardsEnabled?: InputMaybe<Scalars['Boolean']>;
  emailCreditMonitoringEnabled?: InputMaybe<Scalars['Boolean']>;
  emailMarketingEnabled?: InputMaybe<Scalars['Boolean']>;
  emailSpendingAlertsEnabled?: InputMaybe<Scalars['Boolean']>;
  emailPersonalizedContentEnabled?: InputMaybe<Scalars['Boolean']>;
  emailProductAnnouncementsEnabled?: InputMaybe<Scalars['Boolean']>;
  emailProfileUpdatesEnabled?: InputMaybe<Scalars['Boolean']>;
  emailProgressUpdatesEnabled?: InputMaybe<Scalars['Boolean']>;
  emailTransactionalMarketingEnabled?: InputMaybe<Scalars['Boolean']>;
  pushEnabled?: InputMaybe<Scalars['Boolean']>;
  pushCashBackRewardsEnabled?: InputMaybe<Scalars['Boolean']>;
  pushCreditMonitoringEnabled?: InputMaybe<Scalars['Boolean']>;
  pushMarketingUpdatesEnabled?: InputMaybe<Scalars['Boolean']>;
  pushPersonalizedContentEnabled?: InputMaybe<Scalars['Boolean']>;
  pushProductAnnouncementsEnabled?: InputMaybe<Scalars['Boolean']>;
  pushProfileUpdatesEnabled?: InputMaybe<Scalars['Boolean']>;
  pushSpendingAlertsEnabled?: InputMaybe<Scalars['Boolean']>;
  pushTransactionalMarketingEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateUserWalletCardInput = {
  /** The ID of the existing user's wallet card in the my cards service */
  userWalletCardId: Scalars['ID'];
  /** The ID of the marketplace offer to associate with the user's wallet card */
  marketplaceOfferId?: InputMaybe<Scalars['ID']>;
  /** The ID of the financial account to associate with the user's wallet card */
  financialAccountId?: InputMaybe<Scalars['ID']>;
};

export type UpdateUserWalletCardResponse = {
  __typename?: 'UpdateUserWalletCardResponse';
  card: UserWalletCard;
};

/** Input Type for accepting URL params for a query */
export type UrlParamsInput = {
  key: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_url_record post type from WordPress. */
export type UrlRecord = PostInterface & PostWithAuthorsInterface & PostWithContentClassificationInterface & PostWithFaQsInterface & PostWithFeaturedImageInterface & PostWithReviewerInterface & PostWithSeoInterface & PostWithTitleInterface & {
  __typename?: 'UrlRecord';
  /** The assigning editor set on the content. */
  assigningEditor?: Maybe<Author>;
  /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
  attributionTopic?: Maybe<Scalars['String']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the UrlRecord object. */
  categories?: Maybe<Array<Category>>;
  /** Additional content clusters for this piece of content. */
  contentClusters?: Maybe<Array<Scalars['String']>>;
  /** The custom last modified date for the content. */
  customLastModifiedDate?: Maybe<Scalars['DateTime']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** The format to use when displaying the date. */
  dateDisplayFormat?: Maybe<DateDisplayFormatEnum>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']>;
  /** The faqs to display on this piece of content. */
  faqs?: Maybe<Array<ContentFaq>>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']>;
  /** Whether or not to hide the Author information from the header of this piece of content. */
  hideAuthor?: Maybe<Scalars['Boolean']>;
  /** Whether or not to hide the date for this piece of content. */
  hideDate?: Maybe<Scalars['Boolean']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
  isArchivesEligible?: Maybe<Scalars['Boolean']>;
  /** Whether or not to prevent this piece of content from being recommended to users. */
  isRecommendationEligible?: Maybe<Scalars['Boolean']>;
  /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
  isSearchEligible?: Maybe<Scalars['Boolean']>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** Whether to override the last modified date for the content using one of the available options. */
  overrideLastModifiedDateWithCurrentDate?: Maybe<OverrideLastModifiedDateEnum>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']>;
  /** The primary category object for the content. */
  primaryCategory?: Maybe<Category>;
  /** The primary content field for this URL record. */
  primaryContent?: Maybe<Scalars['StructuredContentDocument']>;
  /** The primary content cluster for this piece of content. */
  primaryContentCluster?: Maybe<Scalars['String']>;
  /** A date after which this content should no longer be recommended. */
  recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']>;
  /** The reviewers that this URL has been reviewed by. */
  reviewedBy?: Maybe<Array<ContentReviewer>>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** Whether or not to display the FAQ's. */
  showFaqs?: Maybe<Scalars['Boolean']>;
  /** Whether or not to show the last modified date. */
  showLastModifiedDate?: Maybe<Scalars['Boolean']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The content to display below the title of a piece of content. */
  synopsis?: Maybe<Scalars['String']>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
  /** The URL path to query for URL Records by. */
  url?: Maybe<Scalars['URL']>;
  /** Whether or not to use a custom last modified date for this piece of content. */
  useCustomLastModifiedDate?: Maybe<Scalars['Boolean']>;
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']>>;
  /** The Breadcrumb to display */
  breadcrumb?: Maybe<Breadcrumb>;
  /** The display date (depends on checked boxes in WP, could be custom_last_modified_date, modified, or published dates) */
  displayDate?: Maybe<Scalars['DateTime']>;
};


/** Type modeling the data for posts within the nw_url_record post type from WordPress. */
export type UrlRecordDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_url_record post type from WordPress. */
export type UrlRecordModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Type modeling the data for posts within the nw_url_record post type from WordPress. */
export type UrlRecordTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type UrlRecordConnectionResponse = {
  __typename?: 'UrlRecordConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The UrlRecord returned for the connection. */
  items?: Maybe<Array<UrlRecord>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of UrlRecord objects. */
export type UrlRecordFilterInput = {
  /** Limit collection to UrlRecords published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to UrlRecords within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']>>;
  /** Limit results to those with the specified cluster. */
  cluster?: InputMaybe<Scalars['String']>;
  /** Limit results to those with the specified Assigning Editor, filtered by ID. */
  editorIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Limit collection to UrlRecords with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']>;
  /** Limit results to those with the specified Reviewer, filtered by ID. */
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Limit collection to UrlRecords with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
  /** Limit result set to the item with the specified URL. */
  urlPath?: InputMaybe<Scalars['String']>;
};

/**
 * A UserAction is anything that the user might do in response to an insight.  At their simplest, they are just a raw
 * AppAction (e.g., a simple CTA that navigates to an L2), but can be augmented with additional context or even bespoke
 * data visualizations.
 */
export type UserAction = {
  __typename?: 'UserAction';
  /**
   * A human-readable identifier for a particular user action.  Primarily used for analytics.
   *
   * Example: credit-score-pay-off-account-early
   */
  slug?: Maybe<Scalars['String']>;
  /**
   * Language that summarizes or introduces the UserAction.
   *
   * This is *not* the CTA text -- that should be supplied in appAction.text
   */
  title?: Maybe<Scalars['String']>;
  /**
   * Language that describes the UserAction in detail.
   *
   * This is *not* the CTA text -- that should be supplied in appAction.text
   */
  body?: Maybe<Scalars['String']>;
  /** The mechanical action to be performed in the app when the user engages with this UserAction */
  appAction: AppAction;
};

export type UserBestCreditCardRecommendations = {
  __typename?: 'userBestCreditCardRecommendations';
  recommendations: Array<BccPageCard>;
};

export type UserBestCreditCardRecommendationsInput = {
  limit?: InputMaybe<Scalars['Int']>;
  pageId?: InputMaybe<Scalars['String']>;
};

export enum UserFinancialTransactionRuleType {
  Category = 'CATEGORY',
  Hide = 'HIDE',
  Tag = 'TAG'
}

/**
 * UserInsightDataVisualizationInterface must be implemented by a concrete type that contains all the data necessary to
 * render a specific data visualization.
 */
export type UserInsightDataVisualizationInterface = {
  dataVisualizationType: UserInsightDataVisualizationTypeEnum;
};

/** UserInsightDataVisualizationTypeEnum represents all possible data visualizations that might appear with an insight */
export enum UserInsightDataVisualizationTypeEnum {
  /** A visualization of the user's spending in the current month, by the top categories */
  SpendingByTopCategories = 'SPENDING_BY_TOP_CATEGORIES',
  /**
   * A visualization of the user's total spending in the current month to date vs. their total spending as of the same
   * date in the previous month
   */
  SpendingByMonths = 'SPENDING_BY_MONTHS',
  /** A visualization for credit score activation */
  CreditScoreActivation = 'CREDIT_SCORE_ACTIVATION',
  /** A visualization for financial account(s) activation */
  FinancialAccountsActivation = 'FINANCIAL_ACCOUNTS_ACTIVATION',
  /** A visualization of the user's credit score change */
  WhyDidMyScoreChange = 'WHY_DID_MY_SCORE_CHANGE',
  /** A visualization of the user's potential score change */
  CreditBooster = 'CREDIT_BOOSTER',
  /** A visualization for My Cards activation */
  MyCardsActivation = 'MY_CARDS_ACTIVATION'
}

/** UserInsightEligibleModulesEnum represents all possible eligible modules */
export enum UserInsightEligibleModulesEnum {
  /** Indicates the insight is eligible for the why did my score change module */
  WhyDidMyScoreChange = 'WHY_DID_MY_SCORE_CHANGE',
  /** Indicates the insight is eligible for the credit booster module */
  CreditBooster = 'CREDIT_BOOSTER',
  /** Indicates the insight is eligible for the member home module */
  MemberHome = 'MEMBER_HOME',
  /** Indicates the insight is eligible for the credit score UI&A module */
  CreditScore = 'CREDIT_SCORE',
  /** Indicates the insight is eligible for the cash flow UI&A module */
  CashFlow = 'CASH_FLOW',
  /** Indicates the insight is eligible for the net worth UI&A module */
  NetWorth = 'NET_WORTH',
  /** Indicates the insight is eligible for the member home activation UI&A module */
  MemberHomeActivationHooks = 'MEMBER_HOME_ACTIVATION_HOOKS',
  /** Indicates the insight is eligible for the credit score activation UI&A module */
  CreditScoreActivationHooks = 'CREDIT_SCORE_ACTIVATION_HOOKS',
  /** Indicates the insight is eligible for the Moment of Delight module at the end of TU Activation */
  TuActivationComplete = 'TU_ACTIVATION_COMPLETE'
}

/**
 * This field encapsulates the concept of an increase or gain to a user’s personal finances.
 *
 * This could range from credit score increases to an increase in savings or debt.
 */
export type UserInsightGain = {
  __typename?: 'UserInsightGain';
  /** Represents the minimum gain from this user insight */
  minGain: Scalars['Float'];
  /** Represents the maximum gain from this user insight */
  maxGain: Scalars['Float'];
  /** Represents the type of gain from this user insight */
  gainUnit: UserInsightGainUnitEnum;
  /** Describes the gain impact */
  description: Scalars['String'];
};

/**
 * "
 * UserInsightGainUnitEnum represents all possible gain units for user insights
 */
export enum UserInsightGainUnitEnum {
  /** Indicates the unit for gain is points */
  CreditScorePoints = 'CREDIT_SCORE_POINTS'
}

/** A UserInsightImage is an image associated with a user insight. Used to add further detail or exemplify the insight itself. */
export type UserInsightImage = {
  __typename?: 'UserInsightImage';
  /** The link to the image. */
  imageUri: Scalars['String'];
  /** A descriptive title for the image. */
  label?: Maybe<Scalars['String']>;
};

/**
 * A "user insight" is something noteworthy or interesting that NerdWallet has identified about the user.
 *
 * Examples include:
 * - Your credit score changed this week -- here's why
 * - How your cash flow compares to the same day last month
 * - Your monthly spending breakdown by category
 * - You have too much money in your checking account -- consider moving some to a high-yield savings account
 *
 * There are several insight inventory sources, each with a bespoke data model.  This interface represents the fields
 * that are common across each inventory source.
 */
export type UserInsightInterface = {
  /**
   * A human-readable identifier for a particular insight inventory item.  Primarily used for analytics.
   *
   * Note that the slug field is the same across all instances of a particular insight (whereas the id field is unique).
   *
   * Example: credit-score-utilization-increase-by-ten-or-more-points
   */
  slug?: Maybe<Scalars['String']>;
  /**
   * The primary identifier for a UserInsight.  Primarily used for tracking user engagement.
   *
   * Because insight inventory items are typically stateless and do not have proper database IDs, this field will generally
   * be inferred by source-specific heuristics.
   *
   * Note that the id field is unique across all instances of a particular insight (whereas the slug field is not).
   */
  id: Scalars['ID'];
  /** Language that summarizes or introduces the insight. */
  title?: Maybe<Scalars['String']>;
  /** The insights regeneration group. */
  regenerationGroup?: Maybe<UserInsightRegenerationGroupEnum>;
  /** Language that describes the insight in detail. */
  description?: Maybe<Scalars['String']>;
  /** General suggestions related to this insight that are not immediately actionable are surfaced as a "tip" */
  tip?: Maybe<UserInsightTip>;
  /**
   * A measure of how impactful this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * impact)
   *
   * For example, a large transaction alert would be high-urgency while a credit card recommendation would be low-urgency.
   */
  impact?: Maybe<Scalars['Float']>;
  /**
   * A measure of how urgent this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * urgency)
   *
   * For example, a large transaction alert would be high-urgency while a credit card recommendation would be
   * low-urgency.
   */
  urgency?: Maybe<Scalars['Float']>;
  /**
   * Information about the ML model used to produce a personalized ranking score for the current user about a particular
   * insight.
   */
  personalizedRankingScore?: Maybe<UserInsightPersonalizedRankingScore>;
  /**
   * A qualitative indication of how the user should feel about a particular insight.  Used primarily to inform UI
   * treatment (e.g. red vs. yellow vs. blue accent color).
   *
   * Note that a NEUTRAL sentiment value means that the insight is explicitly assessed to be of neutral sentiment, whereas
   * the absence of a sentiment value means that the sentiment is unknown.
   */
  sentiment?: Maybe<UserInsightSentimentEnum>;
  /** The actions that we recommend for the user to perform based on this insight. */
  actions: Array<UserAction>;
  /** Insights may be related to one or more features, which are represented via this field. */
  relatedFeatures?: Maybe<Array<MembershipFeatureEnum>>;
  /**
   * The source of truth for this particular insight (typically a service or a CMS).
   *
   * Used primarily to infer the type of a particular UserInsightInterface instance.
   */
  inventorySource: UserInsightInventorySourceEnum;
  /** An object containing the data necessary to render the data visualization for this insight. */
  dataVisualization?: Maybe<UserInsightDataVisualizationInterface>;
  /** An image to be displayed with the insight near the description. */
  bodyImage?: Maybe<UserInsightImage>;
  /**
   * This field encapsulates the concept of an increase or gain to a user’s personal finances.
   *
   * This could range from credit score increases to an increase in savings or debt.
   */
  gain?: Maybe<UserInsightGain>;
  /** The UX modules that this insight may appear in. */
  eligibleModules?: Maybe<Array<UserInsightEligibleModulesEnum>>;
  /** The eligibility configuration for the current client */
  clientEligibilityConfig?: Maybe<ClientEligibilityConfig>;
};

/** UserInsightInventorySourceEnum represents all possible sources of truth for user insights. */
export enum UserInsightInventorySourceEnum {
  /**
   * Some insights are derived on-demand by credit-service; specifically, an activation UI&A for user's who have not
   * yet linked TU
   */
  CreditService = 'CREDIT_SERVICE',
  /**
   * Some insights are generated on-demand by recommendation-service.  Note that the inventory source for such insights
   * is recommendation-service, not the intermediary orchestration layer through which they were retrieved (e.g.
   * Factory)
   */
  RecommendationService = 'RECOMMENDATION_SERVICE',
  /**
   * Some insights are generated on-demand by financial-insights service. Note that the inventory source for such insights
   * is financial-insights service, not FDP which is where the data that determines the UI&A is derived
   */
  FinancialInsightsService = 'FINANCIAL_INSIGHTS_SERVICE',
  /** Some insights are generated on-demand by my-cards-service */
  MyCardsService = 'MY_CARDS_SERVICE'
}

/** The personalized ranking score that was used to rank this insight. */
export type UserInsightPersonalizedRankingScore = {
  __typename?: 'UserInsightPersonalizedRankingScore';
  /**
   * The model execution IDs that were involved in producing the user's personalized ranking score for this insight.
   * These should all be included in analytics events for this insight.
   *
   * Includes:
   * - A model execution ID that indicates which ML model produced this ranking score
   * - A model execution ID that indicates which _variant_ of the ML model produced this ranking score
   */
  modelExecutionIds: Array<Scalars['String']>;
  /**
   * A measure of how compelling this particular insight is to this particular user.  Used as an input into ranking
   * decisions.  Takes a value from 0 to 1.
   */
  score: Scalars['Float'];
};

/** The specific insight's regeneration group */
export enum UserInsightRegenerationGroupEnum {
  /** Credit booster regeneration group (includes WDMSC) */
  CreditBooster = 'CREDIT_BOOSTER',
  /** Credit report regeneration group */
  CreditReport = 'CREDIT_REPORT',
  /** Credit score activation regeneration group */
  CreditScoreActivation = 'CREDIT_SCORE_ACTIVATION',
  /** My bills regeneration group */
  MyBills = 'MY_BILLS',
  /** My cards activation regeneration group */
  MyCardsActivation = 'MY_CARDS_ACTIVATION',
  /** Net worth activation regeneration group */
  NetWorthActivation = 'NET_WORTH_ACTIVATION',
  /** Optimize regeneration group */
  Optimize = 'OPTIMIZE',
  /** Spending regeneration group */
  Spending = 'SPENDING'
}

/**
 * A qualitative indication of how the user should feel about a particular insight.  Used primarily to inform UI
 * treatment (e.g. red vs. yellow vs. blue accent color).
 */
export enum UserInsightSentimentEnum {
  /** Indicates that the insight is beneficial for the user (e.g., their paycheck was deposited) */
  Positive = 'POSITIVE',
  /** Indicates that the insight is neither inherently beneficial nor cautionary */
  Neutral = 'NEUTRAL',
  /**
   * Indicates that the insight is potentially (but not necessarily) harmful for the user (e.g., a hard credit pull or
   * detection of a large transaction)
   */
  Cautionary = 'CAUTIONARY'
}

export type UserInsightsFilterInput = {
  /** If specified, only include insights that are eligible for at least one of the specified modules */
  relatedFeatures?: InputMaybe<Array<MembershipFeatureEnum>>;
  /** If specified, only include insights at or above this level of urgency.  Ranges from 0 to 1. */
  minUrgency?: InputMaybe<Scalars['Float']>;
  /** If specified, only include insights at or below this level of urgency.  Ranges from 0 to 1. */
  maxUrgency?: InputMaybe<Scalars['Float']>;
  /** If specified, only include insights that are eligible for at least one of the specified modules */
  eligibleModules?: InputMaybe<Array<UserInsightEligibleModulesEnum>>;
  /** If specified, exclude insights with matching slugs */
  ineligibleInsightSlugs?: InputMaybe<Array<Scalars['String']>>;
};

export type UserInsightsResponse = {
  __typename?: 'UserInsightsResponse';
  userInsights: Array<UserInsightInterface>;
};

/** A non-actionable suggestion related to a UserInsight */
export type UserInsightTip = {
  __typename?: 'UserInsightTip';
  /** The label under which the tip appears (e.g. "Nerdy Tip") */
  label?: Maybe<Scalars['String']>;
  /** Language that describes the tip in detail */
  description: Scalars['String'];
};

/** This type holds the individual subscription preference selections. */
export type UserOpsCommsSubscriptionPreferences = {
  __typename?: 'UserOpsCommsSubscriptionPreferences';
  /** Is the emailCreditMonitoringEnabled message type enabled */
  emailCreditMonitoringEnabled?: Maybe<Scalars['Boolean']>;
  /** Is the email channel enabled */
  emailEnabled?: Maybe<Scalars['Boolean']>;
  /** Is the emailMarketingEnabled message type enabled */
  emailMarketingEnabled?: Maybe<Scalars['Boolean']>;
  /** Is the emailPersonalizedContentEnabled message type enabled */
  emailPersonalizedContentEnabled?: Maybe<Scalars['Boolean']>;
  /** Is the emailSpendingAlertsEnabled message type enabled */
  emailSpendingAlertsEnabled?: Maybe<Scalars['Boolean']>;
  /** Is the emailTransactionalMarketingEnabled message type enabled */
  emailTransactionalMarketingEnabled?: Maybe<Scalars['Boolean']>;
  /** Is the pushCreditMonitoringEnabled message type enabled */
  pushCreditMonitoringEnabled?: Maybe<Scalars['Boolean']>;
  /** Is the push channel enabled */
  pushEnabled?: Maybe<Scalars['Boolean']>;
  /** Is the pushMarketingUpdatesEnabled message type enabled */
  pushMarketingUpdatesEnabled?: Maybe<Scalars['Boolean']>;
  /** Is the pushPersonalizedContentEnabled message type enabled */
  pushPersonalizedContentEnabled?: Maybe<Scalars['Boolean']>;
  /** Is the pushSpendingAlertsEnabled message type enabled */
  pushSpendingAlertsEnabled?: Maybe<Scalars['Boolean']>;
  /** Is the pushTransactionalMarketingEnabled message type enabled */
  pushTransactionalMarketingEnabled?: Maybe<Scalars['Boolean']>;
};

/** This type wraps the users subscription preferences and also includes metadata about the preferences. */
export type UserOpsCommsSubscriptionPreferencesWrapper = {
  __typename?: 'UserOpsCommsSubscriptionPreferencesWrapper';
  /** Event ID associated with this snapshot of subscription preferences. Useful for looking up in Snowflake. */
  eventId: Scalars['ID'];
  /** Timestamp associated with this snapshot of subscription preferences. */
  timestamp: Scalars['DateTime'];
  /** List of subscription preferences sorted in descending order. */
  subscriptionPreferences: UserOpsCommsSubscriptionPreferences;
};

/** The shape of each messaging activity event */
export type UserOpsMessagingActivityEvent = {
  __typename?: 'UserOpsMessagingActivityEvent';
  /** Action that the user took on this message, could be opened, delivered, bounced, or spam report */
  action: Scalars['String'];
  /** Blueshift campaign uuid associated with this message */
  campaignUuid: Scalars['ID'];
  /** Either push-message or email, cannot use enum because of hyphen */
  channel: Scalars['String'];
  /** Event ID associated with this messaging event, useful for Snowflake lookup */
  eventId: Scalars['ID'];
  /** Subject line of the message if applicable */
  subjectLine?: Maybe<Scalars['String']>;
  /** Timestamp associated with this messaging event. */
  timestamp: Scalars['DateTime'];
};

/** This type holds a subset of fields from the portal_activity_occurred event that is relevant for User Ops. */
export type UserOpsPaoEventDetails = {
  __typename?: 'UserOpsPAOEventDetails';
  /** The activity type that happened (such as linking_process_error). */
  activityType?: Maybe<Scalars['String']>;
  /** Authentication state of the portal. */
  authState?: Maybe<FinancialPortalAuthState>;
  /** When this event occurred */
  eventOccurredAt: Scalars['DateTime'];
  /** app-schemata definition: The raw error payload from FDP Proxy. */
  fdpPrimaryErrorBlob?: Maybe<UserOpsPaoEventDetailsError>;
  /** app-schemata definition: The associated Plaid event_name. */
  plaidEventName?: Maybe<Scalars['String']>;
  /** app-schemata definition: Plaid's link_session_idZ. */
  plaidLinkSessionId?: Maybe<Scalars['ID']>;
  /** app-schemata definition: Plaid's request_id. */
  plaidRequestId?: Maybe<Scalars['String']>;
  /** ID of the portal for which this event was fired */
  portalId?: Maybe<Scalars['ID']>;
  /**
   * app-schemata definition: The identifier of the institution as defined in the underlying source,
   * i.e. plaid_id or yodlee_id.
   */
  sourceInstitutionId?: Maybe<Scalars['String']>;
};

/** This type represents the error blob inside the portal_activity_occurred event. */
export type UserOpsPaoEventDetailsError = {
  __typename?: 'UserOpsPAOEventDetailsError';
  /** The error code from Plaid. */
  errorCode?: Maybe<Scalars['String']>;
  /** The error message from Plaid. */
  errorMessage?: Maybe<Scalars['String']>;
  /** The error type from Plaid. */
  errorType?: Maybe<Scalars['String']>;
};

export type UserPageVideo = {
  __typename?: 'UserPageVideo';
  /** Featured video length for this User Page. */
  length?: Maybe<Scalars['String']>;
  /** Featured video synopsis for this User Page. */
  synopsis?: Maybe<Scalars['String']>;
  /** Featured video title for this User Page. */
  title?: Maybe<Scalars['String']>;
  /** Featured video Youtube URL for this User Page. */
  url?: Maybe<Scalars['URL']>;
};

export type UserReportedCreditCardInput = {
  cardId: Scalars['Int'];
  cardName: Scalars['String'];
};

export type UserReportedCreditCardsResult = {
  __typename?: 'UserReportedCreditCardsResult';
  /** User self-reported list of credit cards */
  cards?: Maybe<Array<RewardsCreditCard>>;
};

/**
 * The `UserReportedFinancialAccount` type represents a financial
 * account queried as part of the Financial Identity Profile
 */
export type UserReportedFinancialAccount = {
  __typename?: 'UserReportedFinancialAccount';
  id?: Maybe<Scalars['ID']>;
  type: Scalars['String'];
  displayName?: Maybe<Scalars['String']>;
  ccExtraData?: Maybe<Scalars['JSON']>;
  yodleeFk?: Maybe<Scalars['String']>;
  marketplaceFk?: Maybe<Scalars['String']>;
  transunionFk?: Maybe<Scalars['String']>;
  tuTradelineCompositeKey?: Maybe<Scalars['String']>;
  institutionFk?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  currentValue?: Maybe<Scalars['Float']>;
};

export type UserWalletCard = {
  __typename?: 'UserWalletCard';
  /** The ID of the user's wallet card in the my cards service */
  id: Scalars['ID'];
  /** The credit card offer associated with the user's wallet card */
  offer?: Maybe<CreditCardsOfferV2>;
  /** The FDP financial account associated with the user's wallet card */
  financialAccount?: Maybe<FinancialAccount>;
};

export type UserWalletCardsResponse = {
  __typename?: 'UserWalletCardsResponse';
  cards: Array<Maybe<UserWalletCard>>;
};

export type Variant = {
  __typename?: 'Variant';
  variantId: Scalars['String'];
  variantName: Scalars['String'];
  customData?: Maybe<Scalars['JSON']>;
};

export type VehicleModel = {
  __typename?: 'VehicleModel';
  /** The unique key for this vehicle model */
  key?: Maybe<Scalars['String']>;
  /** The display name for the vehicle model */
  name?: Maybe<Scalars['String']>;
};

export type VehiclePremiumByYear = {
  __typename?: 'VehiclePremiumByYear';
  /** The model year of the vehicle */
  modelYear?: Maybe<Scalars['String']>;
  /** The average annual premium */
  averagePremium: Scalars['Float'];
};

export type VehicleYearCheapestPremiums = {
  __typename?: 'VehicleYearCheapestPremiums';
  /** The model year of the vehicle */
  modelYear?: Maybe<Scalars['String']>;
  /** Array of cheapest companies and annual premiums for this model year */
  offers?: Maybe<Array<AutoInsuranceCarrier>>;
};

export type WealthRecommenderUser = {
  __typename?: 'WealthRecommenderUser';
  /** User-defined amount for how much to keep in their checking account */
  checkingTargetBalance?: Maybe<Scalars['Float']>;
  /** ID for wealth-recommender user */
  id: Scalars['ID'];
  /**
   * Whether the user has dismissed notification about saving too much money
   * before paying off debt
   */
  isDebtWarningDismissed: Scalars['Boolean'];
  /**
   * NW-defined amount that the user should maintain in their checking account
   * (1.5x average monthly spend)
   */
  recommendedChecking?: Maybe<Scalars['Float']>;
  /**
   * NW-defined amount that the user should maintain in their savings account.
   * (3x average monthly spend)
   */
  recommendedSavings?: Maybe<Scalars['Float']>;
  /** User-defined amount for how much to keep in their savings account */
  savingsTargetBalance?: Maybe<Scalars['Float']>;
};

export type WebFeatureDiscoveryDetails = {
  __typename?: 'WebFeatureDiscoveryDetails';
  title?: Maybe<Scalars['String']>;
  copy: Scalars['String'];
  destinationUrl: Scalars['String'];
  featuredImageUrl: Scalars['URL'];
  featureName: Scalars['String'];
};

export type WhyDidMyScoreChangeDataVisualization = UserInsightDataVisualizationInterface & {
  __typename?: 'WhyDidMyScoreChangeDataVisualization';
  /** This will always be WHY_DID_MY_SCORE_CHANGE */
  dataVisualizationType: UserInsightDataVisualizationTypeEnum;
  /** User's current credit score info */
  creditScoreChangeInfo: CreditScoreChangeInfo;
};

/** The input type representing the Yak message to be published */
export type YakMessageInput = {
  /**
   * The Yak exchange to which the message should be delivered. Supplied on the message envelope.
   *
   * Example: `ANALYTIC_PIPELINE_MOUTH`
   */
  exchangeId: Scalars['String'];
  /** A GUID (UUID) for this specific message. Supplied on the message envelope. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * The Yak message type. Supplied on the message envelope.
   *
   * Example: `navigate` (for a navigation analytics event)
   */
  type?: InputMaybe<Scalars['String']>;
  /** The Yak message subtype. Supplied on the message envelope. */
  subType?: InputMaybe<Scalars['String']>;
  /** The Yak message payload. */
  payload?: InputMaybe<Scalars['JSON']>;
};

export type AdvertiserDisclosureFragment = { __typename?: 'Article', showAdvertiserDisclosure: boolean, disclosureType: string };

export type AuthorDetailsFragment = { __typename?: 'Author', contactEmail?: string | null, facebook?: any | null, name?: string | null, link?: any | null, slug?: string | null, tagline?: string | null, twitter?: string | null, authorBoxAvatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', url?: any | null }> | null };

export type AuthorBoxFragment = { __typename?: 'Article', authors?: Array<{ __typename?: 'Author', contactEmail?: string | null, facebook?: any | null, name?: string | null, link?: any | null, slug?: string | null, tagline?: string | null, twitter?: string | null, authorBoxAvatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', url?: any | null }> | null }> | null };

export type BlockGroupFragment = { __typename?: 'BlockGroup', id: string, blocks?: Array<{ __typename?: 'CombinedBlockGroupBlock', type?: string | null, title?: string | null, data?: any | null } | null> | null };

export type BlockFragment = { __typename?: 'CombinedBlockGroupBlock', type?: string | null, title?: string | null, data?: any | null };

export type CcHeadToHeadLinksFragment = { __typename?: 'Article', creditCardsHeadToHead?: Array<{ __typename?: 'AutoLoansInstitutionV2', productType: string } | { __typename?: 'AutoLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any } | null } | { __typename?: 'AutoLoansProductV2', productType: string } | { __typename?: 'BankingInstitutionV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any } | null } | { __typename?: 'BankingOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any } | null } | { __typename?: 'BankingProductV2', productType: string } | { __typename?: 'CreditCardsInstitutionV2', productType: string } | { __typename?: 'CreditCardsOfferV2', displayName?: string | null, monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any } | null } | { __typename?: 'CreditCardsProductV2', productType: string } | { __typename?: 'EducationLoansInstitutionV2', productType: string } | { __typename?: 'EducationLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any } | null } | { __typename?: 'EducationLoansProductV2', productType: string } | { __typename?: 'InsuranceInstitutionV2', productType: string } | { __typename?: 'InsuranceOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any } | null } | { __typename?: 'InsuranceProductV2', productType: string } | { __typename?: 'InvestingInstitutionV2', productType: string } | { __typename?: 'InvestingOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any } | null } | { __typename?: 'InvestingProductV2', productType: string } | { __typename?: 'MortgagesInstitutionV2', productType: string } | { __typename?: 'MortgagesOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any } | null } | { __typename?: 'MortgagesProductV2', productType: string } | { __typename?: 'PersonalLoansInstitutionV2', productType: string } | { __typename?: 'PersonalLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any } | null } | { __typename?: 'PersonalLoansProductV2', productType: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', productType: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any } | null } | { __typename?: 'SmallMediumBusinessLoansProductV2', productType: string } | { __typename?: 'SoftwareInstitutionV2', productType: string } | { __typename?: 'SoftwareOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any } | null } | { __typename?: 'SoftwareProductV2', productType: string } | { __typename?: 'ThirdPartyEmbedsInstitution', productType: string } | { __typename?: 'ThirdPartyEmbedsProduct', productType: string } | null> | null };

export type CcHeadToHeadFragment = { __typename?: 'Article', creditCardsHeadToHead?: Array<{ __typename?: 'AutoLoansInstitutionV2', productType: string } | { __typename?: 'AutoLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'AutoLoansProductV2', productType: string } | { __typename?: 'BankingInstitutionV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'BankingOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'BankingProductV2', productType: string } | { __typename?: 'CreditCardsInstitutionV2', productType: string } | { __typename?: 'CreditCardsOfferV2', displayName?: string | null, starRating?: number | null, productType: string, phoneNumber?: string | null, reviewLink?: any | null, termsAndFeesLink?: any | null, monetizable: string, image?: { __typename?: 'EntityPlacementImage', sourceMedium?: any | null, alt?: string | null } | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'CreditCardsProductV2', productType: string } | { __typename?: 'EducationLoansInstitutionV2', productType: string } | { __typename?: 'EducationLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'EducationLoansProductV2', productType: string } | { __typename?: 'InsuranceInstitutionV2', productType: string } | { __typename?: 'InsuranceOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'InsuranceProductV2', productType: string } | { __typename?: 'InvestingInstitutionV2', productType: string } | { __typename?: 'InvestingOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'InvestingProductV2', productType: string } | { __typename?: 'MortgagesInstitutionV2', productType: string } | { __typename?: 'MortgagesOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'MortgagesProductV2', productType: string } | { __typename?: 'PersonalLoansInstitutionV2', productType: string } | { __typename?: 'PersonalLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'PersonalLoansProductV2', productType: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', productType: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'SmallMediumBusinessLoansProductV2', productType: string } | { __typename?: 'SoftwareInstitutionV2', productType: string } | { __typename?: 'SoftwareOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'SoftwareProductV2', productType: string } | { __typename?: 'ThirdPartyEmbedsInstitution', productType: string } | { __typename?: 'ThirdPartyEmbedsProduct', productType: string } | null> | null };

export type ContentPageHeaderFragment = { __typename: 'Article', hideDate?: boolean | null, showLastModifiedDate?: boolean | null, hideFeaturedImage?: boolean | null, advertiserDisclosureType: string, editorialDisclaimerType?: string | null, id: string, showAdvertiserDisclosure: boolean, showAuthorByline: boolean, showEditorialDisclaimer: boolean, title?: string | null, dateTimeDisplayDate?: any | null, stringSynopsis?: string | null, featuredImage?: { __typename?: 'MediaItem', id: string, altText?: string | null, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', sourceUrl?: any | null, width?: number | null, height?: number | null, size?: string | null }> | null } | null } | null, reviewedBy?: Array<{ __typename?: 'ContentReviewer', name?: string | null, url?: any | null }> | null, authors?: Array<{ __typename?: 'Author', name?: string | null, link?: any | null }> | null, primaryCategory?: { __typename?: 'Category', name?: string | null } | null };

export type EditorialStandardsFragment = { __typename?: 'Article', showEditorialDisclaimer: boolean, disclaimerType?: string | null };

export type HouseAdFragment = { __typename?: 'Article', articleType?: ArticleTypeEnum | null, houseAd?: { __typename?: 'HouseAd', id: string } | null };

export type MethodologyFragment = { __typename?: 'Article', methodology?: { __typename?: 'Block', content?: any | null } | null };

export type NextStepsFragment = { __typename?: 'Article', id: string, articleType?: ArticleTypeEnum | null, nextSteps?: { __typename?: 'BlockGroup', id: string, blocks?: Array<{ __typename?: 'CombinedBlockGroupBlock', type?: string | null, title?: string | null, data?: any | null } | null> | null } | null, primaryCategory?: { __typename?: 'Category', name?: string | null, link: any } | null };

export type RelatedLinksFragment = { __typename?: 'Article', id: string, articleType?: ArticleTypeEnum | null, relatedLinks?: { __typename?: 'BlockGroup', id: string, blocks?: Array<{ __typename?: 'CombinedBlockGroupBlock', type?: string | null, title?: string | null, data?: any | null } | null> | null } | null, primaryCategory?: { __typename?: 'Category', name?: string | null, link: any } | null };

export type BreadcrumbFragment = { __typename?: 'Article', breadcrumb?: { __typename?: 'Breadcrumb', slug?: string | null, page?: { __typename?: 'BreadcrumbPage', title: string } | null } | null };

export type ArticleFragmentFragment = { __typename: 'Article', id: string, isPublished: boolean, articleType?: ArticleTypeEnum | null, title?: string | null, heroBannerDocument?: any | null, bottomStickyDocument?: any | null, slug?: string | null, pageTaxonomy?: any | null, content?: any | null, link?: any | null, showEditorialDisclaimer: boolean, showAuthorBox?: boolean | null, contentClusters?: Array<string> | null, attributionVertical?: string | null, attributionTopic?: string | null, primaryContentCluster?: string | null, marketplaceEntityLogoRowDocument?: any | null, takeaways?: any | null, bottomDocument?: any | null, sidebarDocument?: any | null, hideDate?: boolean | null, showLastModifiedDate?: boolean | null, synopsis?: string | null, type: string, modified?: string | null, date?: string | null, useReviewSchemaType?: boolean | null, reviewProductName?: string | null, reviewRating?: number | null, contentTags?: Array<string> | null, showAdvertiserDisclosure: boolean, hideFeaturedImage?: boolean | null, advertiserDisclosureType: string, editorialDisclaimerType?: string | null, showAuthorByline: boolean, disclosureType: string, disclaimerType?: string | null, dateTimeDisplayDate?: any | null, stringSynopsis?: string | null, seo?: { __typename?: 'SeoSettings', extraJsonLd?: any | null, title?: string | null, description?: string | null, nofollow?: boolean | null, noindex?: boolean | null, keyword?: string | null, facebook?: { __typename?: 'SocialSeoSettings', title?: string | null, description?: string | null } | null, twitter?: { __typename?: 'SocialSeoSettings', title?: string | null, description?: string | null, image?: any | null } | null } | null, nextSteps?: { __typename?: 'BlockGroup', id: string, blocks?: Array<{ __typename?: 'CombinedBlockGroupBlock', type?: string | null, title?: string | null, data?: any | null } | null> | null } | null, primaryCategory?: { __typename?: 'Category', name?: string | null, link: any } | null, relatedLinks?: { __typename?: 'BlockGroup', id: string, blocks?: Array<{ __typename?: 'CombinedBlockGroupBlock', type?: string | null, title?: string | null, data?: any | null } | null> | null } | null, authors?: Array<{ __typename?: 'Author', name?: string | null, link?: any | null, id: string, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, contactEmail?: string | null, facebook?: any | null, slug?: string | null, tagline?: string | null, twitter?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null, authorBoxAvatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', url?: any | null }> | null }> | null, methodology?: { __typename?: 'Block', content?: any | null } | null, houseAd?: { __typename?: 'HouseAd', id: string } | null, featuredMedia?: { __typename?: 'MediaItem', id: string, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', sourceUrl?: any | null, width?: number | null, height?: number | null }> | null } | null } | null, featuredMediaForJsonLd?: { __typename?: 'MediaItem', id: string, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', size?: string | null, sourceUrl?: any | null, width?: number | null, height?: number | null }> | null } | null } | null, breadcrumb?: { __typename?: 'Breadcrumb', slug?: string | null, page?: { __typename?: 'BreadcrumbPage', title: string } | null } | null, creditCardsHeadToHead?: Array<{ __typename?: 'AutoLoansInstitutionV2', productType: string } | { __typename?: 'AutoLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'AutoLoansProductV2', productType: string } | { __typename?: 'BankingInstitutionV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'BankingOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'BankingProductV2', productType: string } | { __typename?: 'CreditCardsInstitutionV2', productType: string } | { __typename?: 'CreditCardsOfferV2', displayName?: string | null, starRating?: number | null, productType: string, phoneNumber?: string | null, reviewLink?: any | null, termsAndFeesLink?: any | null, monetizable: string, image?: { __typename?: 'EntityPlacementImage', sourceMedium?: any | null, alt?: string | null } | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'CreditCardsProductV2', productType: string } | { __typename?: 'EducationLoansInstitutionV2', productType: string } | { __typename?: 'EducationLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'EducationLoansProductV2', productType: string } | { __typename?: 'InsuranceInstitutionV2', productType: string } | { __typename?: 'InsuranceOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'InsuranceProductV2', productType: string } | { __typename?: 'InvestingInstitutionV2', productType: string } | { __typename?: 'InvestingOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'InvestingProductV2', productType: string } | { __typename?: 'MortgagesInstitutionV2', productType: string } | { __typename?: 'MortgagesOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'MortgagesProductV2', productType: string } | { __typename?: 'PersonalLoansInstitutionV2', productType: string } | { __typename?: 'PersonalLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'PersonalLoansProductV2', productType: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', productType: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'SmallMediumBusinessLoansProductV2', productType: string } | { __typename?: 'SoftwareInstitutionV2', productType: string } | { __typename?: 'SoftwareOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'SoftwareProductV2', productType: string } | { __typename?: 'ThirdPartyEmbedsInstitution', productType: string } | { __typename?: 'ThirdPartyEmbedsProduct', productType: string } | null> | null, featuredImage?: { __typename?: 'MediaItem', id: string, altText?: string | null, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', sourceUrl?: any | null, width?: number | null, height?: number | null, size?: string | null }> | null } | null } | null, reviewedBy?: Array<{ __typename?: 'ContentReviewer', name?: string | null, id: string, link?: any | null, honorificSuffix?: string | null, jobTitle?: string | null, knowsAbout?: string | null, alumniOf?: Array<string> | null, url?: any | null, featuredMedia?: { __typename?: 'MediaItem', id: string, croppedImages?: Array<{ __typename?: 'CroppedImageSize', sourceUrl?: any | null }> | null } | null }> | null, assigningEditor?: { __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null } | null, categories?: Array<{ __typename?: 'Category', name?: string | null }> | null };

export type ArticleQueryVariables = Exact<{
  identifier: Scalars['ID'];
  wpnonce?: InputMaybe<Scalars['ID']>;
}>;


export type ArticleQuery = { __typename?: 'Query', article?: { __typename: 'Article', id: string, isPublished: boolean, articleType?: ArticleTypeEnum | null, title?: string | null, heroBannerDocument?: any | null, bottomStickyDocument?: any | null, slug?: string | null, pageTaxonomy?: any | null, content?: any | null, link?: any | null, showEditorialDisclaimer: boolean, showAuthorBox?: boolean | null, contentClusters?: Array<string> | null, attributionVertical?: string | null, attributionTopic?: string | null, primaryContentCluster?: string | null, marketplaceEntityLogoRowDocument?: any | null, takeaways?: any | null, bottomDocument?: any | null, sidebarDocument?: any | null, hideDate?: boolean | null, showLastModifiedDate?: boolean | null, synopsis?: string | null, type: string, modified?: string | null, date?: string | null, useReviewSchemaType?: boolean | null, reviewProductName?: string | null, reviewRating?: number | null, contentTags?: Array<string> | null, showAdvertiserDisclosure: boolean, hideFeaturedImage?: boolean | null, advertiserDisclosureType: string, editorialDisclaimerType?: string | null, showAuthorByline: boolean, disclosureType: string, disclaimerType?: string | null, dateTimeDisplayDate?: any | null, stringSynopsis?: string | null, seo?: { __typename?: 'SeoSettings', extraJsonLd?: any | null, title?: string | null, description?: string | null, nofollow?: boolean | null, noindex?: boolean | null, keyword?: string | null, facebook?: { __typename?: 'SocialSeoSettings', title?: string | null, description?: string | null } | null, twitter?: { __typename?: 'SocialSeoSettings', title?: string | null, description?: string | null, image?: any | null } | null } | null, nextSteps?: { __typename?: 'BlockGroup', id: string, blocks?: Array<{ __typename?: 'CombinedBlockGroupBlock', type?: string | null, title?: string | null, data?: any | null } | null> | null } | null, primaryCategory?: { __typename?: 'Category', name?: string | null, link: any } | null, relatedLinks?: { __typename?: 'BlockGroup', id: string, blocks?: Array<{ __typename?: 'CombinedBlockGroupBlock', type?: string | null, title?: string | null, data?: any | null } | null> | null } | null, authors?: Array<{ __typename?: 'Author', name?: string | null, link?: any | null, id: string, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, contactEmail?: string | null, facebook?: any | null, slug?: string | null, tagline?: string | null, twitter?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null, authorBoxAvatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', url?: any | null }> | null }> | null, methodology?: { __typename?: 'Block', content?: any | null } | null, houseAd?: { __typename?: 'HouseAd', id: string } | null, featuredMedia?: { __typename?: 'MediaItem', id: string, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', sourceUrl?: any | null, width?: number | null, height?: number | null }> | null } | null } | null, featuredMediaForJsonLd?: { __typename?: 'MediaItem', id: string, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', size?: string | null, sourceUrl?: any | null, width?: number | null, height?: number | null }> | null } | null } | null, breadcrumb?: { __typename?: 'Breadcrumb', slug?: string | null, page?: { __typename?: 'BreadcrumbPage', title: string } | null } | null, creditCardsHeadToHead?: Array<{ __typename?: 'AutoLoansInstitutionV2', productType: string } | { __typename?: 'AutoLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'AutoLoansProductV2', productType: string } | { __typename?: 'BankingInstitutionV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'BankingOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'BankingProductV2', productType: string } | { __typename?: 'CreditCardsInstitutionV2', productType: string } | { __typename?: 'CreditCardsOfferV2', displayName?: string | null, starRating?: number | null, productType: string, phoneNumber?: string | null, reviewLink?: any | null, termsAndFeesLink?: any | null, monetizable: string, image?: { __typename?: 'EntityPlacementImage', sourceMedium?: any | null, alt?: string | null } | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'CreditCardsProductV2', productType: string } | { __typename?: 'EducationLoansInstitutionV2', productType: string } | { __typename?: 'EducationLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'EducationLoansProductV2', productType: string } | { __typename?: 'InsuranceInstitutionV2', productType: string } | { __typename?: 'InsuranceOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'InsuranceProductV2', productType: string } | { __typename?: 'InvestingInstitutionV2', productType: string } | { __typename?: 'InvestingOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'InvestingProductV2', productType: string } | { __typename?: 'MortgagesInstitutionV2', productType: string } | { __typename?: 'MortgagesOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'MortgagesProductV2', productType: string } | { __typename?: 'PersonalLoansInstitutionV2', productType: string } | { __typename?: 'PersonalLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'PersonalLoansProductV2', productType: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', productType: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'SmallMediumBusinessLoansProductV2', productType: string } | { __typename?: 'SoftwareInstitutionV2', productType: string } | { __typename?: 'SoftwareOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'SoftwareProductV2', productType: string } | { __typename?: 'ThirdPartyEmbedsInstitution', productType: string } | { __typename?: 'ThirdPartyEmbedsProduct', productType: string } | null> | null, featuredImage?: { __typename?: 'MediaItem', id: string, altText?: string | null, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', sourceUrl?: any | null, width?: number | null, height?: number | null, size?: string | null }> | null } | null } | null, reviewedBy?: Array<{ __typename?: 'ContentReviewer', name?: string | null, id: string, link?: any | null, honorificSuffix?: string | null, jobTitle?: string | null, knowsAbout?: string | null, alumniOf?: Array<string> | null, url?: any | null, featuredMedia?: { __typename?: 'MediaItem', id: string, croppedImages?: Array<{ __typename?: 'CroppedImageSize', sourceUrl?: any | null }> | null } | null }> | null, assigningEditor?: { __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null } | null, categories?: Array<{ __typename?: 'Category', name?: string | null }> | null } | null };

export type ArticleForkQueryVariables = Exact<{
  identifier: Scalars['ID'];
  wpnonce?: InputMaybe<Scalars['String']>;
  forkPreview?: InputMaybe<Scalars['Boolean']>;
  forkIdentifier: Scalars['Int'];
  forkNonce?: InputMaybe<Scalars['String']>;
}>;


export type ArticleForkQuery = { __typename?: 'Query', articleFork?: { __typename: 'Article', id: string, isPublished: boolean, articleType?: ArticleTypeEnum | null, title?: string | null, heroBannerDocument?: any | null, bottomStickyDocument?: any | null, slug?: string | null, pageTaxonomy?: any | null, content?: any | null, link?: any | null, showEditorialDisclaimer: boolean, showAuthorBox?: boolean | null, contentClusters?: Array<string> | null, attributionVertical?: string | null, attributionTopic?: string | null, primaryContentCluster?: string | null, marketplaceEntityLogoRowDocument?: any | null, takeaways?: any | null, bottomDocument?: any | null, sidebarDocument?: any | null, hideDate?: boolean | null, showLastModifiedDate?: boolean | null, synopsis?: string | null, type: string, modified?: string | null, date?: string | null, useReviewSchemaType?: boolean | null, reviewProductName?: string | null, reviewRating?: number | null, contentTags?: Array<string> | null, showAdvertiserDisclosure: boolean, hideFeaturedImage?: boolean | null, advertiserDisclosureType: string, editorialDisclaimerType?: string | null, showAuthorByline: boolean, disclosureType: string, disclaimerType?: string | null, dateTimeDisplayDate?: any | null, stringSynopsis?: string | null, seo?: { __typename?: 'SeoSettings', extraJsonLd?: any | null, title?: string | null, description?: string | null, nofollow?: boolean | null, noindex?: boolean | null, keyword?: string | null, facebook?: { __typename?: 'SocialSeoSettings', title?: string | null, description?: string | null } | null, twitter?: { __typename?: 'SocialSeoSettings', title?: string | null, description?: string | null, image?: any | null } | null } | null, nextSteps?: { __typename?: 'BlockGroup', id: string, blocks?: Array<{ __typename?: 'CombinedBlockGroupBlock', type?: string | null, title?: string | null, data?: any | null } | null> | null } | null, primaryCategory?: { __typename?: 'Category', name?: string | null, link: any } | null, relatedLinks?: { __typename?: 'BlockGroup', id: string, blocks?: Array<{ __typename?: 'CombinedBlockGroupBlock', type?: string | null, title?: string | null, data?: any | null } | null> | null } | null, authors?: Array<{ __typename?: 'Author', name?: string | null, link?: any | null, id: string, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, contactEmail?: string | null, facebook?: any | null, slug?: string | null, tagline?: string | null, twitter?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null, authorBoxAvatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', url?: any | null }> | null }> | null, methodology?: { __typename?: 'Block', content?: any | null } | null, houseAd?: { __typename?: 'HouseAd', id: string } | null, featuredMedia?: { __typename?: 'MediaItem', id: string, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', sourceUrl?: any | null, width?: number | null, height?: number | null }> | null } | null } | null, featuredMediaForJsonLd?: { __typename?: 'MediaItem', id: string, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', size?: string | null, sourceUrl?: any | null, width?: number | null, height?: number | null }> | null } | null } | null, breadcrumb?: { __typename?: 'Breadcrumb', slug?: string | null, page?: { __typename?: 'BreadcrumbPage', title: string } | null } | null, creditCardsHeadToHead?: Array<{ __typename?: 'AutoLoansInstitutionV2', productType: string } | { __typename?: 'AutoLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'AutoLoansProductV2', productType: string } | { __typename?: 'BankingInstitutionV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'BankingOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'BankingProductV2', productType: string } | { __typename?: 'CreditCardsInstitutionV2', productType: string } | { __typename?: 'CreditCardsOfferV2', displayName?: string | null, starRating?: number | null, productType: string, phoneNumber?: string | null, reviewLink?: any | null, termsAndFeesLink?: any | null, monetizable: string, image?: { __typename?: 'EntityPlacementImage', sourceMedium?: any | null, alt?: string | null } | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'CreditCardsProductV2', productType: string } | { __typename?: 'EducationLoansInstitutionV2', productType: string } | { __typename?: 'EducationLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'EducationLoansProductV2', productType: string } | { __typename?: 'InsuranceInstitutionV2', productType: string } | { __typename?: 'InsuranceOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'InsuranceProductV2', productType: string } | { __typename?: 'InvestingInstitutionV2', productType: string } | { __typename?: 'InvestingOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'InvestingProductV2', productType: string } | { __typename?: 'MortgagesInstitutionV2', productType: string } | { __typename?: 'MortgagesOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'MortgagesProductV2', productType: string } | { __typename?: 'PersonalLoansInstitutionV2', productType: string } | { __typename?: 'PersonalLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'PersonalLoansProductV2', productType: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', productType: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'SmallMediumBusinessLoansProductV2', productType: string } | { __typename?: 'SoftwareInstitutionV2', productType: string } | { __typename?: 'SoftwareOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, institutionId: string, offerId?: string | null, productId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null } | { __typename?: 'SoftwareProductV2', productType: string } | { __typename?: 'ThirdPartyEmbedsInstitution', productType: string } | { __typename?: 'ThirdPartyEmbedsProduct', productType: string } | null> | null, featuredImage?: { __typename?: 'MediaItem', id: string, altText?: string | null, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', sourceUrl?: any | null, width?: number | null, height?: number | null, size?: string | null }> | null } | null } | null, reviewedBy?: Array<{ __typename?: 'ContentReviewer', name?: string | null, id: string, link?: any | null, honorificSuffix?: string | null, jobTitle?: string | null, knowsAbout?: string | null, alumniOf?: Array<string> | null, url?: any | null, featuredMedia?: { __typename?: 'MediaItem', id: string, croppedImages?: Array<{ __typename?: 'CroppedImageSize', sourceUrl?: any | null }> | null } | null }> | null, assigningEditor?: { __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null } | null, categories?: Array<{ __typename?: 'Category', name?: string | null }> | null } | null };

export type GetAbTestConfigFragment = { __typename?: 'Article', articleType?: ArticleTypeEnum | null };

export type GetArticleCanonicalUrlFragment = { __typename?: 'Article', link?: any | null };

export type GetArticleSchemaFragment = { __typename: 'Article', id: string, link?: any | null, modified?: string | null, date?: string | null, useReviewSchemaType?: boolean | null, reviewProductName?: string | null, reviewRating?: number | null, contentTags?: Array<string> | null, featuredMediaForJsonLd?: { __typename?: 'MediaItem', id: string, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', size?: string | null, sourceUrl?: any | null, width?: number | null, height?: number | null }> | null } | null } | null, authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null, reviewedBy?: Array<{ __typename?: 'ContentReviewer', id: string, name?: string | null, link?: any | null, honorificSuffix?: string | null, jobTitle?: string | null, knowsAbout?: string | null, alumniOf?: Array<string> | null, featuredMedia?: { __typename?: 'MediaItem', id: string, croppedImages?: Array<{ __typename?: 'CroppedImageSize', sourceUrl?: any | null }> | null } | null }> | null, assigningEditor?: { __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null } | null, categories?: Array<{ __typename?: 'Category', name?: string | null }> | null };

export type GetArticleSchemaQueryVariables = Exact<{
  articleId: Scalars['ID'];
}>;


export type GetArticleSchemaQuery = { __typename?: 'Query', article?: { __typename: 'Article', id: string, link?: any | null, modified?: string | null, date?: string | null, useReviewSchemaType?: boolean | null, reviewProductName?: string | null, reviewRating?: number | null, contentTags?: Array<string> | null, featuredMediaForJsonLd?: { __typename?: 'MediaItem', id: string, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', size?: string | null, sourceUrl?: any | null, width?: number | null, height?: number | null }> | null } | null } | null, authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null, reviewedBy?: Array<{ __typename?: 'ContentReviewer', id: string, name?: string | null, link?: any | null, honorificSuffix?: string | null, jobTitle?: string | null, knowsAbout?: string | null, alumniOf?: Array<string> | null, featuredMedia?: { __typename?: 'MediaItem', id: string, croppedImages?: Array<{ __typename?: 'CroppedImageSize', sourceUrl?: any | null }> | null } | null }> | null, assigningEditor?: { __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null } | null, categories?: Array<{ __typename?: 'Category', name?: string | null }> | null } | null };

export type GetBccArticleSchemaFragment = { __typename: 'BccPage', date?: string | null, modified?: string | null, title?: string | null, imageForBccArticleSchema?: string | null, seo?: { __typename?: 'SeoSettings', title?: string | null } | null, authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null, reviewedBy?: Array<{ __typename?: 'ContentReviewer', id: string, name?: string | null, link?: any | null, honorificSuffix?: string | null, jobTitle?: string | null, knowsAbout?: string | null, alumniOf?: Array<string> | null, featuredMedia?: { __typename?: 'MediaItem', id: string, croppedImages?: Array<{ __typename?: 'CroppedImageSize', sourceUrl?: any | null }> | null } | null }> | null };

export type GetBccItemListSchemaFragment = { __typename?: 'BccPage', link?: any | null, title?: string | null, sections?: Array<{ __typename?: 'BccPageSection', identifier?: string | null, shortTitle?: string | null, offers?: Array<{ __typename?: 'BccPageCard', cardId?: string | null, offer?: { __typename?: 'CreditCardsOfferV2', annualFee?: number | null, aprMax?: number | null, aprMin?: number | null, displayName?: string | null, image?: { __typename?: 'EntityPlacementImage', sourceLarge?: any | null } | null } | null }> | null }> | null };

type GetReviewerSchema_Article_Fragment = { __typename: 'Article', reviewedBy?: Array<{ __typename?: 'ContentReviewer', id: string, name?: string | null, link?: any | null, honorificSuffix?: string | null, jobTitle?: string | null, knowsAbout?: string | null, alumniOf?: Array<string> | null, featuredMedia?: { __typename?: 'MediaItem', id: string, croppedImages?: Array<{ __typename?: 'CroppedImageSize', sourceUrl?: any | null }> | null } | null }> | null };

type GetReviewerSchema_BccPage_Fragment = { __typename: 'BccPage', reviewedBy?: Array<{ __typename?: 'ContentReviewer', id: string, name?: string | null, link?: any | null, honorificSuffix?: string | null, jobTitle?: string | null, knowsAbout?: string | null, alumniOf?: Array<string> | null, featuredMedia?: { __typename?: 'MediaItem', id: string, croppedImages?: Array<{ __typename?: 'CroppedImageSize', sourceUrl?: any | null }> | null } | null }> | null };

type GetReviewerSchema_Review_Fragment = { __typename: 'Review', reviewedBy?: Array<{ __typename?: 'ContentReviewer', id: string, name?: string | null, link?: any | null, honorificSuffix?: string | null, jobTitle?: string | null, knowsAbout?: string | null, alumniOf?: Array<string> | null, featuredMedia?: { __typename?: 'MediaItem', id: string, croppedImages?: Array<{ __typename?: 'CroppedImageSize', sourceUrl?: any | null }> | null } | null }> | null };

type GetReviewerSchema_Roundup_Fragment = { __typename: 'Roundup', reviewedBy?: Array<{ __typename?: 'ContentReviewer', id: string, name?: string | null, link?: any | null, honorificSuffix?: string | null, jobTitle?: string | null, knowsAbout?: string | null, alumniOf?: Array<string> | null, featuredMedia?: { __typename?: 'MediaItem', id: string, croppedImages?: Array<{ __typename?: 'CroppedImageSize', sourceUrl?: any | null }> | null } | null }> | null };

type GetReviewerSchema_UrlRecord_Fragment = { __typename: 'UrlRecord', reviewedBy?: Array<{ __typename?: 'ContentReviewer', id: string, name?: string | null, link?: any | null, honorificSuffix?: string | null, jobTitle?: string | null, knowsAbout?: string | null, alumniOf?: Array<string> | null, featuredMedia?: { __typename?: 'MediaItem', id: string, croppedImages?: Array<{ __typename?: 'CroppedImageSize', sourceUrl?: any | null }> | null } | null }> | null };

export type GetReviewerSchemaFragment = GetReviewerSchema_Article_Fragment | GetReviewerSchema_BccPage_Fragment | GetReviewerSchema_Review_Fragment | GetReviewerSchema_Roundup_Fragment | GetReviewerSchema_UrlRecord_Fragment;

type GetUserInfoSchema_Article_Fragment = { __typename?: 'Article', id: string, link?: any | null };

type GetUserInfoSchema_Banner_Fragment = { __typename?: 'Banner', id: string, link?: any | null };

type GetUserInfoSchema_BccPage_Fragment = { __typename?: 'BccPage', id: string, link?: any | null };

type GetUserInfoSchema_BccPageCard_Fragment = { __typename?: 'BccPageCard', id: string, link?: any | null };

type GetUserInfoSchema_Block_Fragment = { __typename?: 'Block', id: string, link?: any | null };

type GetUserInfoSchema_BlockGroup_Fragment = { __typename?: 'BlockGroup', id: string, link?: any | null };

type GetUserInfoSchema_ContentPack_Fragment = { __typename?: 'ContentPack', id: string, link?: any | null };

type GetUserInfoSchema_ContentReviewer_Fragment = { __typename?: 'ContentReviewer', honorificSuffix?: string | null, jobTitle?: string | null, alumniOf?: Array<string> | null, description?: string | null, id: string, link?: any | null, name?: string | null, knowsAbout?: string | null, socialMediaLinks?: Array<{ __typename?: 'AuthorSocialMediaLink', type: AuthorSocialMediaLinkTypeEnum, url: string }> | null, featuredMedia?: { __typename?: 'MediaItem', id: string, croppedImage?: { __typename?: 'CroppedImageSize', sourceUrl?: any | null } | null } | null };

type GetUserInfoSchema_ContentSearchResult_Fragment = { __typename?: 'ContentSearchResult', id: string, link?: any | null };

type GetUserInfoSchema_ContentUserPage_Fragment = { __typename?: 'ContentUserPage', awards?: Array<string> | null, jobTitle?: string | null, credentials?: Array<string> | null, id: string, link?: any | null, name?: string | null, memberOf?: Array<string> | null, socialMediaLinks?: Array<{ __typename?: 'AuthorSocialMediaLink', type: AuthorSocialMediaLinkTypeEnum, url: string }> | null, featuredMedia?: { __typename?: 'MediaItem', id: string, croppedImage?: { __typename?: 'CroppedImageSize', sourceUrl?: any | null } | null } | null, user?: { __typename?: 'Author', alumniOf?: string | null, description?: string | null, affiliation?: string | null, knowsAbout?: string | null } | null };

type GetUserInfoSchema_EngineeringPost_Fragment = { __typename?: 'EngineeringPost', id: string, link?: any | null };

type GetUserInfoSchema_GlobalNavItem_Fragment = { __typename?: 'GlobalNavItem', id: string, link?: any | null };

type GetUserInfoSchema_HouseAd_Fragment = { __typename?: 'HouseAd', id: string, link?: any | null };

type GetUserInfoSchema_Hub_Fragment = { __typename?: 'Hub', id: string, link?: any | null };

type GetUserInfoSchema_InsurancePage_Fragment = { __typename?: 'InsurancePage', id: string, link?: any | null };

type GetUserInfoSchema_LandingPage_Fragment = { __typename?: 'LandingPage', id: string, link?: any | null };

type GetUserInfoSchema_LegacyLender_Fragment = { __typename?: 'LegacyLender', id: string, link?: any | null };

type GetUserInfoSchema_MarketplaceEntryPoint_Fragment = { __typename?: 'MarketplaceEntryPoint', id: string, link?: any | null };

type GetUserInfoSchema_MediaItem_Fragment = { __typename?: 'MediaItem', id: string, link?: any | null };

type GetUserInfoSchema_Page_Fragment = { __typename?: 'Page', id: string, link?: any | null };

type GetUserInfoSchema_Post_Fragment = { __typename?: 'Post', id: string, link?: any | null };

type GetUserInfoSchema_PressRelease_Fragment = { __typename?: 'PressRelease', id: string, link?: any | null };

type GetUserInfoSchema_Review_Fragment = { __typename?: 'Review', id: string, link?: any | null };

type GetUserInfoSchema_Roundup_Fragment = { __typename?: 'Roundup', id: string, link?: any | null };

type GetUserInfoSchema_StructuredContentCalculator_Fragment = { __typename?: 'StructuredContentCalculator', id: string, link?: any | null };

type GetUserInfoSchema_Table_Fragment = { __typename?: 'Table', id: string, link?: any | null };

type GetUserInfoSchema_UrlRecord_Fragment = { __typename?: 'UrlRecord', id: string, link?: any | null };

export type GetUserInfoSchemaFragment = GetUserInfoSchema_Article_Fragment | GetUserInfoSchema_Banner_Fragment | GetUserInfoSchema_BccPage_Fragment | GetUserInfoSchema_BccPageCard_Fragment | GetUserInfoSchema_Block_Fragment | GetUserInfoSchema_BlockGroup_Fragment | GetUserInfoSchema_ContentPack_Fragment | GetUserInfoSchema_ContentReviewer_Fragment | GetUserInfoSchema_ContentSearchResult_Fragment | GetUserInfoSchema_ContentUserPage_Fragment | GetUserInfoSchema_EngineeringPost_Fragment | GetUserInfoSchema_GlobalNavItem_Fragment | GetUserInfoSchema_HouseAd_Fragment | GetUserInfoSchema_Hub_Fragment | GetUserInfoSchema_InsurancePage_Fragment | GetUserInfoSchema_LandingPage_Fragment | GetUserInfoSchema_LegacyLender_Fragment | GetUserInfoSchema_MarketplaceEntryPoint_Fragment | GetUserInfoSchema_MediaItem_Fragment | GetUserInfoSchema_Page_Fragment | GetUserInfoSchema_Post_Fragment | GetUserInfoSchema_PressRelease_Fragment | GetUserInfoSchema_Review_Fragment | GetUserInfoSchema_Roundup_Fragment | GetUserInfoSchema_StructuredContentCalculator_Fragment | GetUserInfoSchema_Table_Fragment | GetUserInfoSchema_UrlRecord_Fragment;

type GetAuthorSchema_Article_Fragment = { __typename: 'Article', authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type GetAuthorSchema_Banner_Fragment = { __typename: 'Banner', authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type GetAuthorSchema_BccPage_Fragment = { __typename: 'BccPage', authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type GetAuthorSchema_BccPageCard_Fragment = { __typename: 'BccPageCard', authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type GetAuthorSchema_Block_Fragment = { __typename: 'Block', authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type GetAuthorSchema_BlockGroup_Fragment = { __typename: 'BlockGroup', authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type GetAuthorSchema_ContentPack_Fragment = { __typename: 'ContentPack', authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type GetAuthorSchema_ContentReviewer_Fragment = { __typename: 'ContentReviewer', authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type GetAuthorSchema_ContentSearchResult_Fragment = { __typename: 'ContentSearchResult', authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type GetAuthorSchema_ContentUserPage_Fragment = { __typename: 'ContentUserPage', authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type GetAuthorSchema_EngineeringPost_Fragment = { __typename: 'EngineeringPost', authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type GetAuthorSchema_HouseAd_Fragment = { __typename: 'HouseAd', authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type GetAuthorSchema_Hub_Fragment = { __typename: 'Hub', authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type GetAuthorSchema_InsurancePage_Fragment = { __typename: 'InsurancePage', authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type GetAuthorSchema_LandingPage_Fragment = { __typename: 'LandingPage', authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type GetAuthorSchema_LegacyLender_Fragment = { __typename: 'LegacyLender', authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type GetAuthorSchema_MarketplaceEntryPoint_Fragment = { __typename: 'MarketplaceEntryPoint', authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type GetAuthorSchema_MediaItem_Fragment = { __typename: 'MediaItem', authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type GetAuthorSchema_Page_Fragment = { __typename: 'Page', authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type GetAuthorSchema_Post_Fragment = { __typename: 'Post', authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type GetAuthorSchema_PressRelease_Fragment = { __typename: 'PressRelease', authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type GetAuthorSchema_Review_Fragment = { __typename: 'Review', authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type GetAuthorSchema_Roundup_Fragment = { __typename: 'Roundup', authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type GetAuthorSchema_StructuredContentCalculator_Fragment = { __typename: 'StructuredContentCalculator', authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type GetAuthorSchema_UrlRecord_Fragment = { __typename: 'UrlRecord', authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

export type GetAuthorSchemaFragment = GetAuthorSchema_Article_Fragment | GetAuthorSchema_Banner_Fragment | GetAuthorSchema_BccPage_Fragment | GetAuthorSchema_BccPageCard_Fragment | GetAuthorSchema_Block_Fragment | GetAuthorSchema_BlockGroup_Fragment | GetAuthorSchema_ContentPack_Fragment | GetAuthorSchema_ContentReviewer_Fragment | GetAuthorSchema_ContentSearchResult_Fragment | GetAuthorSchema_ContentUserPage_Fragment | GetAuthorSchema_EngineeringPost_Fragment | GetAuthorSchema_HouseAd_Fragment | GetAuthorSchema_Hub_Fragment | GetAuthorSchema_InsurancePage_Fragment | GetAuthorSchema_LandingPage_Fragment | GetAuthorSchema_LegacyLender_Fragment | GetAuthorSchema_MarketplaceEntryPoint_Fragment | GetAuthorSchema_MediaItem_Fragment | GetAuthorSchema_Page_Fragment | GetAuthorSchema_Post_Fragment | GetAuthorSchema_PressRelease_Fragment | GetAuthorSchema_Review_Fragment | GetAuthorSchema_Roundup_Fragment | GetAuthorSchema_StructuredContentCalculator_Fragment | GetAuthorSchema_UrlRecord_Fragment;

export type GetEditorSchemaFragment = { __typename: 'Article', assigningEditor?: { __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null } | null };

type GetAboutSchema_Article_Fragment = { __typename: 'Article', categories?: Array<{ __typename?: 'Category', name?: string | null }> | null };

type GetAboutSchema_Banner_Fragment = { __typename: 'Banner' };

type GetAboutSchema_BccPage_Fragment = { __typename: 'BccPage' };

type GetAboutSchema_BccPageCard_Fragment = { __typename: 'BccPageCard' };

type GetAboutSchema_Block_Fragment = { __typename: 'Block' };

type GetAboutSchema_BlockGroup_Fragment = { __typename: 'BlockGroup' };

type GetAboutSchema_ContentPack_Fragment = { __typename: 'ContentPack' };

type GetAboutSchema_ContentReviewer_Fragment = { __typename: 'ContentReviewer' };

type GetAboutSchema_ContentSearchResult_Fragment = { __typename: 'ContentSearchResult' };

type GetAboutSchema_ContentUserPage_Fragment = { __typename: 'ContentUserPage' };

type GetAboutSchema_EngineeringPost_Fragment = { __typename: 'EngineeringPost' };

type GetAboutSchema_GlobalNavItem_Fragment = { __typename: 'GlobalNavItem' };

type GetAboutSchema_HouseAd_Fragment = { __typename: 'HouseAd' };

type GetAboutSchema_Hub_Fragment = { __typename: 'Hub' };

type GetAboutSchema_InsurancePage_Fragment = { __typename: 'InsurancePage' };

type GetAboutSchema_LandingPage_Fragment = { __typename: 'LandingPage' };

type GetAboutSchema_LegacyLender_Fragment = { __typename: 'LegacyLender' };

type GetAboutSchema_MarketplaceEntryPoint_Fragment = { __typename: 'MarketplaceEntryPoint' };

type GetAboutSchema_MediaItem_Fragment = { __typename: 'MediaItem' };

type GetAboutSchema_Page_Fragment = { __typename: 'Page' };

type GetAboutSchema_Post_Fragment = { __typename: 'Post' };

type GetAboutSchema_PressRelease_Fragment = { __typename: 'PressRelease' };

type GetAboutSchema_Review_Fragment = { __typename: 'Review' };

type GetAboutSchema_Roundup_Fragment = { __typename: 'Roundup', categories?: Array<{ __typename?: 'Category', name?: string | null }> | null };

type GetAboutSchema_StructuredContentCalculator_Fragment = { __typename: 'StructuredContentCalculator' };

type GetAboutSchema_Table_Fragment = { __typename: 'Table' };

type GetAboutSchema_UrlRecord_Fragment = { __typename: 'UrlRecord' };

export type GetAboutSchemaFragment = GetAboutSchema_Article_Fragment | GetAboutSchema_Banner_Fragment | GetAboutSchema_BccPage_Fragment | GetAboutSchema_BccPageCard_Fragment | GetAboutSchema_Block_Fragment | GetAboutSchema_BlockGroup_Fragment | GetAboutSchema_ContentPack_Fragment | GetAboutSchema_ContentReviewer_Fragment | GetAboutSchema_ContentSearchResult_Fragment | GetAboutSchema_ContentUserPage_Fragment | GetAboutSchema_EngineeringPost_Fragment | GetAboutSchema_GlobalNavItem_Fragment | GetAboutSchema_HouseAd_Fragment | GetAboutSchema_Hub_Fragment | GetAboutSchema_InsurancePage_Fragment | GetAboutSchema_LandingPage_Fragment | GetAboutSchema_LegacyLender_Fragment | GetAboutSchema_MarketplaceEntryPoint_Fragment | GetAboutSchema_MediaItem_Fragment | GetAboutSchema_Page_Fragment | GetAboutSchema_Post_Fragment | GetAboutSchema_PressRelease_Fragment | GetAboutSchema_Review_Fragment | GetAboutSchema_Roundup_Fragment | GetAboutSchema_StructuredContentCalculator_Fragment | GetAboutSchema_Table_Fragment | GetAboutSchema_UrlRecord_Fragment;

export type GetAuthorSchemaQueryVariables = Exact<{
  articleId: Scalars['ID'];
}>;


export type GetAuthorSchemaQuery = { __typename?: 'Query', article?: { __typename: 'Article', authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | null };

export type GetAboutSchemaQueryVariables = Exact<{
  articleId: Scalars['ID'];
}>;


export type GetAboutSchemaQuery = { __typename?: 'Query', article?: { __typename: 'Article', categories?: Array<{ __typename?: 'Category', name?: string | null }> | null } | null };

export type GetUserPageQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetUserPageQuery = { __typename?: 'Query', postById?: { __typename?: 'Article', id: string, link?: any | null } | { __typename?: 'Banner', id: string, link?: any | null } | { __typename?: 'BccPage', id: string, link?: any | null } | { __typename?: 'BccPageCard', id: string, link?: any | null } | { __typename?: 'Block', id: string, link?: any | null } | { __typename?: 'BlockGroup', id: string, link?: any | null } | { __typename?: 'ContentPack', id: string, link?: any | null } | { __typename?: 'ContentReviewer', honorificSuffix?: string | null, jobTitle?: string | null, alumniOf?: Array<string> | null, description?: string | null, id: string, link?: any | null, name?: string | null, knowsAbout?: string | null, socialMediaLinks?: Array<{ __typename?: 'AuthorSocialMediaLink', type: AuthorSocialMediaLinkTypeEnum, url: string }> | null, featuredMedia?: { __typename?: 'MediaItem', id: string, croppedImage?: { __typename?: 'CroppedImageSize', sourceUrl?: any | null } | null } | null } | { __typename?: 'ContentSearchResult', id: string, link?: any | null } | { __typename?: 'ContentUserPage', awards?: Array<string> | null, jobTitle?: string | null, credentials?: Array<string> | null, id: string, link?: any | null, name?: string | null, memberOf?: Array<string> | null, socialMediaLinks?: Array<{ __typename?: 'AuthorSocialMediaLink', type: AuthorSocialMediaLinkTypeEnum, url: string }> | null, featuredMedia?: { __typename?: 'MediaItem', id: string, croppedImage?: { __typename?: 'CroppedImageSize', sourceUrl?: any | null } | null } | null, user?: { __typename?: 'Author', alumniOf?: string | null, description?: string | null, affiliation?: string | null, knowsAbout?: string | null } | null } | { __typename?: 'EngineeringPost', id: string, link?: any | null } | { __typename?: 'GlobalNavItem', id: string, link?: any | null } | { __typename?: 'HouseAd', id: string, link?: any | null } | { __typename?: 'Hub', id: string, link?: any | null } | { __typename?: 'InsurancePage', id: string, link?: any | null } | { __typename?: 'LandingPage', id: string, link?: any | null } | { __typename?: 'LegacyLender', id: string, link?: any | null } | { __typename?: 'MarketplaceEntryPoint', id: string, link?: any | null } | { __typename?: 'MediaItem', id: string, link?: any | null } | { __typename?: 'Page', id: string, link?: any | null } | { __typename?: 'Post', id: string, link?: any | null } | { __typename?: 'PressRelease', id: string, link?: any | null } | { __typename?: 'Review', id: string, link?: any | null } | { __typename?: 'Roundup', id: string, link?: any | null } | { __typename?: 'StructuredContentCalculator', id: string, link?: any | null } | { __typename?: 'Table', id: string, link?: any | null } | { __typename?: 'UrlRecord', id: string, link?: any | null } | null };

export type GetReviewSchemaFragment = { __typename: 'Review', date?: string | null, link?: any | null, modified?: string | null, title?: string | null, marketplaceEntity?: { __typename?: 'AutoLoansInstitutionV2' } | { __typename?: 'AutoLoansOfferV2', displayName?: string | null, starRating?: number | null, institution: { __typename?: 'AutoLoansInstitutionV2', name: string } | { __typename?: 'AutoLoansOfferV2', name: string } | { __typename?: 'AutoLoansProductV2', name: string } | { __typename?: 'BankingInstitutionV2', name: string } | { __typename?: 'BankingOfferV2', name: string } | { __typename?: 'BankingProductV2', name: string } | { __typename?: 'CreditCardsInstitutionV2', name: string } | { __typename?: 'CreditCardsOfferV2', name: string } | { __typename?: 'CreditCardsProductV2', name: string } | { __typename?: 'EducationLoansInstitutionV2', name: string } | { __typename?: 'EducationLoansOfferV2', name: string } | { __typename?: 'EducationLoansProductV2', name: string } | { __typename?: 'InsuranceInstitutionV2', name: string } | { __typename?: 'InsuranceOfferV2', name: string } | { __typename?: 'InsuranceProductV2', name: string } | { __typename?: 'InvestingInstitutionV2', name: string } | { __typename?: 'InvestingOfferV2', name: string } | { __typename?: 'InvestingProductV2', name: string } | { __typename?: 'MortgagesInstitutionV2', name: string } | { __typename?: 'MortgagesOfferV2', name: string } | { __typename?: 'MortgagesProductV2', name: string } | { __typename?: 'PersonalLoansInstitutionV2', name: string } | { __typename?: 'PersonalLoansOfferV2', name: string } | { __typename?: 'PersonalLoansProductV2', name: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', name: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', name: string } | { __typename?: 'SmallMediumBusinessLoansProductV2', name: string } | { __typename?: 'SoftwareInstitutionV2', name: string } | { __typename?: 'SoftwareOfferV2', name: string } | { __typename?: 'SoftwareProductV2', name: string } | { __typename?: 'ThirdPartyEmbedsInstitution', name: string } | { __typename?: 'ThirdPartyEmbedsProduct', name: string } } | { __typename?: 'AutoLoansProductV2', institution: { __typename?: 'AutoLoansInstitutionV2', name: string } } | { __typename?: 'BankingInstitutionV2', displayName?: string | null, starRating?: number | null } | { __typename?: 'BankingOfferV2', displayName?: string | null, starRating?: number | null, institution: { __typename?: 'AutoLoansInstitutionV2', name: string } | { __typename?: 'AutoLoansOfferV2', name: string } | { __typename?: 'AutoLoansProductV2', name: string } | { __typename?: 'BankingInstitutionV2', name: string } | { __typename?: 'BankingOfferV2', name: string } | { __typename?: 'BankingProductV2', name: string } | { __typename?: 'CreditCardsInstitutionV2', name: string } | { __typename?: 'CreditCardsOfferV2', name: string } | { __typename?: 'CreditCardsProductV2', name: string } | { __typename?: 'EducationLoansInstitutionV2', name: string } | { __typename?: 'EducationLoansOfferV2', name: string } | { __typename?: 'EducationLoansProductV2', name: string } | { __typename?: 'InsuranceInstitutionV2', name: string } | { __typename?: 'InsuranceOfferV2', name: string } | { __typename?: 'InsuranceProductV2', name: string } | { __typename?: 'InvestingInstitutionV2', name: string } | { __typename?: 'InvestingOfferV2', name: string } | { __typename?: 'InvestingProductV2', name: string } | { __typename?: 'MortgagesInstitutionV2', name: string } | { __typename?: 'MortgagesOfferV2', name: string } | { __typename?: 'MortgagesProductV2', name: string } | { __typename?: 'PersonalLoansInstitutionV2', name: string } | { __typename?: 'PersonalLoansOfferV2', name: string } | { __typename?: 'PersonalLoansProductV2', name: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', name: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', name: string } | { __typename?: 'SmallMediumBusinessLoansProductV2', name: string } | { __typename?: 'SoftwareInstitutionV2', name: string } | { __typename?: 'SoftwareOfferV2', name: string } | { __typename?: 'SoftwareProductV2', name: string } | { __typename?: 'ThirdPartyEmbedsInstitution', name: string } | { __typename?: 'ThirdPartyEmbedsProduct', name: string } } | { __typename?: 'BankingProductV2', institution: { __typename?: 'BankingInstitutionV2', name: string } } | { __typename?: 'CreditCardsInstitutionV2' } | { __typename?: 'CreditCardsOfferV2', displayName?: string | null, starRating?: number | null, institution: { __typename?: 'AutoLoansInstitutionV2', name: string } | { __typename?: 'AutoLoansOfferV2', name: string } | { __typename?: 'AutoLoansProductV2', name: string } | { __typename?: 'BankingInstitutionV2', name: string } | { __typename?: 'BankingOfferV2', name: string } | { __typename?: 'BankingProductV2', name: string } | { __typename?: 'CreditCardsInstitutionV2', name: string } | { __typename?: 'CreditCardsOfferV2', name: string } | { __typename?: 'CreditCardsProductV2', name: string } | { __typename?: 'EducationLoansInstitutionV2', name: string } | { __typename?: 'EducationLoansOfferV2', name: string } | { __typename?: 'EducationLoansProductV2', name: string } | { __typename?: 'InsuranceInstitutionV2', name: string } | { __typename?: 'InsuranceOfferV2', name: string } | { __typename?: 'InsuranceProductV2', name: string } | { __typename?: 'InvestingInstitutionV2', name: string } | { __typename?: 'InvestingOfferV2', name: string } | { __typename?: 'InvestingProductV2', name: string } | { __typename?: 'MortgagesInstitutionV2', name: string } | { __typename?: 'MortgagesOfferV2', name: string } | { __typename?: 'MortgagesProductV2', name: string } | { __typename?: 'PersonalLoansInstitutionV2', name: string } | { __typename?: 'PersonalLoansOfferV2', name: string } | { __typename?: 'PersonalLoansProductV2', name: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', name: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', name: string } | { __typename?: 'SmallMediumBusinessLoansProductV2', name: string } | { __typename?: 'SoftwareInstitutionV2', name: string } | { __typename?: 'SoftwareOfferV2', name: string } | { __typename?: 'SoftwareProductV2', name: string } | { __typename?: 'ThirdPartyEmbedsInstitution', name: string } | { __typename?: 'ThirdPartyEmbedsProduct', name: string } } | { __typename?: 'CreditCardsProductV2', institution: { __typename?: 'CreditCardsInstitutionV2', name: string } } | { __typename?: 'EducationLoansInstitutionV2', starRating?: number | null } | { __typename?: 'EducationLoansOfferV2', displayName?: string | null, starRating?: number | null, institution: { __typename?: 'AutoLoansInstitutionV2', name: string } | { __typename?: 'AutoLoansOfferV2', name: string } | { __typename?: 'AutoLoansProductV2', name: string } | { __typename?: 'BankingInstitutionV2', name: string } | { __typename?: 'BankingOfferV2', name: string } | { __typename?: 'BankingProductV2', name: string } | { __typename?: 'CreditCardsInstitutionV2', name: string } | { __typename?: 'CreditCardsOfferV2', name: string } | { __typename?: 'CreditCardsProductV2', name: string } | { __typename?: 'EducationLoansInstitutionV2', name: string } | { __typename?: 'EducationLoansOfferV2', name: string } | { __typename?: 'EducationLoansProductV2', name: string } | { __typename?: 'InsuranceInstitutionV2', name: string } | { __typename?: 'InsuranceOfferV2', name: string } | { __typename?: 'InsuranceProductV2', name: string } | { __typename?: 'InvestingInstitutionV2', name: string } | { __typename?: 'InvestingOfferV2', name: string } | { __typename?: 'InvestingProductV2', name: string } | { __typename?: 'MortgagesInstitutionV2', name: string } | { __typename?: 'MortgagesOfferV2', name: string } | { __typename?: 'MortgagesProductV2', name: string } | { __typename?: 'PersonalLoansInstitutionV2', name: string } | { __typename?: 'PersonalLoansOfferV2', name: string } | { __typename?: 'PersonalLoansProductV2', name: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', name: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', name: string } | { __typename?: 'SmallMediumBusinessLoansProductV2', name: string } | { __typename?: 'SoftwareInstitutionV2', name: string } | { __typename?: 'SoftwareOfferV2', name: string } | { __typename?: 'SoftwareProductV2', name: string } | { __typename?: 'ThirdPartyEmbedsInstitution', name: string } | { __typename?: 'ThirdPartyEmbedsProduct', name: string } } | { __typename?: 'EducationLoansProductV2', institution: { __typename?: 'EducationLoansInstitutionV2', name: string } } | { __typename?: 'InsuranceInstitutionV2', starRating?: number | null } | { __typename?: 'InsuranceOfferV2', displayName?: string | null, starRating?: number | null, institution: { __typename?: 'AutoLoansInstitutionV2', name: string } | { __typename?: 'AutoLoansOfferV2', name: string } | { __typename?: 'AutoLoansProductV2', name: string } | { __typename?: 'BankingInstitutionV2', name: string } | { __typename?: 'BankingOfferV2', name: string } | { __typename?: 'BankingProductV2', name: string } | { __typename?: 'CreditCardsInstitutionV2', name: string } | { __typename?: 'CreditCardsOfferV2', name: string } | { __typename?: 'CreditCardsProductV2', name: string } | { __typename?: 'EducationLoansInstitutionV2', name: string } | { __typename?: 'EducationLoansOfferV2', name: string } | { __typename?: 'EducationLoansProductV2', name: string } | { __typename?: 'InsuranceInstitutionV2', name: string } | { __typename?: 'InsuranceOfferV2', name: string } | { __typename?: 'InsuranceProductV2', name: string } | { __typename?: 'InvestingInstitutionV2', name: string } | { __typename?: 'InvestingOfferV2', name: string } | { __typename?: 'InvestingProductV2', name: string } | { __typename?: 'MortgagesInstitutionV2', name: string } | { __typename?: 'MortgagesOfferV2', name: string } | { __typename?: 'MortgagesProductV2', name: string } | { __typename?: 'PersonalLoansInstitutionV2', name: string } | { __typename?: 'PersonalLoansOfferV2', name: string } | { __typename?: 'PersonalLoansProductV2', name: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', name: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', name: string } | { __typename?: 'SmallMediumBusinessLoansProductV2', name: string } | { __typename?: 'SoftwareInstitutionV2', name: string } | { __typename?: 'SoftwareOfferV2', name: string } | { __typename?: 'SoftwareProductV2', name: string } | { __typename?: 'ThirdPartyEmbedsInstitution', name: string } | { __typename?: 'ThirdPartyEmbedsProduct', name: string } } | { __typename?: 'InsuranceProductV2', institution: { __typename?: 'InsuranceInstitutionV2', name: string } } | { __typename?: 'InvestingInstitutionV2', starRating?: number | null } | { __typename?: 'InvestingOfferV2', displayName?: string | null, starRating?: number | null, institution: { __typename?: 'AutoLoansInstitutionV2', name: string } | { __typename?: 'AutoLoansOfferV2', name: string } | { __typename?: 'AutoLoansProductV2', name: string } | { __typename?: 'BankingInstitutionV2', name: string } | { __typename?: 'BankingOfferV2', name: string } | { __typename?: 'BankingProductV2', name: string } | { __typename?: 'CreditCardsInstitutionV2', name: string } | { __typename?: 'CreditCardsOfferV2', name: string } | { __typename?: 'CreditCardsProductV2', name: string } | { __typename?: 'EducationLoansInstitutionV2', name: string } | { __typename?: 'EducationLoansOfferV2', name: string } | { __typename?: 'EducationLoansProductV2', name: string } | { __typename?: 'InsuranceInstitutionV2', name: string } | { __typename?: 'InsuranceOfferV2', name: string } | { __typename?: 'InsuranceProductV2', name: string } | { __typename?: 'InvestingInstitutionV2', name: string } | { __typename?: 'InvestingOfferV2', name: string } | { __typename?: 'InvestingProductV2', name: string } | { __typename?: 'MortgagesInstitutionV2', name: string } | { __typename?: 'MortgagesOfferV2', name: string } | { __typename?: 'MortgagesProductV2', name: string } | { __typename?: 'PersonalLoansInstitutionV2', name: string } | { __typename?: 'PersonalLoansOfferV2', name: string } | { __typename?: 'PersonalLoansProductV2', name: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', name: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', name: string } | { __typename?: 'SmallMediumBusinessLoansProductV2', name: string } | { __typename?: 'SoftwareInstitutionV2', name: string } | { __typename?: 'SoftwareOfferV2', name: string } | { __typename?: 'SoftwareProductV2', name: string } | { __typename?: 'ThirdPartyEmbedsInstitution', name: string } | { __typename?: 'ThirdPartyEmbedsProduct', name: string } } | { __typename?: 'InvestingProductV2', institution: { __typename?: 'InvestingInstitutionV2', name: string } } | { __typename?: 'MortgagesInstitutionV2' } | { __typename?: 'MortgagesOfferV2', displayName?: string | null, starRating?: number | null, institution: { __typename?: 'AutoLoansInstitutionV2', name: string } | { __typename?: 'AutoLoansOfferV2', name: string } | { __typename?: 'AutoLoansProductV2', name: string } | { __typename?: 'BankingInstitutionV2', name: string } | { __typename?: 'BankingOfferV2', name: string } | { __typename?: 'BankingProductV2', name: string } | { __typename?: 'CreditCardsInstitutionV2', name: string } | { __typename?: 'CreditCardsOfferV2', name: string } | { __typename?: 'CreditCardsProductV2', name: string } | { __typename?: 'EducationLoansInstitutionV2', name: string } | { __typename?: 'EducationLoansOfferV2', name: string } | { __typename?: 'EducationLoansProductV2', name: string } | { __typename?: 'InsuranceInstitutionV2', name: string } | { __typename?: 'InsuranceOfferV2', name: string } | { __typename?: 'InsuranceProductV2', name: string } | { __typename?: 'InvestingInstitutionV2', name: string } | { __typename?: 'InvestingOfferV2', name: string } | { __typename?: 'InvestingProductV2', name: string } | { __typename?: 'MortgagesInstitutionV2', name: string } | { __typename?: 'MortgagesOfferV2', name: string } | { __typename?: 'MortgagesProductV2', name: string } | { __typename?: 'PersonalLoansInstitutionV2', name: string } | { __typename?: 'PersonalLoansOfferV2', name: string } | { __typename?: 'PersonalLoansProductV2', name: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', name: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', name: string } | { __typename?: 'SmallMediumBusinessLoansProductV2', name: string } | { __typename?: 'SoftwareInstitutionV2', name: string } | { __typename?: 'SoftwareOfferV2', name: string } | { __typename?: 'SoftwareProductV2', name: string } | { __typename?: 'ThirdPartyEmbedsInstitution', name: string } | { __typename?: 'ThirdPartyEmbedsProduct', name: string } } | { __typename?: 'MortgagesProductV2', institution: { __typename?: 'MortgagesInstitutionV2', name: string } } | { __typename?: 'PersonalLoansInstitutionV2' } | { __typename?: 'PersonalLoansOfferV2', displayName?: string | null, starRating?: number | null, institution: { __typename?: 'AutoLoansInstitutionV2', name: string } | { __typename?: 'AutoLoansOfferV2', name: string } | { __typename?: 'AutoLoansProductV2', name: string } | { __typename?: 'BankingInstitutionV2', name: string } | { __typename?: 'BankingOfferV2', name: string } | { __typename?: 'BankingProductV2', name: string } | { __typename?: 'CreditCardsInstitutionV2', name: string } | { __typename?: 'CreditCardsOfferV2', name: string } | { __typename?: 'CreditCardsProductV2', name: string } | { __typename?: 'EducationLoansInstitutionV2', name: string } | { __typename?: 'EducationLoansOfferV2', name: string } | { __typename?: 'EducationLoansProductV2', name: string } | { __typename?: 'InsuranceInstitutionV2', name: string } | { __typename?: 'InsuranceOfferV2', name: string } | { __typename?: 'InsuranceProductV2', name: string } | { __typename?: 'InvestingInstitutionV2', name: string } | { __typename?: 'InvestingOfferV2', name: string } | { __typename?: 'InvestingProductV2', name: string } | { __typename?: 'MortgagesInstitutionV2', name: string } | { __typename?: 'MortgagesOfferV2', name: string } | { __typename?: 'MortgagesProductV2', name: string } | { __typename?: 'PersonalLoansInstitutionV2', name: string } | { __typename?: 'PersonalLoansOfferV2', name: string } | { __typename?: 'PersonalLoansProductV2', name: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', name: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', name: string } | { __typename?: 'SmallMediumBusinessLoansProductV2', name: string } | { __typename?: 'SoftwareInstitutionV2', name: string } | { __typename?: 'SoftwareOfferV2', name: string } | { __typename?: 'SoftwareProductV2', name: string } | { __typename?: 'ThirdPartyEmbedsInstitution', name: string } | { __typename?: 'ThirdPartyEmbedsProduct', name: string } } | { __typename?: 'PersonalLoansProductV2', institution: { __typename?: 'PersonalLoansInstitutionV2', name: string } } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2' } | { __typename?: 'SmallMediumBusinessLoansOfferV2', displayName?: string | null, starRating?: number | null, institution: { __typename?: 'AutoLoansInstitutionV2', name: string } | { __typename?: 'AutoLoansOfferV2', name: string } | { __typename?: 'AutoLoansProductV2', name: string } | { __typename?: 'BankingInstitutionV2', name: string } | { __typename?: 'BankingOfferV2', name: string } | { __typename?: 'BankingProductV2', name: string } | { __typename?: 'CreditCardsInstitutionV2', name: string } | { __typename?: 'CreditCardsOfferV2', name: string } | { __typename?: 'CreditCardsProductV2', name: string } | { __typename?: 'EducationLoansInstitutionV2', name: string } | { __typename?: 'EducationLoansOfferV2', name: string } | { __typename?: 'EducationLoansProductV2', name: string } | { __typename?: 'InsuranceInstitutionV2', name: string } | { __typename?: 'InsuranceOfferV2', name: string } | { __typename?: 'InsuranceProductV2', name: string } | { __typename?: 'InvestingInstitutionV2', name: string } | { __typename?: 'InvestingOfferV2', name: string } | { __typename?: 'InvestingProductV2', name: string } | { __typename?: 'MortgagesInstitutionV2', name: string } | { __typename?: 'MortgagesOfferV2', name: string } | { __typename?: 'MortgagesProductV2', name: string } | { __typename?: 'PersonalLoansInstitutionV2', name: string } | { __typename?: 'PersonalLoansOfferV2', name: string } | { __typename?: 'PersonalLoansProductV2', name: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', name: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', name: string } | { __typename?: 'SmallMediumBusinessLoansProductV2', name: string } | { __typename?: 'SoftwareInstitutionV2', name: string } | { __typename?: 'SoftwareOfferV2', name: string } | { __typename?: 'SoftwareProductV2', name: string } | { __typename?: 'ThirdPartyEmbedsInstitution', name: string } | { __typename?: 'ThirdPartyEmbedsProduct', name: string } } | { __typename?: 'SmallMediumBusinessLoansProductV2', institution: { __typename?: 'SmallMediumBusinessLoansInstitutionV2', name: string } } | { __typename?: 'SoftwareInstitutionV2' } | { __typename?: 'SoftwareOfferV2', displayName?: string | null, starRating?: number | null, institution: { __typename?: 'AutoLoansInstitutionV2', name: string } | { __typename?: 'AutoLoansOfferV2', name: string } | { __typename?: 'AutoLoansProductV2', name: string } | { __typename?: 'BankingInstitutionV2', name: string } | { __typename?: 'BankingOfferV2', name: string } | { __typename?: 'BankingProductV2', name: string } | { __typename?: 'CreditCardsInstitutionV2', name: string } | { __typename?: 'CreditCardsOfferV2', name: string } | { __typename?: 'CreditCardsProductV2', name: string } | { __typename?: 'EducationLoansInstitutionV2', name: string } | { __typename?: 'EducationLoansOfferV2', name: string } | { __typename?: 'EducationLoansProductV2', name: string } | { __typename?: 'InsuranceInstitutionV2', name: string } | { __typename?: 'InsuranceOfferV2', name: string } | { __typename?: 'InsuranceProductV2', name: string } | { __typename?: 'InvestingInstitutionV2', name: string } | { __typename?: 'InvestingOfferV2', name: string } | { __typename?: 'InvestingProductV2', name: string } | { __typename?: 'MortgagesInstitutionV2', name: string } | { __typename?: 'MortgagesOfferV2', name: string } | { __typename?: 'MortgagesProductV2', name: string } | { __typename?: 'PersonalLoansInstitutionV2', name: string } | { __typename?: 'PersonalLoansOfferV2', name: string } | { __typename?: 'PersonalLoansProductV2', name: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', name: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', name: string } | { __typename?: 'SmallMediumBusinessLoansProductV2', name: string } | { __typename?: 'SoftwareInstitutionV2', name: string } | { __typename?: 'SoftwareOfferV2', name: string } | { __typename?: 'SoftwareProductV2', name: string } | { __typename?: 'ThirdPartyEmbedsInstitution', name: string } | { __typename?: 'ThirdPartyEmbedsProduct', name: string } } | { __typename?: 'SoftwareProductV2', institution: { __typename?: 'SoftwareInstitutionV2', name: string } } | { __typename?: 'ThirdPartyEmbedsInstitution' } | { __typename?: 'ThirdPartyEmbedsProduct' } | null, seo?: { __typename?: 'SeoSettings', description?: string | null } | null, authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null, reviewedBy?: Array<{ __typename?: 'ContentReviewer', id: string, name?: string | null, link?: any | null, honorificSuffix?: string | null, jobTitle?: string | null, knowsAbout?: string | null, alumniOf?: Array<string> | null, featuredMedia?: { __typename?: 'MediaItem', id: string, croppedImages?: Array<{ __typename?: 'CroppedImageSize', sourceUrl?: any | null }> | null } | null }> | null };

export type GetReviewSchemaQueryVariables = Exact<{
  reviewId: Scalars['ID'];
}>;


export type GetReviewSchemaQuery = { __typename?: 'Query', review?: { __typename: 'Review', date?: string | null, link?: any | null, modified?: string | null, title?: string | null, marketplaceEntity?: { __typename?: 'AutoLoansInstitutionV2' } | { __typename?: 'AutoLoansOfferV2', displayName?: string | null, starRating?: number | null, institution: { __typename?: 'AutoLoansInstitutionV2', name: string } | { __typename?: 'AutoLoansOfferV2', name: string } | { __typename?: 'AutoLoansProductV2', name: string } | { __typename?: 'BankingInstitutionV2', name: string } | { __typename?: 'BankingOfferV2', name: string } | { __typename?: 'BankingProductV2', name: string } | { __typename?: 'CreditCardsInstitutionV2', name: string } | { __typename?: 'CreditCardsOfferV2', name: string } | { __typename?: 'CreditCardsProductV2', name: string } | { __typename?: 'EducationLoansInstitutionV2', name: string } | { __typename?: 'EducationLoansOfferV2', name: string } | { __typename?: 'EducationLoansProductV2', name: string } | { __typename?: 'InsuranceInstitutionV2', name: string } | { __typename?: 'InsuranceOfferV2', name: string } | { __typename?: 'InsuranceProductV2', name: string } | { __typename?: 'InvestingInstitutionV2', name: string } | { __typename?: 'InvestingOfferV2', name: string } | { __typename?: 'InvestingProductV2', name: string } | { __typename?: 'MortgagesInstitutionV2', name: string } | { __typename?: 'MortgagesOfferV2', name: string } | { __typename?: 'MortgagesProductV2', name: string } | { __typename?: 'PersonalLoansInstitutionV2', name: string } | { __typename?: 'PersonalLoansOfferV2', name: string } | { __typename?: 'PersonalLoansProductV2', name: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', name: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', name: string } | { __typename?: 'SmallMediumBusinessLoansProductV2', name: string } | { __typename?: 'SoftwareInstitutionV2', name: string } | { __typename?: 'SoftwareOfferV2', name: string } | { __typename?: 'SoftwareProductV2', name: string } | { __typename?: 'ThirdPartyEmbedsInstitution', name: string } | { __typename?: 'ThirdPartyEmbedsProduct', name: string } } | { __typename?: 'AutoLoansProductV2', institution: { __typename?: 'AutoLoansInstitutionV2', name: string } } | { __typename?: 'BankingInstitutionV2', displayName?: string | null, starRating?: number | null } | { __typename?: 'BankingOfferV2', displayName?: string | null, starRating?: number | null, institution: { __typename?: 'AutoLoansInstitutionV2', name: string } | { __typename?: 'AutoLoansOfferV2', name: string } | { __typename?: 'AutoLoansProductV2', name: string } | { __typename?: 'BankingInstitutionV2', name: string } | { __typename?: 'BankingOfferV2', name: string } | { __typename?: 'BankingProductV2', name: string } | { __typename?: 'CreditCardsInstitutionV2', name: string } | { __typename?: 'CreditCardsOfferV2', name: string } | { __typename?: 'CreditCardsProductV2', name: string } | { __typename?: 'EducationLoansInstitutionV2', name: string } | { __typename?: 'EducationLoansOfferV2', name: string } | { __typename?: 'EducationLoansProductV2', name: string } | { __typename?: 'InsuranceInstitutionV2', name: string } | { __typename?: 'InsuranceOfferV2', name: string } | { __typename?: 'InsuranceProductV2', name: string } | { __typename?: 'InvestingInstitutionV2', name: string } | { __typename?: 'InvestingOfferV2', name: string } | { __typename?: 'InvestingProductV2', name: string } | { __typename?: 'MortgagesInstitutionV2', name: string } | { __typename?: 'MortgagesOfferV2', name: string } | { __typename?: 'MortgagesProductV2', name: string } | { __typename?: 'PersonalLoansInstitutionV2', name: string } | { __typename?: 'PersonalLoansOfferV2', name: string } | { __typename?: 'PersonalLoansProductV2', name: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', name: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', name: string } | { __typename?: 'SmallMediumBusinessLoansProductV2', name: string } | { __typename?: 'SoftwareInstitutionV2', name: string } | { __typename?: 'SoftwareOfferV2', name: string } | { __typename?: 'SoftwareProductV2', name: string } | { __typename?: 'ThirdPartyEmbedsInstitution', name: string } | { __typename?: 'ThirdPartyEmbedsProduct', name: string } } | { __typename?: 'BankingProductV2', institution: { __typename?: 'BankingInstitutionV2', name: string } } | { __typename?: 'CreditCardsInstitutionV2' } | { __typename?: 'CreditCardsOfferV2', displayName?: string | null, starRating?: number | null, institution: { __typename?: 'AutoLoansInstitutionV2', name: string } | { __typename?: 'AutoLoansOfferV2', name: string } | { __typename?: 'AutoLoansProductV2', name: string } | { __typename?: 'BankingInstitutionV2', name: string } | { __typename?: 'BankingOfferV2', name: string } | { __typename?: 'BankingProductV2', name: string } | { __typename?: 'CreditCardsInstitutionV2', name: string } | { __typename?: 'CreditCardsOfferV2', name: string } | { __typename?: 'CreditCardsProductV2', name: string } | { __typename?: 'EducationLoansInstitutionV2', name: string } | { __typename?: 'EducationLoansOfferV2', name: string } | { __typename?: 'EducationLoansProductV2', name: string } | { __typename?: 'InsuranceInstitutionV2', name: string } | { __typename?: 'InsuranceOfferV2', name: string } | { __typename?: 'InsuranceProductV2', name: string } | { __typename?: 'InvestingInstitutionV2', name: string } | { __typename?: 'InvestingOfferV2', name: string } | { __typename?: 'InvestingProductV2', name: string } | { __typename?: 'MortgagesInstitutionV2', name: string } | { __typename?: 'MortgagesOfferV2', name: string } | { __typename?: 'MortgagesProductV2', name: string } | { __typename?: 'PersonalLoansInstitutionV2', name: string } | { __typename?: 'PersonalLoansOfferV2', name: string } | { __typename?: 'PersonalLoansProductV2', name: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', name: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', name: string } | { __typename?: 'SmallMediumBusinessLoansProductV2', name: string } | { __typename?: 'SoftwareInstitutionV2', name: string } | { __typename?: 'SoftwareOfferV2', name: string } | { __typename?: 'SoftwareProductV2', name: string } | { __typename?: 'ThirdPartyEmbedsInstitution', name: string } | { __typename?: 'ThirdPartyEmbedsProduct', name: string } } | { __typename?: 'CreditCardsProductV2', institution: { __typename?: 'CreditCardsInstitutionV2', name: string } } | { __typename?: 'EducationLoansInstitutionV2', starRating?: number | null } | { __typename?: 'EducationLoansOfferV2', displayName?: string | null, starRating?: number | null, institution: { __typename?: 'AutoLoansInstitutionV2', name: string } | { __typename?: 'AutoLoansOfferV2', name: string } | { __typename?: 'AutoLoansProductV2', name: string } | { __typename?: 'BankingInstitutionV2', name: string } | { __typename?: 'BankingOfferV2', name: string } | { __typename?: 'BankingProductV2', name: string } | { __typename?: 'CreditCardsInstitutionV2', name: string } | { __typename?: 'CreditCardsOfferV2', name: string } | { __typename?: 'CreditCardsProductV2', name: string } | { __typename?: 'EducationLoansInstitutionV2', name: string } | { __typename?: 'EducationLoansOfferV2', name: string } | { __typename?: 'EducationLoansProductV2', name: string } | { __typename?: 'InsuranceInstitutionV2', name: string } | { __typename?: 'InsuranceOfferV2', name: string } | { __typename?: 'InsuranceProductV2', name: string } | { __typename?: 'InvestingInstitutionV2', name: string } | { __typename?: 'InvestingOfferV2', name: string } | { __typename?: 'InvestingProductV2', name: string } | { __typename?: 'MortgagesInstitutionV2', name: string } | { __typename?: 'MortgagesOfferV2', name: string } | { __typename?: 'MortgagesProductV2', name: string } | { __typename?: 'PersonalLoansInstitutionV2', name: string } | { __typename?: 'PersonalLoansOfferV2', name: string } | { __typename?: 'PersonalLoansProductV2', name: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', name: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', name: string } | { __typename?: 'SmallMediumBusinessLoansProductV2', name: string } | { __typename?: 'SoftwareInstitutionV2', name: string } | { __typename?: 'SoftwareOfferV2', name: string } | { __typename?: 'SoftwareProductV2', name: string } | { __typename?: 'ThirdPartyEmbedsInstitution', name: string } | { __typename?: 'ThirdPartyEmbedsProduct', name: string } } | { __typename?: 'EducationLoansProductV2', institution: { __typename?: 'EducationLoansInstitutionV2', name: string } } | { __typename?: 'InsuranceInstitutionV2', starRating?: number | null } | { __typename?: 'InsuranceOfferV2', displayName?: string | null, starRating?: number | null, institution: { __typename?: 'AutoLoansInstitutionV2', name: string } | { __typename?: 'AutoLoansOfferV2', name: string } | { __typename?: 'AutoLoansProductV2', name: string } | { __typename?: 'BankingInstitutionV2', name: string } | { __typename?: 'BankingOfferV2', name: string } | { __typename?: 'BankingProductV2', name: string } | { __typename?: 'CreditCardsInstitutionV2', name: string } | { __typename?: 'CreditCardsOfferV2', name: string } | { __typename?: 'CreditCardsProductV2', name: string } | { __typename?: 'EducationLoansInstitutionV2', name: string } | { __typename?: 'EducationLoansOfferV2', name: string } | { __typename?: 'EducationLoansProductV2', name: string } | { __typename?: 'InsuranceInstitutionV2', name: string } | { __typename?: 'InsuranceOfferV2', name: string } | { __typename?: 'InsuranceProductV2', name: string } | { __typename?: 'InvestingInstitutionV2', name: string } | { __typename?: 'InvestingOfferV2', name: string } | { __typename?: 'InvestingProductV2', name: string } | { __typename?: 'MortgagesInstitutionV2', name: string } | { __typename?: 'MortgagesOfferV2', name: string } | { __typename?: 'MortgagesProductV2', name: string } | { __typename?: 'PersonalLoansInstitutionV2', name: string } | { __typename?: 'PersonalLoansOfferV2', name: string } | { __typename?: 'PersonalLoansProductV2', name: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', name: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', name: string } | { __typename?: 'SmallMediumBusinessLoansProductV2', name: string } | { __typename?: 'SoftwareInstitutionV2', name: string } | { __typename?: 'SoftwareOfferV2', name: string } | { __typename?: 'SoftwareProductV2', name: string } | { __typename?: 'ThirdPartyEmbedsInstitution', name: string } | { __typename?: 'ThirdPartyEmbedsProduct', name: string } } | { __typename?: 'InsuranceProductV2', institution: { __typename?: 'InsuranceInstitutionV2', name: string } } | { __typename?: 'InvestingInstitutionV2', starRating?: number | null } | { __typename?: 'InvestingOfferV2', displayName?: string | null, starRating?: number | null, institution: { __typename?: 'AutoLoansInstitutionV2', name: string } | { __typename?: 'AutoLoansOfferV2', name: string } | { __typename?: 'AutoLoansProductV2', name: string } | { __typename?: 'BankingInstitutionV2', name: string } | { __typename?: 'BankingOfferV2', name: string } | { __typename?: 'BankingProductV2', name: string } | { __typename?: 'CreditCardsInstitutionV2', name: string } | { __typename?: 'CreditCardsOfferV2', name: string } | { __typename?: 'CreditCardsProductV2', name: string } | { __typename?: 'EducationLoansInstitutionV2', name: string } | { __typename?: 'EducationLoansOfferV2', name: string } | { __typename?: 'EducationLoansProductV2', name: string } | { __typename?: 'InsuranceInstitutionV2', name: string } | { __typename?: 'InsuranceOfferV2', name: string } | { __typename?: 'InsuranceProductV2', name: string } | { __typename?: 'InvestingInstitutionV2', name: string } | { __typename?: 'InvestingOfferV2', name: string } | { __typename?: 'InvestingProductV2', name: string } | { __typename?: 'MortgagesInstitutionV2', name: string } | { __typename?: 'MortgagesOfferV2', name: string } | { __typename?: 'MortgagesProductV2', name: string } | { __typename?: 'PersonalLoansInstitutionV2', name: string } | { __typename?: 'PersonalLoansOfferV2', name: string } | { __typename?: 'PersonalLoansProductV2', name: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', name: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', name: string } | { __typename?: 'SmallMediumBusinessLoansProductV2', name: string } | { __typename?: 'SoftwareInstitutionV2', name: string } | { __typename?: 'SoftwareOfferV2', name: string } | { __typename?: 'SoftwareProductV2', name: string } | { __typename?: 'ThirdPartyEmbedsInstitution', name: string } | { __typename?: 'ThirdPartyEmbedsProduct', name: string } } | { __typename?: 'InvestingProductV2', institution: { __typename?: 'InvestingInstitutionV2', name: string } } | { __typename?: 'MortgagesInstitutionV2' } | { __typename?: 'MortgagesOfferV2', displayName?: string | null, starRating?: number | null, institution: { __typename?: 'AutoLoansInstitutionV2', name: string } | { __typename?: 'AutoLoansOfferV2', name: string } | { __typename?: 'AutoLoansProductV2', name: string } | { __typename?: 'BankingInstitutionV2', name: string } | { __typename?: 'BankingOfferV2', name: string } | { __typename?: 'BankingProductV2', name: string } | { __typename?: 'CreditCardsInstitutionV2', name: string } | { __typename?: 'CreditCardsOfferV2', name: string } | { __typename?: 'CreditCardsProductV2', name: string } | { __typename?: 'EducationLoansInstitutionV2', name: string } | { __typename?: 'EducationLoansOfferV2', name: string } | { __typename?: 'EducationLoansProductV2', name: string } | { __typename?: 'InsuranceInstitutionV2', name: string } | { __typename?: 'InsuranceOfferV2', name: string } | { __typename?: 'InsuranceProductV2', name: string } | { __typename?: 'InvestingInstitutionV2', name: string } | { __typename?: 'InvestingOfferV2', name: string } | { __typename?: 'InvestingProductV2', name: string } | { __typename?: 'MortgagesInstitutionV2', name: string } | { __typename?: 'MortgagesOfferV2', name: string } | { __typename?: 'MortgagesProductV2', name: string } | { __typename?: 'PersonalLoansInstitutionV2', name: string } | { __typename?: 'PersonalLoansOfferV2', name: string } | { __typename?: 'PersonalLoansProductV2', name: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', name: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', name: string } | { __typename?: 'SmallMediumBusinessLoansProductV2', name: string } | { __typename?: 'SoftwareInstitutionV2', name: string } | { __typename?: 'SoftwareOfferV2', name: string } | { __typename?: 'SoftwareProductV2', name: string } | { __typename?: 'ThirdPartyEmbedsInstitution', name: string } | { __typename?: 'ThirdPartyEmbedsProduct', name: string } } | { __typename?: 'MortgagesProductV2', institution: { __typename?: 'MortgagesInstitutionV2', name: string } } | { __typename?: 'PersonalLoansInstitutionV2' } | { __typename?: 'PersonalLoansOfferV2', displayName?: string | null, starRating?: number | null, institution: { __typename?: 'AutoLoansInstitutionV2', name: string } | { __typename?: 'AutoLoansOfferV2', name: string } | { __typename?: 'AutoLoansProductV2', name: string } | { __typename?: 'BankingInstitutionV2', name: string } | { __typename?: 'BankingOfferV2', name: string } | { __typename?: 'BankingProductV2', name: string } | { __typename?: 'CreditCardsInstitutionV2', name: string } | { __typename?: 'CreditCardsOfferV2', name: string } | { __typename?: 'CreditCardsProductV2', name: string } | { __typename?: 'EducationLoansInstitutionV2', name: string } | { __typename?: 'EducationLoansOfferV2', name: string } | { __typename?: 'EducationLoansProductV2', name: string } | { __typename?: 'InsuranceInstitutionV2', name: string } | { __typename?: 'InsuranceOfferV2', name: string } | { __typename?: 'InsuranceProductV2', name: string } | { __typename?: 'InvestingInstitutionV2', name: string } | { __typename?: 'InvestingOfferV2', name: string } | { __typename?: 'InvestingProductV2', name: string } | { __typename?: 'MortgagesInstitutionV2', name: string } | { __typename?: 'MortgagesOfferV2', name: string } | { __typename?: 'MortgagesProductV2', name: string } | { __typename?: 'PersonalLoansInstitutionV2', name: string } | { __typename?: 'PersonalLoansOfferV2', name: string } | { __typename?: 'PersonalLoansProductV2', name: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', name: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', name: string } | { __typename?: 'SmallMediumBusinessLoansProductV2', name: string } | { __typename?: 'SoftwareInstitutionV2', name: string } | { __typename?: 'SoftwareOfferV2', name: string } | { __typename?: 'SoftwareProductV2', name: string } | { __typename?: 'ThirdPartyEmbedsInstitution', name: string } | { __typename?: 'ThirdPartyEmbedsProduct', name: string } } | { __typename?: 'PersonalLoansProductV2', institution: { __typename?: 'PersonalLoansInstitutionV2', name: string } } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2' } | { __typename?: 'SmallMediumBusinessLoansOfferV2', displayName?: string | null, starRating?: number | null, institution: { __typename?: 'AutoLoansInstitutionV2', name: string } | { __typename?: 'AutoLoansOfferV2', name: string } | { __typename?: 'AutoLoansProductV2', name: string } | { __typename?: 'BankingInstitutionV2', name: string } | { __typename?: 'BankingOfferV2', name: string } | { __typename?: 'BankingProductV2', name: string } | { __typename?: 'CreditCardsInstitutionV2', name: string } | { __typename?: 'CreditCardsOfferV2', name: string } | { __typename?: 'CreditCardsProductV2', name: string } | { __typename?: 'EducationLoansInstitutionV2', name: string } | { __typename?: 'EducationLoansOfferV2', name: string } | { __typename?: 'EducationLoansProductV2', name: string } | { __typename?: 'InsuranceInstitutionV2', name: string } | { __typename?: 'InsuranceOfferV2', name: string } | { __typename?: 'InsuranceProductV2', name: string } | { __typename?: 'InvestingInstitutionV2', name: string } | { __typename?: 'InvestingOfferV2', name: string } | { __typename?: 'InvestingProductV2', name: string } | { __typename?: 'MortgagesInstitutionV2', name: string } | { __typename?: 'MortgagesOfferV2', name: string } | { __typename?: 'MortgagesProductV2', name: string } | { __typename?: 'PersonalLoansInstitutionV2', name: string } | { __typename?: 'PersonalLoansOfferV2', name: string } | { __typename?: 'PersonalLoansProductV2', name: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', name: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', name: string } | { __typename?: 'SmallMediumBusinessLoansProductV2', name: string } | { __typename?: 'SoftwareInstitutionV2', name: string } | { __typename?: 'SoftwareOfferV2', name: string } | { __typename?: 'SoftwareProductV2', name: string } | { __typename?: 'ThirdPartyEmbedsInstitution', name: string } | { __typename?: 'ThirdPartyEmbedsProduct', name: string } } | { __typename?: 'SmallMediumBusinessLoansProductV2', institution: { __typename?: 'SmallMediumBusinessLoansInstitutionV2', name: string } } | { __typename?: 'SoftwareInstitutionV2' } | { __typename?: 'SoftwareOfferV2', displayName?: string | null, starRating?: number | null, institution: { __typename?: 'AutoLoansInstitutionV2', name: string } | { __typename?: 'AutoLoansOfferV2', name: string } | { __typename?: 'AutoLoansProductV2', name: string } | { __typename?: 'BankingInstitutionV2', name: string } | { __typename?: 'BankingOfferV2', name: string } | { __typename?: 'BankingProductV2', name: string } | { __typename?: 'CreditCardsInstitutionV2', name: string } | { __typename?: 'CreditCardsOfferV2', name: string } | { __typename?: 'CreditCardsProductV2', name: string } | { __typename?: 'EducationLoansInstitutionV2', name: string } | { __typename?: 'EducationLoansOfferV2', name: string } | { __typename?: 'EducationLoansProductV2', name: string } | { __typename?: 'InsuranceInstitutionV2', name: string } | { __typename?: 'InsuranceOfferV2', name: string } | { __typename?: 'InsuranceProductV2', name: string } | { __typename?: 'InvestingInstitutionV2', name: string } | { __typename?: 'InvestingOfferV2', name: string } | { __typename?: 'InvestingProductV2', name: string } | { __typename?: 'MortgagesInstitutionV2', name: string } | { __typename?: 'MortgagesOfferV2', name: string } | { __typename?: 'MortgagesProductV2', name: string } | { __typename?: 'PersonalLoansInstitutionV2', name: string } | { __typename?: 'PersonalLoansOfferV2', name: string } | { __typename?: 'PersonalLoansProductV2', name: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', name: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', name: string } | { __typename?: 'SmallMediumBusinessLoansProductV2', name: string } | { __typename?: 'SoftwareInstitutionV2', name: string } | { __typename?: 'SoftwareOfferV2', name: string } | { __typename?: 'SoftwareProductV2', name: string } | { __typename?: 'ThirdPartyEmbedsInstitution', name: string } | { __typename?: 'ThirdPartyEmbedsProduct', name: string } } | { __typename?: 'SoftwareProductV2', institution: { __typename?: 'SoftwareInstitutionV2', name: string } } | { __typename?: 'ThirdPartyEmbedsInstitution' } | { __typename?: 'ThirdPartyEmbedsProduct' } | null, seo?: { __typename?: 'SeoSettings', description?: string | null } | null, authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null, reviewedBy?: Array<{ __typename?: 'ContentReviewer', id: string, name?: string | null, link?: any | null, honorificSuffix?: string | null, jobTitle?: string | null, knowsAbout?: string | null, alumniOf?: Array<string> | null, featuredMedia?: { __typename?: 'MediaItem', id: string, croppedImages?: Array<{ __typename?: 'CroppedImageSize', sourceUrl?: any | null }> | null } | null }> | null } | null };

export type GetArticleSchemaOnRoundupFragment = { __typename: 'Roundup', date?: string | null, modified?: string | null, link?: any | null, titleWithoutEntityCount: string, productCardsSection: { __typename?: 'RoundupProductCardsDetails', categorySections?: Array<{ __typename?: 'RoundupCategorySection', productCards?: Array<{ __typename?: 'RoundupSection', gqlMarketplaceEntity?: { __typename?: 'AutoLoansInstitutionV2' } | { __typename?: 'AutoLoansOfferV2', image?: { __typename?: 'EntityPlacementImage', sourceLarge?: any | null } | null } | { __typename?: 'AutoLoansProductV2' } | { __typename?: 'BankingInstitutionV2', image?: { __typename?: 'EntityPlacementImage', sourceLarge?: any | null } | null } | { __typename?: 'BankingOfferV2', image?: { __typename?: 'EntityPlacementImage', sourceLarge?: any | null } | null } | { __typename?: 'BankingProductV2' } | { __typename?: 'CreditCardsInstitutionV2' } | { __typename?: 'CreditCardsOfferV2', image?: { __typename?: 'EntityPlacementImage', sourceLarge?: any | null } | null } | { __typename?: 'CreditCardsProductV2' } | { __typename?: 'EducationLoansInstitutionV2' } | { __typename?: 'EducationLoansOfferV2', image?: { __typename?: 'EntityPlacementImage', sourceLarge?: any | null } | null } | { __typename?: 'EducationLoansProductV2' } | { __typename?: 'InsuranceInstitutionV2' } | { __typename?: 'InsuranceOfferV2', image?: { __typename?: 'EntityPlacementImage', sourceLarge?: any | null } | null } | { __typename?: 'InsuranceProductV2' } | { __typename?: 'InvestingInstitutionV2' } | { __typename?: 'InvestingOfferV2', image?: { __typename?: 'EntityPlacementImage', sourceLarge?: any | null } | null } | { __typename?: 'InvestingProductV2' } | { __typename?: 'MortgagesInstitutionV2' } | { __typename?: 'MortgagesOfferV2', image?: { __typename?: 'EntityPlacementImage', sourceLarge?: any | null } | null } | { __typename?: 'MortgagesProductV2' } | { __typename?: 'PersonalLoansInstitutionV2' } | { __typename?: 'PersonalLoansOfferV2', image?: { __typename?: 'EntityPlacementImage', sourceLarge?: any | null } | null } | { __typename?: 'PersonalLoansProductV2' } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2' } | { __typename?: 'SmallMediumBusinessLoansOfferV2', image?: { __typename?: 'EntityPlacementImage', sourceLarge?: any | null } | null } | { __typename?: 'SmallMediumBusinessLoansProductV2' } | { __typename?: 'SoftwareInstitutionV2' } | { __typename?: 'SoftwareOfferV2', image?: { __typename?: 'EntityPlacementImage', sourceLarge?: any | null } | null } | { __typename?: 'SoftwareProductV2' } | { __typename?: 'ThirdPartyEmbedsInstitution' } | { __typename?: 'ThirdPartyEmbedsProduct' } | null }> | null }> | null }, categories?: Array<{ __typename?: 'Category', name?: string | null }> | null, authors?: Array<{ __typename?: 'Author', id: string, name?: string | null, link?: any | null, alumniOf?: string | null, affiliation?: string | null, award?: string | null, honorificSuffix?: string | null, jobTitle?: string | null, specialties?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null, reviewedBy?: Array<{ __typename?: 'ContentReviewer', id: string, name?: string | null, link?: any | null, honorificSuffix?: string | null, jobTitle?: string | null, knowsAbout?: string | null, alumniOf?: Array<string> | null, featuredMedia?: { __typename?: 'MediaItem', id: string, croppedImages?: Array<{ __typename?: 'CroppedImageSize', sourceUrl?: any | null }> | null } | null }> | null };

export type GetItemListSchemaFragment = { __typename?: 'Roundup', link?: any | null, marketplaceProductType?: MarketplaceProductTypeEnum | null, titleWithoutEntityCount: string, productCardsSection: { __typename?: 'RoundupProductCardsDetails', categorySections?: Array<{ __typename?: 'RoundupCategorySection', title?: string | null, productCards?: Array<{ __typename?: 'RoundupSection', gqlMarketplaceEntity?: { __typename?: 'AutoLoansInstitutionV2', id: string } | { __typename?: 'AutoLoansOfferV2', displayName?: string | null, id: string, image?: { __typename?: 'EntityPlacementImage', sourceLarge?: any | null } | null } | { __typename?: 'AutoLoansProductV2', id: string } | { __typename?: 'BankingInstitutionV2', displayName?: string | null, id: string, image?: { __typename?: 'EntityPlacementImage', sourceLarge?: any | null } | null } | { __typename?: 'BankingOfferV2', displayName?: string | null, id: string, image?: { __typename?: 'EntityPlacementImage', sourceLarge?: any | null } | null } | { __typename?: 'BankingProductV2', id: string } | { __typename?: 'CreditCardsInstitutionV2', id: string } | { __typename?: 'CreditCardsOfferV2', displayName?: string | null, annualFee?: number | null, aprMax?: number | null, aprMin?: number | null, id: string, image?: { __typename?: 'EntityPlacementImage', sourceLarge?: any | null } | null } | { __typename?: 'CreditCardsProductV2', id: string } | { __typename?: 'EducationLoansInstitutionV2', id: string } | { __typename?: 'EducationLoansOfferV2', displayName?: string | null, id: string, image?: { __typename?: 'EntityPlacementImage', sourceLarge?: any | null } | null } | { __typename?: 'EducationLoansProductV2', id: string } | { __typename?: 'InsuranceInstitutionV2', id: string } | { __typename?: 'InsuranceOfferV2', displayName?: string | null, id: string, image?: { __typename?: 'EntityPlacementImage', sourceLarge?: any | null } | null } | { __typename?: 'InsuranceProductV2', id: string } | { __typename?: 'InvestingInstitutionV2', id: string } | { __typename?: 'InvestingOfferV2', displayName?: string | null, id: string, image?: { __typename?: 'EntityPlacementImage', sourceLarge?: any | null } | null } | { __typename?: 'InvestingProductV2', id: string } | { __typename?: 'MortgagesInstitutionV2', id: string } | { __typename?: 'MortgagesOfferV2', displayName?: string | null, id: string, image?: { __typename?: 'EntityPlacementImage', sourceLarge?: any | null } | null } | { __typename?: 'MortgagesProductV2', id: string } | { __typename?: 'PersonalLoansInstitutionV2', id: string } | { __typename?: 'PersonalLoansOfferV2', displayName?: string | null, id: string, image?: { __typename?: 'EntityPlacementImage', sourceLarge?: any | null } | null } | { __typename?: 'PersonalLoansProductV2', id: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', id: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', displayName?: string | null, id: string, image?: { __typename?: 'EntityPlacementImage', sourceLarge?: any | null } | null } | { __typename?: 'SmallMediumBusinessLoansProductV2', id: string } | { __typename?: 'SoftwareInstitutionV2', id: string } | { __typename?: 'SoftwareOfferV2', displayName?: string | null, id: string, image?: { __typename?: 'EntityPlacementImage', sourceLarge?: any | null } | null } | { __typename?: 'SoftwareProductV2', id: string } | { __typename?: 'ThirdPartyEmbedsInstitution', id: string } | { __typename?: 'ThirdPartyEmbedsProduct', id: string } | null }> | null }> | null } };

type WordPressContentPageHeader_Article_Fragment = { __typename: 'Article', hideFeaturedImage?: boolean | null, advertiserDisclosureType: string, editorialDisclaimerType?: string | null, id: string, showAdvertiserDisclosure: boolean, showAuthorByline: boolean, showEditorialDisclaimer: boolean, title?: string | null, dateTimeDisplayDate?: any | null, stringSynopsis?: string | null, featuredImage?: { __typename?: 'MediaItem', id: string, altText?: string | null, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', sourceUrl?: any | null, width?: number | null, height?: number | null, size?: string | null }> | null } | null } | null, reviewedBy?: Array<{ __typename?: 'ContentReviewer', name?: string | null, url?: any | null }> | null, authors?: Array<{ __typename?: 'Author', name?: string | null, link?: any | null }> | null, primaryCategory?: { __typename?: 'Category', name?: string | null } | null };

type WordPressContentPageHeader_Review_Fragment = { __typename: 'Review', advertiserDisclosureType: string, editorialDisclaimerType?: string | null, id: string, showAdvertiserDisclosure: boolean, showAuthorByline: boolean, showEditorialDisclaimer: boolean, title?: string | null, featuredImage?: { __typename?: 'MediaItem', id: string, altText?: string | null, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', sourceUrl?: any | null, width?: number | null, height?: number | null, size?: string | null }> | null } | null } | null, reviewedBy?: Array<{ __typename?: 'ContentReviewer', name?: string | null, url?: any | null }> | null, authors?: Array<{ __typename?: 'Author', name?: string | null, link?: any | null }> | null, primaryCategory?: { __typename?: 'Category', name?: string | null } | null };

type WordPressContentPageHeader_Roundup_Fragment = { __typename: 'Roundup', eyebrowText?: string | null, advertiserDisclosureType: string, editorialDisclaimerType?: string | null, id: string, showAdvertiserDisclosure: boolean, showAuthorByline: boolean, showEditorialDisclaimer: boolean, title?: string | null, formattedDisplayDate?: string | null, structuredContentSynopsis?: any | null, featuredImage?: { __typename?: 'MediaItem', id: string, altText?: string | null, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', sourceUrl?: any | null, width?: number | null, height?: number | null, size?: string | null }> | null } | null } | null, reviewedBy?: Array<{ __typename?: 'ContentReviewer', name?: string | null, url?: any | null }> | null, authors?: Array<{ __typename?: 'Author', name?: string | null, link?: any | null }> | null, primaryCategory?: { __typename?: 'Category', name?: string | null } | null };

export type WordPressContentPageHeaderFragment = WordPressContentPageHeader_Article_Fragment | WordPressContentPageHeader_Review_Fragment | WordPressContentPageHeader_Roundup_Fragment;

type GetPageTaxonomyData_Article_Fragment = { __typename: 'Article', pageTaxonomy?: any | null };

type GetPageTaxonomyData_Review_Fragment = { __typename: 'Review', pageTaxonomy?: any | null };

type GetPageTaxonomyData_Roundup_Fragment = { __typename: 'Roundup', pageTaxonomy?: any | null };

export type GetPageTaxonomyDataFragment = GetPageTaxonomyData_Article_Fragment | GetPageTaxonomyData_Review_Fragment | GetPageTaxonomyData_Roundup_Fragment;

type GetNerdlayoutDynamicOptions_Article_Fragment = { __typename: 'Article', synopsis?: string | null, id: string, type: string, link?: any | null, pageTaxonomy?: any | null, seo?: { __typename?: 'SeoSettings', title?: string | null, description?: string | null, nofollow?: boolean | null, noindex?: boolean | null, keyword?: string | null, facebook?: { __typename?: 'SocialSeoSettings', title?: string | null, description?: string | null } | null, twitter?: { __typename?: 'SocialSeoSettings', title?: string | null, description?: string | null, image?: any | null } | null } | null, featuredMedia?: { __typename?: 'MediaItem', id: string, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', sourceUrl?: any | null, width?: number | null, height?: number | null }> | null } | null } | null };

type GetNerdlayoutDynamicOptions_Banner_Fragment = { __typename: 'Banner', id: string, type: string, link?: any | null };

type GetNerdlayoutDynamicOptions_BccPage_Fragment = { __typename: 'BccPage', id: string, type: string, link?: any | null, seo?: { __typename?: 'SeoSettings', title?: string | null, description?: string | null, nofollow?: boolean | null, noindex?: boolean | null, keyword?: string | null, facebook?: { __typename?: 'SocialSeoSettings', title?: string | null, description?: string | null } | null, twitter?: { __typename?: 'SocialSeoSettings', title?: string | null, description?: string | null, image?: any | null } | null } | null };

type GetNerdlayoutDynamicOptions_BccPageCard_Fragment = { __typename: 'BccPageCard', id: string, type: string, link?: any | null };

type GetNerdlayoutDynamicOptions_Block_Fragment = { __typename: 'Block', id: string, type: string, link?: any | null };

type GetNerdlayoutDynamicOptions_BlockGroup_Fragment = { __typename: 'BlockGroup', id: string, type: string, link?: any | null };

type GetNerdlayoutDynamicOptions_ContentPack_Fragment = { __typename: 'ContentPack', id: string, type: string, link?: any | null };

type GetNerdlayoutDynamicOptions_ContentReviewer_Fragment = { __typename: 'ContentReviewer', id: string, type: string, link?: any | null, seo?: { __typename?: 'SeoSettings', title?: string | null, description?: string | null, nofollow?: boolean | null, noindex?: boolean | null, keyword?: string | null, facebook?: { __typename?: 'SocialSeoSettings', title?: string | null, description?: string | null } | null, twitter?: { __typename?: 'SocialSeoSettings', title?: string | null, description?: string | null, image?: any | null } | null } | null, featuredMedia?: { __typename?: 'MediaItem', id: string, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', sourceUrl?: any | null, width?: number | null, height?: number | null }> | null } | null } | null };

type GetNerdlayoutDynamicOptions_ContentSearchResult_Fragment = { __typename: 'ContentSearchResult', id: string, type: string, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', id: string, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', sourceUrl?: any | null, width?: number | null, height?: number | null }> | null } | null } | null };

type GetNerdlayoutDynamicOptions_ContentUserPage_Fragment = { __typename: 'ContentUserPage', id: string, type: string, link?: any | null, seo?: { __typename?: 'SeoSettings', title?: string | null, description?: string | null, nofollow?: boolean | null, noindex?: boolean | null, keyword?: string | null, facebook?: { __typename?: 'SocialSeoSettings', title?: string | null, description?: string | null } | null, twitter?: { __typename?: 'SocialSeoSettings', title?: string | null, description?: string | null, image?: any | null } | null } | null, featuredMedia?: { __typename?: 'MediaItem', id: string, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', sourceUrl?: any | null, width?: number | null, height?: number | null }> | null } | null } | null };

type GetNerdlayoutDynamicOptions_EngineeringPost_Fragment = { __typename: 'EngineeringPost', id: string, type: string, link?: any | null, seo?: { __typename?: 'SeoSettings', title?: string | null, description?: string | null, nofollow?: boolean | null, noindex?: boolean | null, keyword?: string | null, facebook?: { __typename?: 'SocialSeoSettings', title?: string | null, description?: string | null } | null, twitter?: { __typename?: 'SocialSeoSettings', title?: string | null, description?: string | null, image?: any | null } | null } | null, featuredMedia?: { __typename?: 'MediaItem', id: string, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', sourceUrl?: any | null, width?: number | null, height?: number | null }> | null } | null } | null };

type GetNerdlayoutDynamicOptions_GlobalNavItem_Fragment = { __typename: 'GlobalNavItem', id: string, type: string, link?: any | null };

type GetNerdlayoutDynamicOptions_HouseAd_Fragment = { __typename: 'HouseAd', id: string, type: string, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', id: string, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', sourceUrl?: any | null, width?: number | null, height?: number | null }> | null } | null } | null };

type GetNerdlayoutDynamicOptions_Hub_Fragment = { __typename: 'Hub', id: string, type: string, link?: any | null, seo?: { __typename?: 'SeoSettings', title?: string | null, description?: string | null, nofollow?: boolean | null, noindex?: boolean | null, keyword?: string | null, facebook?: { __typename?: 'SocialSeoSettings', title?: string | null, description?: string | null } | null, twitter?: { __typename?: 'SocialSeoSettings', title?: string | null, description?: string | null, image?: any | null } | null } | null, featuredMedia?: { __typename?: 'MediaItem', id: string, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', sourceUrl?: any | null, width?: number | null, height?: number | null }> | null } | null } | null };

type GetNerdlayoutDynamicOptions_InsurancePage_Fragment = { __typename: 'InsurancePage', id: string, type: string, link?: any | null, seo?: { __typename?: 'SeoSettings', title?: string | null, description?: string | null, nofollow?: boolean | null, noindex?: boolean | null, keyword?: string | null, facebook?: { __typename?: 'SocialSeoSettings', title?: string | null, description?: string | null } | null, twitter?: { __typename?: 'SocialSeoSettings', title?: string | null, description?: string | null, image?: any | null } | null } | null, featuredMedia?: { __typename?: 'MediaItem', id: string, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', sourceUrl?: any | null, width?: number | null, height?: number | null }> | null } | null } | null };

type GetNerdlayoutDynamicOptions_LandingPage_Fragment = { __typename: 'LandingPage', id: string, type: string, link?: any | null, seo?: { __typename?: 'SeoSettings', title?: string | null, description?: string | null, nofollow?: boolean | null, noindex?: boolean | null, keyword?: string | null, facebook?: { __typename?: 'SocialSeoSettings', title?: string | null, description?: string | null } | null, twitter?: { __typename?: 'SocialSeoSettings', title?: string | null, description?: string | null, image?: any | null } | null } | null, featuredMedia?: { __typename?: 'MediaItem', id: string, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', sourceUrl?: any | null, width?: number | null, height?: number | null }> | null } | null } | null };

type GetNerdlayoutDynamicOptions_LegacyLender_Fragment = { __typename: 'LegacyLender', id: string, type: string, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', id: string, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', sourceUrl?: any | null, width?: number | null, height?: number | null }> | null } | null } | null };

type GetNerdlayoutDynamicOptions_MarketplaceEntryPoint_Fragment = { __typename: 'MarketplaceEntryPoint', id: string, type: string, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', id: string, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', sourceUrl?: any | null, width?: number | null, height?: number | null }> | null } | null } | null };

type GetNerdlayoutDynamicOptions_MediaItem_Fragment = { __typename: 'MediaItem', id: string, type: string, link?: any | null };

type GetNerdlayoutDynamicOptions_Page_Fragment = { __typename: 'Page', id: string, type: string, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', id: string, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', sourceUrl?: any | null, width?: number | null, height?: number | null }> | null } | null } | null };

type GetNerdlayoutDynamicOptions_Post_Fragment = { __typename: 'Post', id: string, type: string, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', id: string, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', sourceUrl?: any | null, width?: number | null, height?: number | null }> | null } | null } | null };

type GetNerdlayoutDynamicOptions_PressRelease_Fragment = { __typename: 'PressRelease', id: string, type: string, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', id: string, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', sourceUrl?: any | null, width?: number | null, height?: number | null }> | null } | null } | null };

type GetNerdlayoutDynamicOptions_Review_Fragment = { __typename: 'Review', id: string, type: string, link?: any | null, pageTaxonomy?: any | null, seo?: { __typename?: 'SeoSettings', title?: string | null, description?: string | null, nofollow?: boolean | null, noindex?: boolean | null, keyword?: string | null, facebook?: { __typename?: 'SocialSeoSettings', title?: string | null, description?: string | null } | null, twitter?: { __typename?: 'SocialSeoSettings', title?: string | null, description?: string | null, image?: any | null } | null } | null, featuredMedia?: { __typename?: 'MediaItem', id: string, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', sourceUrl?: any | null, width?: number | null, height?: number | null }> | null } | null } | null };

type GetNerdlayoutDynamicOptions_Roundup_Fragment = { __typename: 'Roundup', id: string, type: string, link?: any | null, pageTaxonomy?: any | null, seo?: { __typename?: 'SeoSettings', title?: string | null, description?: string | null, nofollow?: boolean | null, noindex?: boolean | null, keyword?: string | null, facebook?: { __typename?: 'SocialSeoSettings', title?: string | null, description?: string | null } | null, twitter?: { __typename?: 'SocialSeoSettings', title?: string | null, description?: string | null, image?: any | null } | null } | null, featuredMedia?: { __typename?: 'MediaItem', id: string, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', sourceUrl?: any | null, width?: number | null, height?: number | null }> | null } | null } | null };

type GetNerdlayoutDynamicOptions_StructuredContentCalculator_Fragment = { __typename: 'StructuredContentCalculator', id: string, type: string, link?: any | null };

type GetNerdlayoutDynamicOptions_Table_Fragment = { __typename: 'Table', id: string, type: string, link?: any | null };

type GetNerdlayoutDynamicOptions_UrlRecord_Fragment = { __typename: 'UrlRecord', id: string, type: string, link?: any | null, seo?: { __typename?: 'SeoSettings', title?: string | null, description?: string | null, nofollow?: boolean | null, noindex?: boolean | null, keyword?: string | null, facebook?: { __typename?: 'SocialSeoSettings', title?: string | null, description?: string | null } | null, twitter?: { __typename?: 'SocialSeoSettings', title?: string | null, description?: string | null, image?: any | null } | null } | null, featuredMedia?: { __typename?: 'MediaItem', id: string, mediaDetails?: { __typename?: 'MediaDetails', id: string, sizes?: Array<{ __typename?: 'MediaSize', sourceUrl?: any | null, width?: number | null, height?: number | null }> | null } | null } | null };

export type GetNerdlayoutDynamicOptionsFragment = GetNerdlayoutDynamicOptions_Article_Fragment | GetNerdlayoutDynamicOptions_Banner_Fragment | GetNerdlayoutDynamicOptions_BccPage_Fragment | GetNerdlayoutDynamicOptions_BccPageCard_Fragment | GetNerdlayoutDynamicOptions_Block_Fragment | GetNerdlayoutDynamicOptions_BlockGroup_Fragment | GetNerdlayoutDynamicOptions_ContentPack_Fragment | GetNerdlayoutDynamicOptions_ContentReviewer_Fragment | GetNerdlayoutDynamicOptions_ContentSearchResult_Fragment | GetNerdlayoutDynamicOptions_ContentUserPage_Fragment | GetNerdlayoutDynamicOptions_EngineeringPost_Fragment | GetNerdlayoutDynamicOptions_GlobalNavItem_Fragment | GetNerdlayoutDynamicOptions_HouseAd_Fragment | GetNerdlayoutDynamicOptions_Hub_Fragment | GetNerdlayoutDynamicOptions_InsurancePage_Fragment | GetNerdlayoutDynamicOptions_LandingPage_Fragment | GetNerdlayoutDynamicOptions_LegacyLender_Fragment | GetNerdlayoutDynamicOptions_MarketplaceEntryPoint_Fragment | GetNerdlayoutDynamicOptions_MediaItem_Fragment | GetNerdlayoutDynamicOptions_Page_Fragment | GetNerdlayoutDynamicOptions_Post_Fragment | GetNerdlayoutDynamicOptions_PressRelease_Fragment | GetNerdlayoutDynamicOptions_Review_Fragment | GetNerdlayoutDynamicOptions_Roundup_Fragment | GetNerdlayoutDynamicOptions_StructuredContentCalculator_Fragment | GetNerdlayoutDynamicOptions_Table_Fragment | GetNerdlayoutDynamicOptions_UrlRecord_Fragment;

export const BlockFragmentDoc = gql`
    fragment block on CombinedBlockGroupBlock {
  type
  title
  data
}
    `;
export const BlockGroupFragmentDoc = gql`
    fragment BlockGroup on BlockGroup {
  id
  blocks {
    ...block
  }
}
    ${BlockFragmentDoc}`;
export const NextStepsFragmentDoc = gql`
    fragment NextSteps on Article {
  id
  articleType
  nextSteps {
    ...BlockGroup
  }
  primaryCategory {
    name
    link
  }
}
    ${BlockGroupFragmentDoc}`;
export const RelatedLinksFragmentDoc = gql`
    fragment RelatedLinks on Article {
  id
  articleType
  relatedLinks {
    ...BlockGroup
  }
  primaryCategory {
    name
    link
  }
}
    ${BlockGroupFragmentDoc}`;
export const AuthorDetailsFragmentDoc = gql`
    fragment AuthorDetails on Author {
  authorBoxAvatarUrls: avatarUrls(sizes: [SIZE_96]) {
    url
  }
  contactEmail
  facebook
  name
  link
  slug
  tagline
  twitter
}
    `;
export const AuthorBoxFragmentDoc = gql`
    fragment AuthorBox on Article {
  authors {
    ...AuthorDetails
  }
}
    ${AuthorDetailsFragmentDoc}`;
export const WordPressContentPageHeaderFragmentDoc = gql`
    fragment WordPressContentPageHeader on ContentPageHeaderInterface {
  __typename
  advertiserDisclosureType
  authors {
    name
    link
  }
  editorialDisclaimerType
  id
  primaryCategory {
    name
  }
  showAdvertiserDisclosure
  showAuthorByline
  showEditorialDisclaimer
  title
  ... on PostWithFeaturedImageInterface {
    featuredImage: featuredMedia {
      id
      altText
      mediaDetails {
        id
        sizes(
          sizes: ["bb-article", "primary-xxxl", "primary-xxl", "primary-xl", "primary-l", "primary-m", "primary-s", "primary-xs", "primary-xxs", "full"]
        ) {
          sourceUrl
          width
          height
          size
        }
      }
    }
  }
  ... on PostWithReviewerInterface {
    reviewedBy {
      name
      url: link
    }
  }
  ... on Article {
    hideFeaturedImage
    dateTimeDisplayDate: displayDate
    stringSynopsis: synopsis
  }
  ... on Roundup {
    eyebrowText
    formattedDisplayDate: displayDate
    structuredContentSynopsis: synopsis
  }
}
    `;
export const ContentPageHeaderFragmentDoc = gql`
    fragment ContentPageHeader on Article {
  hideDate
  showLastModifiedDate
  ...WordPressContentPageHeader
}
    ${WordPressContentPageHeaderFragmentDoc}`;
export const MethodologyFragmentDoc = gql`
    fragment Methodology on Article {
  methodology {
    content
  }
}
    `;
export const HouseAdFragmentDoc = gql`
    fragment HouseAd on Article {
  articleType
  houseAd {
    id
  }
}
    `;
export const GetArticleCanonicalUrlFragmentDoc = gql`
    fragment getArticleCanonicalUrl on Article {
  link
}
    `;
export const GetPageTaxonomyDataFragmentDoc = gql`
    fragment getPageTaxonomyData on PostWithPageTaxonomyInterface {
  __typename
  pageTaxonomy
}
    `;
export const GetNerdlayoutDynamicOptionsFragmentDoc = gql`
    fragment getNerdlayoutDynamicOptions on PostInterface {
  __typename
  id
  type
  link
  ...getPageTaxonomyData
  ... on Article {
    synopsis
  }
  ... on PostWithSEOInterface {
    seo {
      title
      description
      nofollow
      noindex
      keyword
      facebook {
        title
        description
      }
      twitter {
        title
        description
        image
      }
    }
  }
  ... on PostWithFeaturedImageInterface {
    featuredMedia {
      id
      mediaDetails {
        id
        sizes(sizes: ["primary-xl", "full"]) {
          sourceUrl
          width
          height
        }
      }
    }
  }
}
    ${GetPageTaxonomyDataFragmentDoc}`;
export const GetAuthorSchemaFragmentDoc = gql`
    fragment getAuthorSchema on PostWithAuthorsInterface {
  __typename
  authors {
    id
    name
    link
    avatarUrls {
      size
      url
    }
    alumniOf
    affiliation
    award
    honorificSuffix
    jobTitle
    specialties
  }
}
    `;
export const GetReviewerSchemaFragmentDoc = gql`
    fragment getReviewerSchema on PostWithReviewerInterface {
  __typename
  reviewedBy {
    id
    name
    link
    honorificSuffix
    jobTitle
    knowsAbout
    alumniOf
    featuredMedia {
      id
      croppedImages(sizes: [SQUARE_350, SQUARE_160, SQUARE]) {
        sourceUrl
      }
    }
  }
}
    `;
export const GetEditorSchemaFragmentDoc = gql`
    fragment getEditorSchema on Article {
  __typename
  assigningEditor {
    id
    name
    link
    avatarUrls(sizes: [SIZE_96]) {
      size
      url
    }
    alumniOf
    affiliation
    award
    honorificSuffix
    jobTitle
    specialties
  }
}
    `;
export const GetAboutSchemaFragmentDoc = gql`
    fragment getAboutSchema on PostInterface {
  __typename
  ... on Article {
    categories {
      name
    }
  }
  ... on Roundup {
    categories {
      name
    }
  }
}
    `;
export const GetArticleSchemaFragmentDoc = gql`
    fragment getArticleSchema on Article {
  __typename
  id
  ...getAuthorSchema
  ...getReviewerSchema
  ...getEditorSchema
  ...getAboutSchema
  featuredMediaForJsonLd: featuredMedia {
    id
    mediaDetails {
      id
      sizes(
        sizes: ["square-350", "preview", "hero-wide", "primary-xl", "primary-l", "primary-m"]
      ) {
        size
        sourceUrl
        width
        height
      }
    }
  }
  link
  modified
  date
  useReviewSchemaType
  reviewProductName
  reviewRating
  contentTags
}
    ${GetAuthorSchemaFragmentDoc}
${GetReviewerSchemaFragmentDoc}
${GetEditorSchemaFragmentDoc}
${GetAboutSchemaFragmentDoc}`;
export const GetAbTestConfigFragmentDoc = gql`
    fragment getAbTestConfig on Article {
  articleType
}
    `;
export const AdvertiserDisclosureFragmentDoc = gql`
    fragment AdvertiserDisclosure on Article {
  showAdvertiserDisclosure
  disclosureType: advertiserDisclosureType
}
    `;
export const EditorialStandardsFragmentDoc = gql`
    fragment EditorialStandards on Article {
  showEditorialDisclaimer
  disclaimerType: editorialDisclaimerType
}
    `;
export const BreadcrumbFragmentDoc = gql`
    fragment Breadcrumb on Article {
  breadcrumb {
    slug
    page {
      title
    }
  }
}
    `;
export const CcHeadToHeadFragmentDoc = gql`
    fragment CCHeadToHead on Article {
  creditCardsHeadToHead {
    productType
    ... on CreditCardsOfferV2 {
      displayName
      starRating
      productType
      phoneNumber
      reviewLink
      image {
        sourceMedium
        alt
      }
      termsAndFeesLink
    }
    ... on MarketplaceEntityWithPlacementInterface {
      analyticsProps {
        hasLegacyImpression
        legacyAdditionalEventData
        legacyIssuer
        legacySlug
        legacyVertical
        institutionId
        offerId
        productId
      }
      cta {
        link
        subtext
        text
        type
      }
      monetizable
    }
  }
}
    `;
export const CcHeadToHeadLinksFragmentDoc = gql`
    fragment CCHeadToHeadLinks on Article {
  creditCardsHeadToHead {
    productType
    ... on CreditCardsOfferV2 {
      displayName
    }
    ... on MarketplaceEntityWithPlacementInterface {
      analyticsProps {
        hasLegacyImpression
        legacyAdditionalEventData
        legacyIssuer
        legacySlug
        legacyVertical
        institutionId
        offerId
        productId
      }
      cta {
        link
      }
      monetizable
    }
  }
}
    `;
export const ArticleFragmentFragmentDoc = gql`
    fragment articleFragment on Article {
  id
  isPublished
  articleType
  title
  heroBannerDocument
  bottomStickyDocument
  seo {
    extraJsonLd
  }
  slug
  pageTaxonomy
  content
  link
  showEditorialDisclaimer
  showAuthorBox
  contentClusters
  attributionVertical
  attributionTopic
  primaryContentCluster
  marketplaceEntityLogoRowDocument
  takeaways
  bottomDocument
  sidebarDocument
  ...NextSteps
  ...RelatedLinks
  ...AuthorBox
  ...ContentPageHeader
  ...Methodology
  ...HouseAd
  ...getArticleCanonicalUrl
  ...getNerdlayoutDynamicOptions
  ...getArticleSchema
  ...getAbTestConfig
  ...AdvertiserDisclosure
  ...EditorialStandards
  ...Breadcrumb
  ...CCHeadToHead
  ...CCHeadToHeadLinks
}
    ${NextStepsFragmentDoc}
${RelatedLinksFragmentDoc}
${AuthorBoxFragmentDoc}
${ContentPageHeaderFragmentDoc}
${MethodologyFragmentDoc}
${HouseAdFragmentDoc}
${GetArticleCanonicalUrlFragmentDoc}
${GetNerdlayoutDynamicOptionsFragmentDoc}
${GetArticleSchemaFragmentDoc}
${GetAbTestConfigFragmentDoc}
${AdvertiserDisclosureFragmentDoc}
${EditorialStandardsFragmentDoc}
${BreadcrumbFragmentDoc}
${CcHeadToHeadFragmentDoc}
${CcHeadToHeadLinksFragmentDoc}`;
export const GetBccArticleSchemaFragmentDoc = gql`
    fragment getBCCArticleSchema on BccPage {
  date
  modified
  title(format: PLAIN_TEXT)
  seo {
    title
  }
  imageForBccArticleSchema
  ...getAuthorSchema
  ...getReviewerSchema
}
    ${GetAuthorSchemaFragmentDoc}
${GetReviewerSchemaFragmentDoc}`;
export const GetBccItemListSchemaFragmentDoc = gql`
    fragment getBCCItemListSchema on BccPage {
  link
  title(format: PLAIN_TEXT)
  sections {
    identifier
    shortTitle
    offers: cards {
      cardId
      offer: creditCardOffer {
        ... on CreditCardsOfferV2 {
          annualFee
          aprMax
          aprMin
        }
        ... on MarketplaceEntityWithPlacementInterface {
          displayName
          image {
            sourceLarge
          }
        }
      }
    }
  }
}
    `;
export const GetUserInfoSchemaFragmentDoc = gql`
    fragment getUserInfoSchema on PostInterface {
  id
  link
  ... on PostWithContactInfoInterface {
    socialMediaLinks {
      type
      url
    }
  }
  ... on ContentUserPage {
    awards
    name: fullName
    jobTitle
    featuredMedia {
      id
      croppedImage {
        sourceUrl
      }
    }
    credentials
    memberOf: organizations
    user {
      knowsAbout: specialties
      alumniOf
      description
      affiliation
    }
  }
  ... on ContentReviewer {
    name: fullName
    honorificSuffix
    jobTitle
    knowsAbout: experience
    alumniOf
    description
    featuredMedia {
      id
      croppedImage {
        sourceUrl
      }
    }
  }
}
    `;
export const GetReviewSchemaFragmentDoc = gql`
    fragment getReviewSchema on Review {
  date
  link
  marketplaceEntity {
    ... on MarketplaceEntityWithPlacementInterface {
      displayName
    }
    ... on MarketplaceEntityWithStarRatingInterface {
      starRating
    }
    ... on MarketplaceOfferInterface {
      institution {
        name
      }
    }
    ... on MarketplaceProductInterface {
      institution {
        name
      }
    }
  }
  modified
  seo {
    description
  }
  title
  ...getAuthorSchema
  ...getReviewerSchema
}
    ${GetAuthorSchemaFragmentDoc}
${GetReviewerSchemaFragmentDoc}`;
export const GetArticleSchemaOnRoundupFragmentDoc = gql`
    fragment getArticleSchemaOnRoundup on Roundup {
  date
  modified
  link
  productCardsSection {
    categorySections(
      abTestCCPepPhase1IsActive: $isCCPepPhase1Active
      abTestCCEPCProductOrderingIsActive: $isEPCOrderingActive
      abTestBankingPepPhase1IsActive: $isBankingPepPhase1Active
      abTestInvestingPepPhase1IsActive: $isInvestingPepPhase1Active
      abTestDeviceTypePhase1IsActive: $isRankedByDeviceType
      abTestBmlRedesignIsActive: $isBmlRedesignActive
      isDesktopUserAgent: $isDesktopUserAgent
      abTestCCGeotargeting: $geotargetingInput
    ) {
      productCards {
        gqlMarketplaceEntity: marketplaceEntity {
          ... on MarketplaceEntityWithPlacementInterface {
            image {
              sourceLarge
            }
          }
        }
      }
    }
  }
  titleWithoutEntityCount
  ...getAboutSchema
  ...getAuthorSchema
  ...getReviewerSchema
}
    ${GetAboutSchemaFragmentDoc}
${GetAuthorSchemaFragmentDoc}
${GetReviewerSchemaFragmentDoc}`;
export const GetItemListSchemaFragmentDoc = gql`
    fragment getItemListSchema on Roundup {
  link
  marketplaceProductType
  titleWithoutEntityCount
  productCardsSection {
    categorySections(
      abTestCCPepPhase1IsActive: $isCCPepPhase1Active
      abTestCCEPCProductOrderingIsActive: $isEPCOrderingActive
      abTestBankingPepPhase1IsActive: $isBankingPepPhase1Active
      abTestInvestingPepPhase1IsActive: $isInvestingPepPhase1Active
      abTestDeviceTypePhase1IsActive: $isRankedByDeviceType
      abTestBmlRedesignIsActive: $isBmlRedesignActive
      isDesktopUserAgent: $isDesktopUserAgent
      abTestCCGeotargeting: $geotargetingInput
    ) {
      title
      productCards {
        gqlMarketplaceEntity: marketplaceEntity {
          id
          ... on MarketplaceEntityWithPlacementInterface {
            displayName
            image {
              sourceLarge
            }
          }
          ... on CreditCardsOfferV2 {
            annualFee
            aprMax
            aprMin
          }
        }
      }
    }
  }
}
    `;
export const ArticleDocument = gql`
    query article($identifier: ID!, $wpnonce: ID) {
  article(input: {identifier: $identifier, wpnonce: $wpnonce}) {
    ...articleFragment
  }
}
    ${ArticleFragmentFragmentDoc}`;
export type ArticleComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArticleQuery, ArticleQueryVariables>, 'query'> & ({ variables: ArticleQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArticleComponent = (props: ArticleComponentProps) => (
      <ApolloReactComponents.Query<ArticleQuery, ArticleQueryVariables> query={ArticleDocument} {...props} />
    );
    
export type ArticleProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArticleQuery, ArticleQueryVariables>
    } & TChildProps;
export function withArticle<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArticleQuery,
  ArticleQueryVariables,
  ArticleProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArticleQuery, ArticleQueryVariables, ArticleProps<TChildProps, TDataName>>(ArticleDocument, {
      alias: 'article',
      ...operationOptions
    });
};

/**
 * __useArticleQuery__
 *
 * To run a query within a React component, call `useArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      wpnonce: // value for 'wpnonce'
 *   },
 * });
 */
export function useArticleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArticleQuery, ArticleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArticleQuery, ArticleQueryVariables>(ArticleDocument, options);
      }
export function useArticleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArticleQuery, ArticleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArticleQuery, ArticleQueryVariables>(ArticleDocument, options);
        }
export type ArticleQueryHookResult = ReturnType<typeof useArticleQuery>;
export type ArticleLazyQueryHookResult = ReturnType<typeof useArticleLazyQuery>;
export type ArticleQueryResult = ApolloReactCommon.QueryResult<ArticleQuery, ArticleQueryVariables>;
export const ArticleForkDocument = gql`
    query articleFork($identifier: ID!, $wpnonce: String, $forkPreview: Boolean, $forkIdentifier: Int!, $forkNonce: String) {
  articleFork(
    input: {identifier: $identifier, wpnonce: $wpnonce, forkPreview: $forkPreview, forkIdentifier: $forkIdentifier, forkNonce: $forkNonce}
  ) {
    ...articleFragment
  }
}
    ${ArticleFragmentFragmentDoc}`;
export type ArticleForkComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArticleForkQuery, ArticleForkQueryVariables>, 'query'> & ({ variables: ArticleForkQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArticleForkComponent = (props: ArticleForkComponentProps) => (
      <ApolloReactComponents.Query<ArticleForkQuery, ArticleForkQueryVariables> query={ArticleForkDocument} {...props} />
    );
    
export type ArticleForkProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArticleForkQuery, ArticleForkQueryVariables>
    } & TChildProps;
export function withArticleFork<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArticleForkQuery,
  ArticleForkQueryVariables,
  ArticleForkProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArticleForkQuery, ArticleForkQueryVariables, ArticleForkProps<TChildProps, TDataName>>(ArticleForkDocument, {
      alias: 'articleFork',
      ...operationOptions
    });
};

/**
 * __useArticleForkQuery__
 *
 * To run a query within a React component, call `useArticleForkQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleForkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleForkQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      wpnonce: // value for 'wpnonce'
 *      forkPreview: // value for 'forkPreview'
 *      forkIdentifier: // value for 'forkIdentifier'
 *      forkNonce: // value for 'forkNonce'
 *   },
 * });
 */
export function useArticleForkQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArticleForkQuery, ArticleForkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArticleForkQuery, ArticleForkQueryVariables>(ArticleForkDocument, options);
      }
export function useArticleForkLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArticleForkQuery, ArticleForkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArticleForkQuery, ArticleForkQueryVariables>(ArticleForkDocument, options);
        }
export type ArticleForkQueryHookResult = ReturnType<typeof useArticleForkQuery>;
export type ArticleForkLazyQueryHookResult = ReturnType<typeof useArticleForkLazyQuery>;
export type ArticleForkQueryResult = ApolloReactCommon.QueryResult<ArticleForkQuery, ArticleForkQueryVariables>;
export const GetArticleSchemaDocument = gql`
    query getArticleSchema($articleId: ID!) {
  article(input: {identifier: $articleId}) {
    ...getArticleSchema
  }
}
    ${GetArticleSchemaFragmentDoc}`;
export type GetArticleSchemaComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetArticleSchemaQuery, GetArticleSchemaQueryVariables>, 'query'> & ({ variables: GetArticleSchemaQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetArticleSchemaComponent = (props: GetArticleSchemaComponentProps) => (
      <ApolloReactComponents.Query<GetArticleSchemaQuery, GetArticleSchemaQueryVariables> query={GetArticleSchemaDocument} {...props} />
    );
    
export type GetArticleSchemaProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetArticleSchemaQuery, GetArticleSchemaQueryVariables>
    } & TChildProps;
export function withGetArticleSchema<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetArticleSchemaQuery,
  GetArticleSchemaQueryVariables,
  GetArticleSchemaProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetArticleSchemaQuery, GetArticleSchemaQueryVariables, GetArticleSchemaProps<TChildProps, TDataName>>(GetArticleSchemaDocument, {
      alias: 'getArticleSchema',
      ...operationOptions
    });
};

/**
 * __useGetArticleSchemaQuery__
 *
 * To run a query within a React component, call `useGetArticleSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticleSchemaQuery({
 *   variables: {
 *      articleId: // value for 'articleId'
 *   },
 * });
 */
export function useGetArticleSchemaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetArticleSchemaQuery, GetArticleSchemaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetArticleSchemaQuery, GetArticleSchemaQueryVariables>(GetArticleSchemaDocument, options);
      }
export function useGetArticleSchemaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetArticleSchemaQuery, GetArticleSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetArticleSchemaQuery, GetArticleSchemaQueryVariables>(GetArticleSchemaDocument, options);
        }
export type GetArticleSchemaQueryHookResult = ReturnType<typeof useGetArticleSchemaQuery>;
export type GetArticleSchemaLazyQueryHookResult = ReturnType<typeof useGetArticleSchemaLazyQuery>;
export type GetArticleSchemaQueryResult = ApolloReactCommon.QueryResult<GetArticleSchemaQuery, GetArticleSchemaQueryVariables>;
export const GetAuthorSchemaDocument = gql`
    query getAuthorSchema($articleId: ID!) {
  article(input: {identifier: $articleId}) {
    ...getAuthorSchema
  }
}
    ${GetAuthorSchemaFragmentDoc}`;
export type GetAuthorSchemaComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAuthorSchemaQuery, GetAuthorSchemaQueryVariables>, 'query'> & ({ variables: GetAuthorSchemaQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetAuthorSchemaComponent = (props: GetAuthorSchemaComponentProps) => (
      <ApolloReactComponents.Query<GetAuthorSchemaQuery, GetAuthorSchemaQueryVariables> query={GetAuthorSchemaDocument} {...props} />
    );
    
export type GetAuthorSchemaProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAuthorSchemaQuery, GetAuthorSchemaQueryVariables>
    } & TChildProps;
export function withGetAuthorSchema<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAuthorSchemaQuery,
  GetAuthorSchemaQueryVariables,
  GetAuthorSchemaProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAuthorSchemaQuery, GetAuthorSchemaQueryVariables, GetAuthorSchemaProps<TChildProps, TDataName>>(GetAuthorSchemaDocument, {
      alias: 'getAuthorSchema',
      ...operationOptions
    });
};

/**
 * __useGetAuthorSchemaQuery__
 *
 * To run a query within a React component, call `useGetAuthorSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthorSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthorSchemaQuery({
 *   variables: {
 *      articleId: // value for 'articleId'
 *   },
 * });
 */
export function useGetAuthorSchemaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAuthorSchemaQuery, GetAuthorSchemaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAuthorSchemaQuery, GetAuthorSchemaQueryVariables>(GetAuthorSchemaDocument, options);
      }
export function useGetAuthorSchemaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAuthorSchemaQuery, GetAuthorSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAuthorSchemaQuery, GetAuthorSchemaQueryVariables>(GetAuthorSchemaDocument, options);
        }
export type GetAuthorSchemaQueryHookResult = ReturnType<typeof useGetAuthorSchemaQuery>;
export type GetAuthorSchemaLazyQueryHookResult = ReturnType<typeof useGetAuthorSchemaLazyQuery>;
export type GetAuthorSchemaQueryResult = ApolloReactCommon.QueryResult<GetAuthorSchemaQuery, GetAuthorSchemaQueryVariables>;
export const GetAboutSchemaDocument = gql`
    query getAboutSchema($articleId: ID!) {
  article(input: {identifier: $articleId}) {
    ...getAboutSchema
  }
}
    ${GetAboutSchemaFragmentDoc}`;
export type GetAboutSchemaComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAboutSchemaQuery, GetAboutSchemaQueryVariables>, 'query'> & ({ variables: GetAboutSchemaQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetAboutSchemaComponent = (props: GetAboutSchemaComponentProps) => (
      <ApolloReactComponents.Query<GetAboutSchemaQuery, GetAboutSchemaQueryVariables> query={GetAboutSchemaDocument} {...props} />
    );
    
export type GetAboutSchemaProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAboutSchemaQuery, GetAboutSchemaQueryVariables>
    } & TChildProps;
export function withGetAboutSchema<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAboutSchemaQuery,
  GetAboutSchemaQueryVariables,
  GetAboutSchemaProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAboutSchemaQuery, GetAboutSchemaQueryVariables, GetAboutSchemaProps<TChildProps, TDataName>>(GetAboutSchemaDocument, {
      alias: 'getAboutSchema',
      ...operationOptions
    });
};

/**
 * __useGetAboutSchemaQuery__
 *
 * To run a query within a React component, call `useGetAboutSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAboutSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAboutSchemaQuery({
 *   variables: {
 *      articleId: // value for 'articleId'
 *   },
 * });
 */
export function useGetAboutSchemaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAboutSchemaQuery, GetAboutSchemaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAboutSchemaQuery, GetAboutSchemaQueryVariables>(GetAboutSchemaDocument, options);
      }
export function useGetAboutSchemaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAboutSchemaQuery, GetAboutSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAboutSchemaQuery, GetAboutSchemaQueryVariables>(GetAboutSchemaDocument, options);
        }
export type GetAboutSchemaQueryHookResult = ReturnType<typeof useGetAboutSchemaQuery>;
export type GetAboutSchemaLazyQueryHookResult = ReturnType<typeof useGetAboutSchemaLazyQuery>;
export type GetAboutSchemaQueryResult = ApolloReactCommon.QueryResult<GetAboutSchemaQuery, GetAboutSchemaQueryVariables>;
export const GetUserPageDocument = gql`
    query getUserPage($id: Int!) {
  postById(id: $id) {
    ...getUserInfoSchema
  }
}
    ${GetUserInfoSchemaFragmentDoc}`;
export type GetUserPageComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetUserPageQuery, GetUserPageQueryVariables>, 'query'> & ({ variables: GetUserPageQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetUserPageComponent = (props: GetUserPageComponentProps) => (
      <ApolloReactComponents.Query<GetUserPageQuery, GetUserPageQueryVariables> query={GetUserPageDocument} {...props} />
    );
    
export type GetUserPageProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetUserPageQuery, GetUserPageQueryVariables>
    } & TChildProps;
export function withGetUserPage<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetUserPageQuery,
  GetUserPageQueryVariables,
  GetUserPageProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetUserPageQuery, GetUserPageQueryVariables, GetUserPageProps<TChildProps, TDataName>>(GetUserPageDocument, {
      alias: 'getUserPage',
      ...operationOptions
    });
};

/**
 * __useGetUserPageQuery__
 *
 * To run a query within a React component, call `useGetUserPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserPageQuery, GetUserPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserPageQuery, GetUserPageQueryVariables>(GetUserPageDocument, options);
      }
export function useGetUserPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserPageQuery, GetUserPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserPageQuery, GetUserPageQueryVariables>(GetUserPageDocument, options);
        }
export type GetUserPageQueryHookResult = ReturnType<typeof useGetUserPageQuery>;
export type GetUserPageLazyQueryHookResult = ReturnType<typeof useGetUserPageLazyQuery>;
export type GetUserPageQueryResult = ApolloReactCommon.QueryResult<GetUserPageQuery, GetUserPageQueryVariables>;
export const GetReviewSchemaDocument = gql`
    query getReviewSchema($reviewId: ID!) {
  review(input: {identifier: $reviewId}) {
    ...getReviewSchema
  }
}
    ${GetReviewSchemaFragmentDoc}`;
export type GetReviewSchemaComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetReviewSchemaQuery, GetReviewSchemaQueryVariables>, 'query'> & ({ variables: GetReviewSchemaQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetReviewSchemaComponent = (props: GetReviewSchemaComponentProps) => (
      <ApolloReactComponents.Query<GetReviewSchemaQuery, GetReviewSchemaQueryVariables> query={GetReviewSchemaDocument} {...props} />
    );
    
export type GetReviewSchemaProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetReviewSchemaQuery, GetReviewSchemaQueryVariables>
    } & TChildProps;
export function withGetReviewSchema<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetReviewSchemaQuery,
  GetReviewSchemaQueryVariables,
  GetReviewSchemaProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetReviewSchemaQuery, GetReviewSchemaQueryVariables, GetReviewSchemaProps<TChildProps, TDataName>>(GetReviewSchemaDocument, {
      alias: 'getReviewSchema',
      ...operationOptions
    });
};

/**
 * __useGetReviewSchemaQuery__
 *
 * To run a query within a React component, call `useGetReviewSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewSchemaQuery({
 *   variables: {
 *      reviewId: // value for 'reviewId'
 *   },
 * });
 */
export function useGetReviewSchemaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetReviewSchemaQuery, GetReviewSchemaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReviewSchemaQuery, GetReviewSchemaQueryVariables>(GetReviewSchemaDocument, options);
      }
export function useGetReviewSchemaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetReviewSchemaQuery, GetReviewSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReviewSchemaQuery, GetReviewSchemaQueryVariables>(GetReviewSchemaDocument, options);
        }
export type GetReviewSchemaQueryHookResult = ReturnType<typeof useGetReviewSchemaQuery>;
export type GetReviewSchemaLazyQueryHookResult = ReturnType<typeof useGetReviewSchemaLazyQuery>;
export type GetReviewSchemaQueryResult = ApolloReactCommon.QueryResult<GetReviewSchemaQuery, GetReviewSchemaQueryVariables>;